import {
  Duration__minus_impl_q5cfm7ntz6q4kzlr5l as Duration__minus_impl_q5cfm7,
  Duration__plus_impl_yu9v8f1x7qwk17prwx4 as Duration__plus_impl_yu9v8f,
  Duration__compareTo_impl_pchp0f1z7ae3ty3s6c1 as Duration__compareTo_impl_pchp0f,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instance104q5opgivhr8 as Unit_instance,
  Comparable198qfk8pnblz0 as Comparable,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Duration__toString_impl_8d916b1f2vqqjkgwgjr as Duration__toString_impl_8d916b,
  ValueTimeMark__elapsedNow_impl_eonqvs2ntz2k8jdtq63 as ValueTimeMark__elapsedNow_impl_eonqvs,
  Duration5ynfiptaqcrg as Duration,
  printStackTrace18lnx7a39cni as printStackTrace,
  Monotonic_instance19wu6xfdyzm85 as Monotonic_instance,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  maxOfnpw4mt1rg0hl as maxOf,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  createThis2j2avj17cvnv2 as createThis,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Enum3alwj03lh1n41 as Enum,
  _Char___init__impl__6a9atx35f3p1971c8nj as _Char___init__impl__6a9atx,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  toString26mv3gzfo7fn as toString_0,
  Char__hashCode_impl_otmysaxeh01anngge as Char__hashCode_impl_otmys,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_1,
  hashCodeq5arwsb9dgti as hashCode,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  joinToString1cxrrlmo0chqs as joinToString,
  booleanArray2jdug9b51huk7 as booleanArray,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  StringBuildermazzzhj6kkai as StringBuilder,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  emptySetcxexqki71qfa as emptySet,
  Long2qws0ah9gnpki as Long,
  isInterface3d6p8outrmvmk as isInterface,
  distinct10qe1scfdvu5k as distinct,
  compareTo3ankvs086tmwq as compareTo,
  Companion_getInstance1pxg306pnafvz as Companion_getInstance_0,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  KProperty1ca4yb4wlo496 as KProperty1,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toList3jhuyej2anx2q as toList,
  listOfvhqybd2zx248 as listOf,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashMap1a0ld5kgwhmhv as HashMap,
  lazy2hsh8ze7j6ikd as lazy,
  numberToLong1a4cndvg6c52s as numberToLong,
  toLongw1zpgk99d84b as toLong,
  println2shhhgwwt4c61 as println,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOf1jh22dvmctj1r as listOf_0,
  Triple1vhi3d0dgpnjb as Triple,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  last1vo29oleiqj36 as last,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getOrNull1d60i0672n7ns as getOrNull,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  emptyList1g2z5xcrvp2zy as emptyList,
  reversed22y3au42jl32b as reversed,
  HashSet2dzve9y63nf0v as HashSet,
  plus310ted5e4i90h as plus,
  joinToStringxqcavsxcmh4q as joinToString_0,
  contains2el4s70rdq4ld as contains,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  Iterable1y3qizuf89iou as Iterable,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  toList383f556t1dixk as toList_0,
  to2cs3ny02qtbcb as to,
  boxApply1qmzdb3dh90hg as boxApply,
  plus1ogy4liedzq5j as plus_0,
  withIndex37cl61h9v5txo as withIndex,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd1g1ubcha2b2yr as Char__toInt_impl_vasixd,
  numberToChar93r9buh19yek as numberToChar,
  until1jbpn0z3f8lbg as until,
  toSet2orjxp16sotqu as toSet,
  split2bvyvnrlcifjv as split,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  numberToDouble210hrknaofnhf as numberToDouble,
  get_indicesc04v40g017hw as get_indices,
  anyToString3ho3k49fc56mj as anyToString,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  copyToArray2j022khrow2yi as copyToArray,
  startsWith1bgirhbedtv2y as startsWith,
  isBlank1dvkhjjvox3p0 as isBlank,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
  contains1tccixv8iwdcq as contains_0,
  EmptyCoroutineContext_getInstance2bxophqwsfm9n as EmptyCoroutineContext_getInstance,
  round2mrvepag8eey0 as round,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  addAll1k27qatfgp3k5 as addAll,
  Companion_getInstance3kme2txpd8mob as Companion_getInstance_1,
  mapOf1xd03cq9cnmy8 as mapOf,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  ObservableProperty3aw08lidjfpjm as ObservableProperty,
  Delegates_instanceib38j9qg9yhk as Delegates_instance,
  DurationUnit_MICROSECONDS_getInstance2dy62s6vvg5md as DurationUnit_MICROSECONDS_getInstance,
  Duration__times_impl_sfuzvp1yoh2cju8vble as Duration__times_impl_sfuzvp,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus_1,
  Element2gr7ezmxqaln7 as Element,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz831xktsyjq1qrq as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  KProperty02ce7r476m8633 as KProperty0,
  toSet1glep2u1u9tcb as toSet_0,
  reversednxqwdkac9dn0 as reversed_0,
  toMutableListoiy7juhbnlr7 as toMutableList,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  isNaNymqb93xtq8w8 as isNaN_0,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Console_getInstance25u15nzhjnxu2 as Console_getInstance,
  Companion_getInstance1lqql7kjbk545 as Companion_getInstance_2,
  Level_INFO_getInstance2ziz2o3m3loni as Level_INFO_getInstance,
  Level_ERROR_getInstance3sgixyayx9gy9 as Level_ERROR_getInstance,
  Level_TRACE_getInstance3v3hjwgnnbwb6 as Level_TRACE_getInstance,
  Level_DEBUG_getInstance2cjwrm9110zsz as Level_DEBUG_getInstance,
  valueOf3aj0dpb8xpu5n as valueOf,
  Level_WARN_getInstancejrnwzyc079xb as Level_WARN_getInstance,
} from './korlibs-korlibs-logger.mjs';
import {
  SyncPauseable20rt0nt3umu2s as SyncPauseable,
  Companion_instance3aqdk7kknb8d1 as Companion_instance_0,
  FastIdentityMap17d14y8i3m5g7 as FastIdentityMap,
  get2pw1zlgv5zypd as get_0,
  set2vuztm9k7ubgo as set,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref11k43t82thcp3 as Ref,
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  Pool1zbsw0zhvh8ca as Pool,
  containsrsn76oa0puwr as contains_1,
  clear3idbm40uzyume as clear,
  get_size2tttv7g2u748n as get_size,
  FastSmallSet2og2j8v2pz4c7 as FastSmallSet,
  getAndRemove1ksxnnren48mb as getAndRemove,
  get_keyswqddktl7cnu2 as get_keys,
  ReturnablePool3rkgvxsckx2u2 as ReturnablePool,
  TGenQueue2v9j3ju90xgpv as TGenQueue,
} from './korlibs-korlibs-datastructure.mjs';
import {
  Lock5n7hh3dgcidl as Lock,
  Signal3nnez3346azzf as Signal,
  invoke2sf88d1xeuyqh as invoke,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
} from './korlibs-korlibs-concurrent.mjs';
import {
  cancel1amaozv14ic7s as cancel,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  Companion_getInstance4j5fpzk5rb8p as Companion_getInstance_3,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  unsupported198cz39rr1ztw as unsupported,
  Companion_instance21jklwk36y3dn as Companion_instance_1,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_getInstance1x6v9sy9zfof9 as Companion_getInstance_4,
  Os_UNKNOWN_getInstance1flk2wnh3ycyv as Os_UNKNOWN_getInstance,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
} from './korlibs-korlibs-platform.mjs';
import {
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Mixin3lmkm5hum2vdj as Mixin,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  toFastListzo2jtkrx0z5y as toFastList_0,
} from './korlibs-korlibs-datastructure-core.mjs';
import {
  Companion_getInstanceuv1p1c5gwy11 as Companion_getInstance_5,
  Vector2D378fe5rov8fgw as Vector2D,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstancewvzae8n0fprj as Companion_getInstance_6,
  BoundsBuilder__plus_impl_cz7f7x1gtmpkit3llyq as BoundsBuilder__plus_impl_cz7f7x,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance2npyq9n96lvll as Companion_getInstance_7,
  Companion_getInstance3jdtpl42k8kus as Companion_getInstance_8,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  get_scale17gmsnxnqj6j9 as get_scale,
  Matrix43neeu8v4zk4i7 as Matrix4,
  orthow9c0o91bw54n as ortho,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instance3cau272s9vxbi as Companion_instance_2,
  interpolateAngleNormalized3h8mzdshuvgea as interpolateAngleNormalized,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__times_impl_v3s9y213uoamn5n3x7j as Angle__times_impl_v3s9y2,
  Angle2itorpob18n08 as Angle,
  Companion_getInstance21plr7f541fx9 as Companion_getInstance_9,
} from './korlibs-korlibs-math-vector.mjs';
import {
  Companion_getInstance3moaeo8p2fvjj as Companion_getInstance_10,
  DateTime__hashCode_impl_yf0bc92p1oa6fp4l38p as DateTime__hashCode_impl_yf0bc9,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr1r08ed2cb76hy as _FastDuration___get_fastNanoseconds__impl__9kjwbr,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  _FastDuration___get_fastMilliseconds__impl__pe68va279q35r54j5bc as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__minus_impl_evs2371fjveki3j5gyc as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj71uadlvoozsr50 as FastDuration__compareTo_impl_4fhnj7,
  Companion_instance2mxqoacslm62w as Companion_instance_3,
  get_fastNanoseconds1laeiegsk8vcx as get_fastNanoseconds_0,
  FastDuration__plus_impl_q1enab3lvjsvnxno7fk as FastDuration__plus_impl_q1enab,
  toDuration15w5sljvx2ut2 as toDuration_1,
  FastDuration3d3pupg2e5ora as FastDuration,
  FastDuration__hashCode_impl_y13la61yn3ntf9nmd1o as FastDuration__hashCode_impl_y13la6,
  get_milliseconds20vru1dkca6bq as get_milliseconds,
  minus2npwq73u0d9yx as minus,
  FastDuration__compareTo_impl_4fhnj71anf17lkhs1by as FastDuration__compareTo_impl_4fhnj7_0,
  FastDuration__minus_impl_evs2371ieewiyvo7cp9 as FastDuration__minus_impl_evs237_0,
  max1q2oylvn6uire as max,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__plus_impl_q1enab14z0pv6jz22jd as FastDuration__plus_impl_q1enab_0,
  get_fast37cu8s8qwnuyi as get_fast,
  roundMilliseconds3bd2pntxev66o as roundMilliseconds,
  FastDuration__toString_impl_c9xohb3cvph1y7s95v4 as FastDuration__toString_impl_c9xohb,
} from './korlibs-korlibs-time-core.mjs';
import {
  arraycopy52dxe7vhzf14 as arraycopy,
  _Int8Buffer___init__impl__e20lvc25rd50uuh5h3r as _Int8Buffer___init__impl__e20lvc,
  _Int8Buffer___get_buffer__impl__q0gulb1rowdgq1svh9p as _Int8Buffer___get_buffer__impl__q0gulb,
  _Float32Buffer___init__impl__403k2m37epj48967hb0 as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9x3g4pb23dnjw1t as _Float32Buffer___get_buffer__impl__x5nu9x,
  sliceWithSize2i7i6olf26byj as sliceWithSize,
  arrayequal25g4om83vd8w1 as arrayequal,
  clonelcrqoxe4ne5i as clone,
  Companion_getInstancehxhdjetxjiew as Companion_getInstance_11,
  ByteUnits__toString_impl_ox2ku23u8mrfdqfevi9 as ByteUnits__toString_impl_ox2ku2,
  arraycopy3uxsqjlixmnz3 as arraycopy_0,
  Buffer25z94vsj0kb1s as Buffer,
  get_i323p4hlz6j3xys8 as get_i32,
  arraycopy1hsh296f5d0xg as arraycopy_1,
  get_f3218rglfhpgbhzp as get_f32,
  arraycopy3fi6tr79d693r as arraycopy_2,
  get_i83qhdj74rhdyeg as get_i8,
  arraycopyphzg5lpa6gvz as arraycopy_3,
  get_size13scmefs6mbfn as get_size_0,
  Companion_instanceimfvy8b5dxd9 as Companion_instance_4,
  allocDirecttfrgytwudkpf as allocDirect,
  sliceBufferpiate0wictoq as sliceBuffer,
  copyOfnqvdm0sc8lk as copyOf,
  setInt83254513lyzytp as setInt8,
  getInt837es7ejbt6cz0 as getInt8,
  setInt32178h074gei71f as setInt32,
  getInt32gmg3zyw00v1v as getInt32,
  arraycopy9a0yzbjqwnvw as arraycopy_4,
  Uint16Buffer__set_impl_g0kliu1yamftxrkicc6 as Uint16Buffer__set_impl_g0kliu,
  Float32Buffer__get_impl_659lhu25y6ts3w0gs8j as Float32Buffer__get_impl_659lhu,
  Float32Buffer__set_impl_34sznevuviq8wx4pjc as Float32Buffer__set_impl_34szne,
  get_u163bxpdbbave1v5 as get_u16,
  setFloat323e0ukqyly1ufv as setFloat32,
  asUShortArrayInt2gfk0h9rafip5 as asUShortArrayInt,
  arraycopy28e1us87mwypg as arraycopy_5,
  arrayadd3erpr00t9k8j as arrayadd,
  arraycopyqmyo4vjwforw as arraycopy_6,
  arrayfill1njpugsfcm512 as arrayfill,
  arrayfill2iqmyqqqfwuaf as arrayfill_0,
  allocNoDirect3dykranmovqsj as allocNoDirect,
  get_arrayUByte9swx7ogt2hf2 as get_arrayUByte,
  get_arrayInt3v8kuk47rixtz as get_arrayInt,
  get_arrayFloat1r0vk858s9phl as get_arrayFloat,
} from './korlibs-korlibs-memory.mjs';
import {
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  get_isPowerOfTwoeb2yxu9ww0f7 as get_isPowerOfTwo,
  extract2vhru1ihy4ogl as extract,
  insert52qor1kqho1lpj as insert5,
  insert22yqrzxcpmo55e as insert2,
  insert2fz5125p2hdyd as insert,
  insert42sy0xc4ax89g9 as insert4,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  toIntRound1mv0y8x9hh1p4 as toIntRound,
  toIntRoundjnzmk86x1qp5 as toIntRound_0,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  fromLowHigh12fm8h1tmjclj as fromLowHigh,
  insert141hi307uxchfzk as insert14,
  ilog23dbvpk38jf7rc as ilog2,
  insert8f3zk23r8x9da as insert8,
  insert32d422lnha9g5r as insert3,
  extractScaledf013fj6eqsu4szwo as extractScaledf01,
  insertScaledf01oj6k04gavkch as insertScaledf01,
  insertm9bp9ll4cml3 as insert_0,
  min1z074tc6jeruz as min,
  max1izmzj76cv5b4 as max_0,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
  Ratio__toFloat_impl_1ftup5294anfb3s41c1 as Ratio__toFloat_impl_1ftup5,
  nextAlignedTo2788hp7lcoqp as nextAlignedTo,
  setBitsqsmqq5kc486j as setBits,
  Companion_getInstance1kb6pmvl5oz92 as Companion_getInstance_12,
  _Ratio___init__impl__9mwvn21qo8ztog8o9ep as _Ratio___init__impl__9mwvn2,
  Ratio136tf4z2t0p2d as Ratio,
  interpolate35pbs3ac913y4 as interpolate,
  interpolate2g7wzskc23f1q as interpolate_0,
  interpolate1wglaj6k11c6v as interpolate_1,
  Ratio__toDouble_impl_o7epze3e3zsci3ipwe7 as Ratio__toDouble_impl_o7epze,
  toRatio1hooqit5gulhr as toRatio,
} from './korlibs-korlibs-math-core.mjs';
import {
  NullBitmap15b22oyta4usb as NullBitmap,
  MultiBitmapk0zsv2zy1mpk as MultiBitmap,
  ForcedTexId3ivekmtdm8t3u as ForcedTexId,
  RGBA__toString_impl_4lw6dp2cnrrhh9rakoc as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf63jsbsnnrny7w3 as RGBA__hashCode_impl_h59qf6,
  FloatBitmap321fufbxi3ys0iu as FloatBitmap32,
  Bitmap82ekc5d8xpcfp2 as Bitmap8,
  NativeImagebqxh3nwkmck as NativeImage,
  _RGBA___get_rf__impl__kvz75k3pk03bu2ddet as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1u2gy3h5k9nkx as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5yg3ni93gubw9yz3 as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv3iv1uv3wd82oh as _RGBA___get_af__impl__vu36qv,
  _RGBAPremultiplied___get_rf__impl__pt0c4y18zok6tr9apch as _RGBAPremultiplied___get_rf__impl__pt0c4y,
  _RGBAPremultiplied___get_gf__impl__ivron74okc5xdveso1 as _RGBAPremultiplied___get_gf__impl__ivron7,
  _RGBAPremultiplied___get_bf__impl__qa3on213rxeu9ptyi9h as _RGBAPremultiplied___get_bf__impl__qa3on2,
  _RGBAPremultiplied___get_af__impl__euwcjn1b7069ioje2c2 as _RGBAPremultiplied___get_af__impl__euwcjn,
  Colors_getInstance1qvds1isfbag2 as Colors_getInstance,
  Companion_instance307r99gfwddav as Companion_instance_5,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  readBitmap1xlsnvr8f9icc as readBitmap,
  slice2pfxfvku0ybgy as slice,
  Companion_instancevwyx2uq9kvqe as Companion_instance_6,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  get_baseMipmapLevel1ty2cgb5p9xw4 as get_baseMipmapLevel,
  get_maxMipmapLevel13juf70j6ney9 as get_maxMipmapLevel,
  _RGBA___get_value__impl__hhco8v1fb2bqjo5n70o as _RGBA___get_value__impl__hhco8v,
  RGBA34obx2i62wcl3 as RGBA,
  Bitmaps_instancebct336c8d0m7 as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  Companion_getInstanceocd6ti8e4l21 as Companion_getInstance_13,
  HtmlNativeImagenz79853f60h as HtmlNativeImage,
  toHtmlNative1zcg9na83p2te as toHtmlNative,
} from './korlibs-korlibs-image.mjs';
import {
  get_hex32p4ssq0y1xxx as get_hex,
  fromBase6434uveajlhn2ar as fromBase64,
} from './korlibs-korlibs-encoding.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  Companion_getInstance3mi66xu3smuhs as Companion_getInstance_14,
  Indenterdf10c5coibyi as Indenter,
  MountableVfs3mmbka3zq5l6i as MountableVfs,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  fromGlobop2d8fuuz6ri as fromGlob,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  delay37k8qmbtkbicq as delay,
  toVfsr7ir4p66g1my as toVfs,
  launchImmediately11za8mkid9pxu as launchImmediately_0,
} from './korlibs-korlibs-io.mjs';
import {
  get_immutablepxpdoj6e54ll as get_immutable,
  Companion_instance104pvig6e11lu as Companion_instance_7,
  RectSlicec5msorw5q4el as RectSlice,
  Companion_getInstance2yrgpxwoeu923 as Companion_getInstance_15,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
} from './korlibs-korlibs-math.mjs';
import { openAsync37anb1e84urmo as openAsync } from './korlibs-korlibs-io-stream.mjs';
import { InjectorDependency2f8dsqe1kn3nn as InjectorDependency } from './korlibs-korlibs-inject.mjs';
import {
  delay1a7xkalnslpld as delay_0,
  cancelChildrennwartoz0yn6c as cancelChildren,
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  cancelAndJoin2e3e4cwh51my6 as cancelAndJoin,
  MainScope1gi1r4abhrtmm as MainScope,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
} from './kotlinx-coroutines-core.mjs';
import {
  IntTimedCache39ymx9abjz88x as IntTimedCache,
  PerformanceCounter_getInstance23wo5gavc7ilf as PerformanceCounter_getInstance,
  Stopwatch1guqi4xl0rpfb as Stopwatch,
} from './korlibs-korlibs-time.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class TimedTask {
  constructor(eventLoop, now, time, interval, callback) {
    this.v88_1 = eventLoop;
    this.w88_1 = now;
    this.x88_1 = time;
    this.y88_1 = interval;
    this.z88_1 = callback;
  }
  a89(value) {
    this.w88_1 = Duration__minus_impl_q5cfm7(value, this.x88_1);
  }
  b89() {
    return Duration__plus_impl_yu9v8f(this.w88_1, this.x88_1);
  }
  c89(other) {
    return Duration__compareTo_impl_pchp0f(this.b89(), other.b89());
  }
  d(other) {
    return this.c89(other instanceof TimedTask ? other : THROW_CCE());
  }
  u6() {
    this.y88_1 = false;
    this.v88_1.n89_1.z34(this);
  }
}
class BaseEventLoop {
  constructor() {
    this.w89_1 = new Lock();
  }
}
class SyncEventLoop extends BaseEventLoop {
  constructor(precise, immediateRun) {
    precise = precise === VOID ? false : precise;
    immediateRun = immediateRun === VOID ? false : immediateRun;
    super();
    this.e89_1 = precise;
    this.f89_1 = immediateRun;
    this.g89_1 = new SyncPauseable();
    this.h89_1 = paused$factory(this.g89_1);
    this.i89_1 = new Lock();
    this.j89_1 = true;
    this.k89_1 = Monotonic_instance.bk();
    var tmp = this;
    tmp.l89_1 = SyncEventLoop$nowProvider$lambda(this);
    this.m89_1 = ArrayDeque.jl();
    var tmp_0 = this;
    var tmp_1 = Companion_instance_0;
    tmp_0.n89_1 = tmp_1.b3a(VOID, SyncEventLoop$timedTasks$lambda);
    var tmp_2 = this;
    tmp_2.o89_1 = SyncEventLoop$uncatchedExceptionHandler$lambda;
    this.p89_1 = null;
  }
  q89(task) {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.i89_1;
      this_0.w1w();
      try {
        this.m89_1.ml(task);
        this.i89_1.c1x();
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
  }
  r89(time, task) {
    return _queueAfter(this, time, false, task);
  }
  u6() {
    var oldImmediateRun = this.f89_1;
    try {
      this.f89_1 = true;
      this.s89();
      this.j89_1 = false;
    }finally {
      this.f89_1 = oldImmediateRun;
    }
  }
  t89(task) {
    if (this.f89_1)
      return true;
    return Duration__compareTo_impl_pchp0f(_get_now__e6dlkr(this), this.n89_1.h3a().b89()) >= 0;
  }
  u89(runTimers) {
    var count = 0;
    while (this.v89(runTimers)) {
      count = count + 1 | 0;
    }
    return count;
  }
  s89(runTimers, $super) {
    runTimers = runTimers === VOID ? true : runTimers;
    return $super === VOID ? this.u89(runTimers) : $super.u89.call(this, runTimers);
  }
  v89(runTimers) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.i89_1;
      this_0.w1w();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp;
        if (runTimers) {
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.n89_1.a1()) {
            tmp_1 = this.t89(this.n89_1.h3a());
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = this.n89_1.i3a();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
        tmp$ret$2 = tmp;
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
    var timedTask = tmp$ret$2;
    if (!(timedTask == null)) {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
      try {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        timedTask.z88_1();
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.o89_1(e);
        } else {
          throw $p;
        }
      }
      if (timedTask.y88_1 && !this.f89_1) {
        timedTask.a89(maxOf(new Duration(Duration__plus_impl_yu9v8f(timedTask.b89(), timedTask.x88_1)), new Duration(_get_now__e6dlkr(this))).hk_1);
        this.n89_1.y34(timedTask);
      }
    }
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_1 = this.i89_1;
      this_1.w1w();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.m89_1.a1()) {
          tmp_2 = this.m89_1.nl();
        } else {
          tmp_2 = null;
        }
        tmp$ret$6 = tmp_2;
        break $l$block_0;
      }finally {
        this_1.z1w();
      }
    }
    var task = tmp$ret$6;
    // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      if (task == null)
        null;
      else
        task();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.o89_1(e_0);
      } else {
        throw $p;
      }
    }
    return !(task == null) || !(timedTask == null);
  }
}
class Listener {
  constructor(func, node, base) {
    this.x89_1 = func;
    this.y89_1 = node;
    this.z89_1 = base;
  }
  u6() {
    if (this.y89_1.b8a_1.n3(this)) {
      __updateChildListenerCount(this.z89_1, this.y89_1.a8a_1, -1);
    }
  }
  d8a() {
    this.y89_1.b8a_1.f(this);
    __updateChildListenerCount(this.z89_1, this.y89_1.a8a_1, 1);
  }
}
class ListenerNode {
  constructor(type) {
    this.a8a_1 = type;
    this.b8a_1 = FastArrayList.g14();
    this.c8a_1 = FastArrayList.g14();
  }
}
class EventListener {}
function onEvents(etypes, handler) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (etypes.length === 0) {
    // Inline function 'kotlin.error' call
    var message = 'Must have at least one event type';
    throw IllegalStateException.m5(toString(message));
  }
  var closeable = new CancellableGroup();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < etypes.length) {
    // Inline function 'korlibs.event.EventListener.onEvents.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = etypes[_unary__edvuaz];
    closeable.ku(this.k8a(it, handler));
  }
  return closeable;
}
function dispatch(type, event, result) {
  return this.m8a(type, event, result, true, true);
}
function dispatch$default(type, event, result, $super) {
  result = result === VOID ? null : result;
  return $super === VOID ? this.t8a(type, event, result) : dispatch(type, event, result);
}
function dispatchDown(type, event, result) {
  return this.m8a(type, event, result, false, true);
}
function dispatchUp(type, event, result) {
  return this.m8a(type, event, result, true, false);
}
function dispatch_0(event) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return this.u8a(event.b2n(), event);
}
class BaseEventListener {
  static i8a() {
    var $this = createThis(this);
    $this.e8a_1 = null;
    $this.f8a_1 = null;
    $this.g8a_1 = null;
    $this.h8a_1 = null;
    return $this;
  }
  n13(_set____db54di) {
    this.e8a_1 = _set____db54di;
  }
  o13() {
    return this.e8a_1;
  }
  j8a(other) {
    var tmp3_safe_receiver = this.f8a_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp3_safe_receiver, this, false);
    }
    this.f8a_1 = other;
    var tmp4_safe_receiver = this.f8a_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp4_safe_receiver, this, true);
    }
  }
  k8a(type, handler) {
    if (this.g8a_1 == null)
      this.g8a_1 = FastIdentityMap();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = ensureNotNull(this.g8a_1);
      var res = get_0(this_0, type);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
      var out = new ListenerNode(type);
      set(this_0, type, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    var lists = tmp instanceof ListenerNode ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_1 = new Listener(handler, lists, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
    this_1.d8a();
    return this_1;
  }
  l8a(type) {
    var tmp10_safe_receiver = this.g8a_1;
    var tmp = tmp10_safe_receiver == null ? null : get_0(tmp10_safe_receiver, type);
    return tmp instanceof ListenerNode ? tmp : null;
  }
  m8a(type, event, result, up, down) {
    var eventListenerCount = this.n8a(type);
    if (eventListenerCount <= 0)
      return false;
    if (down) {
      this.o8a(type, event, result);
    }
    var listeners = this.l8a(type);
    var tmp12_safe_receiver = listeners == null ? null : listeners.b8a_1;
    if (tmp12_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
      var temp = listeners.c8a_1;
      toFastList(tmp12_safe_receiver, temp);
      try {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = temp.e14_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array[_unary__edvuaz].x89_1(event);
          if (result == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            result.q8a_1 = result.q8a_1 + 1 | 0;
          }
        }
      }finally {
        temp.o3();
      }
    }
    if (up) {
      this.r8a(type, event, result);
    }
    if (result == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
      result.p8a_1 = result.p8a_1 + 1 | 0;
    }
    return event.s8a();
  }
  t8a(type, event, result) {
    return dispatch.call(this, type, event, result);
  }
  v8a(event) {
    return dispatch_0.call(this, event);
  }
  r8a(type, event, result) {
  }
  o8a(type, event, result) {
  }
  n8a(type) {
    var tmp15_safe_receiver = this.h8a_1;
    var tmp;
    if (tmp15_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.getNull' call
      tmp = type == null ? null : get_0(tmp15_safe_receiver, type);
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
}
class EventResult {
  constructor(iterationCount, resultCount) {
    iterationCount = iterationCount === VOID ? 0 : iterationCount;
    resultCount = resultCount === VOID ? 0 : resultCount;
    this.p8a_1 = iterationCount;
    this.q8a_1 = resultCount;
  }
  z33() {
    this.p8a_1 = 0;
    this.q8a_1 = 0;
  }
  toString() {
    return 'EventResult(iterationCount=' + this.p8a_1 + ', resultCount=' + this.q8a_1 + ')';
  }
  hashCode() {
    var result = this.p8a_1;
    result = imul(result, 31) + this.q8a_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventResult))
      return false;
    var tmp0_other_with_cast = other instanceof EventResult ? other : THROW_CCE();
    if (!(this.p8a_1 === tmp0_other_with_cast.p8a_1))
      return false;
    if (!(this.q8a_1 === tmp0_other_with_cast.q8a_1))
      return false;
    return true;
  }
}
class Companion {}
class Event {
  constructor() {
    this.c8b_1 = null;
    this.d8b_1 = false;
  }
  e8b(_set____db54di) {
    this.c8b_1 = _set____db54di;
  }
  f8b(reason) {
    throw StopPropagatingException.k8e(reason);
  }
  g8b(reason, $super) {
    reason = reason === VOID ? null : reason;
    var tmp;
    if ($super === VOID) {
      this.f8b(reason);
      tmp = Unit_instance;
    } else {
      tmp = $super.f8b.call(this, reason);
    }
    return tmp;
  }
  h8b(_set____db54di) {
    this.d8b_1 = _set____db54di;
  }
  s8a() {
    return this.d8b_1;
  }
  i8b(reason) {
    this.d8b_1 = true;
  }
  j8b(reason, $super) {
    reason = reason === VOID ? null : reason;
    var tmp;
    if ($super === VOID) {
      this.i8b(reason);
      tmp = Unit_instance;
    } else {
      tmp = $super.i8b.call(this, reason);
    }
    return tmp;
  }
}
class TypedEvent extends Event {
  constructor(type) {
    super();
    this.b8b_1 = type;
  }
  b2n() {
    return this.b8b_1;
  }
}
class PauseEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_8);
  }
}
class Companion_0 {}
class ResumeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_9);
  }
}
class Companion_1 {}
class StopEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_10);
  }
}
class Companion_2 {}
class DestroyEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_11);
  }
}
class RenderEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_20();
    super(Companion_getInstance_20());
    this.n8b_1 = true;
    this.o8b_1 = true;
  }
  toString() {
    return 'RenderEvent(update=' + this.n8b_1 + ', render=' + this.o8b_1 + ')';
  }
}
class Companion_3 extends RenderEvent {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
  }
}
class InitEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_21();
    super(Companion_getInstance_21());
  }
}
class Companion_4 extends InitEvent {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class Companion_5 {}
class DisposeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_14);
  }
}
class Companion_6 {}
class FullScreenEvent extends TypedEvent {
  constructor(fullscreen) {
    fullscreen = fullscreen === VOID ? false : fullscreen;
    super(Companion_instance_15);
    this.s8b_1 = fullscreen;
  }
  toString() {
    return 'FullScreenEvent(fullscreen=' + this.s8b_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.s8b_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this.s8b_1 === tmp0_other_with_cast.s8b_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ReshapeEvent extends TypedEvent {
  constructor(x, y, width, height) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    super(Companion_instance_16);
    this.w8b_1 = x;
    this.x8b_1 = y;
    this.y8b_1 = width;
    this.z8b_1 = height;
  }
  toString() {
    return 'ReshapeEvent(x=' + this.w8b_1 + ', y=' + this.x8b_1 + ', width=' + this.y8b_1 + ', height=' + this.z8b_1 + ')';
  }
  hashCode() {
    var result = this.w8b_1;
    result = imul(result, 31) + this.x8b_1 | 0;
    result = imul(result, 31) + this.y8b_1 | 0;
    result = imul(result, 31) + this.z8b_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this.w8b_1 === tmp0_other_with_cast.w8b_1))
      return false;
    if (!(this.x8b_1 === tmp0_other_with_cast.x8b_1))
      return false;
    if (!(this.y8b_1 === tmp0_other_with_cast.y8b_1))
      return false;
    if (!(this.z8b_1 === tmp0_other_with_cast.z8b_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_17 = this;
    this.a8c_1 = values();
  }
}
class Type extends Enum {}
class KeyEvent extends Event {
  constructor(type, id, key, keyCode, character, shift, ctrl, alt, meta, str) {
    type = type === VOID ? Type_UP_getInstance() : type;
    id = id === VOID ? 0 : id;
    key = key === VOID ? Key_UP_getInstance() : key;
    keyCode = keyCode === VOID ? 0 : keyCode;
    character = character === VOID ? _Char___init__impl__6a9atx(0) : character;
    shift = shift === VOID ? false : shift;
    ctrl = ctrl === VOID ? false : ctrl;
    alt = alt === VOID ? false : alt;
    meta = meta === VOID ? false : meta;
    str = str === VOID ? null : str;
    super();
    this.d8c_1 = type;
    this.e8c_1 = id;
    this.f8c_1 = key;
    this.g8c_1 = keyCode;
    this.h8c_1 = character;
    this.i8c_1 = shift;
    this.j8c_1 = ctrl;
    this.k8c_1 = alt;
    this.l8c_1 = meta;
    this.m8c_1 = str;
    this.n8c_1 = Companion_getInstance().ik_1;
  }
  b2n() {
    return this.d8c_1;
  }
  o8c() {
    var tmp0_elvis_lhs = this.m8c_1;
    return tmp0_elvis_lhs == null ? toString_0(this.h8c_1) : tmp0_elvis_lhs;
  }
  p8c() {
    return Companion_getInstance_3().uw().rw() ? this.l8c_1 : this.j8c_1;
  }
  toString() {
    return 'KeyEvent(type=' + toString(this.d8c_1) + ', id=' + this.e8c_1 + ', key=' + this.f8c_1.toString() + ', keyCode=' + this.g8c_1 + ', character=' + toString_0(this.h8c_1) + ', shift=' + this.i8c_1 + ', ctrl=' + this.j8c_1 + ', alt=' + this.k8c_1 + ', meta=' + this.l8c_1 + ', str=' + this.m8c_1 + ')';
  }
  hashCode() {
    var result = this.d8c_1.hashCode();
    result = imul(result, 31) + this.e8c_1 | 0;
    result = imul(result, 31) + this.f8c_1.hashCode() | 0;
    result = imul(result, 31) + this.g8c_1 | 0;
    result = imul(result, 31) + Char__hashCode_impl_otmys(this.h8c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i8c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j8c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k8c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l8c_1) | 0;
    result = imul(result, 31) + (this.m8c_1 == null ? 0 : getStringHashCode(this.m8c_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this.d8c_1.equals(tmp0_other_with_cast.d8c_1))
      return false;
    if (!(this.e8c_1 === tmp0_other_with_cast.e8c_1))
      return false;
    if (!this.f8c_1.equals(tmp0_other_with_cast.f8c_1))
      return false;
    if (!(this.g8c_1 === tmp0_other_with_cast.g8c_1))
      return false;
    if (!(this.h8c_1 === tmp0_other_with_cast.h8c_1))
      return false;
    if (!(this.i8c_1 === tmp0_other_with_cast.i8c_1))
      return false;
    if (!(this.j8c_1 === tmp0_other_with_cast.j8c_1))
      return false;
    if (!(this.k8c_1 === tmp0_other_with_cast.k8c_1))
      return false;
    if (!(this.l8c_1 === tmp0_other_with_cast.l8c_1))
      return false;
    if (!(this.m8c_1 == tmp0_other_with_cast.m8c_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_18 = this;
    this.q8c_1 = values_0();
  }
}
class Type_0 extends Enum {}
class ScrollDeltaMode extends Enum {
  constructor(name, ordinal, scale) {
    super(name, ordinal);
    this.t8c_1 = scale;
  }
  u8c(value, target) {
    return value * (this.t8c_1 / target.t8c_1);
  }
}
class MouseEvent extends Event {
  constructor(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, scrollDeltaMode) {
    type = type === VOID ? Type_MOVE_getInstance() : type;
    id = id === VOID ? 0 : id;
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    button = button === VOID ? MouseButton_NONE_getInstance() : button;
    buttons = buttons === VOID ? 0 : buttons;
    scrollDeltaX = scrollDeltaX === VOID ? 0.0 : scrollDeltaX;
    scrollDeltaY = scrollDeltaY === VOID ? 0.0 : scrollDeltaY;
    scrollDeltaZ = scrollDeltaZ === VOID ? 0.0 : scrollDeltaZ;
    isShiftDown = isShiftDown === VOID ? false : isShiftDown;
    isCtrlDown = isCtrlDown === VOID ? false : isCtrlDown;
    isAltDown = isAltDown === VOID ? false : isAltDown;
    isMetaDown = isMetaDown === VOID ? false : isMetaDown;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    scrollDeltaMode = scrollDeltaMode === VOID ? ScrollDeltaMode_LINE_getInstance() : scrollDeltaMode;
    super();
    this.x8c_1 = type;
    this.y8c_1 = id;
    this.z8c_1 = x;
    this.a8d_1 = y;
    this.b8d_1 = button;
    this.c8d_1 = buttons;
    this.d8d_1 = scrollDeltaX;
    this.e8d_1 = scrollDeltaY;
    this.f8d_1 = scrollDeltaZ;
    this.g8d_1 = isShiftDown;
    this.h8d_1 = isCtrlDown;
    this.i8d_1 = isAltDown;
    this.j8d_1 = isMetaDown;
    this.k8d_1 = scaleCoords;
    this.l8d_1 = emulated;
    this.m8d_1 = scrollDeltaMode;
    this.n8d_1 = null;
    var tmp = this;
    tmp.o8d_1 = MouseEvent$requestLock$lambda;
  }
  b2n() {
    return this.x8c_1;
  }
  p8d(other) {
    this.x8c_1 = other.x8c_1;
    this.y8c_1 = other.y8c_1;
    this.z8c_1 = other.z8c_1;
    this.a8d_1 = other.a8d_1;
    this.b8d_1 = other.b8d_1;
    this.c8d_1 = other.c8d_1;
    this.d8d_1 = other.d8d_1;
    this.e8d_1 = other.e8d_1;
    this.f8d_1 = other.f8d_1;
    this.g8d_1 = other.g8d_1;
    this.h8d_1 = other.h8d_1;
    this.i8d_1 = other.i8d_1;
    this.j8d_1 = other.j8d_1;
    this.k8d_1 = other.k8d_1;
    this.l8d_1 = other.l8d_1;
    this.m8d_1 = other.m8d_1;
  }
  q8d(mode) {
    return this.m8d_1.u8c(this.d8d_1, mode);
  }
  r8d(mode) {
    return this.m8d_1.u8c(this.e8d_1, mode);
  }
  s8d(mode, x, y, z) {
    this.m8d_1 = mode;
    this.d8d_1 = x;
    this.e8d_1 = y;
    this.f8d_1 = z;
  }
  toString() {
    return 'MouseEvent(type=' + toString(this.x8c_1) + ', id=' + this.y8c_1 + ', x=' + this.z8c_1 + ', y=' + this.a8d_1 + ', button=' + this.b8d_1.toString() + ', buttons=' + this.c8d_1 + ', scrollDeltaX=' + this.d8d_1 + ', scrollDeltaY=' + this.e8d_1 + ', scrollDeltaZ=' + this.f8d_1 + ', isShiftDown=' + this.g8d_1 + ', isCtrlDown=' + this.h8d_1 + ', isAltDown=' + this.i8d_1 + ', isMetaDown=' + this.j8d_1 + ', scaleCoords=' + this.k8d_1 + ', emulated=' + this.l8d_1 + ', scrollDeltaMode=' + this.m8d_1.toString() + ')';
  }
  hashCode() {
    var result = this.x8c_1.hashCode();
    result = imul(result, 31) + this.y8c_1 | 0;
    result = imul(result, 31) + this.z8c_1 | 0;
    result = imul(result, 31) + this.a8d_1 | 0;
    result = imul(result, 31) + this.b8d_1.hashCode() | 0;
    result = imul(result, 31) + this.c8d_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.d8d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e8d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f8d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g8d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h8d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i8d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j8d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k8d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l8d_1) | 0;
    result = imul(result, 31) + this.m8d_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent))
      return false;
    var tmp0_other_with_cast = other instanceof MouseEvent ? other : THROW_CCE();
    if (!this.x8c_1.equals(tmp0_other_with_cast.x8c_1))
      return false;
    if (!(this.y8c_1 === tmp0_other_with_cast.y8c_1))
      return false;
    if (!(this.z8c_1 === tmp0_other_with_cast.z8c_1))
      return false;
    if (!(this.a8d_1 === tmp0_other_with_cast.a8d_1))
      return false;
    if (!this.b8d_1.equals(tmp0_other_with_cast.b8d_1))
      return false;
    if (!(this.c8d_1 === tmp0_other_with_cast.c8d_1))
      return false;
    if (!equals(this.d8d_1, tmp0_other_with_cast.d8d_1))
      return false;
    if (!equals(this.e8d_1, tmp0_other_with_cast.e8d_1))
      return false;
    if (!equals(this.f8d_1, tmp0_other_with_cast.f8d_1))
      return false;
    if (!(this.g8d_1 === tmp0_other_with_cast.g8d_1))
      return false;
    if (!(this.h8d_1 === tmp0_other_with_cast.h8d_1))
      return false;
    if (!(this.i8d_1 === tmp0_other_with_cast.i8d_1))
      return false;
    if (!(this.j8d_1 === tmp0_other_with_cast.j8d_1))
      return false;
    if (!(this.k8d_1 === tmp0_other_with_cast.k8d_1))
      return false;
    if (!(this.l8d_1 === tmp0_other_with_cast.l8d_1))
      return false;
    if (!this.m8d_1.equals(tmp0_other_with_cast.m8d_1))
      return false;
    return true;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_19 = this;
    this.t8d_1 = values_1();
  }
}
class Type_1 extends Enum {}
class GestureEvent extends Event {
  constructor(type, id, amountX, amountY) {
    type = type === VOID ? Type_MAGNIFY_getInstance() : type;
    id = id === VOID ? 0 : id;
    amountX = amountX === VOID ? 0.0 : amountX;
    amountY = amountY === VOID ? 0.0 : amountY;
    super();
    this.w8d_1 = type;
    this.x8d_1 = id;
    this.y8d_1 = amountX;
    this.z8d_1 = amountY;
  }
  b2n() {
    return this.w8d_1;
  }
  a8e() {
    return this.y8d_1;
  }
  b8e(other) {
    this.w8d_1 = other.w8d_1;
    this.x8d_1 = other.x8d_1;
    this.y8d_1 = other.y8d_1;
    this.z8d_1 = other.z8d_1;
  }
  toString() {
    return 'GestureEvent(type=' + toString(this.w8d_1) + ', id=' + this.x8d_1 + ', amountX=' + this.y8d_1 + ', amountY=' + this.z8d_1 + ')';
  }
  hashCode() {
    var result = this.w8d_1.hashCode();
    result = imul(result, 31) + this.x8d_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.y8d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z8d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GestureEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GestureEvent ? other : THROW_CCE();
    if (!this.w8d_1.equals(tmp0_other_with_cast.w8d_1))
      return false;
    if (!(this.x8d_1 === tmp0_other_with_cast.x8d_1))
      return false;
    if (!equals(this.y8d_1, tmp0_other_with_cast.y8d_1))
      return false;
    if (!equals(this.z8d_1, tmp0_other_with_cast.z8d_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_20 = this;
    this.c8e_1 = values_2();
  }
}
class Type_2 extends Enum {}
class DropFileEvent extends Event {
  constructor(type, files) {
    type = type === VOID ? Type_START_getInstance() : type;
    files = files === VOID ? null : files;
    super();
    this.f8e_1 = type;
    this.g8e_1 = files;
  }
  b2n() {
    return this.f8e_1;
  }
  toString() {
    return 'DropFileEvent(type=' + toString(this.f8e_1) + ', files=' + toString_1(this.g8e_1) + ')';
  }
  hashCode() {
    var result = this.f8e_1.hashCode();
    result = imul(result, 31) + (this.g8e_1 == null ? 0 : hashCode(this.g8e_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this.f8e_1.equals(tmp0_other_with_cast.f8e_1))
      return false;
    if (!equals(this.g8e_1, tmp0_other_with_cast.g8e_1))
      return false;
    return true;
  }
}
class StopPropagatingException extends Exception {
  static k8e(reason) {
    reason = reason === VOID ? null : reason;
    var $this = this.te();
    captureStack($this, $this.j8e_1);
    $this.i8e_1 = reason;
    return $this;
  }
}
class Status extends Enum {}
class Kind extends Enum {}
class Companion_12 {
  constructor() {
    Companion_instance_21 = this;
    this.l8e_1 = new Touch(-1);
  }
}
class Touch {
  constructor(index, id, p, force, status, kind, button) {
    Companion_getInstance_29();
    index = index === VOID ? -1 : index;
    id = id === VOID ? -1 : id;
    p = p === VOID ? Companion_getInstance_5().a2i_1 : p;
    force = force === VOID ? 1.0 : force;
    status = status === VOID ? Status_KEEP_getInstance() : status;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    this.m8e_1 = new Mixin();
    this.n8e_1 = index;
    this.o8e_1 = id;
    this.p8e_1 = p;
    this.q8e_1 = force;
    this.r8e_1 = status;
    this.s8e_1 = kind;
    this.t8e_1 = button;
  }
  n13(_set____db54di) {
    this.m8e_1.n13(_set____db54di);
  }
  o13() {
    return this.m8e_1.o13();
  }
  n4f() {
    return this.p8e_1.i2h_1;
  }
  p4f() {
    return this.p8e_1.j2h_1;
  }
  d15() {
    return !this.r8e_1.equals(Status_REMOVE_getInstance());
  }
  u8e(other) {
    this.o8e_1 = other.o8e_1;
    this.p8e_1 = other.p8e_1;
    this.q8e_1 = other.q8e_1;
    this.r8e_1 = other.r8e_1;
    this.s8e_1 = other.s8e_1;
    this.t8e_1 = other.t8e_1;
  }
  hashCode() {
    return this.n8e_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Touch) {
      tmp = this.n8e_1 === other.n8e_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'Touch(index=' + this.n8e_1 + ', id=' + this.o8e_1 + ', p=' + this.p8e_1.toString() + ', force=' + this.q8e_1 + ', status=' + this.r8e_1.toString() + ', kind=' + this.s8e_1.toString() + ', button=' + this.t8e_1.toString() + ')';
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_22 = this;
    this.v8e_1 = values_3();
  }
}
class Type_3 extends Enum {}
class Companion_14 {
  constructor() {
    this.w8e_1 = 10;
  }
}
class TouchEvent extends Event {
  constructor(type, screen, currentTime, scaleCoords, emulated) {
    type = type === VOID ? Type_START_getInstance_0() : type;
    screen = screen === VOID ? 0 : screen;
    currentTime = currentTime === VOID ? Companion_getInstance_10().c1w_1 : currentTime;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    super();
    this.z8e_1 = type;
    this.a8f_1 = screen;
    this.b8f_1 = currentTime;
    this.c8f_1 = scaleCoords;
    this.d8f_1 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_instance_23.w8e_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new Touch(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.e8f_1 = tmp_2;
    this.f8f_1 = FastArrayList.g14();
    this.g8f_1 = FastArrayList.g14();
    this.h8f_1 = FastIntMap();
  }
  b2n() {
    return this.z8e_1;
  }
  i8f() {
    return this.f8f_1;
  }
  j8f() {
    return this.g8f_1;
  }
  k8f() {
    return this.i8f().j1();
  }
  l8f(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.h8f_1.get(id);
  }
  toString() {
    var tmp = toString(this.z8e_1);
    var tmp_0 = this.k8f();
    var tmp_1 = this.i8f();
    return 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString(tmp_1, ', ', VOID, VOID, VOID, VOID, TouchEvent$toString$lambda) + ')';
  }
  m8f(type) {
    this.z8e_1 = type;
    this.b8f_1 = Companion_getInstance_10().h1w();
    this.f8f_1.o3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.h8f_1.clear();
  }
  n8f() {
    this.g8f_1.o3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.i8f();
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.event.TouchEvent.endFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.i1(_unary__edvuaz);
      if (it.d15()) {
        this.g8f_1.f(it);
      }
    }
  }
  o8f(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.h8f_1.get(id);
    return tmp0_elvis_lhs == null ? this.p8f(id) : tmp0_elvis_lhs;
  }
  p8f(id) {
    var touch = this.e8f_1[this.f8f_1.j1()];
    touch.o8e_1 = id;
    this.f8f_1.f(touch);
    // Inline function 'korlibs.datastructure.set' call
    var this_0 = this.h8f_1;
    var key = touch.o8e_1;
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, touch);
    return touch;
  }
  q8f(id, p, status, force, kind, button) {
    var touch = this.o8f(id);
    touch.p8e_1 = p;
    touch.r8e_1 = status;
    touch.q8e_1 = force;
    touch.s8e_1 = kind;
    touch.t8e_1 = button;
  }
  r8f(id, p, status, force, kind, button, $super) {
    status = status === VOID ? Status_KEEP_getInstance() : status;
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.q8f(id, p, status, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.q8f.call(this, id, p, status, force, kind, button);
    }
    return tmp;
  }
  s8f(touch) {
    this.q8f(touch.o8e_1, touch.p8e_1, touch.r8e_1, touch.q8e_1, touch.s8e_1, touch.t8e_1);
  }
  t8f(other) {
    this.z8e_1 = other.z8e_1;
    this.a8f_1 = other.a8f_1;
    this.b8f_1 = other.b8f_1;
    this.c8f_1 = other.c8f_1;
    this.d8f_1 = other.d8f_1;
    var inductionVariable = 0;
    var last = Companion_instance_23.w8e_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.e8f_1[n].u8e(other.e8f_1[n]);
      }
       while (inductionVariable < last);
    this.f8f_1.o3();
    this.g8f_1.o3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.h8f_1.clear();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = other.i8f();
    var n_0 = 0;
    while (n_0 < this_0.j1()) {
      // Inline function 'korlibs.event.TouchEvent.copyFrom.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var otherTouch = this_0.i1(_unary__edvuaz);
      var touch = this.e8f_1[otherTouch.n8e_1];
      this.f8f_1.f(touch);
      if (touch.d15()) {
        this.g8f_1.f(touch);
      }
      // Inline function 'korlibs.datastructure.set' call
      var this_1 = this.h8f_1;
      var key = touch.o8e_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_1.set(key, touch);
    }
  }
  u8f() {
    return this.z8e_1.equals(Type_START_getInstance_0());
  }
  v8f() {
    return this.z8e_1.equals(Type_END_getInstance_0());
  }
  hashCode() {
    var result = this.z8e_1.hashCode();
    result = imul(result, 31) + this.a8f_1 | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.b8f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c8f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d8f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchEvent ? other : THROW_CCE();
    if (!this.z8e_1.equals(tmp0_other_with_cast.z8e_1))
      return false;
    if (!(this.a8f_1 === tmp0_other_with_cast.a8f_1))
      return false;
    if (!equals(this.b8f_1, tmp0_other_with_cast.b8f_1))
      return false;
    if (!(this.c8f_1 === tmp0_other_with_cast.c8f_1))
      return false;
    if (!(this.d8f_1 === tmp0_other_with_cast.d8f_1))
      return false;
    return true;
  }
}
class Mode extends Enum {}
class TouchBuilder {
  constructor() {
    this.w8f_1 = new TouchEvent();
    this.x8f_1 = new TouchEvent();
    this.y8f_1 = Mode_JS_getInstance();
  }
  z8f(type, scaleCoords) {
    this.x8f_1.c8f_1 = scaleCoords;
    this.x8f_1.m8f(type);
    if (this.y8f_1.v3_1 === 2) {
      this.x8f_1.t8f(this.w8f_1);
      this.x8f_1.z8e_1 = type;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var this_0 = this.x8f_1.f8f_1;
      var n = 0;
      var m = 0;
      while (n < this_0.j1()) {
        if (m >= 0 && !(m === n)) {
          this_0.p3(m, this_0.i1(n));
        }
        // Inline function 'korlibs.event.TouchBuilder.startFrame.<anonymous>' call
        var it = this_0.i1(n);
        var tmp;
        if (it.d15()) {
          it.r8e_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          // Inline function 'korlibs.datastructure.remove' call
          var this_1 = this.x8f_1.h8f_1;
          var key = it.o8e_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_1.delete(key);
          tmp = true;
        }
        if (tmp) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.j1() > m) {
        this_0.q3(this_0.j1() - 1 | 0);
      }
    }
  }
  a8g() {
    switch (this.y8f_1.v3_1) {
      case 0:
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var this_0 = this.w8f_1.i8f();
        var n = 0;
        while (n < this_0.j1()) {
          // Inline function 'korlibs.event.TouchBuilder.endFrame.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var oldTouch = this_0.i1(_unary__edvuaz);
          if (this.x8f_1.l8f(oldTouch.o8e_1) == null) {
            if (oldTouch.d15()) {
              oldTouch.r8e_1 = Status_REMOVE_getInstance();
              this.x8f_1.s8f(oldTouch);
            }
          }
        }

        break;
      case 2:
        break;
      default:
        break;
    }
    this.x8f_1.n8f();
    this.w8f_1.t8f(this.x8f_1);
    return this.x8f_1;
  }
  b8g(id, p, force, kind, button) {
    var touch = this.x8f_1.o8f(id);
    touch.p8e_1 = p;
    touch.q8e_1 = force;
    touch.s8e_1 = kind;
    touch.t8e_1 = button;
    if (this.y8f_1.v3_1 === 2) {
      var tmp = touch;
      switch (this.x8f_1.z8e_1.v3_1) {
        case 0:
          tmp.r8e_1 = Status_ADD_getInstance();
          break;
        case 1:
          tmp.r8e_1 = Status_REMOVE_getInstance();
          break;
        default:
          tmp.r8e_1 = Status_KEEP_getInstance();
          break;
      }
    } else {
      var oldTouch = this.w8f_1.l8f(id);
      touch.r8e_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  }
  c8g(id, p, force, kind, button, $super) {
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.b8g(id, p, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.b8g.call(this, id, p, force, kind, button);
    }
    return tmp;
  }
}
class GamepadInfoEmitter {
  constructor(dispatcher) {
    this.d8g_1 = dispatcher;
    this.e8g_1 = booleanArray(4);
    this.f8g_1 = new GamePadUpdateEvent();
    this.g8g_1 = new GamePadConnectionEvent();
    this.h8g_1 = IntArrayList.f31();
  }
  i8g() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.f8g_1.m8g_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateStart.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0[_unary__edvuaz].o8g_1 = false;
    }
    this.f8g_1.l8g_1 = 0;
  }
  u8g(info) {
    var _receiver__tnumb7 = this.f8g_1;
    var _unary__edvuaz = _receiver__tnumb7.l8g_1;
    _receiver__tnumb7.l8g_1 = _unary__edvuaz + 1 | 0;
    var index = _unary__edvuaz;
    var pad = this.f8g_1.m8g_1[index];
    pad.v8g(info);
    pad.o8g_1 = true;
    pad.n8g_1 = index;
  }
  w8g(out) {
    out.o3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.f8g_1.m8g_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0[_unary__edvuaz];
      if (!(this.e8g_1[it.n8g_1] === it.o8g_1)) {
        this.e8g_1[it.n8g_1] = it.o8g_1;
        out.l31(it.n8g_1);
        if (!it.o8g_1) {
          it.p8g_1 = null;
        }
        // Inline function 'kotlin.apply' call
        var this_1 = this.g8g_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>.<anonymous>' call
        this_1.z8g_1 = Companion_getInstance_34().c8h(it.o8g_1);
        this_1.a8h_1 = it.n8g_1;
        this.d8g_1.v8a(this_1);
      }
    }
    this.d8g_1.v8a(this.f8g_1);
    return out;
  }
}
class BatteryStatus extends Enum {}
class Companion_15 {
  constructor() {
    this.d8h_1 = 'Wireless Controller';
    this.e8h_1 = 4;
    this.f8h_1 = 0.075;
  }
  g8h(value, margin, apply) {
    var tmp;
    if (apply) {
      // Inline function 'kotlin.math.absoluteValue' call
      tmp = Math.abs(value) < margin;
    } else {
      tmp = false;
    }
    if (tmp)
      return 0.0;
    return value;
  }
  h8h(value, margin, apply, $super) {
    margin = margin === VOID ? 0.075 : margin;
    apply = apply === VOID ? true : apply;
    return $super === VOID ? this.g8h(value, margin, apply) : $super.g8h.call(this, value, margin, apply);
  }
}
class GamepadInfo {
  constructor(index, connected, name, rawButtons, batteryLevel, name2, batteryStatus) {
    index = index === VOID ? 0 : index;
    connected = connected === VOID ? false : connected;
    name = name === VOID ? null : name;
    rawButtons = rawButtons === VOID ? new Float32Array(32) : rawButtons;
    batteryLevel = batteryLevel === VOID ? 1.0 : batteryLevel;
    name2 = name2 === VOID ? Companion_instance_24.d8h_1 : name2;
    batteryStatus = batteryStatus === VOID ? BatteryStatus_UNKNOWN_getInstance() : batteryStatus;
    this.n8g_1 = index;
    this.o8g_1 = connected;
    this.p8g_1 = name;
    this.q8g_1 = rawButtons;
    this.r8g_1 = batteryLevel;
    this.s8g_1 = name2;
    this.t8g_1 = batteryStatus;
  }
  i8h() {
    var tmp0_elvis_lhs = this.p8g_1;
    return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' - ' + this.s8g_1;
  }
  v8g(that) {
    this.n8g_1 = that.n8g_1;
    this.p8g_1 = that.p8g_1;
    this.s8g_1 = that.s8g_1;
    this.o8g_1 = that.o8g_1;
    this.r8g_1 = that.r8g_1;
    this.t8g_1 = that.t8g_1;
    var tmp = that.q8g_1;
    var tmp_0 = this.q8g_1;
    // Inline function 'kotlin.math.min' call
    var a = this.q8g_1.length;
    var b = that.q8g_1.length;
    var tmp$ret$0 = Math.min(a, b);
    arraycopy(tmp, 0, tmp_0, 0, tmp$ret$0);
  }
  j8h(button) {
    return this.q8g_1[button.m8h()];
  }
  n8h(stick) {
    return Vector2D.u2n(this.o8h(stick), this.p8h(stick));
  }
  o8h(stick) {
    var tmp;
    switch (stick.v3_1) {
      case 0:
        tmp = this.j8h(GameButton_LX_getInstance());
        break;
      case 1:
        tmp = this.j8h(GameButton_RX_getInstance());
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  p8h(stick) {
    var tmp;
    switch (stick.v3_1) {
      case 0:
        tmp = this.j8h(GameButton_LY_getInstance());
        break;
      case 1:
        tmp = this.j8h(GameButton_RY_getInstance());
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  q8h(includeButtons) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.GamepadInfo.toStringEx.<anonymous>' call
    this_0.ic('Gamepad[' + this.n8g_1 + '][' + this.i8h() + ']');
    if (includeButtons) {
      this_0.ic('[');
      var count = 0;
      var indexedObject = values_5();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var value = this.j8h(button);
        if (!(value === 0.0)) {
          if (count > 0) {
            this_0.ic(',');
          }
          this_0.ic(button.toString() + '=' + get_niceStr(value));
          count = count + 1 | 0;
        }
      }
      this_0.ic(']');
    }
    return this_0.toString();
  }
  r8h(includeButtons, $super) {
    includeButtons = includeButtons === VOID ? true : includeButtons;
    return $super === VOID ? this.q8h(includeButtons) : $super.q8h.call(this, includeButtons);
  }
  toString() {
    return this.q8h(false);
  }
}
class Companion_16 {}
class GamePadUpdateEvent extends Event {
  constructor(gamepadsLength, gamepads) {
    gamepadsLength = gamepadsLength === VOID ? 0 : gamepadsLength;
    var tmp;
    if (gamepads === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(4), null);
      while (tmp_0 < 4) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = new GamepadInfo(tmp_2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = gamepads;
    }
    gamepads = tmp;
    super();
    this.l8g_1 = gamepadsLength;
    this.m8g_1 = gamepads;
  }
  b2n() {
    return Companion_instance_25;
  }
  s8h(that) {
    this.l8g_1 = that.l8g_1;
    var inductionVariable = 0;
    var last = this.m8g_1.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.m8g_1[n].v8g(that.m8g_1[n]);
      }
       while (inductionVariable < last);
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.m8g_1;
    var destination = ArrayList.m1();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      if (element.o8g_1) {
        destination.f(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      var tmp$ret$3 = item.r8h();
      destination_0.f(tmp$ret$3);
    }
    return 'GamePadUpdateEvent(' + toString(destination_0) + ')';
  }
  hashCode() {
    var result = this.l8g_1;
    result = imul(result, 31) + hashCode(this.m8g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this.l8g_1 === tmp0_other_with_cast.l8g_1))
      return false;
    if (!equals(this.m8g_1, tmp0_other_with_cast.m8g_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_26 = this;
    this.b8h_1 = values_4();
  }
  c8h(connected) {
    return connected ? Type_CONNECTED_getInstance() : Type_DISCONNECTED_getInstance();
  }
}
class Type_4 extends Enum {}
class GamePadConnectionEvent extends Event {
  constructor(type, gamepad) {
    type = type === VOID ? Type_CONNECTED_getInstance() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    super();
    this.z8g_1 = type;
    this.a8h_1 = gamepad;
  }
  b2n() {
    return this.z8g_1;
  }
  toString() {
    return 'GamePadConnectionEvent(type=' + toString(this.z8g_1) + ', gamepad=' + this.a8h_1 + ')';
  }
  hashCode() {
    var result = this.z8g_1.hashCode();
    result = imul(result, 31) + this.a8h_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this.z8g_1.equals(tmp0_other_with_cast.z8g_1))
      return false;
    if (!(this.a8h_1 === tmp0_other_with_cast.a8h_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_27 = this;
    this.t8h_1 = values_5();
    this.u8h_1 = 32;
  }
}
class GameButton extends Enum {
  m8h() {
    return this.v3_1;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_28 = this;
    this.v8h_1 = values_6();
  }
}
class GameStick extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.y8h_1 = id;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_29 = this;
    this.z8h_1 = Key_UNKNOWN_getInstance().v3_1 + 1 | 0;
    this.a8i_1 = Key_ENTER_getInstance();
    this.b8i_1 = Key_N0_getInstance();
    this.c8i_1 = Key_N1_getInstance();
    this.d8i_1 = Key_N2_getInstance();
    this.e8i_1 = Key_N3_getInstance();
    this.f8i_1 = Key_N4_getInstance();
    this.g8i_1 = Key_N5_getInstance();
    this.h8i_1 = Key_N6_getInstance();
    this.i8i_1 = Key_N7_getInstance();
    this.j8i_1 = Key_N8_getInstance();
    this.k8i_1 = Key_N9_getInstance();
  }
  l8i() {
    return Key_CONTROL_getInstance();
  }
  m8i() {
    return Key_CONTROL_getInstance();
  }
  n8i() {
    return Key_SHIFT_getInstance();
  }
  o8i() {
    return Key_SHIFT_getInstance();
  }
  p8i() {
    return Key_ALT_getInstance();
  }
  q8i() {
    return Key_ALT_getInstance();
  }
  r8i() {
    return Key_SUPER_getInstance();
  }
  s8i() {
    return Key_SUPER_getInstance();
  }
}
class Key extends Enum {
  v8i() {
    switch (this.v3_1) {
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
        return true;
      default:
        return false;
    }
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_30 = this;
    this.w8i_1 = MouseButton_NONE_getInstance().v3_1 + 1 | 0;
    this.x8i_1 = values_7();
  }
  i1(id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.x8i_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= id ? id <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[id];
    } else {
      // Inline function 'korlibs.event.Companion.get.<anonymous>' call
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  }
}
class MouseButton extends Enum {
  constructor(name, ordinal, id, bits) {
    bits = bits === VOID ? 1 << id : bits;
    super(name, ordinal);
    this.a8j_1 = id;
    this.b8j_1 = bits;
  }
}
class ISoftKeyboardConfig {}
class SoftKeyboardType extends Enum {}
class SoftKeyboardReturnKeyType extends Enum {}
class SoftKeyboardConfig {
  constructor(softKeyboardType, softKeyboardSmartDashes, softKeyboardSmartQuotes, softKeyboardSpellChecking, softKeyboardTextContentType, softKeyboardSmartInsertDelete, softKeyboardPassword, softKeyboardReturnKeyType, softKeyboardAutocapitalization, softKeyboardAutocorrection, softKeyboardEnablesReturnKeyAutomatically) {
    softKeyboardType = softKeyboardType === VOID ? SoftKeyboardType_DEFAULT_getInstance() : softKeyboardType;
    softKeyboardSmartDashes = softKeyboardSmartDashes === VOID ? null : softKeyboardSmartDashes;
    softKeyboardSmartQuotes = softKeyboardSmartQuotes === VOID ? null : softKeyboardSmartQuotes;
    softKeyboardSpellChecking = softKeyboardSpellChecking === VOID ? null : softKeyboardSpellChecking;
    softKeyboardTextContentType = softKeyboardTextContentType === VOID ? null : softKeyboardTextContentType;
    softKeyboardSmartInsertDelete = softKeyboardSmartInsertDelete === VOID ? null : softKeyboardSmartInsertDelete;
    softKeyboardPassword = softKeyboardPassword === VOID ? false : softKeyboardPassword;
    softKeyboardReturnKeyType = softKeyboardReturnKeyType === VOID ? SoftKeyboardReturnKeyType_DEFAULT_getInstance() : softKeyboardReturnKeyType;
    softKeyboardAutocapitalization = softKeyboardAutocapitalization === VOID ? null : softKeyboardAutocapitalization;
    softKeyboardAutocorrection = softKeyboardAutocorrection === VOID ? null : softKeyboardAutocorrection;
    softKeyboardEnablesReturnKeyAutomatically = softKeyboardEnablesReturnKeyAutomatically === VOID ? false : softKeyboardEnablesReturnKeyAutomatically;
    this.c8j_1 = softKeyboardType;
    this.d8j_1 = softKeyboardSmartDashes;
    this.e8j_1 = softKeyboardSmartQuotes;
    this.f8j_1 = softKeyboardSpellChecking;
    this.g8j_1 = softKeyboardTextContentType;
    this.h8j_1 = softKeyboardSmartInsertDelete;
    this.i8j_1 = softKeyboardPassword;
    this.j8j_1 = softKeyboardReturnKeyType;
    this.k8j_1 = softKeyboardAutocapitalization;
    this.l8j_1 = softKeyboardAutocorrection;
    this.m8j_1 = softKeyboardEnablesReturnKeyAutomatically;
  }
  toString() {
    return 'SoftKeyboardConfig(softKeyboardType=' + this.c8j_1.toString() + ', softKeyboardSmartDashes=' + this.d8j_1 + ', softKeyboardSmartQuotes=' + this.e8j_1 + ', softKeyboardSpellChecking=' + this.f8j_1 + ', softKeyboardTextContentType=' + this.g8j_1 + ', softKeyboardSmartInsertDelete=' + this.h8j_1 + ', softKeyboardPassword=' + this.i8j_1 + ', softKeyboardReturnKeyType=' + this.j8j_1.toString() + ', softKeyboardAutocapitalization=' + this.k8j_1 + ', softKeyboardAutocorrection=' + this.l8j_1 + ', softKeyboardEnablesReturnKeyAutomatically=' + this.m8j_1 + ')';
  }
  hashCode() {
    var result = this.c8j_1.hashCode();
    result = imul(result, 31) + (this.d8j_1 == null ? 0 : getBooleanHashCode(this.d8j_1)) | 0;
    result = imul(result, 31) + (this.e8j_1 == null ? 0 : getBooleanHashCode(this.e8j_1)) | 0;
    result = imul(result, 31) + (this.f8j_1 == null ? 0 : getBooleanHashCode(this.f8j_1)) | 0;
    result = imul(result, 31) + (this.g8j_1 == null ? 0 : getStringHashCode(this.g8j_1)) | 0;
    result = imul(result, 31) + (this.h8j_1 == null ? 0 : getBooleanHashCode(this.h8j_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i8j_1) | 0;
    result = imul(result, 31) + this.j8j_1.hashCode() | 0;
    result = imul(result, 31) + (this.k8j_1 == null ? 0 : getBooleanHashCode(this.k8j_1)) | 0;
    result = imul(result, 31) + (this.l8j_1 == null ? 0 : getBooleanHashCode(this.l8j_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m8j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoftKeyboardConfig))
      return false;
    var tmp0_other_with_cast = other instanceof SoftKeyboardConfig ? other : THROW_CCE();
    if (!this.c8j_1.equals(tmp0_other_with_cast.c8j_1))
      return false;
    if (!(this.d8j_1 == tmp0_other_with_cast.d8j_1))
      return false;
    if (!(this.e8j_1 == tmp0_other_with_cast.e8j_1))
      return false;
    if (!(this.f8j_1 == tmp0_other_with_cast.f8j_1))
      return false;
    if (!(this.g8j_1 == tmp0_other_with_cast.g8j_1))
      return false;
    if (!(this.h8j_1 == tmp0_other_with_cast.h8j_1))
      return false;
    if (!(this.i8j_1 === tmp0_other_with_cast.i8j_1))
      return false;
    if (!this.j8j_1.equals(tmp0_other_with_cast.j8j_1))
      return false;
    if (!(this.k8j_1 == tmp0_other_with_cast.k8j_1))
      return false;
    if (!(this.l8j_1 == tmp0_other_with_cast.l8j_1))
      return false;
    if (!(this.m8j_1 === tmp0_other_with_cast.m8j_1))
      return false;
    return true;
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_31 = this;
    this.n8j_1 = Companion_getInstance_2().ez('AG');
    this.o8j_1 = 96.0;
  }
}
class AGFeatures {}
function get_parentFeatures() {
  return null;
}
function get_graphicExtensions() {
  return emptySet();
}
function get_isInstancedSupported() {
  var tmp41_safe_receiver = this.o8k();
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver.q8k();
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function get_isUniformBuffersSupported() {
  var tmp42_safe_receiver = this.o8k();
  var tmp0_elvis_lhs = tmp42_safe_receiver == null ? null : tmp42_safe_receiver.r8k();
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function get_isVertexArraysSupported() {
  var tmp43_safe_receiver = this.o8k();
  var tmp0_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.s8k();
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function get_isFloatTextureSupported() {
  var tmp45_safe_receiver = this.o8k();
  var tmp0_elvis_lhs = tmp45_safe_receiver == null ? null : tmp45_safe_receiver.t8k();
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
class AG {
  constructor() {
    Companion_getInstance_39();
    this.p8j_1 = new Mixin();
    this.q8j_1 = AGFrameBuffer.g8k(true);
    this.r8j_1 = 0;
    this.s8j_1 = new AGStats();
  }
  n13(_set____db54di) {
    this.p8j_1.n13(_set____db54di);
  }
  o13() {
    return this.p8j_1.o13();
  }
  h8k() {
    return this.q8j_1;
  }
  i8k() {
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_39().n8j_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      this_0.v3g(level, this);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_39().n8j_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.u3g(level_0)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      var tmp$ret$2 = 'AG.contextLost()';
      this_1.v3g(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    this.r8j_1 = this.r8j_1 + 1 | 0;
  }
  j8k() {
    return this.k8k(AGFinish_instance);
  }
  l8k() {
    return Unit_instance;
  }
  n8f() {
    return Unit_instance;
  }
  k8k(command) {
    return Unit_instance;
  }
  m8k(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    return this.k8k(new AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil));
  }
  n8k(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    return this.k8k(new AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances));
  }
}
class Immutable {
  constructor(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.d8m_1 = parentFeatures;
    this.e8m_1 = graphicExtensions;
    this.f8m_1 = isInstancedSupported;
    this.g8m_1 = isUniformBuffersSupported;
    this.h8m_1 = isVertexArraysSupported;
    this.i8m_1 = isStorageMultisampleSupported;
    this.j8m_1 = isFloatTextureSupported;
  }
  o8k() {
    return this.d8m_1;
  }
  q8k() {
    return this.f8m_1;
  }
  r8k() {
    return this.g8m_1;
  }
  s8k() {
    return this.h8m_1;
  }
  t8k() {
    return this.j8m_1;
  }
  toString() {
    return 'Immutable(parentFeatures=' + toString_1(this.d8m_1) + ', graphicExtensions=' + toString(this.e8m_1) + ', isInstancedSupported=' + this.f8m_1 + ', isUniformBuffersSupported=' + this.g8m_1 + ', isVertexArraysSupported=' + this.h8m_1 + ', isStorageMultisampleSupported=' + this.i8m_1 + ', isFloatTextureSupported=' + this.j8m_1 + ')';
  }
  hashCode() {
    var result = this.d8m_1 == null ? 0 : hashCode(this.d8m_1);
    result = imul(result, 31) + hashCode(this.e8m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f8m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g8m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h8m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i8m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j8m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable))
      return false;
    var tmp0_other_with_cast = other instanceof Immutable ? other : THROW_CCE();
    if (!equals(this.d8m_1, tmp0_other_with_cast.d8m_1))
      return false;
    if (!equals(this.e8m_1, tmp0_other_with_cast.e8m_1))
      return false;
    if (!(this.f8m_1 === tmp0_other_with_cast.f8m_1))
      return false;
    if (!(this.g8m_1 === tmp0_other_with_cast.g8m_1))
      return false;
    if (!(this.h8m_1 === tmp0_other_with_cast.h8m_1))
      return false;
    if (!(this.i8m_1 === tmp0_other_with_cast.i8m_1))
      return false;
    if (!(this.j8m_1 === tmp0_other_with_cast.j8m_1))
      return false;
    return true;
  }
}
class Mutable {
  constructor(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.k8m_1 = parentFeatures;
    this.l8m_1 = graphicExtensions;
    this.m8m_1 = isInstancedSupported;
    this.n8m_1 = isUniformBuffersSupported;
    this.o8m_1 = isVertexArraysSupported;
    this.p8m_1 = isStorageMultisampleSupported;
    this.q8m_1 = isFloatTextureSupported;
  }
  o8k() {
    return this.k8m_1;
  }
  q8k() {
    return this.m8m_1;
  }
  r8k() {
    return this.n8m_1;
  }
  s8k() {
    return this.o8m_1;
  }
  t8k() {
    return this.q8m_1;
  }
}
class AGObject {
  constructor() {
    this.w8n_1 = null;
    this.x8n_1 = -1;
    this.y8n_1 = -2;
    this.z8n_1 = -1;
  }
  b8o() {
    this.a8o();
    this.y8n_1 = this.z8n_1 - 1 | 0;
  }
  a8o() {
    this.z8n_1 = this.z8n_1 + 1 | 0;
  }
  u6() {
    var tmp46_safe_receiver = this.w8n_1;
    if (tmp46_safe_receiver == null)
      null;
    else {
      tmp46_safe_receiver.f8r();
    }
    this.w8n_1 = null;
  }
}
class AGBuffer extends AGObject {
  constructor() {
    super();
    this.q8n_1 = null;
  }
  r8n(data, offset, length) {
    return this.s8n(_Int8Buffer___get_buffer__impl__q0gulb(_Int8Buffer___init__impl__e20lvc(data, offset, length)));
  }
  t8n(data, offset, length) {
    return this.s8n(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(data, offset, length)));
  }
  u8n(data, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? data.length - offset | 0 : length;
    return $super === VOID ? this.t8n(data, offset, length) : $super.t8n.call(this, data, offset, length);
  }
  v8n(data, offset, length) {
    return this.s8n(sliceWithSize(data, offset, length));
  }
  s8n(data) {
    if (data.y10() < 1024) {
      if (!(this.q8n_1 == null) && ensureNotNull(this.q8n_1).y10() === data.y10() && arrayequal(ensureNotNull(this.q8n_1), 0, data, 0, data.y10()))
        return this;
    }
    this.q8n_1 = clone(data);
    this.a8o();
    return this;
  }
  toString() {
    var tmp48_safe_receiver = this.q8n_1;
    var tmp0_elvis_lhs = tmp48_safe_receiver == null ? null : tmp48_safe_receiver.y10();
    return 'AGBuffer(' + (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) + ')';
  }
}
class Companion_23 {
  constructor() {
    this.f8l_1 = 8;
  }
  g8l() {
    return AGTextureUnits.e8o();
  }
}
class AGTextureUnits {
  static f8o(textures, infos) {
    var $this = createThis(this);
    $this.c8o_1 = textures;
    $this.d8o_1 = infos;
    return $this;
  }
  static e8o(size) {
    size = size === VOID ? Companion_instance_32.f8l_1 : size;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    return this.f8o(tmp$ret$0, _AGTextureUnitInfoArray___init__impl__c77rdb_0(size));
  }
  j1() {
    return this.c8o_1.length;
  }
  g8o(other, sampler) {
    return this.u8o(other, sampler.s8o_1);
  }
  u8o(other, index) {
    return this.v8o(index, other.c8o_1[index], AGTextureUnitInfoArray__get_impl_xhvpef(other.d8o_1, index));
  }
  v8o(index, texture, info) {
    this.c8o_1[index] = texture;
    AGTextureUnitInfoArray__set_impl_s95rfh(this.d8o_1, index, info);
  }
  w8o(index, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_42().y8o_1 : info;
    var tmp;
    if ($super === VOID) {
      this.v8o(index, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.v8o.call(this, index, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  z8o(sampler, texture, info) {
    this.v8o(sampler.s8o_1, texture, info);
  }
  a8p(sampler, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_42().y8o_1 : info;
    var tmp;
    if ($super === VOID) {
      this.z8o(sampler, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.z8o.call(this, sampler, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  o3() {
    var inductionVariable = 0;
    var last = this.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.v8o(n, null, Companion_getInstance_42().y8o_1);
      }
       while (inductionVariable < last);
  }
  j13() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.c8o_1.slice();
    return AGTextureUnits.f8o(tmp$ret$1, AGTextureUnitInfoArray__copyOf_impl_z2w8z3(this.d8o_1));
  }
  toString() {
    return 'AGTextureUnits(textures=' + toString(this.c8o_1) + ', infos=' + AGTextureUnitInfoArray__toString_impl_kr9cgh(this.d8o_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.c8o_1);
    result = imul(result, 31) + AGTextureUnitInfoArray__hashCode_impl_siosps(this.d8o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGTextureUnits))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnits ? other : THROW_CCE();
    if (!equals(this.c8o_1, tmp0_other_with_cast.c8o_1))
      return false;
    if (!equals(this.d8o_1, tmp0_other_with_cast.d8o_1))
      return false;
    return true;
  }
}
class Companion_24 {
  constructor() {
    this.b8p_1 = 128;
    this.c8p_1 = 128;
  }
}
class AGFrameBuffer {
  static d8p(base, id) {
    id = id === VOID ? -1 : id;
    var $this = createThis(this);
    $this.t8j_1 = base;
    $this.u8j_1 = id;
    $this.v8j_1 = 1;
    $this.w8j_1 = true;
    $this.x8j_1 = true;
    $this.y8j_1 = 0;
    $this.z8j_1 = 0;
    $this.a8k_1 = 128;
    $this.b8k_1 = 128;
    $this.c8k_1 = 128;
    $this.d8k_1 = 128;
    $this.e8k_1 = RectangleInt.w2u();
    $this.f8k_1 = null;
    return $this;
  }
  static g8k(isMain, id) {
    isMain = isMain === VOID ? false : isMain;
    id = id === VOID ? -1 : id;
    return this.d8p(new AGFrameBufferBase(isMain), id);
  }
  e8p() {
    return this.t8j_1.e8p();
  }
  m8p() {
    return this.t8j_1.j8p_1;
  }
  n8p() {
    return this.t8j_1.k8p_1;
  }
  c8m() {
    return AGFrameBufferInfo__withHasStencil_impl_nbaemo(AGFrameBufferInfo__withHasDepth_impl_fjgbiv(AGFrameBufferInfo__withSamples_impl_83818f(AGFrameBufferInfo__withBounds_impl_sg0n3x(_AGFrameBufferInfo___init__impl__dbxiro(new Long(0, 0)), this.y8j_1, this.z8j_1, this.a8k_1, this.b8k_1), this.v8j_1), this.x8j_1), this.w8j_1);
  }
  o8p(width, height) {
    return this.p8p(0, 0, width, height);
  }
  q8p(x, y, width, height, fullWidth, fullHeight) {
    if (this.y8j_1 === x && this.z8j_1 === y && this.a8k_1 === width && this.b8k_1 === height && this.c8k_1 === fullWidth && this.d8k_1 === fullHeight)
      return true;
    this.n8p().f8q(NullBitmap.m56(width, height));
    this.t8j_1.l8p_1 = Companion_getInstance_11().b13(imul(imul(fullWidth, fullHeight), 8));
    this.y8j_1 = x;
    this.z8j_1 = y;
    this.a8k_1 = width;
    this.b8k_1 = height;
    this.c8k_1 = fullWidth;
    this.d8k_1 = fullHeight;
    markAsDirty(this);
    return false;
  }
  p8p(x, y, width, height, fullWidth, fullHeight, $super) {
    fullWidth = fullWidth === VOID ? width : fullWidth;
    fullHeight = fullHeight === VOID ? height : fullHeight;
    return $super === VOID ? this.q8p(x, y, width, height, fullWidth, fullHeight) : $super.q8p.call(this, x, y, width, height, fullWidth, fullHeight);
  }
  u6() {
    this.t8j_1.u6();
  }
  g8q(samples) {
    if (this.v8j_1 === samples)
      return Unit_instance;
    this.v8j_1 = samples;
    markAsDirty(this);
  }
  h8q(hasDepth, hasStencil) {
    if (this.x8j_1 === hasDepth && this.w8j_1 === hasStencil)
      return Unit_instance;
    this.x8j_1 = hasDepth;
    this.w8j_1 = hasStencil;
    markAsDirty(this);
  }
  toString() {
    return 'AGFrameBuffer(' + (this.m8p() ? 'main' : '' + this.u8j_1) + ', ' + this.a8k_1 + ', ' + this.b8k_1 + ')';
  }
}
class AGTexture extends AGObject {
  constructor(targetKind) {
    targetKind = targetKind === VOID ? Companion_getInstance_53().i8q_1 : targetKind;
    super();
    this.v8p_1 = targetKind;
    this.w8p_1 = Companion_getInstance_2().ez('AGTexture');
    this.x8p_1 = false;
    this.y8p_1 = false;
    this.z8p_1 = null;
    this.a8q_1 = null;
    this.b8q_1 = null;
    this.c8q_1 = false;
    this.d8q_1 = null;
    this.e8q_1 = Companion_getInstance_11().c13(new Long(0, 0));
  }
  m8q() {
    var tmp50_safe_receiver = this.d8q_1;
    var tmp51_safe_receiver = tmp50_safe_receiver == null ? null : tmp50_safe_receiver.l54();
    var tmp;
    if (tmp51_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.AGTexture.<get-implForcedTexTarget>.<anonymous>' call
      tmp = fromGl(Companion_getInstance_53(), tmp51_safe_receiver);
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new AGTextureTargetKind(tmp_1)) == null) {
      tmp_0 = this.v8p_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  j2y() {
    var tmp52_safe_receiver = this.b8q_1;
    var tmp0_elvis_lhs = tmp52_safe_receiver == null ? null : tmp52_safe_receiver.j2y();
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  k2y() {
    var tmp53_safe_receiver = this.b8q_1;
    var tmp0_elvis_lhs = tmp53_safe_receiver == null ? null : tmp53_safe_receiver.k2y();
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  o8q() {
    var tmp = this.b8q_1;
    var tmp54_safe_receiver = (tmp == null ? true : tmp instanceof MultiBitmap) ? tmp : null;
    var tmp55_safe_receiver = tmp54_safe_receiver == null ? null : tmp54_safe_receiver.c8r_1;
    var tmp0_elvis_lhs = tmp55_safe_receiver == null ? null : tmp55_safe_receiver.j1();
    return tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
  }
  d8r(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    if (bmp == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      checkBitmaps(this, bmp);
    }
    var tmp = this;
    tmp.d8q_1 = (bmp == null ? true : isInterface(bmp, ForcedTexId)) ? bmp : null;
    this.b8q_1 = bmp;
    this.e8q_1 = Companion_getInstance_11().b13(imul(imul(imul(this.j2y(), this.k2y()), this.o8q()), 4));
    this.a8o();
    this.y8p_1 = mipmaps;
    this.z8p_1 = baseMipmapLevel;
    this.a8q_1 = maxMipmapLevel;
    return this;
  }
  f8q(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel, $super) {
    mipmaps = mipmaps === VOID ? false : mipmaps;
    baseMipmapLevel = baseMipmapLevel === VOID ? null : baseMipmapLevel;
    maxMipmapLevel = maxMipmapLevel === VOID ? null : maxMipmapLevel;
    return $super === VOID ? this.d8r(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) : $super.d8r.call(this, bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  e8r(bitmap, requestMipmaps) {
    var tmp0_elvis_lhs = bitmap == null ? null : bitmap.j2y();
    var width = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = bitmap == null ? null : bitmap.k2y();
    var height = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return requestMipmaps && get_isPowerOfTwo(width) && get_isPowerOfTwo(height);
  }
  toString() {
    return 'AGTexture(size=' + this.j2y() + ',' + this.k2y() + ')';
  }
}
class AGFrameBufferBase extends AGObject {
  constructor(isMain) {
    super();
    this.j8p_1 = isMain;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new AGTexture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGFrameBufferBase.tex.<anonymous>' call
    this_0.x8p_1 = true;
    tmp.k8p_1 = this_0;
    this.l8p_1 = Companion_getInstance_11().b13(0);
  }
  e8p() {
    return !this.j8p_1;
  }
  u6() {
    this.k8p_1.u6();
  }
  toString() {
    return 'AGFrameBufferBase(isMain=' + this.j8p_1 + ')';
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_34 = this;
    this.x8o_1 = _AGTextureUnitInfo___init__impl__s1tthu(-1);
    this.y8o_1 = AGTextureUnitInfo__withKind_impl_aa0b04(AGTextureUnitInfo__withWrap_impl_akwb6y(AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(_AGTextureUnitInfo___init__impl__s1tthu(0), true, true), Companion_getInstance_54().h8r_1), Companion_getInstance_53().i8q_1);
  }
  g8r(data) {
    return _AGTextureUnitInfo___init__impl__s1tthu(data);
  }
  k8r(wrap, linear, trilinear) {
    return AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(AGTextureUnitInfo__withWrap_impl_akwb6y(_AGTextureUnitInfo___init__impl__s1tthu(0), wrap), linear, trilinear);
  }
  l8r(wrap, linear, trilinear, $super) {
    wrap = wrap === VOID ? Companion_getInstance_54().h8r_1 : wrap;
    linear = linear === VOID ? true : linear;
    trilinear = trilinear === VOID ? linear : trilinear;
    return $super === VOID ? this.k8r(wrap, linear, trilinear) : $super.k8r.call(this, new AGWrapMode(wrap), linear, trilinear).m8r_1;
  }
}
class AGTextureUnitInfo {
  constructor(data) {
    Companion_getInstance_42();
    this.m8r_1 = data;
  }
  toString() {
    return AGTextureUnitInfo__toString_impl_7im6je(this.m8r_1);
  }
  hashCode() {
    return AGTextureUnitInfo__hashCode_impl_e8jq9h(this.m8r_1);
  }
  equals(other) {
    return AGTextureUnitInfo__equals_impl_j2jlgn(this.m8r_1, other);
  }
}
class AGNativeObject {}
class BufferCache {
  constructor() {
    this.n8r_1 = FastIdentityMap();
  }
  z33() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.n8r_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.reset.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).z33();
    }
  }
  w8r() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.n8r_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.uploadUpdatedBuffers.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).x8r();
    }
  }
  y8r(block) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.n8r_1;
      var res = get_0(this_0, block);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.BufferCache.get.<anonymous>' call
      var out = new UniformBlockBuffer(block);
      set(this_0, block, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    return tmp instanceof UniformBlockBuffer ? tmp : THROW_CCE();
  }
}
class AGProgramWithUniforms {
  constructor(program, bufferCache) {
    bufferCache = bufferCache === VOID ? new BufferCache() : bufferCache;
    this.z8r_1 = program;
    this.a8s_1 = bufferCache;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.z8r_1.m8s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformLayouts.<anonymous>' call
      var tmp$ret$0 = item.g8t_1;
      destination.f(tmp$ret$0);
    }
    tmp.b8s_1 = distinct(destination);
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.b8s_1.f1();
      if (!iterator.g1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
      var maxValue = iterator.h1().i8t_1 + 1 | 0;
      while (iterator.g1()) {
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
        var v = iterator.h1().i8t_1 + 1 | 0;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.c8s_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var tmp_2 = 0;
    var tmp_3 = this.c8s_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocks.<anonymous>' call
    var _iterator__ex2g4s = this.b8s_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var layout = _iterator__ex2g4s.h1();
      tmp_4[layout.i8t_1] = layout;
    }
    tmp_1.d8s_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this.d8s_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_8 = fillArrayVal(Array(tmp_7), null);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      var tmp60_safe_receiver = this.d8s_1[tmp_9];
      var tmp_10;
      if (tmp60_safe_receiver == null) {
        tmp_10 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocksData.<anonymous>' call
        tmp_10 = this.a8s_1.y8r(tmp60_safe_receiver);
      }
      tmp_8[tmp_9] = tmp_10;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5.e8s_1 = tmp_8;
    var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = this.d8s_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var tmp61_safe_receiver = this.e8s_1[tmp_15];
      var tmp62_safe_receiver = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.o8r_1;
      var tmp_16;
      if (tmp62_safe_receiver == null) {
        tmp_16 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.agUniformBlockDatas.<anonymous>' call
        tmp_16 = new UniformBlockBuffer(tmp62_safe_receiver);
      }
      tmp_14[tmp_15] = tmp_16;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.f8s_1 = tmp_14;
    var tmp_17 = this;
    var tmp_18 = 0;
    var tmp_19 = this.d8s_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_20 = fillArrayVal(Array(tmp_19), null);
    while (tmp_18 < tmp_19) {
      var tmp_21 = tmp_18;
      var tmp63_safe_receiver = this.e8s_1[tmp_21];
      tmp_20[tmp_21] = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.p8r_1;
      tmp_18 = tmp_18 + 1 | 0;
    }
    tmp_17.g8s_1 = tmp_20;
    var tmp_22 = this;
    var tmp_23 = 0;
    var tmp_24 = this.d8s_1.length;
    var tmp_25 = new Int32Array(tmp_24);
    while (tmp_23 < tmp_24) {
      tmp_25[tmp_23] = 0;
      tmp_23 = tmp_23 + 1 | 0;
    }
    tmp_22.h8s_1 = tmp_25;
  }
  m8t() {
    var inductionVariable = 0;
    var last = this.h8s_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp65_safe_receiver = this.e8s_1[n];
        var tmp0_elvis_lhs = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.n8t();
        this.h8s_1[n] = tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.h8s_1.slice();
    return new UniformBlocksBuffersRef(this.f8s_1, this.g8s_1, tmp$ret$1);
  }
}
class AGVertexArrayObject {
  static r8t(list, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    var $this = createThis(this);
    $this.o8t_1 = new Mixin();
    $this.p8t_1 = list;
    $this.q8t_1 = isDynamic;
    return $this;
  }
  n13(_set____db54di) {
    this.o8t_1.n13(_set____db54di);
  }
  o13() {
    return this.o8t_1.o13();
  }
  static s8t(datas, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    return this.r8t(fastArrayListOf(datas.slice()), isDynamic);
  }
  toString() {
    return 'AGVertexArrayObject(list=' + this.p8t_1.toString() + ', isDynamic=' + this.q8t_1 + ')';
  }
  hashCode() {
    var result = this.p8t_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.q8t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexArrayObject))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexArrayObject ? other : THROW_CCE();
    if (!this.p8t_1.equals(tmp0_other_with_cast.p8t_1))
      return false;
    if (!(this.q8t_1 === tmp0_other_with_cast.q8t_1))
      return false;
    return true;
  }
}
class AGVertexData {
  static w8t(layout, buffer, baseOffset) {
    layout = layout === VOID ? ProgramLayout.f8u([]) : layout;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    var $this = createThis(this);
    $this.t8t_1 = layout;
    $this.u8t_1 = buffer;
    $this.v8t_1 = baseOffset;
    return $this;
  }
  static g8u(attributes, layoutSize, buffer, baseOffset) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    return this.w8t(ProgramLayout.f8u(attributes.slice(), layoutSize), buffer, baseOffset);
  }
  toString() {
    return 'AGVertexData(layout=' + this.t8t_1.toString() + ', buffer=' + this.u8t_1.toString() + ', baseOffset=' + this.v8t_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.t8t_1);
    result = imul(result, 31) + hashCode(this.u8t_1) | 0;
    result = imul(result, 31) + this.v8t_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexData))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexData ? other : THROW_CCE();
    if (!equals(this.t8t_1, tmp0_other_with_cast.t8t_1))
      return false;
    if (!equals(this.u8t_1, tmp0_other_with_cast.u8t_1))
      return false;
    if (!(this.v8t_1 === tmp0_other_with_cast.v8t_1))
      return false;
    return true;
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_35 = this;
    this.h8u_1 = _AGDrawType___init__impl__emm6mb(0);
    this.i8u_1 = _AGDrawType___init__impl__emm6mb(1);
    this.j8u_1 = _AGDrawType___init__impl__emm6mb(2);
    this.k8u_1 = _AGDrawType___init__impl__emm6mb(3);
    this.l8u_1 = _AGDrawType___init__impl__emm6mb(4);
    this.m8u_1 = _AGDrawType___init__impl__emm6mb(5);
    this.n8u_1 = _AGDrawType___init__impl__emm6mb(6);
  }
}
class AGDrawType {
  constructor(ordinal) {
    Companion_getInstance_43();
    this.o8u_1 = ordinal;
  }
  toString() {
    return AGDrawType__toString_impl_eonaeb(this.o8u_1);
  }
  hashCode() {
    return AGDrawType__hashCode_impl_ylaury(this.o8u_1);
  }
  equals(other) {
    return AGDrawType__equals_impl_rtafo6(this.o8u_1, other);
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_36 = this;
    this.u8k_1 = _AGIndexType___init__impl__yqnmb7(0);
    this.v8k_1 = _AGIndexType___init__impl__yqnmb7(1);
    this.w8k_1 = _AGIndexType___init__impl__yqnmb7(2);
    this.x8k_1 = _AGIndexType___init__impl__yqnmb7(3);
  }
}
class AGIndexType {
  constructor(ordinal) {
    Companion_getInstance_44();
    this.p8u_1 = ordinal;
  }
  toString() {
    return AGIndexType__toString_impl_hjqwm3(this.p8u_1);
  }
  hashCode() {
    return AGIndexType__hashCode_impl_47f06s(this.p8u_1);
  }
  equals(other) {
    return AGIndexType__equals_impl_goy6ag(this.p8u_1, other);
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_37 = this;
    this.y8k_1 = _AGBlending___init__impl__upt3bq(-1);
    this.z8k_1 = Companion_getInstance_45().e8v(Companion_getInstance_55().w8u_1, Companion_getInstance_55().d8v_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().d8v_1);
    this.a8l_1 = Companion_getInstance_45().e8v(Companion_getInstance_55().b8v_1, Companion_getInstance_55().z8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().z8u_1);
    this.b8l_1 = Companion_getInstance_45().f8v(Companion_getInstance_55().w8u_1, Companion_getInstance_55().z8u_1);
    this.c8l_1 = Companion_getInstance_45().e8v(Companion_getInstance_55().b8v_1, Companion_getInstance_55().u8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1);
    this.d8l_1 = Companion_getInstance_45().e8v(Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1);
  }
  g8v(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    return AGBlending__withEQ_impl_e9gm04(AGBlending__withDST_impl_y1hpet(AGBlending__withSRC_impl_hh0mjq(_AGBlending___init__impl__upt3bq(0), srcRGB, srcA), dstRGB, dstA), eqRGB, eqA);
  }
  e8v(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $super) {
    srcA = srcA === VOID ? srcRGB : srcA;
    dstA = dstA === VOID ? dstRGB : dstA;
    eqRGB = eqRGB === VOID ? Companion_getInstance_56().h8v_1 : eqRGB;
    eqA = eqA === VOID ? eqRGB : eqA;
    return $super === VOID ? this.g8v(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) : $super.g8v.call(this, new AGBlendFactor(srcRGB), new AGBlendFactor(dstRGB), new AGBlendFactor(srcA), new AGBlendFactor(dstA), new AGBlendEquation(eqRGB), new AGBlendEquation(eqA)).q8u_1;
  }
  k8v(src, dst, eq) {
    return AGBlending__withEQ$default_impl_iltiw7(AGBlending__withDST$default_impl_leu6qg(AGBlending__withSRC$default_impl_uuu5hz(_AGBlending___init__impl__upt3bq(0), src), dst), eq);
  }
  f8v(src, dst, eq, $super) {
    eq = eq === VOID ? Companion_getInstance_56().h8v_1 : eq;
    return $super === VOID ? this.k8v(src, dst, eq) : $super.k8v.call(this, new AGBlendFactor(src), new AGBlendFactor(dst), new AGBlendEquation(eq)).q8u_1;
  }
}
class AGBlending {
  constructor(data) {
    Companion_getInstance_45();
    this.q8u_1 = data;
  }
  toString() {
    return AGBlending__toString_impl_d5hic6(this.q8u_1);
  }
  hashCode() {
    return AGBlending__hashCode_impl_ywnf51(this.q8u_1);
  }
  equals(other) {
    return AGBlending__equals_impl_rp3dmf(this.q8u_1, other);
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_38 = this;
    this.t8l_1 = AGScissor.p8v(0, 0, 0, 0);
    this.u8l_1 = Companion_getInstance_46().h2t(-2147483648, -2147483648, 2147483647, 2147483647);
    this.v8l_1 = Companion_getInstance_46().h2t(-32766, -32766, 2147483647, 2147483647);
    this.w8l_1 = Companion_getInstance_46().h2t(-32767, -32767, 2147483647, 2147483647);
  }
  h2t(left, top, right, bottom) {
    return AGScissor.p8v(left, top, right - left | 0, bottom - top | 0);
  }
  q8v(left, top, right, bottom) {
    return AGScissor.r8v(left, top, right - left, bottom - top);
  }
  s8v(rect) {
    if (rect == null)
      return this.w8l_1;
    if (rect.n2i())
      return this.w8l_1;
    return AGScissor.t8v(rect.i2i_1, rect.j2i_1, rect.k2i_1, rect.l2i_1);
  }
  u8v(prev, next) {
    if (prev.equals(this.w8l_1))
      return next;
    if (next.equals(this.w8l_1))
      return prev;
    var intersectsX = prev.p2i() <= next.q2i() && prev.q2i() >= next.p2i();
    var intersectsY = prev.r2i() <= next.s2i() && prev.s2i() >= next.r2i();
    if (!intersectsX || !intersectsY)
      return this.t8l_1;
    // Inline function 'kotlin.math.max' call
    var a = prev.p2i();
    var b = next.p2i();
    var left = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = prev.r2i();
    var b_0 = next.r2i();
    var top = Math.max(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = prev.q2i();
    var b_1 = next.q2i();
    var right = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.min' call
    var a_2 = prev.s2i();
    var b_2 = next.s2i();
    var bottom = Math.min(a_2, b_2);
    return this.h2t(left, top, right, bottom);
  }
}
class AGScissor {
  static v8v(_left, _top, _right, _bottom) {
    Companion_getInstance_46();
    var $this = createThis(this);
    $this.l8v_1 = _left;
    $this.m8v_1 = _top;
    $this.n8v_1 = _right;
    $this.o8v_1 = _bottom;
    return $this;
  }
  n2i() {
    return this.equals(Companion_getInstance_46().w8l_1);
  }
  static p8v(x, y, width, height) {
    Companion_getInstance_46();
    return this.v8v(toShortClamped(x), toShortClamped(y), toShortClamped(x + width | 0), toShortClamped(y + height | 0));
  }
  static r8v(x, y, width, height) {
    Companion_getInstance_46();
    return this.p8v(toIntRound(x), toIntRound(y), toIntRound(width), toIntRound(height));
  }
  static t8v(x, y, width, height) {
    Companion_getInstance_46();
    return this.p8v(toIntRound_0(x), toIntRound_0(y), toIntRound_0(width), toIntRound_0(height));
  }
  p2i() {
    return this.l8v_1;
  }
  r2i() {
    return this.m8v_1;
  }
  q2i() {
    return this.n8v_1;
  }
  s2i() {
    return this.o8v_1;
  }
  n4f() {
    return this.p2i();
  }
  p4f() {
    return this.r2i();
  }
  j2y() {
    return this.q2i() - this.p2i() | 0;
  }
  k2y() {
    return this.s2i() - this.r2i() | 0;
  }
  toString() {
    if (this.equals(Companion_getInstance_46().w8l_1))
      return 'null';
    return 'Scissor(x=' + this.n4f() + ', y=' + this.p4f() + ', width=' + this.j2y() + ', height=' + this.k2y() + ')';
  }
  w8v() {
    return this.n2i() ? Companion_getInstance_6().x2i() : Companion_getInstance_6().d2t(this.n4f(), this.p4f(), this.j2y(), this.k2y());
  }
  x8v() {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.w8v();
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.graphics.AGScissor.toRectOrNull.<anonymous>' call
    if (this_0.o2i()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  hashCode() {
    var result = this.l8v_1;
    result = imul(result, 31) + this.m8v_1 | 0;
    result = imul(result, 31) + this.n8v_1 | 0;
    result = imul(result, 31) + this.o8v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGScissor))
      return false;
    var tmp0_other_with_cast = other instanceof AGScissor ? other : THROW_CCE();
    if (!(this.l8v_1 === tmp0_other_with_cast.l8v_1))
      return false;
    if (!(this.m8v_1 === tmp0_other_with_cast.m8v_1))
      return false;
    if (!(this.n8v_1 === tmp0_other_with_cast.n8v_1))
      return false;
    if (!(this.o8v_1 === tmp0_other_with_cast.o8v_1))
      return false;
    return true;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_39 = this;
    this.z8v_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(0, 0);
    this.a8w_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(-1, 0);
  }
}
class AGFinish {}
class AGClear {
  constructor(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil) {
    this.b8w_1 = frameBuffer;
    this.c8w_1 = frameBufferInfo;
    this.d8w_1 = color;
    this.e8w_1 = depth;
    this.f8w_1 = stencil;
    this.g8w_1 = clearColor;
    this.h8w_1 = clearDepth;
    this.i8w_1 = clearStencil;
  }
  toString() {
    return 'AGClear(frameBuffer=' + this.b8w_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.c8w_1) + ', color=' + RGBA__toString_impl_4lw6dp(this.d8w_1) + ', depth=' + this.e8w_1 + ', stencil=' + this.f8w_1 + ', clearColor=' + this.g8w_1 + ', clearDepth=' + this.h8w_1 + ', clearStencil=' + this.i8w_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.b8w_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.c8w_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.d8w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e8w_1) | 0;
    result = imul(result, 31) + this.f8w_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g8w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h8w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i8w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGClear))
      return false;
    var tmp0_other_with_cast = other instanceof AGClear ? other : THROW_CCE();
    if (!equals(this.b8w_1, tmp0_other_with_cast.b8w_1))
      return false;
    if (!equals(this.c8w_1, tmp0_other_with_cast.c8w_1))
      return false;
    if (!(this.d8w_1 === tmp0_other_with_cast.d8w_1))
      return false;
    if (!equals(this.e8w_1, tmp0_other_with_cast.e8w_1))
      return false;
    if (!(this.f8w_1 === tmp0_other_with_cast.f8w_1))
      return false;
    if (!(this.g8w_1 === tmp0_other_with_cast.g8w_1))
      return false;
    if (!(this.h8w_1 === tmp0_other_with_cast.h8w_1))
      return false;
    if (!(this.i8w_1 === tmp0_other_with_cast.i8w_1))
      return false;
    return true;
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_40 = this;
    this.h8l_1 = _AGStencilReference___init__impl__rta8vg(new Long(-1, -1));
    this.i8l_1 = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(AGStencilReference__withReferenceValue$default_impl_2trj0v(_AGStencilReference___init__impl__rta8vg(new Long(0, 0)), 0), 255), 255);
  }
}
class AGStencilReference {
  constructor(data) {
    Companion_getInstance_48();
    this.j8w_1 = data;
  }
  toString() {
    return AGStencilReference__toString_impl_qu5r8s(this.j8w_1);
  }
  hashCode() {
    return AGStencilReference__hashCode_impl_52zufx(this.j8w_1);
  }
  equals(other) {
    return AGStencilReference__equals_impl_kj05j(this.j8w_1, other);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_41 = this;
    this.j8l_1 = _AGStencilOpFunc___init__impl__t3f62q(-1);
    this.k8l_1 = AGStencilOpFunc__withAction$default_impl_jx9cm1(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(_AGStencilOpFunc___init__impl__t3f62q(0), false), Companion_getInstance_59().n8w_1), Companion_getInstance_58().a8x_1, Companion_getInstance_58().a8x_1, Companion_getInstance_58().a8x_1);
  }
}
class AGStencilOpFunc {
  constructor(data) {
    Companion_getInstance_49();
    this.d8x_1 = data;
  }
  toString() {
    return AGStencilOpFunc__toString_impl_pl8quy(this.d8x_1);
  }
  hashCode() {
    return AGStencilOpFunc__hashCode_impl_nopebb(this.d8x_1);
  }
  equals(other) {
    return AGStencilOpFunc__equals_impl_y44i4z(this.d8x_1, other);
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_42 = this;
    this.l8l_1 = _AGColorMask___init__impl__j38ai8(-1);
    this.m8l_1 = _AGColorMask___init__impl__j38ai8_1();
    this.n8l_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.o8l_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.p8l_1 = _AGColorMask___init__impl__j38ai8_0(true, true, true, false);
    this.q8l_1 = _AGColorMask___init__impl__j38ai8_1(false);
  }
}
class AGColorMask {
  constructor(data) {
    Companion_getInstance_50();
    this.j8x_1 = data;
  }
  toString() {
    return AGColorMask__toString_impl_5i5oqg(this.j8x_1);
  }
  hashCode() {
    return AGColorMask__hashCode_impl_g9082f(this.j8x_1);
  }
  equals(other) {
    return AGColorMask__equals_impl_mrih8l(this.j8x_1, other);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_43 = this;
    this.r8l_1 = _AGDepthAndFrontFace___init__impl__ra8x65(-2);
    this.s8l_1 = AGDepthAndFrontFace__withFrontFace_impl_mwk87t(AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs(AGDepthAndFrontFace__withDepthMask_impl_610nhs(AGDepthAndFrontFace__withDepth_impl_wsx82k(_AGDepthAndFrontFace___init__impl__ra8x65(0), 0.0, 1.0), true), Companion_getInstance_59().n8w_1), Companion_getInstance_60().k8x_1);
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_44 = this;
    this.x8l_1 = _AGCullFace___init__impl__ckmjdg(-1);
    this.y8l_1 = _AGCullFace___init__impl__ckmjdg(0);
    this.z8l_1 = _AGCullFace___init__impl__ckmjdg(1);
    this.a8m_1 = _AGCullFace___init__impl__ckmjdg(2);
    this.b8m_1 = _AGCullFace___init__impl__ckmjdg(3);
  }
}
class AGCullFace {
  constructor(ordinal) {
    Companion_getInstance_52();
    this.n8x_1 = ordinal;
  }
  toString() {
    return AGCullFace__toString_impl_7d891w(this.n8x_1);
  }
  hashCode() {
    return AGCullFace__hashCode_impl_t4e5ur(this.n8x_1);
  }
  equals(other) {
    return AGCullFace__equals_impl_wgngjr(this.n8x_1, other);
  }
}
class AGBatch {
  constructor(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances) {
    vertexData = vertexData === VOID ? AGVertexArrayObject.s8t([AGVertexData.w8t()], true) : vertexData;
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_44().w8k_1 : indexType;
    program = program === VOID ? DefaultShaders_getInstance().h8y_1 : program;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_61().e8l_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_32.g8l() : textureUnits;
    blending = blending === VOID ? Companion_getInstance_45().a8l_1 : blending;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_49().k8l_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_48().i8l_1 : stencilRef;
    colorMask = colorMask === VOID ? Companion_getInstance_50().n8l_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_51().s8l_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_46().w8l_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_52().y8l_1 : cullFace;
    drawType = drawType === VOID ? Companion_getInstance_43().l8u_1 : drawType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    vertexCount = vertexCount === VOID ? 0 : vertexCount;
    instances = instances === VOID ? 1 : instances;
    this.t8m_1 = frameBuffer;
    this.u8m_1 = frameBufferInfo;
    this.v8m_1 = vertexData;
    this.w8m_1 = indices;
    this.x8m_1 = indexType;
    this.y8m_1 = program;
    this.z8m_1 = uniformBlocks;
    this.a8n_1 = textureUnits;
    this.b8n_1 = blending;
    this.c8n_1 = stencilOpFunc;
    this.d8n_1 = stencilRef;
    this.e8n_1 = colorMask;
    this.f8n_1 = depthAndFrontFace;
    this.g8n_1 = scissor;
    this.h8n_1 = cullFace;
    this.i8n_1 = drawType;
    this.j8n_1 = drawOffset;
    this.k8n_1 = vertexCount;
    this.l8n_1 = instances;
  }
  s8m(ag) {
    ag.n8k(this.t8m_1, this.u8m_1, this.v8m_1, this.y8m_1, this.i8n_1, this.k8n_1, this.w8m_1, this.x8m_1, this.j8n_1, this.b8n_1, this.z8m_1, this.a8n_1, this.d8n_1, this.c8n_1, this.e8n_1, this.f8n_1, this.g8n_1, this.h8n_1, this.l8n_1);
  }
  toString() {
    return 'AGBatch(frameBuffer=' + this.t8m_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.u8m_1) + ', vertexData=' + this.v8m_1.toString() + ', indices=' + toString_1(this.w8m_1) + ', indexType=' + AGIndexType__toString_impl_hjqwm3(this.x8m_1) + ', program=' + this.y8m_1.toString() + ', uniformBlocks=' + toString(this.z8m_1) + ', textureUnits=' + this.a8n_1.toString() + ', blending=' + AGBlending__toString_impl_d5hic6(this.b8n_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.c8n_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.d8n_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.e8n_1) + ', depthAndFrontFace=' + AGDepthAndFrontFace__toString_impl_c305m3(this.f8n_1) + ', scissor=' + this.g8n_1.toString() + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.h8n_1) + ', drawType=' + AGDrawType__toString_impl_eonaeb(this.i8n_1) + ', drawOffset=' + this.j8n_1 + ', vertexCount=' + this.k8n_1 + ', instances=' + this.l8n_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.t8m_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.u8m_1) | 0;
    result = imul(result, 31) + this.v8m_1.hashCode() | 0;
    result = imul(result, 31) + (this.w8m_1 == null ? 0 : hashCode(this.w8m_1)) | 0;
    result = imul(result, 31) + AGIndexType__hashCode_impl_47f06s(this.x8m_1) | 0;
    result = imul(result, 31) + this.y8m_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.z8m_1) | 0;
    result = imul(result, 31) + this.a8n_1.hashCode() | 0;
    result = imul(result, 31) + AGBlending__hashCode_impl_ywnf51(this.b8n_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.c8n_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.d8n_1) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.e8n_1) | 0;
    result = imul(result, 31) + AGDepthAndFrontFace__hashCode_impl_xu62ey(this.f8n_1) | 0;
    result = imul(result, 31) + this.g8n_1.hashCode() | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.h8n_1) | 0;
    result = imul(result, 31) + AGDrawType__hashCode_impl_ylaury(this.i8n_1) | 0;
    result = imul(result, 31) + this.j8n_1 | 0;
    result = imul(result, 31) + this.k8n_1 | 0;
    result = imul(result, 31) + this.l8n_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGBatch ? other : THROW_CCE();
    if (!equals(this.t8m_1, tmp0_other_with_cast.t8m_1))
      return false;
    if (!equals(this.u8m_1, tmp0_other_with_cast.u8m_1))
      return false;
    if (!this.v8m_1.equals(tmp0_other_with_cast.v8m_1))
      return false;
    if (!equals(this.w8m_1, tmp0_other_with_cast.w8m_1))
      return false;
    if (!(this.x8m_1 === tmp0_other_with_cast.x8m_1))
      return false;
    if (!this.y8m_1.equals(tmp0_other_with_cast.y8m_1))
      return false;
    if (!equals(this.z8m_1, tmp0_other_with_cast.z8m_1))
      return false;
    if (!this.a8n_1.equals(tmp0_other_with_cast.a8n_1))
      return false;
    if (!(this.b8n_1 === tmp0_other_with_cast.b8n_1))
      return false;
    if (!(this.c8n_1 === tmp0_other_with_cast.c8n_1))
      return false;
    if (!equals(this.d8n_1, tmp0_other_with_cast.d8n_1))
      return false;
    if (!(this.e8n_1 === tmp0_other_with_cast.e8n_1))
      return false;
    if (!(this.f8n_1 === tmp0_other_with_cast.f8n_1))
      return false;
    if (!this.g8n_1.equals(tmp0_other_with_cast.g8n_1))
      return false;
    if (!(this.h8n_1 === tmp0_other_with_cast.h8n_1))
      return false;
    if (!(this.i8n_1 === tmp0_other_with_cast.i8n_1))
      return false;
    if (!(this.j8n_1 === tmp0_other_with_cast.j8n_1))
      return false;
    if (!(this.k8n_1 === tmp0_other_with_cast.k8n_1))
      return false;
    if (!(this.l8n_1 === tmp0_other_with_cast.l8n_1))
      return false;
    return true;
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_45 = this;
    this.i8q_1 = _AGTextureTargetKind___init__impl__4zdmch(0);
    this.j8q_1 = _AGTextureTargetKind___init__impl__4zdmch(1);
    this.k8q_1 = _AGTextureTargetKind___init__impl__4zdmch(2);
    this.l8q_1 = _AGTextureTargetKind___init__impl__4zdmch(3);
  }
}
class AGTextureTargetKind {
  constructor(ordinal) {
    Companion_getInstance_53();
    this.n8q_1 = ordinal;
  }
  toString() {
    return AGTextureTargetKind__toString_impl_68648p(this.n8q_1);
  }
  hashCode() {
    return AGTextureTargetKind__hashCode_impl_rzc11k(this.n8q_1);
  }
  equals(other) {
    return AGTextureTargetKind__equals_impl_q2tams(this.n8q_1, other);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_46 = this;
    this.h8r_1 = _AGWrapMode___init__impl__x5wmya(0);
    this.i8r_1 = _AGWrapMode___init__impl__x5wmya(1);
    this.j8r_1 = _AGWrapMode___init__impl__x5wmya(2);
  }
}
class AGWrapMode {
  constructor(ordinal) {
    Companion_getInstance_54();
    this.j8y_1 = ordinal;
  }
  toString() {
    return AGWrapMode__toString_impl_8bjnw2(this.j8y_1);
  }
  hashCode() {
    return AGWrapMode__hashCode_impl_u2pkox(this.j8y_1);
  }
  equals(other) {
    return AGWrapMode__equals_impl_4aw0kl(this.j8y_1, other);
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_47 = this;
    this.u8u_1 = _AGBlendFactor___init__impl__iqtmxr(0);
    this.v8u_1 = _AGBlendFactor___init__impl__iqtmxr(1);
    this.w8u_1 = _AGBlendFactor___init__impl__iqtmxr(2);
    this.x8u_1 = _AGBlendFactor___init__impl__iqtmxr(3);
    this.y8u_1 = _AGBlendFactor___init__impl__iqtmxr(4);
    this.z8u_1 = _AGBlendFactor___init__impl__iqtmxr(5);
    this.a8v_1 = _AGBlendFactor___init__impl__iqtmxr(6);
    this.b8v_1 = _AGBlendFactor___init__impl__iqtmxr(7);
    this.c8v_1 = _AGBlendFactor___init__impl__iqtmxr(8);
    this.d8v_1 = _AGBlendFactor___init__impl__iqtmxr(9);
  }
}
class AGBlendFactor {
  constructor(ordinal) {
    Companion_getInstance_55();
    this.k8y_1 = ordinal;
  }
  toString() {
    return AGBlendFactor__toString_impl_1hr6m1(this.k8y_1);
  }
  hashCode() {
    return AGBlendFactor__hashCode_impl_n8x3ew(this.k8y_1);
  }
  equals(other) {
    return AGBlendFactor__equals_impl_dlauac(this.k8y_1, other);
  }
}
class Companion_39 {
  constructor() {
    Companion_instance_48 = this;
    this.h8v_1 = _AGBlendEquation___init__impl__fpv7c2(0);
    this.i8v_1 = _AGBlendEquation___init__impl__fpv7c2(1);
    this.j8v_1 = _AGBlendEquation___init__impl__fpv7c2(2);
  }
}
class AGBlendEquation {
  constructor(ordinal) {
    Companion_getInstance_56();
    this.l8y_1 = ordinal;
  }
  toString() {
    return AGBlendEquation__toString_impl_5t2sx6(this.l8y_1);
  }
  hashCode() {
    return AGBlendEquation__hashCode_impl_fy33vp(this.l8y_1);
  }
  equals(other) {
    return AGBlendEquation__equals_impl_yykk3b(this.l8y_1, other);
  }
}
class Companion_40 {
  m8y() {
    return _AGSize___init__impl__h9blcq(-2);
  }
  y8v(width, height) {
    return AGSize__with_impl_qn6qww(_AGSize___init__impl__h9blcq(0), width, height);
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_50 = this;
    this.v8w_1 = _AGStencilOp___init__impl__llpkv6(0);
    this.w8w_1 = _AGStencilOp___init__impl__llpkv6(1);
    this.x8w_1 = _AGStencilOp___init__impl__llpkv6(2);
    this.y8w_1 = _AGStencilOp___init__impl__llpkv6(3);
    this.z8w_1 = _AGStencilOp___init__impl__llpkv6(4);
    this.a8x_1 = _AGStencilOp___init__impl__llpkv6(5);
    this.b8x_1 = _AGStencilOp___init__impl__llpkv6(6);
    this.c8x_1 = _AGStencilOp___init__impl__llpkv6(7);
  }
}
class AGStencilOp {
  constructor(ordinal) {
    Companion_getInstance_58();
    this.n8y_1 = ordinal;
  }
  toString() {
    return AGStencilOp__toString_impl_1dm6fq(this.n8y_1);
  }
  hashCode() {
    return AGStencilOp__hashCode_impl_n4s38l(this.n8y_1);
  }
  equals(other) {
    return AGStencilOp__equals_impl_rq4p55(this.n8y_1, other);
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_51 = this;
    this.n8w_1 = _AGCompareMode___init__impl__j8kqbb(0);
    this.o8w_1 = _AGCompareMode___init__impl__j8kqbb(1);
    this.p8w_1 = _AGCompareMode___init__impl__j8kqbb(2);
    this.q8w_1 = _AGCompareMode___init__impl__j8kqbb(3);
    this.r8w_1 = _AGCompareMode___init__impl__j8kqbb(4);
    this.s8w_1 = _AGCompareMode___init__impl__j8kqbb(5);
    this.t8w_1 = _AGCompareMode___init__impl__j8kqbb(6);
    this.u8w_1 = _AGCompareMode___init__impl__j8kqbb(7);
  }
}
class AGCompareMode {
  constructor(ordinal) {
    Companion_getInstance_59();
    this.o8y_1 = ordinal;
  }
  toString() {
    return AGCompareMode__toString_impl_gs33a9(this.o8y_1);
  }
  hashCode() {
    return AGCompareMode__hashCode_impl_whv1w0(this.o8y_1);
  }
  equals(other) {
    return AGCompareMode__equals_impl_rbniy4(this.o8y_1, other);
  }
}
class Companion_43 {
  constructor() {
    Companion_instance_52 = this;
    this.k8x_1 = _AGFrontFace___init__impl__vsm7rb(0);
    this.l8x_1 = _AGFrontFace___init__impl__vsm7rb(1);
    this.m8x_1 = _AGFrontFace___init__impl__vsm7rb(2);
  }
}
class AGMultiBatch {
  constructor(list) {
    this.r8m_1 = list;
  }
  s8m(ag) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.r8m_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.graphics.AGMultiBatch.execute.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.i1(_unary__edvuaz).s8m(ag);
    }
  }
  toString() {
    return 'AGMultiBatch(list=' + toString(this.r8m_1) + ')';
  }
  hashCode() {
    return hashCode(this.r8m_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGMultiBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGMultiBatch ? other : THROW_CCE();
    if (!equals(this.r8m_1, tmp0_other_with_cast.r8m_1))
      return false;
    return true;
  }
}
class AGConfig {
  constructor(antialiasHint) {
    antialiasHint = antialiasHint === VOID ? true : antialiasHint;
    this.p8y_1 = antialiasHint;
  }
  toString() {
    return 'AGConfig(antialiasHint=' + this.p8y_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.p8y_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this.p8y_1 === tmp0_other_with_cast.p8y_1))
      return false;
    return true;
  }
}
class AGBufferKind extends Enum {}
class AGStats {
  constructor(texturesCount, texturesMemory, buffersCount, buffersMemory, frameBuffersCount, frameBuffersMemory, texturesCreated, texturesDeleted, programCount) {
    texturesCount = texturesCount === VOID ? 0 : texturesCount;
    texturesMemory = texturesMemory === VOID ? Companion_getInstance_11().b13(0) : texturesMemory;
    buffersCount = buffersCount === VOID ? 0 : buffersCount;
    buffersMemory = buffersMemory === VOID ? Companion_getInstance_11().b13(0) : buffersMemory;
    frameBuffersCount = frameBuffersCount === VOID ? 0 : frameBuffersCount;
    frameBuffersMemory = frameBuffersMemory === VOID ? Companion_getInstance_11().b13(0) : frameBuffersMemory;
    texturesCreated = texturesCreated === VOID ? 0 : texturesCreated;
    texturesDeleted = texturesDeleted === VOID ? 0 : texturesDeleted;
    programCount = programCount === VOID ? 0 : programCount;
    this.q8y_1 = texturesCount;
    this.r8y_1 = texturesMemory;
    this.s8y_1 = buffersCount;
    this.t8y_1 = buffersMemory;
    this.u8y_1 = frameBuffersCount;
    this.v8y_1 = frameBuffersMemory;
    this.w8y_1 = texturesCreated;
    this.x8y_1 = texturesDeleted;
    this.y8y_1 = programCount;
  }
  toString() {
    return 'AGStats(textures[' + this.q8y_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.r8y_1) + ', buffers[' + this.s8y_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.t8y_1) + ', frameBuffers[' + this.u8y_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.v8y_1) + ', programs[' + this.y8y_1 + '])';
  }
}
class UniformBlock {
  constructor(fixedLocation) {
    this.i8t_1 = fixedLocation;
    this.j8t_1 = new UBLayoutBuilder();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.k8t_1 = ArrayList.m1();
    this.l8t_1 = 0;
  }
  w3() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
  s8z() {
    return this.k8t_1;
  }
  t8z() {
    return this.j8t_1.j1();
  }
  u8z() {
    return nextMultipleOf(this.t8z(), 256);
  }
  v8z() {
    return this.s8z().j1();
  }
  w8z(name) {
    return this.f90(name, VarType_Float1_getInstance(), 4, 4);
  }
  x8z(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.w8z(name) : $super.w8z.call(this, name);
  }
  y8z(name) {
    return this.f90(name, VarType_Float2_getInstance(), 8, 8);
  }
  z8z(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.y8z(name) : $super.y8z.call(this, name);
  }
  a90(name) {
    return this.f90(name, VarType_Float4_getInstance(), 16, 16);
  }
  b90(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.a90(name) : $super.a90.call(this, name);
  }
  c90(name) {
    return this.f90(name, VarType_Mat3_getInstance(), 48, 16);
  }
  d90(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.c90(name) : $super.c90.call(this, name);
  }
  e90(name) {
    return this.f90(name, VarType_Mat4_getInstance(), 64, 16);
  }
  f8z(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.e90(name) : $super.e90.call(this, name);
  }
  r9g(size, gen) {
    var offset = this.j8t_1.o9g_1;
    var maxAlign = this.j8t_1.p9g_1;
    var tmp;
    try {
      tmp = gen();
    }finally {
      this.j8t_1.o9g_1 = offset;
      this.j8t_1.p9g_1 = maxAlign;
    }
    var dgen = tmp;
    var tmp_0 = dgen.n9g(VOID, VOID, this.j8t_1.s9g(imul(dgen.m8z_1, size), dgen.n8z_1), VOID, VOID, size);
    return tmp_0 instanceof Gen ? tmp_0 : THROW_CCE();
  }
  f90(name, type, size, align) {
    var tmp = this.j8t_1.s9g(size, align);
    var _unary__edvuaz = this.l8t_1;
    this.l8t_1 = _unary__edvuaz + 1 | 0;
    return new Gen(this, name, tmp, _unary__edvuaz, type, 1, size, align);
  }
  toString() {
    return 'UniformBlock[' + get_portableSimpleName(getKClassFromExpression(this)) + '][' + joinToString(this.s8z(), ', ') + ', fixedLocation=' + this.i8t_1 + ']';
  }
}
class ProjViewUB extends UniformBlock {
  constructor() {
    ProjViewUB_instance = null;
    super(0);
    ProjViewUB_instance = this;
    this.d8z_1 = this.f8z().p8z(this, u_ProjMat$factory());
    this.e8z_1 = this.f8z().p8z(this, u_ViewMat$factory());
  }
  q8z() {
    return this.d8z_1.ko(this, u_ProjMat$factory_0());
  }
  r8z() {
    return this.e8z_1.ko(this, u_ViewMat$factory_0());
  }
}
class DefaultShaders {
  constructor() {
    DefaultShaders_instance = this;
    this.o8x_1 = Sampler_0(1, SamplerVarType_Sampler2D_getInstance()).i90(this, u_Tex$factory());
    this.p8x_1 = Sampler_0(2, SamplerVarType_Sampler2D_getInstance()).i90(this, u_TexEx$factory());
    this.q8x_1 = Attribute.z90('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance(), 0);
    this.r8x_1 = Attribute.z90('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance(), 1);
    this.s8x_1 = Attribute.z90('a_Col', VarType_UByte4_getInstance(), true, Precision_LOW_getInstance(), 2);
    this.t8x_1 = Varying.l91('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    this.u8x_1 = Varying.l91('v_Col', VarType_Float4_getInstance());
    this.v8x_1 = Temp.x91(0, VarType_Float4_getInstance());
    this.w8x_1 = Temp.x91(1, VarType_Float4_getInstance());
    this.x8x_1 = Temp.x91(2, VarType_Mat2_getInstance());
    this.y8x_1 = ProgramLayout.f8u([this.q8x_1, this.r8x_1, this.s8x_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.graphics.DefaultShaders.VERTEX_DEFAULT.<anonymous>' call
    builder.f92(builder.b92(), builder.c92());
    builder.f92(builder.g92(), builder.h92());
    builder.f92(builder.i92(), builder.j92(builder.j92(builder.q8z(), builder.r8z()), builder.m92([builder.k92(), builder.l92(0.0), builder.l92(1.0)])));
    tmp.z8x_1 = VertexShader(builder.n92());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.a92();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.DefaultShaders.MERGE_ALPHA_PROGRAM.<anonymous>' call
    var coords = this_0.o92(this_0.b92(), 'xy');
    this_0.f92(this_0.i92(), this_0.j92(this_0.q92(this_0.p92(), coords), this_0.s92(this_0.q92(DefaultShaders_getInstance().r92(), coords))));
    var tmp$ret$2 = FragmentShader(this_0.n92());
    tmp_0.a8y_1 = new Program(this.z8x_1, tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_DEBUG.<anonymous>' call
    builder_0.f92(builder_0.i92(), builder_0.m92([builder_0.l92(1.0), builder_0.l92(1.0), builder_0.l92(0.0), builder_0.l92(1.0)]));
    tmp_1.b8y_1 = FragmentShader(builder_0.n92());
    var tmp_2 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_1 = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_SOLID_COLOR.<anonymous>' call
    builder_1.f92(builder_1.i92(), builder_1.g92());
    tmp_2.c8y_1 = FragmentShader(builder_1.n92());
    var tmp_3 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_2 = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE.<anonymous>' call
    builder_2.f92(builder_2.i92(), builder_2.j92(builder_2.o92(builder_2.q92(builder_2.p92(), builder_2.o92(builder_2.b92(), 'xy')), 'rgba'), builder_2.g92()));
    var tmp$ret$5 = FragmentShader(builder_2.n92());
    tmp_3.d8y_1 = new Program(this.z8x_1, tmp$ret$5, 'PROGRAM_TINTED_TEXTURE');
    var tmp_4 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_3 = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE_PREMULT.<anonymous>' call
    builder_3.f92(builder_3.t92(), builder_3.q92(builder_3.p92(), builder_3.o92(builder_3.b92(), 'xy')));
    builder_3.f92(builder_3.o92(builder_3.t92(), 'rgb'), builder_3.u92(builder_3.o92(builder_3.t92(), 'rgb'), builder_3.o92(builder_3.t92(), 'a')));
    builder_3.f92(builder_3.i92(), builder_3.j92(builder_3.o92(builder_3.t92(), 'rgba'), builder_3.g92()));
    var tmp$ret$6 = FragmentShader(builder_3.n92());
    tmp_4.e8y_1 = new Program(this.z8x_1, tmp$ret$6, 'PROGRAM_TINTED_TEXTURE');
    this.f8y_1 = new Program(this.z8x_1, this.c8y_1, 'PROGRAM_SOLID_COLOR');
    this.g8y_1 = ProgramLayout.f8u([this.q8x_1]);
    var tmp_5 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_4 = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_4.f92(builder_4.i92(), builder_4.m92([builder_4.k92(), builder_4.l92(0.0), builder_4.l92(1.0)]));
    var tmp_6 = VertexShader(builder_4.n92());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_5 = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_5.f92(builder_5.i92(), builder_5.m92([builder_5.l92(1.0), builder_5.l92(0.0), builder_5.l92(0.0), builder_5.l92(1.0)]));
    var tmp$ret$8 = FragmentShader(builder_5.n92());
    tmp_5.h8y_1 = new Program(tmp_6, tmp$ret$8, 'PROGRAM_DEBUG');
    var tmp_7 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_6 = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_6.f92(builder_6.i92(), builder_6.j92(builder_6.j92(builder_6.q8z(), builder_6.r8z()), builder_6.m92([builder_6.k92(), builder_6.l92(0.0), builder_6.l92(1.0)])));
    var tmp_8 = VertexShader(builder_6.n92());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_7 = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_7.f92(builder_7.i92(), builder_7.m92([builder_7.l92(1.0), builder_7.l92(0.0), builder_7.l92(0.0), builder_7.l92(1.0)]));
    var tmp$ret$10 = FragmentShader(builder_7.n92());
    tmp_7.i8y_1 = new Program(tmp_8, tmp$ret$10, 'PROGRAM_DEBUG_WITH_PROJ');
  }
  p92() {
    return this.o8x_1.ko(this, u_Tex$factory_0());
  }
  r92() {
    return this.p8x_1.ko(this, u_TexEx$factory_0());
  }
  q8z() {
    return ProjViewUB_getInstance().q8z().h8t_1;
  }
  r8z() {
    return ProjViewUB_getInstance().r8z().h8t_1;
  }
}
class VarTypeAccessor {}
function get_Int1() {
  return VarType_Int1_getInstance();
}
function get_Float1() {
  return VarType_Float1_getInstance();
}
function get_Float2() {
  return VarType_Float2_getInstance();
}
function get_Float4() {
  return VarType_Float4_getInstance();
}
class ExpressionBuilder {}
function get_out() {
  return Output_getInstance();
}
function sin(arg) {
  return Func.u9q('sin', [arg]);
}
function cos(arg) {
  return Func.u9q('cos', [arg]);
}
function atan(y, x) {
  return Func.u9q('atan', [y, x]);
}
function texture2D(sampler, coord) {
  return Func.u9q('texture2D', [sampler, coord], VarType_Float4_getInstance());
}
function TERNARY(cond, otrue, ofalse) {
  return Ternary.e9q(cond, otrue, ofalse);
}
function int(v) {
  return Func.u9q('int', [v]);
}
function float(v) {
  return Func.u9q('float', [v]);
}
function pow(b, e) {
  return Func.u9q('pow', [b, e]);
}
function exp(v) {
  return Func.u9q('exp', [v]);
}
function sqrt(v) {
  return Func.u9q('sqrt', [v]);
}
function abs(v) {
  return Func.u9q('abs', [v]);
}
function ceil(v) {
  return Func.u9q('ceil', [v]);
}
function fract(v) {
  return Func.u9q('fract', [v]);
}
function clamp01(v) {
  return this.l94(v, this.l92(0.0), this.l92(1.0));
}
function clamp(v, min, max) {
  return Func.u9q('clamp', [v, min, max]);
}
function min_0(a, b) {
  return Func.u9q('min', [a, b]);
}
function max_1(a, b) {
  return Func.u9q('max', [a, b]);
}
function fwidth(a) {
  return Func.u9q('fwidth', [a]);
}
function mix(a, b, step) {
  return Func.u9q('mix', [a, b, step]);
}
function smoothstep(a, b, c) {
  return Func.u9q('smoothstep', [a, b, c]);
}
function length(a) {
  return Func.u9q('length', [a]);
}
function dot(a, b) {
  return Func.u9q('dot', [a, b]);
}
function normalize(a) {
  return Func.u9q('normalize', [a]);
}
function reflect(a, b) {
  return Func.u9q('reflect', [a, b]);
}
function get_lit(_this__u8e3s4) {
  return IntLiteral.i9q(_this__u8e3s4);
}
function get_lit_0(_this__u8e3s4) {
  return FloatLiteral.j9q(_this__u8e3s4);
}
function vec2(ops) {
  return Vector.k9q(VarType_Float2_getInstance(), ops);
}
function vec3(ops) {
  return Vector.k9q(VarType_Float3_getInstance(), ops);
}
function vec4(ops) {
  return Vector.k9q(VarType_Float4_getInstance(), ops);
}
function mat2(ops) {
  return Vector.k9q(VarType_Mat2_getInstance(), ops);
}
function vec2_0(ops) {
  var tmp = VarType_Float2_getInstance();
  var tmp_0 = 0;
  var tmp_1 = ops.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = fillArrayVal(Array(tmp_1), null);
  while (tmp_0 < tmp_1) {
    var tmp_3 = tmp_0;
    tmp_2[tmp_3] = this.l92(ops[tmp_3]);
    tmp_0 = tmp_0 + 1 | 0;
  }
  return Vector.k9q(tmp, tmp_2);
}
function vec4_0(ops) {
  var tmp = VarType_Float4_getInstance();
  var tmp_0 = 0;
  var tmp_1 = ops.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = fillArrayVal(Array(tmp_1), null);
  while (tmp_0 < tmp_1) {
    var tmp_3 = tmp_0;
    tmp_2[tmp_3] = this.l92(ops[tmp_3]);
    tmp_0 = tmp_0 + 1 | 0;
  }
  return Vector.k9q(tmp, tmp_2);
}
function get_1(_this__u8e3s4, index) {
  var tmp;
  if (_this__u8e3s4 instanceof OperandWithArray) {
    tmp = ArrayAccess.n9q(_this__u8e3s4, this.t94(index));
  } else {
    if (_this__u8e3s4.b2n().w9a_1) {
      tmp = ArrayAccess.n9q(_this__u8e3s4, this.t94(index));
    } else {
      var tmp_0;
      switch (index) {
        case 0:
          tmp_0 = this.a95(_this__u8e3s4);
          break;
        case 1:
          tmp_0 = this.b95(_this__u8e3s4);
          break;
        case 2:
          tmp_0 = this.c95(_this__u8e3s4);
          break;
        case 3:
          tmp_0 = this.d95(_this__u8e3s4);
          break;
        default:
          var message = 'Invalid index ' + index;
          throw IllegalStateException.m5(toString(message));
      }
      tmp = tmp_0;
    }
  }
  return tmp;
}
function get_2(_this__u8e3s4, swizzle) {
  return Swizzle.l9q(_this__u8e3s4, swizzle);
}
function get_x(_this__u8e3s4) {
  return this.o92(_this__u8e3s4, 'x');
}
function get_y(_this__u8e3s4) {
  return this.o92(_this__u8e3s4, 'y');
}
function get_z(_this__u8e3s4) {
  return this.o92(_this__u8e3s4, 'z');
}
function get_w(_this__u8e3s4) {
  return this.o92(_this__u8e3s4, 'w');
}
function get_r(_this__u8e3s4) {
  return this.o92(_this__u8e3s4, 'x');
}
function get_a(_this__u8e3s4) {
  return this.o92(_this__u8e3s4, 'w');
}
function unaryMinus(_this__u8e3s4) {
  return Unop.g9q('-', _this__u8e3s4);
}
function minus_0(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '-', that);
}
function plus_2(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '+', that);
}
function times(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '*', that);
}
function div(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '/', that);
}
function eq(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '==', that);
}
function ne(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '!=', that);
}
function lt(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '<', that);
}
function le(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '<=', that);
}
function gt(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '>', that);
}
function ge(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '>=', that);
}
function minus_1(_this__u8e3s4, that) {
  return this.g95(this.l92(_this__u8e3s4), that);
}
function plus_3(_this__u8e3s4, that) {
  return this.i95(this.l92(_this__u8e3s4), that);
}
function times_0(_this__u8e3s4, that) {
  return this.j92(this.l92(_this__u8e3s4), that);
}
function plus_4(_this__u8e3s4, that) {
  return this.i95(_this__u8e3s4, this.l92(that));
}
function times_1(_this__u8e3s4, that) {
  return this.j92(_this__u8e3s4, this.l92(that));
}
function div_0(_this__u8e3s4, that) {
  return this.u92(_this__u8e3s4, this.l92(that));
}
function lt_0(_this__u8e3s4, that) {
  return this.n95(_this__u8e3s4, this.l92(that));
}
function gt_0(_this__u8e3s4, that) {
  return this.q95(_this__u8e3s4, this.l92(that));
}
function and(_this__u8e3s4, that) {
  return Binop.h9q(_this__u8e3s4, '&&', that);
}
function inRange(_this__u8e3s4, low, high) {
  return this.t95(this.s95(_this__u8e3s4, low), this.n95(_this__u8e3s4, high));
}
class Builder {
  static v92(context) {
    context = context === VOID ? new BuilderContext() : context;
    var $this = createThis(this);
    $this.d92_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.e92_1 = ArrayList.m1();
    return $this;
  }
  static i9p(parent) {
    return this.v92(parent.d92_1);
  }
  w92() {
    return Builder.i9p(this);
  }
  x92() {
    return FuncBuilder.h9p(this);
  }
  y92() {
    return new Stms(toList(this.e92_1));
  }
  z92() {
    var funcs = LinkedHashMap.vc();
    (new Program$Builder$_funcs$1(funcs)).d9q(this.e92_1);
    var _iterator__ex2g4s = this.d92_1.x9q_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var func = _iterator__ex2g4s.h1();
      // Inline function 'kotlin.collections.set' call
      var key = func.h9m_1;
      funcs.r3(key, func);
    }
    return toList(funcs.m3());
  }
  n92() {
    return to(this.y92(), this.z92());
  }
  a93(name, rettype, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.x92();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var funcBuild = this_0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = funcBuild.f9p_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
      var tmp$ret$1 = to(item.x98_1, item.b2n());
      destination.f(tmp$ret$1);
    }
    var this_2 = new FuncDecl(name, rettype, destination, funcBuild.y92());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.d92_1.x9q_1.f(this_2);
    return this_2;
  }
  b93(p0, dummy, returns, block) {
    var tmp = listOf(p0);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda(block));
  }
  c93(p0, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.b93(p0, dummy, returns, block);
    } else {
      var tmp_0 = $super.b93;
      tmp = tmp_0.call(this, p0, Unit_instance, returns, block);
    }
    return tmp;
  }
  d93(p0, p1, dummy, returns, block) {
    var tmp = listOf_0([p0, p1]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_0(block));
  }
  e93(p0, p1, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.d93(p0, p1, dummy, returns, block);
    } else {
      var tmp_0 = $super.d93;
      tmp = tmp_0.call(this, p0, p1, Unit_instance, returns, block);
    }
    return tmp;
  }
  f93(p0, p1, p2, dummy, returns, block) {
    var tmp = listOf_0([p0, p1, p2]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_1(block));
  }
  g93(p0, p1, p2, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.f93(p0, p1, p2, dummy, returns, block);
    } else {
      var tmp_0 = $super.f93;
      tmp = tmp_0.call(this, p0, p1, p2, Unit_instance, returns, block);
    }
    return tmp;
  }
  h93(type) {
    var _receiver__tnumb7 = this.d92_1;
    var _unary__edvuaz = _receiver__tnumb7.y9q_1;
    _receiver__tnumb7.y9q_1 = _unary__edvuaz + 1 | 0;
    return Temp.x91(_unary__edvuaz, type);
  }
  i93(_this__u8e3s4, p0) {
    return CustomFunc.v9q(_this__u8e3s4, listOf(p0));
  }
  j93(_this__u8e3s4, p0, p1) {
    return CustomFunc.v9q(_this__u8e3s4, listOf_0([p0, p1]));
  }
  k93(_this__u8e3s4, p0, p1, p2) {
    return CustomFunc.v9q(_this__u8e3s4, listOf_0([p0, p1, p2]));
  }
  l93(_this__u8e3s4, callback) {
    var body = this.w92();
    callback(body);
    _this__u8e3s4.w9n_1 = body.y92();
  }
  m93(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else if ((max - min | 0) <= 1) {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.l95(ref, this.l92(min));
      var body = this.w92();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.y92());
      // Inline function 'kotlin.collections.plusAssign' call
      this.e92_1.f(stmIf);
      var tmp = stmIf;
      this.l93(tmp, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda(block, max));
    } else {
      var middle = (min + max | 0) / 2 | 0;
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond_0 = this.p95(ref, this.l92(middle));
      var body_0 = this.w92();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      body_0.m93(ref, min, middle, block);
      var stmIf_0 = new If(cond_0, body_0.y92());
      // Inline function 'kotlin.collections.plusAssign' call
      this.e92_1.f(stmIf_0);
      var tmp_0 = stmIf_0;
      this.l93(tmp_0, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0(ref, middle, max, block));
    }
  }
  n93(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.l95(ref, this.l92(min));
      var body = this.w92();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_LIST.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.y92());
      // Inline function 'kotlin.collections.plusAssign' call
      this.e92_1.f(stmIf);
      var tmp = stmIf;
      this.l93(tmp, Program$Builder$IF_ELSE_LIST$lambda(ref, min, max, block));
    }
  }
  o93(shader) {
    this.p93(shader);
    return this;
  }
  p93(shader) {
    var tmp = shader.f9j_1;
    if (tmp instanceof Stms) {
      this.e92_1.k1(shader.f9j_1.a9n_1);
    } else {
      this.e92_1.f(shader.f9j_1);
    }
    this.d92_1.x9q_1.k1(shader.g9j_1);
  }
  f92(target, expr) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.e92_1;
    var element = new Set(target, expr);
    this_0.f(element);
  }
  q93() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.e92_1;
    var element = Discard_getInstance();
    this_0.f(element);
  }
  r93() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.e92_1;
    var element = Break_getInstance();
    this_0.f(element);
  }
  s93(operand) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.e92_1;
    var element = new Return(operand);
    this_0.f(element);
  }
  t93(operand, $super) {
    operand = operand === VOID ? null : operand;
    var tmp;
    if ($super === VOID) {
      this.s93(operand);
      tmp = Unit_instance;
    } else {
      tmp = $super.s93.call(this, operand);
    }
    return tmp;
  }
  u93(type) {
    var _receiver__tnumb7 = this.d92_1;
    var _unary__edvuaz = _receiver__tnumb7.y9q_1;
    _receiver__tnumb7.y9q_1 = _unary__edvuaz + 1 | 0;
    return Temp.z9q(_unary__edvuaz, type, 1);
  }
}
class IDefaultShaders {}
function get_u_Tex() {
  return DefaultShaders_getInstance().p92();
}
function get_u_ProjMat() {
  return DefaultShaders_getInstance().q8z();
}
function get_u_ViewMat() {
  return DefaultShaders_getInstance().r8z();
}
function get_a_Pos() {
  return DefaultShaders_getInstance().q8x_1;
}
function get_a_Tex() {
  return DefaultShaders_getInstance().r8x_1;
}
function get_a_Col() {
  return DefaultShaders_getInstance().s8x_1;
}
function get_v_Tex() {
  return DefaultShaders_getInstance().t8x_1;
}
function get_v_Col() {
  return DefaultShaders_getInstance().u8x_1;
}
function get_t_Temp0() {
  return DefaultShaders_getInstance().v8x_1;
}
function get_t_Temp1() {
  return DefaultShaders_getInstance().w8x_1;
}
function get_t_TempMat2() {
  return DefaultShaders_getInstance().x8x_1;
}
class ProgramBuilderDefault extends Builder {
  static a92() {
    return this.v92();
  }
}
class GLVAO {
  constructor(vao, glId, contextVersion) {
    glId = glId === VOID ? -1 : glId;
    contextVersion = contextVersion === VOID ? -1 : contextVersion;
    this.x95_1 = vao;
    this.y95_1 = glId;
    this.z95_1 = contextVersion;
  }
}
class ShaderException extends RuntimeException {
  static k96(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    var $this = this.db('Error Compiling Shader : ' + debugName + ' type=' + type + ' : ' + get_hex(errorInt) + " : '" + error + "' : source='" + str + "', shaderReturnInt=" + shaderReturnInt + ', gl.versionInt=' + get_versionInt(gl) + ", gl.versionString='" + get_versionString(gl) + "', gl=" + toString(gl));
    captureStack($this, $this.j96_1);
    $this.c96_1 = str;
    $this.d96_1 = error;
    $this.e96_1 = errorInt;
    $this.f96_1 = gl;
    $this.g96_1 = debugName;
    $this.h96_1 = type;
    $this.i96_1 = shaderReturnInt;
    return $this;
  }
}
class TextureUnitParams {
  constructor(index) {
    this.l99_1 = index;
    this.m99_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.n99_1 = -1;
    this.o99_1 = -1;
    this.p99_1 = -1;
    this.q99_1 = -1;
  }
  z33() {
    this.m99_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.n99_1 = -1;
    this.o99_1 = -1;
    this.p99_1 = -1;
    this.q99_1 = -1;
  }
}
class AGOpengl extends AG {
  constructor(gl, context) {
    context = context === VOID ? null : context;
    super();
    this.p96_1 = gl;
    this.q96_1 = context;
    var tmp = this;
    // Inline function 'kotlin.collections.linkedSetOf' call
    tmp.r96_1 = LinkedHashSet.l1();
    this.s96_1 = new GLGlobalState(this.p96_1, this);
    this.t96_1 = HashMap.c9();
    this.u96_1 = null;
    var tmp_0 = this;
    tmp_0.v96_1 = lazy(AGOpengl$glslConfig$delegate$lambda(this));
    this.w96_1 = null;
    this.x96_1 = Companion_getInstance_45().y8k_1;
    this.y96_1 = Companion_getInstance_52().x8l_1;
    this.z96_1 = Companion_getInstance_49().j8l_1;
    this.a97_1 = Companion_getInstance_48().h8l_1;
    this.b97_1 = Companion_getInstance_50().l8l_1;
    this.c97_1 = Companion_getInstance_51().r8l_1;
    this.d97_1 = null;
    this.e97_1 = AGTextureUnits.e8o();
    this.f97_1 = new Int32Array(this.e97_1.j1());
    this.g97_1 = 0;
    this.h97_1 = Companion_getInstance_46().v8l_1;
    this.i97_1 = -1;
    this.j97_1 = -1;
    this.k97_1 = get_ENABLE_VERTEX_ARRAY_OBJECTS();
    this.l97_1 = Ref();
    this.m97_1 = Buffer.t10(36);
    var tmp_1 = this;
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(32), null);
    while (tmp_2 < 32) {
      var tmp_4 = tmp_2;
      tmp_3[tmp_4] = new TextureUnitParams(tmp_4);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.n97_1 = tmp_3;
    this.o97_1 = allocDirect(Companion_instance_4, 0);
    this.p97_1 = 7;
    this.q97_1 = 0;
    this.r97_1 = Companion_instance_49.m8y();
    this.s97_1 = -1;
    this.t97_1 = new Long(-1, -1);
    this.u97_1 = null;
  }
  o8k() {
    return this.p96_1;
  }
  i8k() {
    var gl = this.p96_1;
    super.i8k();
    gl.z9b();
    gl.p8k();
    this.t96_1.o3();
    resetObjects(this);
    this.i97_1 = -1;
    this.j97_1 = -1;
    this.k97_1 = true;
  }
  m8k(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    var gl = this.p96_1;
    this.a9c(frameBuffer, frameBufferInfo);
    this.b9c(scissor, frameBuffer, frameBufferInfo);
    var mask = 0;
    if (clearColor) {
      this.c9c(Companion_getInstance_50().o8l_1);
      gl.d9c(_RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
      mask = mask | 16384;
    }
    if (clearDepth) {
      gl.e9c(true);
      gl.f9c(depth);
      mask = mask | 256;
    }
    if (clearStencil) {
      this.z96_1 = Companion_getInstance_49().j8l_1;
      gl.g9c(-1);
      gl.h9c(stencil);
      mask = mask | 1024;
    }
    gl.q38(mask);
  }
  n8k(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    var gl = this.p96_1;
    this.a9c(frameBuffer, frameBufferInfo);
    this.b9c(scissor, frameBuffer, frameBufferInfo);
    var tmp100_safe_receiver = this.w96_1;
    if (!equals(tmp100_safe_receiver == null ? null : tmp100_safe_receiver.p8t_1, vertexData.p8t_1)) {
      var tmp99_safe_receiver = this.w96_1;
      if (tmp99_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.i9c(tmp99_safe_receiver);
      }
      this.w96_1 = vertexData;
      this.j9c(vertexData);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vertexData.p8t_1.e14_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.u8t_1, AGBufferKind_VERTEX_getInstance(), true);
      }
    }
    useProgram(this, program);
    this.k9c(uniformBlocks, textureUnits, program, frameBuffer);
    if (!(this.x96_1 === blending)) {
      this.x96_1 = blending;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = _AGBlending___get_enabled__impl__s7igz6(blending);
      if (gl.n9c(3042, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        gl.l9c(toGl(_AGBlending___get_eqRGB__impl__7pv8oi(blending)), toGl(_AGBlending___get_eqA__impl__2j4ray(blending)));
        gl.m9c(toGl_0(_AGBlending___get_srcRGB__impl__jvh03e(blending)), toGl_0(_AGBlending___get_dstRGB__impl__nz9ogp(blending)), toGl_0(_AGBlending___get_srcA__impl__ftmwxe(blending)), toGl_0(_AGBlending___get_dstA__impl__l7q6tv(blending)));
      }
    }
    this.o9c(depthAndFrontFace);
    this.c9c(colorMask);
    if (!(this.y96_1 === cullFace)) {
      this.y96_1 = cullFace;
      this.p9c(cullFace);
    }
    if (!(this.z96_1 === stencilOpFunc) || !equals(this.a97_1, stencilRef)) {
      this.z96_1 = stencilOpFunc;
      this.a97_1 = stencilRef;
      if (_AGStencilOpFunc___get_enabled__impl__hxq8wy(stencilOpFunc)) {
        gl.r9c(2960);
        if (_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc) === _AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc) && _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef) === _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef) && _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef) === _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef)) {
          gl.t9c(toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
        } else {
          gl.s9c(1028, toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
          gl.s9c(1029, toGl_1(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc)), _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef), _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef));
        }
        if (_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc) && _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc) && _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc) === _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)) {
          gl.v9c(toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
        } else {
          gl.u9c(1028, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
          gl.u9c(1029, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)));
        }
        if (_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef) === _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef)) {
          gl.g9c(_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
        } else {
          gl.w9c(1028, _AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
          gl.w9c(1029, _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef));
        }
      } else {
        gl.q9c(2960);
        gl.g9c(0);
      }
    }
    if (indices == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
      bindBuffer$default(this, indices, AGBufferKind_INDEX_getInstance());
    }
    var indexType_0 = !(indices == null) ? indexType : Companion_getInstance_44().u8k_1;
    if (!(indexType_0 === Companion_getInstance_44().u8k_1))
      if (!(instances === 1)) {
        gl.a9d(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset, instances);
      } else {
        gl.z9c(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset);
      }
     else if (!(instances === 1)) {
      gl.y9c(toGl_3(drawType), drawOffset, vertexCount, instances);
    } else {
      gl.x9c(toGl_3(drawType), drawOffset, vertexCount);
    }
  }
  a98() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v96_1;
    glslConfig$factory();
    return this_0.b2();
  }
  l8k() {
    var gl = this.p96_1;
    var tmp102_safe_receiver = this.q96_1;
    if (tmp102_safe_receiver == null)
      null;
    else {
      tmp102_safe_receiver.e9d();
    }
    gl.f9d(this.r8j_1);
    resetObjects(this);
    this.g97_1 = getIntegerv(gl, 36006);
    gl.k9b(33984);
    if (_GLVariant___get_supportTextureLevel__impl__3yeu62(gl.l9b())) {
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.j9b(3553, 33084, 0);
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.j9b(3553, 33085, 0);
    }
  }
  n8f() {
    var tmp103_safe_receiver = this.w96_1;
    if (tmp103_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.i9c(tmp103_safe_receiver);
    }
    this.w96_1 = null;
    this.a9c(this.h8k().t8j_1, this.h8k().c8m());
    var tmp104_safe_receiver = this.q96_1;
    if (tmp104_safe_receiver == null)
      null;
    else {
      tmp104_safe_receiver.g9d();
    }
  }
  j8k() {
    var tmp106_safe_receiver = this.w96_1;
    if (tmp106_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.i9c(tmp106_safe_receiver);
    }
    this.w96_1 = null;
    this.p96_1.fd();
    deletePendingObjects(this);
  }
  p9c(face) {
    if (this.p96_1.n9c(2884, _AGCullFace___get_ordinal__impl__jd1wps(face) > _AGCullFace___get_ordinal__impl__jd1wps(Companion_getInstance_52().y8l_1))) {
      this.p96_1.h9d(toGl_5(face));
    }
  }
  k9a(_this__u8e3s4, block) {
    if (!(_this__u8e3s4.y8n_1 === _this__u8e3s4.z8n_1)) {
      _this__u8e3s4.y8n_1 = _this__u8e3s4.z8n_1;
      block(_this__u8e3s4);
    }
  }
  i9c(vao) {
    if (this.k97_1 && this.p96_1.s8k()) {
      this.p96_1.k9d(0);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.p8t_1.e14_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        // Inline function 'korlibs.graphics.shader.attributes' call
        var this_0 = array[_unary__edvuaz].t8t_1.x8t_1;
        var n_0 = 0;
        while (n_0 < this_0.j1()) {
          // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>.<anonymous>' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          var att = this_0.i1(_unary__edvuaz_0);
          if (att.w90_1) {
            var loc = att.y90_1;
            if (loc >= 0) {
              if (!(att.x90_1 === 0)) {
                this.p96_1.i9d(loc, 0);
              }
              this.p96_1.j9d(loc);
            }
          }
        }
      }
    }
  }
  j9c(vao) {
    var gl = this.p96_1;
    if (this.k97_1 && gl.s8k()) {
      var vaoGl = get_gl(vao);
      if (vao.q8t_1) {
        if (!(this.j97_1 === this.r8j_1)) {
          this.i97_1 = genVertexArray(gl);
          this.j97_1 = this.r8j_1;
          if (this.i97_1 <= 0)
            this.k97_1 = false;
        }
        gl.k9d(this.i97_1);
        this.l9d(vao);
      } else {
        if (!(vaoGl.z95_1 === this.r8j_1)) {
          vaoGl.z95_1 = this.r8j_1;
          vaoGl.y95_1 = genVertexArray(gl);
          if (vaoGl.y95_1 <= 0)
            this.k97_1 = false;
          gl.k9d(vaoGl.y95_1);
          this.l9d(vao);
        }
        gl.k9d(vaoGl.y95_1);
        this.m9d(vao, this.k97_1);
      }
    } else {
      this.l9d(vao);
    }
  }
  m9d(vao, updateBuffersOnly) {
    var gl = this.p96_1;
    if (updateBuffersOnly) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.p8t_1.e14_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.u8t_1, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.l97_1);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = vao.p8t_1.e14_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry_0 = array_0[_unary__edvuaz_0];
      var vertices = entry_0.u8t_1;
      var vertexLayout = entry_0.t8t_1;
      // Inline function 'korlibs.graphics.shader.attributes' call
      var vattrs = vertexLayout.x8t_1;
      // Inline function 'korlibs.graphics.shader.attributePositions' call
      var vattrspos = vertexLayout.c8u_1;
      bindBuffer$default(this, vertices, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.l97_1);
      var totalSize = vertexLayout.e8u_1;
      var inductionVariable = 0;
      var last = vattrspos.j1() - 1 | 0;
      if (inductionVariable <= last)
        $l$loop: do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var att = vattrs.i1(n_1);
          if (!att.w90_1)
            continue $l$loop;
          var off = vattrspos.i1(n_1);
          var loc = att.y90_1;
          var glElementType = toGl_7(att.b2n());
          var elementCount = att.b2n().v9a_1;
          if (loc >= 0) {
            gl.n9d(loc);
            gl.o9d(loc, elementCount, glElementType, att.v90_1, totalSize, numberToLong(entry_0.v8t_1).c4(toLong(off)));
            if (!(att.x90_1 === 0)) {
              gl.i9d(loc, att.x90_1);
            }
          }
        }
         while (inductionVariable <= last);
    }
  }
  l9d(vao, updateBuffersOnly, $super) {
    updateBuffersOnly = updateBuffersOnly === VOID ? false : updateBuffersOnly;
    var tmp;
    if ($super === VOID) {
      this.m9d(vao, updateBuffersOnly);
      tmp = Unit_instance;
    } else {
      tmp = $super.m9d.call(this, vao, updateBuffersOnly);
    }
    return tmp;
  }
  k9c(uniformBlocks, textureUnits, program, frameBuffer) {
    var tmp0_elvis_lhs = this.d97_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var glProgram = tmp;
    // Inline function 'korlibs.graphics.AGTextureUnits.fastForEach' call
    var inductionVariable = 0;
    var last = textureUnits.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
        var tex = textureUnits.c8o_1[n];
        var info = AGTextureUnitInfoArray__get_impl_xhvpef(textureUnits.d8o_1, n);
        var tex_0 = tex;
        if (equals(frameBuffer.k8p_1, tex_0)) {
          tex_0 = null;
        }
        var tmp111_safe_receiver = tex_0;
        var tmp0_elvis_lhs_0 = tmp111_safe_receiver == null ? null : tmp111_safe_receiver.z8n_1;
        var texVersion = tmp0_elvis_lhs_0 == null ? -1 : tmp0_elvis_lhs_0;
        if (!(this.e97_1.c8o_1[n] === tex_0) || !(AGTextureUnitInfoArray__get_impl_xhvpef(this.e97_1.d8o_1, n) === info) || !(this.f97_1[n] === texVersion)) {
          this.e97_1.v8o(n, tex_0, info);
          this.f97_1[n] = texVersion;
          selectTextureUnit(this, n);
          if (!(tex_0 == null)) {
            var wrap = _AGTextureUnitInfo___get_wrap__impl__dwp6l(info);
            var linear = _AGTextureUnitInfo___get_linear__impl__jak6ny(info);
            var trilinear = _AGTextureUnitInfo___get_trilinear__impl__hxtqfb(info);
            this.p9d(tex_0, _AGTextureUnitInfo___get_kind__impl__6xtjoz(info));
            textureUnitParameters(this, tex_0.m8q(), wrap, this.q9d(tex_0, linear, trilinear), this.r9d(tex_0, linear, trilinear), _AGTextureTargetKind___get_dims__impl__k3cmhd(tex_0.m8q()));
          } else {
            this.p9d(null, Companion_getInstance_53().i8q_1);
          }
        }
      }
       while (inductionVariable < last);
    var glProgramInfo = glProgram.f98_1;
    // Inline function 'korlibs.graphics.shader.UniformBlocksBuffersRef.fastForEachBlock' call
    var inductionVariable_0 = 0;
    var last_0 = uniformBlocks.j1();
    if (inductionVariable_0 < last_0)
      $l$loop: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp0_elvis_lhs_1 = uniformBlocks.s9d_1[n_0];
        var tmp_0;
        if (tmp0_elvis_lhs_1 == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs_1;
        }
        var block = tmp_0;
        $l$block: {
          // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
          var buffer = uniformBlocks.t9d_1[n_0];
          var valueIndex = uniformBlocks.u9d_1[n_0];
          if (glProgram.f98_1.l98_1.k99()) {
            var buffer_0 = bindBuffer$default(this, buffer, AGBufferKind_UNIFORM_getInstance());
            var tmp0_elvis_lhs_2 = buffer_0 == null ? null : buffer_0.h9a_1;
            this.p96_1.v9d(35345, block.o8r_1.i8t_1, tmp0_elvis_lhs_2 == null ? -1 : tmp0_elvis_lhs_2, imul(valueIndex, block.r8r_1), block.r8r_1);
            break $l$block;
          }
          var tmp1_elvis_lhs = glProgramInfo.o98_1[block.o8r_1.i8t_1];
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            var message = "Can't find uniform at " + block.o8r_1.i8t_1 + ' for program ' + program.toString() + ' for block ' + block.toString();
            throw IllegalStateException.m5(toString(message));
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var ref = tmp_1;
          var bufferMem = ensureNotNull(ensureNotNull(buffer).q8n_1);
          var currentMem = ref.x9d_1;
          var ublock = ref.w9d_1;
          if (valueIndex >= 0) {
            if (!arrayequal(bufferMem, valueIndex, currentMem, 0, ublock.u8z())) {
              arraycopy_0(bufferMem, imul(ublock.u8z(), valueIndex), currentMem, 0, ublock.u8z());
              // Inline function 'korlibs.datastructure.iterators.fastForEach' call
              var this_0 = ublock.s8z();
              var n_1 = 0;
              while (n_1 < this_0.j1()) {
                // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>.<anonymous>' call
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var uniform = this_0.i1(_unary__edvuaz);
                writeUniform(this, uniform.h8t_1, glProgramInfo, sliceBuffer(currentMem, uniform.e8t_1, uniform.e8t_1 + uniform.r9a_1 | 0), 'blockUniformSet');
              }
            }
          } else {
            println('ERROR block: ' + block.o8r_1.toString() + ' has an invalid valueIndex=' + valueIndex);
          }
        }
      }
       while (inductionVariable_0 < last_0);
  }
  q9d(_this__u8e3s4, linear, trilinear) {
    var tmp;
    if ((_this__u8e3s4 == null ? null : _this__u8e3s4.c8q_1) === true) {
      tmp = linear ? trilinear ? 9987 : 9985 : trilinear ? 9986 : 9984;
    } else {
      tmp = linear ? 9729 : 9728;
    }
    return tmp;
  }
  r9d(_this__u8e3s4, linear, trilinear) {
    return linear ? 9729 : 9728;
  }
  a9e(scissor, frameBuffer, frameBufferInfo) {
    return scissor.equals(Companion_getInstance_46().w8l_1) || scissor.equals(Companion_getInstance_46().u8l_1) ? scissor : frameBuffer.j8p_1 ? Companion_getInstance_46().h2t(scissor.p2i(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.s2i() | 0, scissor.q2i(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.r2i() | 0) : scissor;
  }
  p9d(tex, target) {
    var gl = this.p96_1;
    var glTex = tex == null ? null : _get_gl__ndc1ty_1(tex, this);
    var tmp = toGl_8(target);
    var tmp0_elvis_lhs = glTex == null ? null : glTex.v9b_1;
    gl.b9e(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs);
    var texBitmap = tex == null ? null : tex.b8q_1;
    if (!(glTex == null) && !(texBitmap == null)) {
      if (!(glTex.w9b_1 === texBitmap.n4p_1) || !(glTex.x9b_1 === this.r8j_1)) {
        glTex.w9b_1 = texBitmap.n4p_1;
        glTex.x9b_1 = this.r8j_1;
        tex.b8o();
      }
      this.k9a(tex, AGOpengl$textureBind$lambda(tex, target, gl, this, glTex));
    }
  }
  a9c(frameBuffer, info) {
    var gl = this.p96_1;
    if (!(this.r97_1 === _AGFrameBufferInfo___get_size__impl__uw80y4(info))) {
      gl.c9e(_AGFrameBufferInfo___get_x__impl__6dzfjj(info), _AGFrameBufferInfo___get_y__impl__mfn1io(info), _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
    }
    if (frameBuffer.j8p_1) {
      if (!(this.s97_1 === this.g97_1)) {
        this.s97_1 = this.g97_1;
        gl.d9e(36160, this.g97_1);
      }
      return Unit_instance;
    }
    var fb = _get_gl__ndc1ty_0(frameBuffer, this);
    var tex = fb.g9e_1.k8p_1;
    var doMsaa = false;
    if (!equals(fb.j9e_1, info)) {
      fb.j9e_1 = info;
      var internalFormat = _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 34041 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36168 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 6402 : 0;
      var texTarget = doMsaa ? 37120 : 3553;
      tex.b8q_1 = NullBitmap.m56(_AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info), false);
      // Inline function 'korlibs.graphics.gl.AGOpengl.selectTextureUnitTemp' call
      var index = this.p97_1;
      var old = selectTextureUnit(this, index);
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.bindFrameBuffer.<anonymous>' call
        this.p9d(tex, Companion_getInstance_53().i8q_1);
        textureUnitParameters(this, Companion_getInstance_53().i8q_1, Companion_getInstance_54().h8r_1, 9729, 9729, 2);
      }finally {
        if (true) {
          this.p9d(null, Companion_getInstance_53().i8q_1);
        }
        selectTextureUnit(this, old);
      }
      gl.k9e(36161, fb.h9e_1);
      if (!(internalFormat === 0)) {
        gl.l9e(36161, internalFormat, _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
      }
      gl.k9e(36161, 0);
      gl.d9e(36160, fb.i9e_1);
      gl.m9e(36160, 36064, 3553, _get_gl__ndc1ty_1(fb.g9e_1.k8p_1, this).v9b_1, 0);
      if (!(internalFormat === 0)) {
        gl.n9e(36160, _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 33306 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36128 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 36096 : 0, 36161, fb.h9e_1);
      } else {
        gl.n9e(36160, 36128, 36161, 0);
        gl.n9e(36160, 36096, 36161, 0);
      }
    }
    if (!(this.s97_1 === fb.i9e_1)) {
      this.s97_1 = fb.i9e_1;
      gl.d9e(36160, fb.i9e_1);
    }
  }
  o9c(renderState) {
    var gl = this.p96_1;
    if (!(this.c97_1 === renderState)) {
      this.c97_1 = renderState;
      gl.o9e(toGl_10(_AGDepthAndFrontFace___get_frontFace__impl__w07k4s(renderState)));
      gl.e9c(_AGDepthAndFrontFace___get_depthMask__impl__ouijn(renderState));
      gl.p9e(_AGDepthAndFrontFace___get_depthNear__impl__cir3a1(renderState), _AGDepthAndFrontFace___get_depthFar__impl__g0cno8(renderState));
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState) === Companion_getInstance_59().n8w_1);
      if (gl.n9c(2929, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setDepthAndFrontFace.<anonymous>' call
        gl.q9e(toGl_1(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState)));
      }
    }
  }
  c9c(colorMask) {
    var gl = this.p96_1;
    if (!(this.b97_1 === colorMask)) {
      this.b97_1 = colorMask;
      gl.r9e(_AGColorMask___get_red__impl__opo1fo(colorMask), _AGColorMask___get_green__impl__d3m1w2(colorMask), _AGColorMask___get_blue__impl__42l0s1(colorMask), _AGColorMask___get_alpha__impl__xmrqzb(colorMask));
    }
  }
  b9c(scissor, frameBuffer, frameBufferInfo) {
    var gl = this.p96_1;
    var scissor_0 = this.a9e(scissor, frameBuffer, frameBufferInfo);
    if (!this.h97_1.equals(scissor_0)) {
      this.h97_1 = scissor_0;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !scissor_0.equals(Companion_getInstance_46().w8l_1);
      if (gl.n9c(3089, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setScissorState.<anonymous>' call
        gl.s9e(scissor_0.n4f(), scissor_0.p4f(), scissor_0.j2y(), scissor_0.k2y());
      }
    }
  }
}
class GLGlobalState {
  constructor(gl, ag) {
    this.r99_1 = gl;
    this.s99_1 = ag;
    this.t99_1 = atomic$int$1(0);
    this.u99_1 = atomic$int$1(0);
    this.v99_1 = atomic$ref$1(0.0);
    this.w99_1 = atomic$int$1(0);
    this.x99_1 = atomic$int$1(0);
    this.y99_1 = atomic$ref$1(0.0);
    this.z99_1 = new Lock();
    this.a9a_1 = fastArrayListOf([]);
  }
}
class GLBaseObject {
  constructor(globalState) {
    this.b9a_1 = globalState;
    this.c9a_1 = this.b9a_1.r99_1;
  }
  d9a() {
  }
  f8r() {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.b9a_1.z99_1;
      this_0.w1w();
      try {
        this.b9a_1.a9a_1.f(this);
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
  }
}
class GLBaseProgram extends GLBaseObject {
  constructor(globalState, programInfo) {
    super(globalState);
    this.f98_1 = programInfo;
  }
  d9a() {
    this.f98_1.t9e(this.c9a_1);
  }
  g98() {
    this.f98_1.u9e(this.c9a_1);
  }
}
class GLBuffer extends GLBaseObject {
  constructor(state) {
    super(state);
    this.h9a_1 = genBuffer(this.c9a_1);
    this.i9a_1 = -1;
    this.j9a_1 = 0.0;
    this.b9a_1.w99_1.atomicfu$incrementAndGet();
  }
  m9b(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.b9a_1.y99_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLBuffer.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.j9a_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.j9a_1 = value;
  }
  d9a() {
    this.b9a_1.x99_1.atomicfu$incrementAndGet();
    deleteBuffer(this.c9a_1, this.h9a_1);
    this.h9a_1 = -1;
    this.i9a_1 = -1;
  }
  toString() {
    return 'GLBuffer(' + this.h9a_1 + ')';
  }
}
class GLTexture extends GLBaseObject {
  constructor(state) {
    super(state);
    this.v9b_1 = genTexture(this.c9a_1);
    this.w9b_1 = -2;
    this.x9b_1 = -2;
    this.y9b_1 = 0.0;
    this.b9a_1.t99_1.atomicfu$incrementAndGet();
  }
  m9b(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.b9a_1.v99_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLTexture.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.y9b_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.y9b_1 = value;
  }
  d9a() {
    this.b9a_1.u99_1.atomicfu$incrementAndGet();
    deleteTexture(this.c9a_1, this.v9b_1);
    this.v9b_1 = -1;
  }
}
class GLFrameBuffer extends GLBaseObject {
  constructor(state, ag) {
    super(state);
    this.g9e_1 = ag;
    this.h9e_1 = genRenderbuffer(this.c9a_1);
    this.i9e_1 = genFramebuffer(this.c9a_1);
    this.j9e_1 = Companion_getInstance_47().a8w_1;
  }
  d9a() {
    deleteRenderbuffer(this.c9a_1, this.h9e_1);
    deleteFramebuffer(this.c9a_1, this.i9e_1);
    this.h9e_1 = -1;
    this.i9e_1 = -1;
  }
}
class GLProgramInfo {
  constructor(programId, vertexId, fragmentId, blocks, config) {
    this.h98_1 = programId;
    this.i98_1 = vertexId;
    this.j98_1 = fragmentId;
    this.k98_1 = blocks;
    this.l98_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.k98_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.blocksByFixedLocation.<anonymous>' call
      var tmp$ret$0 = element.i8t_1;
      destination.r3(tmp$ret$0, element);
    }
    tmp.m98_1 = destination;
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.k98_1.f1();
      if (!iterator.g1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
      var maxValue = iterator.h1().i8t_1;
      while (iterator.g1()) {
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
        var v = iterator.h1().i8t_1;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.n98_1 = (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) + 1 | 0;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.n98_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp145_safe_receiver = this.m98_1.k3(tmp_5);
      var tmp_6;
      if (tmp145_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.uniforms.<anonymous>' call
        tmp_6 = UniformsRef.v9e(tmp145_safe_receiver);
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.o98_1 = tmp_4;
    this.p98_1 = FastStringMap();
    this.q98_1 = FastStringMap();
  }
  c99(gl, name) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.q98_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(name);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.getUniformLocation.<anonymous>' call
      var out = gl.w9e(this.h98_1, name);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(name, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  u9e(gl) {
    gl.x9e(this.h98_1);
  }
  t9e(gl) {
    if (!(this.i98_1 === 0)) {
      gl.y9e(this.i98_1);
    }
    if (!(this.j98_1 === 0)) {
      gl.y9e(this.j98_1);
    }
    if (!(this.h98_1 === 0)) {
      gl.z9e(this.h98_1);
    }
    this.i98_1 = 0;
    this.j98_1 = 0;
    this.h98_1 = 0;
  }
  toString() {
    return 'GLProgramInfo(programId=' + this.h98_1 + ', vertexId=' + this.i98_1 + ', fragmentId=' + this.j98_1 + ', blocks=' + toString(this.k98_1) + ', config=' + this.l98_1.toString() + ')';
  }
  hashCode() {
    var result = this.h98_1;
    result = imul(result, 31) + this.i98_1 | 0;
    result = imul(result, 31) + this.j98_1 | 0;
    result = imul(result, 31) + hashCode(this.k98_1) | 0;
    result = imul(result, 31) + this.l98_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GLProgramInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GLProgramInfo ? other : THROW_CCE();
    if (!(this.h98_1 === tmp0_other_with_cast.h98_1))
      return false;
    if (!(this.i98_1 === tmp0_other_with_cast.i98_1))
      return false;
    if (!(this.j98_1 === tmp0_other_with_cast.j98_1))
      return false;
    if (!equals(this.k98_1, tmp0_other_with_cast.k98_1))
      return false;
    if (!this.l98_1.equals(tmp0_other_with_cast.l98_1))
      return false;
    return true;
  }
}
class GLShaderCompiler {
  constructor() {
    GLShaderCompiler_instance = this;
    this.b98_1 = Companion_getInstance_2().ez('GLShaderCompiler');
  }
  c98(gl, config, program, debugName) {
    var id = gl.e9f();
    var guessedGlSlVersion = get_versionInt(gl);
    var tmp0_elvis_lhs = Companion_getInstance_64().g9f();
    var usedGlSlVersion = tmp0_elvis_lhs == null ? guessedGlSlVersion : tmp0_elvis_lhs;
    if (Companion_getInstance_64().h9f()) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = this.b98_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.u3g(level)) {
        // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
        var tmp$ret$0 = 'GLSL version: usedGlSlVersion=' + usedGlSlVersion + ', guessed=' + guessedGlSlVersion + ', forced=' + Companion_getInstance_64().g9f() + '. used=' + usedGlSlVersion;
        this_0.v3g(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf_0([false, true]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
      var tmp$ret$2 = config.i9f(VOID, VOID, usedGlSlVersion, item);
      destination.f(tmp$ret$2);
    }
    var _destruct__k2r9zo = this.j9f(gl, program, debugName, destination);
    var fragmentShaderId = _destruct__k2r9zo.km();
    var vertexShaderId = _destruct__k2r9zo.lm();
    var finalConfig = _destruct__k2r9zo.ks();
    var _iterator__ex2g4s = program.q8s_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var attr = _iterator__ex2g4s.h1();
      var location = attr.y90_1;
      gl.k9f(id, location, attr.x98_1);
    }
    gl.l9f(id, fragmentShaderId);
    gl.l9f(id, vertexShaderId);
    gl.m9f(id);
    // Inline function 'korlibs.kgl.KmlGl.LINK_STATUS' call
    var linkStatus = getProgramiv(gl, id, 35714);
    return new GLProgramInfo(id, vertexShaderId, fragmentShaderId, program.n8s_1, finalConfig);
  }
  j9f(gl, program, debugName, configs) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var errors = ArrayList.m1();
    var _iterator__ex2g4s = configs.f1();
    $l$loop: while (_iterator__ex2g4s.g1()) {
      var config = _iterator__ex2g4s.h1();
      try {
        var fragmentString = toNewGlslString(program.j8s_1, config);
        var vertexString = toNewGlslString(program.i8s_1, config);
        var fragmentShaderId = createShader(this, gl, 35632, fragmentString, debugName);
        var vertexShaderId = createShader(this, gl, 35633, vertexString, debugName);
        // Inline function 'korlibs.logger.Logger.debug' call
        var this_0 = this.b98_1;
        var level = Level_DEBUG_getInstance();
        var tmp;
        if (this_0.u3g(level)) {
          // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
          var tmp$ret$1 = '!!! PROGRAM SUCCESSFULLY COMPILED: config=' + config.toString() + '\n' + vertexString + '\n' + fragmentString;
          this_0.v3g(level, tmp$ret$1);
          tmp = Unit_instance;
        }
        return new Triple(fragmentShaderId, vertexShaderId, config);
      } catch ($p) {
        if ($p instanceof ShaderException) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.debug' call
          var this_1 = this.b98_1;
          var level_0 = Level_DEBUG_getInstance();
          var tmp_0;
          if (this_1.u3g(level_0)) {
            // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
            var tmp$ret$3 = stackTraceToString(e);
            this_1.v3g(level_0, tmp$ret$3);
            tmp_0 = Unit_instance;
          }
          // Inline function 'kotlin.collections.plusAssign' call
          errors.f(e);
          continue $l$loop;
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(errors, 10));
    var tmp0_iterator = errors.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
      var tmp$ret$5 = item.message;
      destination.f(tmp$ret$5);
    }
    throw Exception.ue('Tried several shaders: ' + toString(destination), last(errors));
  }
}
class AGDummy extends AG {
  constructor(size) {
    size = size === VOID ? Size2D.f2j(640, 480) : size;
    super();
    this.h8k().o8p(numberToInt(size.d2j_1), numberToInt(size.e2j_1));
  }
  p8k() {
    return emptySet();
  }
  q8k() {
    return true;
  }
  t8k() {
    return true;
  }
}
class AGBaseLog extends AGDummy {
  constructor(size) {
    size = size === VOID ? Size2D.f2j(640, 480) : size;
    super(size);
    this.f9g_1 = 0;
    this.g9g_1 = 0;
    this.h9g_1 = 0;
    this.i9g_1 = 0;
    this.j9g_1 = linkedHashMapOf([]);
  }
  a9g(str, kind) {
  }
  k8k(command) {
    this.a9g(toString(command), Kind_COMMAND_getInstance());
  }
  j8k() {
    return this.a9g('finish()', Kind_FLIP_getInstance());
  }
}
class AGPrint extends AGBaseLog {
  constructor(size) {
    size = size === VOID ? Size2D.f2j(640, 480) : size;
    super(size);
  }
  a9g(str, kind) {
    println('PrintAG: ' + str);
  }
}
class Kind_0 extends Enum {}
class Companion_44 {
  constructor() {
    Companion_instance_53 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp.e8l_1 = new UniformBlocksBuffersRef(tmp_0, tmp$ret$1, new Int32Array(0));
  }
}
class UniformBlocksBuffersRef {
  constructor(blocks, buffers, valueIndices) {
    Companion_getInstance_61();
    this.s9d_1 = blocks;
    this.t9d_1 = buffers;
    this.u9d_1 = valueIndices;
  }
  j1() {
    return this.s9d_1.length;
  }
}
class Gen {
  constructor(block, name, voffset, vindex, type, arrayCount, size, align) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    this.g8z_1 = block;
    this.h8z_1 = name;
    this.i8z_1 = voffset;
    this.j8z_1 = vindex;
    this.k8z_1 = type;
    this.l8z_1 = arrayCount;
    this.m8z_1 = size;
    this.n8z_1 = align;
    var tmp = this;
    tmp.o8z_1 = lazy(UniformBlock$Gen$uniform$delegate$lambda(this));
  }
  l9g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o8z_1;
    uniform$factory();
    return this_0.b2();
  }
  p8z(block, property) {
    var tmp = this;
    var tmp0_elvis_lhs = this.h8z_1;
    tmp.h8z_1 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    return this.l9g();
  }
  m9g(block, name, voffset, vindex, type, arrayCount, size, align) {
    return new Gen(block, name, voffset, vindex, type, arrayCount, size, align);
  }
  n9g(block, name, voffset, vindex, type, arrayCount, size, align, $super) {
    block = block === VOID ? this.g8z_1 : block;
    name = name === VOID ? this.h8z_1 : name;
    voffset = voffset === VOID ? this.i8z_1 : voffset;
    vindex = vindex === VOID ? this.j8z_1 : vindex;
    type = type === VOID ? this.k8z_1 : type;
    arrayCount = arrayCount === VOID ? this.l8z_1 : arrayCount;
    size = size === VOID ? this.m8z_1 : size;
    align = align === VOID ? this.n8z_1 : align;
    return $super === VOID ? this.m9g(block, name, voffset, vindex, type, arrayCount, size, align) : $super.m9g.call(this, block, name, voffset, vindex, type, arrayCount, size, align);
  }
  toString() {
    return 'Gen(block=' + this.g8z_1.toString() + ', name=' + this.h8z_1 + ', voffset=' + this.i8z_1 + ', vindex=' + this.j8z_1 + ', type=' + this.k8z_1.toString() + ', arrayCount=' + this.l8z_1 + ', size=' + this.m8z_1 + ', align=' + this.n8z_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.g8z_1);
    result = imul(result, 31) + (this.h8z_1 == null ? 0 : getStringHashCode(this.h8z_1)) | 0;
    result = imul(result, 31) + this.i8z_1 | 0;
    result = imul(result, 31) + this.j8z_1 | 0;
    result = imul(result, 31) + this.k8z_1.hashCode() | 0;
    result = imul(result, 31) + this.l8z_1 | 0;
    result = imul(result, 31) + this.m8z_1 | 0;
    result = imul(result, 31) + this.n8z_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Gen))
      return false;
    var tmp0_other_with_cast = other instanceof Gen ? other : THROW_CCE();
    if (!equals(this.g8z_1, tmp0_other_with_cast.g8z_1))
      return false;
    if (!(this.h8z_1 == tmp0_other_with_cast.h8z_1))
      return false;
    if (!(this.i8z_1 === tmp0_other_with_cast.i8z_1))
      return false;
    if (!(this.j8z_1 === tmp0_other_with_cast.j8z_1))
      return false;
    if (!this.k8z_1.equals(tmp0_other_with_cast.k8z_1))
      return false;
    if (!(this.l8z_1 === tmp0_other_with_cast.l8z_1))
      return false;
    if (!(this.m8z_1 === tmp0_other_with_cast.m8z_1))
      return false;
    if (!(this.n8z_1 === tmp0_other_with_cast.n8z_1))
      return false;
    return true;
  }
}
class Operand {
  static f9q(type) {
    var $this = createThis(this);
    $this.l9a_1 = type;
    return $this;
  }
  b2n() {
    return this.l9a_1;
  }
}
class OperandWithArray extends Operand {
  static g9s(type, arrayCount) {
    var $this = this.f9q(type);
    $this.n9a_1 = arrayCount;
    $this.o9a_1 = type.u9a_1;
    $this.p9a_1 = type.v9a_1;
    $this.q9a_1 = imul($this.p9a_1, $this.n9a_1);
    $this.r9a_1 = imul(type.x9a_1, $this.n9a_1);
    return $this;
  }
}
class Variable extends OperandWithArray {
  static f9r(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    var $this = this.g9s(type, arrayCount);
    $this.x98_1 = name;
    $this.y98_1 = precision;
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(arrayCount), null);
    while (tmp_0 < arrayCount) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = $this.x98_1 + '[' + tmp_2 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.z98_1 = tmp_1;
    $this.a99_1 = 0;
    $this.b99_1 = null;
    return $this;
  }
  static w9r(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.f9r(name, type, 1, precision);
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this.a99_1 === other.a99_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.b2n().equals(other.b2n());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n9a_1 === other.n9a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.x98_1 === other.x98_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.a99_1 + imul(this.b2n().hashCode(), 7) | 0) + imul(getStringHashCode(this.x98_1), 11) | 0;
  }
}
class VariableWithOffset extends Variable {
  static f9h(name, type, arrayCount, precision, offset) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.f9r(name, type, arrayCount, precision);
    $this.e9h_1 = offset;
    return $this;
  }
}
class TypedUniform extends VariableWithOffset {
  static k9g(name, voffset, vindex, block, type, arrayCount) {
    var $this = this.f9h(name, type, arrayCount, Precision_DEFAULT_getInstance());
    $this.e8t_1 = voffset;
    $this.f8t_1 = vindex;
    $this.g8t_1 = block;
    $this.h8t_1 = Uniform.t9h(name, type, arrayCount, VOID, VOID, $this);
    return $this;
  }
  ko(thisRef, property) {
    return this;
  }
  toString() {
    return "TypedUniform(name='" + this.x98_1 + "', offset=" + this.e8t_1 + ', type=' + this.b2n().toString() + ')';
  }
}
class Companion_45 {}
class UniformBlockBuffer {
  constructor(block) {
    this.o8r_1 = block;
    this.p8r_1 = new AGBuffer();
    this.q8r_1 = this.o8r_1.t8z();
    this.r8r_1 = this.o8r_1.u8z();
    this.s8r_1 = this.o8r_1.s8z().j1();
    this.t8r_1 = Buffer.t10(imul(this.r8r_1, 1));
    this.u8r_1 = UniformsRef.u9h(this.o8r_1, this.t8r_1, -1);
    this.v8r_1 = Buffer.t10(this.o8r_1.u8z());
  }
  toString() {
    return 'UniformBlockBuffer(' + toString(this.o8r_1) + ')';
  }
  v9h(value) {
    this.u8r_1.y9d_1 = value;
  }
  n8t() {
    return this.u8r_1.y9d_1;
  }
  w9h(index) {
    if (index >= (_get_bufferSize__mp12kq(this) - 1 | 0)) {
      // Inline function 'kotlin.math.max' call
      var a = index + 1 | 0;
      var b = imul(index + 2 | 0, 3);
      var newCapacity = Math.max(a, b);
      this.t8r_1 = copyOf(this.t8r_1, imul(this.r8r_1, newCapacity));
      this.u8r_1.x9d_1 = this.t8r_1;
    }
  }
  z33() {
    this.v9h(-1);
  }
  x8r() {
    var tmp = this.t8r_1;
    // Inline function 'kotlin.math.max' call
    var b = imul(this.n8t() + 1 | 0, this.o8r_1.u8z());
    var tmp$ret$0 = Math.max(0, b);
    this.p8r_1.v8n(tmp, 0, tmp$ret$0);
    return this;
  }
  x9h() {
    var _unary__edvuaz = this.n8t();
    this.v9h(_unary__edvuaz - 1 | 0);
  }
}
class UBLayoutBuilder {
  constructor() {
    this.o9g_1 = 0;
    this.p9g_1 = 4;
    var tmp = this;
    tmp.q9g_1 = lazy(UBLayoutBuilder$size$delegate$lambda(this));
  }
  j1() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q9g_1;
    size$factory();
    return this_0.b2();
  }
  s9g(size, align_0) {
    // Inline function 'kotlin.also' call
    var this_0 = align(this, align_0).o9g_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UBLayoutBuilder.rawAlloc.<anonymous>' call
    this.o9g_1 = this.o9g_1 + size | 0;
    return this_0;
  }
}
class UniformsRef {
  static u9h(block, buffer, index) {
    var $this = createThis(this);
    $this.w9d_1 = block;
    $this.x9d_1 = buffer;
    $this.y9d_1 = index;
    $this.z9d_1 = $this.w9d_1.u8z();
    return $this;
  }
  static v9e(block, size, index) {
    size = size === VOID ? 1 : size;
    index = index === VOID ? 0 : index;
    return this.u9h(block, Buffer.t10(imul(block.u8z(), size)), index);
  }
  y9h(uniform) {
    return imul(this.y9d_1, this.z9d_1) + uniform.e8t_1 | 0;
  }
  z9h(ref) {
    arraycopy_0(ref.t8r_1, 0, this.x9d_1, imul(this.y9d_1, this.z9d_1), this.z9d_1);
  }
  a9i(uniform, value) {
    return this.b9i(uniform, value ? 1.0 : 0.0);
  }
  c9i(uniform, value) {
    return this.b9i(uniform, value);
  }
  d9i(uniform, value) {
    return this.b9i(uniform, Ratio__toFloat_impl_1ftup5(value));
  }
  e9i(uniform, value) {
    return this.f9i(uniform, value.y2x_1, value.z2x_1);
  }
  g9i(uniform, value) {
    return this.f9i(uniform, value.i2h_1, value.j2h_1);
  }
  h9i(uniform, value) {
    return this.i9i(uniform, _RGBA___get_rf__impl__kvz75k(value), _RGBA___get_gf__impl__5gcu1f(value), _RGBA___get_bf__impl__1xz5yg(value), _RGBA___get_af__impl__vu36qv(value));
  }
  j9i(uniform, value) {
    return this.i9i(uniform, _RGBAPremultiplied___get_rf__impl__pt0c4y(value), _RGBAPremultiplied___get_gf__impl__ivron7(value), _RGBAPremultiplied___get_bf__impl__qa3on2(value), _RGBAPremultiplied___get_af__impl__euwcjn(value));
  }
  k9i(uniform, value) {
    return this.i9i(uniform, value.w2p_1, value.x2p_1, value.y2p_1, value.z2p_1);
  }
  l9i(uniform, value) {
    return this.i9i(uniform, value.a2t_1, value.z2s_1, value.b2t_1, value.y2s_1);
  }
  m9i(uniform, value) {
    switch (uniform.b2n().v3_1) {
      case 3:
        this.n9i(uniform, value, Companion_getInstance_7().o2p_1);
        break;
      case 2:
        this.o9i(uniform, value, Companion_getInstance_7().o2p_1, 12);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.oe();
    }
  }
  p9i(uniform, value) {
    // Inline function 'kotlin.also' call
    var this_0 = this.y9h(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    var inductionVariable = 0;
    var last = value.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.q9i(this_0 + imul(n, 64) | 0, value[n]);
      }
       while (inductionVariable <= last);
  }
  o9i(uniform, value, indices, max) {
    // Inline function 'kotlin.also' call
    var this_0 = this.y9h(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.memory.setF32' call
        var this_1 = this.x9d_1;
        var byteOffset = this_0 + imul(n, 4) | 0;
        // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>.<anonymous>' call
        var it = indices[n];
        var value_0 = value.p2r(it);
        var tmp;
        if (true) {
          this_1.x10(byteOffset, value_0);
          tmp = Unit_instance;
        } else {
          this_1.w10(byteOffset, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  }
  n9i(uniform, value, indices, max, $super) {
    max = max === VOID ? indices.length : max;
    var tmp;
    if ($super === VOID) {
      this.o9i(uniform, value, indices, max);
      tmp = Unit_instance;
    } else {
      tmp = $super.o9i.call(this, uniform, value, indices, max);
    }
    return tmp;
  }
  b9i(uniform, value) {
    // Inline function 'kotlin.also' call
    var this_0 = this.y9h(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.x9d_1;
    var byteOffset = this_0 + 0 | 0;
    var tmp;
    if (true) {
      this_1.x10(byteOffset, value);
      tmp = Unit_instance;
    } else {
      this_1.w10(byteOffset, value);
      tmp = Unit_instance;
    }
  }
  f9i(uniform, x, y) {
    // Inline function 'kotlin.also' call
    var this_0 = this.y9h(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.r9i(this_0, x, y);
  }
  i9i(uniform, x, y, z, w) {
    // Inline function 'kotlin.also' call
    var this_0 = this.y9h(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.s9i(this_0, x, y, z, w);
  }
  r9i(index, x, y) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.x9d_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.x10(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.w10(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.x9d_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.x10(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.w10(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
  }
  s9i(index, x, y, z, w) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.x9d_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.x10(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.w10(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.x9d_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.x10(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.w10(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_2 = this.x9d_1;
    var byteOffset_1 = index + 8 | 0;
    var tmp_1;
    if (true) {
      this_2.x10(byteOffset_1, z);
      tmp_1 = Unit_instance;
    } else {
      this_2.w10(byteOffset_1, z);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_3 = this.x9d_1;
    var byteOffset_2 = index + 12 | 0;
    var tmp_2;
    if (true) {
      this_3.x10(byteOffset_2, w);
      tmp_2 = Unit_instance;
    } else {
      this_3.w10(byteOffset_2, w);
      tmp_2 = Unit_instance;
    }
  }
  t9i(index, value, indices) {
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var max = indices.length;
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.memory.setF32' call
        var this_0 = this.x9d_1;
        var byteOffset = index + imul(n, 4) | 0;
        // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloat16.<anonymous>' call
        var it = indices[n];
        var value_0 = value.p2r(it);
        var tmp;
        if (true) {
          this_0.x10(byteOffset, value_0);
          tmp = Unit_instance;
        } else {
          this_0.w10(byteOffset, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  }
  q9i(index, value, indices, $super) {
    indices = indices === VOID ? Companion_getInstance_7().o2p_1 : indices;
    var tmp;
    if ($super === VOID) {
      this.t9i(index, value, indices);
      tmp = Unit_instance;
    } else {
      tmp = $super.t9i.call(this, index, value, indices);
    }
    return tmp;
  }
}
class Companion_46 {
  u9i(isES, isWebGL, isCore, version, os) {
    return _GLVariant___init__impl__cjzpjb(insert8(insert8(insert(insert(insert(0, isES, 0), isWebGL, 1), isCore, 2), version, 8), os.v3_1, 16));
  }
  v9i(isES, isWebGL, isCore, version, os, $super) {
    isES = isES === VOID ? false : isES;
    isWebGL = isWebGL === VOID ? false : isWebGL;
    isCore = isCore === VOID ? false : isCore;
    version = version === VOID ? 0 : version;
    os = os === VOID ? Os_UNKNOWN_getInstance() : os;
    return $super === VOID ? this.u9i(isES, isWebGL, isCore, version, os) : $super.u9i.call(this, isES, isWebGL, isCore, version, os).w9i_1;
  }
  x9i() {
    return Companion_instance_55.v9i(false, VOID, VOID, 1, Os_UNKNOWN_getInstance());
  }
  y9i(version) {
    return Companion_instance_55.v9i(true, true, VOID, version);
  }
}
class GLVariant {
  constructor(data) {
    this.w9i_1 = data;
  }
  toString() {
    return GLVariant__toString_impl_o5yi3l(this.w9i_1);
  }
  hashCode() {
    return GLVariant__hashCode_impl_2eslaq(this.w9i_1);
  }
  equals(other) {
    return GLVariant__equals_impl_kmlw2(this.w9i_1, other);
  }
}
class Visitor {
  constructor(default_0, $box) {
    boxApply(this, $box);
    this.r9k_1 = default_0;
  }
  s9k(func) {
    this.t9k(func.k9m_1);
  }
  d9q(stms) {
    var _iterator__ex2g4s = stms.f1();
    while (_iterator__ex2g4s.g1()) {
      var stm = _iterator__ex2g4s.h1();
      this.t9k(stm);
    }
  }
  t9k(stm) {
    var tmp;
    if (stm == null) {
      tmp = Unit_instance;
    } else {
      if (stm instanceof Stms) {
        this.u9k(stm);
        tmp = Unit_instance;
      } else {
        if (stm instanceof Set) {
          this.x9k(stm);
          tmp = Unit_instance;
        } else {
          if (stm instanceof If) {
            this.v9k(stm);
            tmp = Unit_instance;
          } else {
            if (stm instanceof ForSimple) {
              this.w9k(stm);
              tmp = Unit_instance;
            } else {
              if (stm instanceof Discard) {
                this.y9k(stm);
                tmp = Unit_instance;
              } else {
                if (stm instanceof Continue) {
                  this.a9l(stm);
                  tmp = Unit_instance;
                } else {
                  if (stm instanceof Break) {
                    this.z9k(stm);
                    tmp = Unit_instance;
                  } else {
                    if (stm instanceof Raw) {
                      this.b9l(stm);
                      tmp = Unit_instance;
                    } else {
                      if (stm instanceof Return) {
                        this.c9l(stm);
                        tmp = Unit_instance;
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  u9k(stms) {
    var _iterator__ex2g4s = stms.a9n_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var stm = _iterator__ex2g4s.h1();
      this.t9k(stm);
    }
  }
  v9k(stm) {
    this.d9l(stm.u9n_1);
    this.t9k(stm.v9n_1);
    this.t9k(stm.w9n_1);
  }
  w9k(stm) {
    this.g9l(stm.x9n_1);
    this.d9l(stm.y9n_1);
    this.t9k(stm.a9o_1);
  }
  x9k(stm) {
    this.d9l(stm.c9n_1);
    this.d9l(stm.b9n_1);
  }
  y9k(stm) {
  }
  z9k(stm) {
  }
  a9l(stm) {
  }
  b9l(stm) {
    this.t9k(stm.u9m_1);
  }
  c9l(stm) {
    var tmp191_safe_receiver = stm.d9n_1;
    if (tmp191_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.shader.Visitor.visit.<anonymous>' call
      this.d9l(tmp191_safe_receiver);
    }
  }
  d9l(operand) {
    var tmp;
    if (operand instanceof Variable) {
      tmp = this.g9l(operand);
    } else {
      if (operand instanceof Unop) {
        tmp = this.k9l(operand);
      } else {
        if (operand instanceof Binop) {
          tmp = this.l9l(operand);
        } else {
          if (operand instanceof Ternary) {
            tmp = this.m9l(operand);
          } else {
            if (operand instanceof BoolLiteral) {
              tmp = this.s9l(operand);
            } else {
              if (operand instanceof IntLiteral) {
                tmp = this.q9l(operand);
              } else {
                if (operand instanceof FloatLiteral) {
                  tmp = this.r9l(operand);
                } else {
                  if (operand instanceof Vector) {
                    tmp = this.p9l(operand);
                  } else {
                    if (operand instanceof Swizzle) {
                      tmp = this.n9l(operand);
                    } else {
                      if (operand instanceof ArrayAccess) {
                        tmp = this.o9l(operand);
                      } else {
                        if (operand instanceof BaseFunc) {
                          tmp = this.e9l(operand);
                        } else {
                          invalidOp("Don't know how to visit operand " + toString(operand));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  e9l(func) {
    var _iterator__ex2g4s = func.p9n().f1();
    while (_iterator__ex2g4s.g1()) {
      var op = _iterator__ex2g4s.h1();
      this.d9l(op);
    }
    var tmp;
    if (func instanceof Func) {
      tmp = this.f9l(func);
    } else {
      if (func instanceof CustomFunc) {
        tmp = this.q9k(func);
      } else {
        invalidOp("Don't know how to visit func " + toString(func));
      }
    }
    return tmp;
  }
  f9l(func) {
    return this.r9k_1;
  }
  q9k(func) {
    return this.r9k_1;
  }
  g9l(operand) {
    var tmp;
    if (operand instanceof Attribute) {
      tmp = this.c9k(operand);
    } else {
      if (operand instanceof Varying) {
        tmp = this.e9k(operand);
      } else {
        if (operand instanceof Sampler) {
          tmp = this.k9k(operand);
        } else {
          if (operand instanceof Uniform) {
            tmp = this.g9k(operand);
          } else {
            if (operand instanceof TypedUniform) {
              tmp = this.i9k(operand);
            } else {
              if (operand instanceof Output) {
                tmp = this.j9l(operand);
              } else {
                if (operand instanceof Temp) {
                  tmp = this.h9l(operand);
                } else {
                  if (operand instanceof Arg) {
                    tmp = this.i9l(operand);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  h9l(temp) {
    return this.r9k_1;
  }
  i9l(arg) {
    return this.r9k_1;
  }
  c9k(attribute) {
    return this.r9k_1;
  }
  e9k(varying) {
    return this.r9k_1;
  }
  g9k(uniform) {
    return this.r9k_1;
  }
  k9k(sampler) {
    return this.r9k_1;
  }
  i9k(typedUniform) {
    return this.g9k(typedUniform.h8t_1);
  }
  j9l(output) {
    return this.r9k_1;
  }
  k9l(operand) {
    this.d9l(operand.j9n_1);
    return this.r9k_1;
  }
  l9l(operand) {
    this.d9l(operand.l9n_1);
    this.d9l(operand.n9n_1);
    return this.r9k_1;
  }
  m9l(operand) {
    this.d9l(operand.r9n_1);
    this.d9l(operand.s9n_1);
    this.d9l(operand.t9n_1);
    return this.r9k_1;
  }
  n9l(operand) {
    this.d9l(operand.i9o_1);
    return this.r9k_1;
  }
  o9l(operand) {
    this.d9l(operand.l9o_1);
    this.d9l(operand.m9o_1);
    return this.r9k_1;
  }
  p9l(operand) {
    var indexedObject = operand.g9n_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.d9l(op);
    }
    return this.r9k_1;
  }
  q9l(operand) {
    return this.r9k_1;
  }
  r9l(operand) {
    return this.r9k_1;
  }
  s9l(operand) {
    return this.r9k_1;
  }
}
class GlobalsProgramVisitor extends Visitor {
  constructor() {
    super(Unit_instance);
    this.u9j_1 = LinkedHashSet.l1();
    this.v9j_1 = LinkedHashSet.l1();
    this.w9j_1 = LinkedHashSet.l1();
    this.x9j_1 = LinkedHashSet.l1();
    this.y9j_1 = LinkedHashSet.l1();
    this.z9j_1 = LinkedHashSet.l1();
    this.a9k_1 = LinkedHashSet.l1();
  }
  b9k(attribute) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.u9j_1.f(attribute);
  }
  c9k(attribute) {
    this.b9k(attribute);
    return Unit_instance;
  }
  d9k(varying) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.v9j_1.f(varying);
  }
  e9k(varying) {
    this.d9k(varying);
    return Unit_instance;
  }
  f9k(uniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.w9j_1.f(uniform);
    var tmp170_safe_receiver = uniform.s9h_1;
    if (tmp170_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.x9j_1.f(tmp170_safe_receiver);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.y9j_1;
    var element = uniform.s9h_1.g8t_1;
    this_0.f(element);
  }
  g9k(uniform) {
    this.f9k(uniform);
    return Unit_instance;
  }
  h9k(typedUniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.w9j_1;
    var element = typedUniform.h8t_1;
    this_0.f(element);
    // Inline function 'kotlin.collections.plusAssign' call
    this.x9j_1.f(typedUniform);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.y9j_1;
    var element_0 = typedUniform.g8t_1;
    this_1.f(element_0);
  }
  i9k(typedUniform) {
    this.h9k(typedUniform);
    return Unit_instance;
  }
  j9k(sampler) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.z9j_1.f(sampler);
  }
  k9k(sampler) {
    this.j9k(sampler);
    return Unit_instance;
  }
  l9k(func) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.a9k_1;
    var element = func.p9k().w3();
    this_0.f(element);
  }
  q9k(func) {
    this.l9k(func);
    return Unit_instance;
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_56 = this;
    this.f9f_1 = Companion_getInstance_2().ez('GlslGenerator');
  }
  g9f() {
    return Companion_getInstance_65().g9f();
  }
  h9f() {
    return Companion_getInstance_65().h9f();
  }
}
class Result {
  constructor(generator, result, attributes, uniforms, varyings) {
    this.z9i_1 = generator;
    this.a9j_1 = result;
    this.b9j_1 = attributes;
    this.c9j_1 = uniforms;
    this.d9j_1 = varyings;
  }
  toString() {
    return 'Result(generator=' + toString(this.z9i_1) + ', result=' + this.a9j_1 + ', attributes=' + toString(this.b9j_1) + ', uniforms=' + toString(this.c9j_1) + ', varyings=' + toString(this.d9j_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.z9i_1);
    result = imul(result, 31) + getStringHashCode(this.a9j_1) | 0;
    result = imul(result, 31) + hashCode(this.b9j_1) | 0;
    result = imul(result, 31) + hashCode(this.c9j_1) | 0;
    result = imul(result, 31) + hashCode(this.d9j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.z9i_1, tmp0_other_with_cast.z9i_1))
      return false;
    if (!(this.a9j_1 === tmp0_other_with_cast.a9j_1))
      return false;
    if (!equals(this.b9j_1, tmp0_other_with_cast.b9j_1))
      return false;
    if (!equals(this.c9j_1, tmp0_other_with_cast.c9j_1))
      return false;
    if (!equals(this.d9j_1, tmp0_other_with_cast.d9j_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.y9l_1 = function_0;
  }
  rj(a, b) {
    return this.y9l_1(a, b);
  }
  compare(a, b) {
    return this.rj(a, b);
  }
}
class BaseGlslGenerator {}
function precToString(prec) {
  var tmp;
  if (!_GLVariant___get_isES__impl__yezzg8(this.r9m().g99_1)) {
    tmp = '';
  } else {
    var tmp_0;
    switch (prec.v3_1) {
      case 0:
        tmp_0 = '';
        break;
      case 1:
        tmp_0 = 'lowp ';
        break;
      case 2:
        tmp_0 = 'mediump ';
        break;
      case 3:
        tmp_0 = 'highp ';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeToString(type) {
  var tmp;
  switch (type.v3_1) {
    case 0:
      tmp = 'void';
      break;
    case 21:
      tmp = 'vec4';
      break;
    case 1:
      tmp = 'mat2';
      break;
    case 2:
      tmp = 'mat3';
      break;
    case 3:
      tmp = 'mat4';
      break;
    case 4:
      tmp = 'sampler1D';
      break;
    case 5:
      tmp = 'sampler2D';
      break;
    case 6:
      tmp = 'sampler3D';
      break;
    case 7:
      tmp = 'samplerCube';
      break;
    default:
      var tmp_0;
      switch (type.u9a_1.v3_1) {
        case 0:
          var tmp_1;
          switch (type.v9a_1) {
            case 1:
              tmp_1 = 'bool';
              break;
            case 2:
              tmp_1 = 'bvec2';
              break;
            case 3:
              tmp_1 = 'bvec3';
              break;
            case 4:
              tmp_1 = 'bvec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_1;
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
          var tmp_2;
          switch (type.v9a_1) {
            case 1:
              tmp_2 = 'float';
              break;
            case 2:
              tmp_2 = 'vec2';
              break;
            case 3:
              tmp_2 = 'vec3';
              break;
            case 4:
              tmp_2 = 'vec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_2;
          break;
        case 5:
          var tmp_3;
          switch (type.v9a_1) {
            case 1:
              tmp_3 = 'int';
              break;
            case 2:
              tmp_3 = 'ivec2';
              break;
            case 3:
              tmp_3 = 'ivec3';
              break;
            case 4:
              tmp_3 = 'ivec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_3;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
}
function get_arrayDecl(_this__u8e3s4) {
  return !(_this__u8e3s4.n9a_1 === 1) ? '[' + _this__u8e3s4.n9a_1 + ']' : '';
}
function get_IN() {
  return this.r9m().a9m();
}
function get_OUT() {
  return this.r9m().f9m();
}
function get_UNIFORM() {
  return this.r9m().e9m();
}
class GlslGenerator {
  constructor(kind, config) {
    Companion_getInstance_64();
    this.q9j_1 = kind;
    this.r9j_1 = config;
  }
  r9m() {
    return this.r9j_1;
  }
  s9j(shader) {
    return this.s9m(shader.f9j_1, shader.g9j_1);
  }
  s9m(root, funcs) {
    var types = new GlobalsProgramVisitor();
    if (this.q9j_1.equals(ShaderType_FRAGMENT_getInstance()) && this.r9j_1.z9l()) {
      types.v9j_1.f(Varying.l91(this.r9j_1.g9m(), VarType_Float4_getInstance()));
    }
    var tmp = VarType_TVOID_getInstance();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    var mainFunc = new FuncDecl('main', tmp, tmp$ret$0, root);
    types.s9k(mainFunc);
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.m1();
    var tmp0_iterator = funcs.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      if (types.a9k_1.f3(element.l9m_1.w3())) {
        destination.f(element);
      }
    }
    var this_0 = reversed(destination);
    var set = HashSet.xa();
    var list = ArrayList.m1();
    var tmp0_iterator_0 = this_0.f1();
    while (tmp0_iterator_0.g1()) {
      var e = tmp0_iterator_0.h1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      var key = e.l9m_1.w3();
      if (set.f(key)) {
        list.f(e);
      }
    }
    var customFuncs = list;
    var _iterator__ex2g4s = funcs.f1();
    while (_iterator__ex2g4s.g1()) {
      var func = _iterator__ex2g4s.h1();
      types.s9k(mainFunc);
    }
    var allFuncs = plus(customFuncs, listOf(mainFunc));
    // Inline function 'kotlin.also' call
    var tmp_0 = Companion_getInstance_14();
    var this_1 = tmp_0.j3o(GlslGenerator$generateResult$lambda(this, types, allFuncs)).toString();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
    if (Companion_getInstance_65().h9f()) {
      // Inline function 'korlibs.logger.Logger.info' call
      var this_2 = Companion_getInstance_64().f9f_1;
      var level = Level_INFO_getInstance();
      var tmp_1;
      if (this_2.u3g(level)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$6 = 'GlSlGenerator.version: ' + this.r9j_1.i99_1;
        this_2.v3g(level, tmp$ret$6);
        tmp_1 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.debug' call
      var this_3 = Companion_getInstance_64().f9f_1;
      var level_0 = Level_DEBUG_getInstance();
      var tmp_2;
      if (this_3.u3g(level_0)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$8 = 'GlSlGenerator:\n' + this_1;
        this_3.v3g(level_0, tmp$ret$8);
        tmp_2 = Unit_instance;
      }
    }
    var result = this_1;
    var tmp_3;
    if (root instanceof Raw) {
      tmp_3 = root.v9m(Companion_getInstance_65().u9l_1);
    } else {
      tmp_3 = result;
    }
    return new Result(this, tmp_3, toList(types.u9j_1), toList(types.w9j_1), toList(types.v9j_1));
  }
  w9m(root, funcs) {
    return this.s9m(root, funcs).a9j_1;
  }
  x9m(root) {
    return this.w9m(root.f9j_1, root.g9j_1);
  }
}
class Companion_48 {
  constructor() {
    Companion_instance_57 = this;
    this.t9l_1 = new GlslConfig(Companion_instance_55.x9i(), new Immutable(VOID, VOID, VOID, true));
    this.u9l_1 = 'GLSL';
    this.v9l_1 = 100;
    this.w9l_1 = 'fragColor';
    this.x9l_1 = 'gl_FragColor';
  }
  g9f() {
    var tmp168_safe_receiver = Companion_instance_1.bj('FORCE_GLSL_VERSION');
    var tmp169_safe_receiver = tmp168_safe_receiver == null ? null : replace(tmp168_safe_receiver, '.', '');
    return tmp169_safe_receiver == null ? null : toIntOrNull(tmp169_safe_receiver);
  }
  h9f() {
    return Companion_instance_1.bj('DEBUG_GLSL') === 'true';
  }
}
class GlslConfig {
  constructor(variant, features, glslVersion, compatibility) {
    Companion_getInstance_65();
    glslVersion = glslVersion === VOID ? -1 : glslVersion;
    compatibility = compatibility === VOID ? true : compatibility;
    this.g99_1 = variant;
    this.h99_1 = features;
    this.i99_1 = glslVersion;
    this.j99_1 = compatibility;
  }
  y9m(name) {
    if (this.j99_1)
      return name;
    return name === 'texture2D' ? 'texture' : name;
  }
  z9l() {
    if (_GLVariant___get_isES__impl__yezzg8(this.g99_1))
      return this.i99_1 >= 300;
    return !this.j99_1;
  }
  k99() {
    return get_ENABLE_UNIFORM_BLOCKS() && this.z9l() && this.h99_1.r8k();
  }
  a9m() {
    return this.z9l() ? 'in' : 'attribute';
  }
  f9m() {
    return this.z9l() ? 'out' : 'varying';
  }
  e9m() {
    return 'uniform';
  }
  g9m() {
    return this.z9l() ? Companion_getInstance_65().w9l_1 : Companion_getInstance_65().x9l_1;
  }
  z9m(variant, features, glslVersion, compatibility) {
    return new GlslConfig(variant, features, glslVersion, compatibility);
  }
  i9f(variant, features, glslVersion, compatibility, $super) {
    variant = variant === VOID ? this.g99_1 : variant;
    features = features === VOID ? this.h99_1 : features;
    glslVersion = glslVersion === VOID ? this.i99_1 : glslVersion;
    compatibility = compatibility === VOID ? this.j99_1 : compatibility;
    return $super === VOID ? this.z9m(variant, features, glslVersion, compatibility) : $super.z9m.call(this, new GLVariant(variant), features, glslVersion, compatibility);
  }
  toString() {
    return 'GlslConfig(variant=' + GLVariant__toString_impl_o5yi3l(this.g99_1) + ', features=' + toString(this.h99_1) + ', glslVersion=' + this.i99_1 + ', compatibility=' + this.j99_1 + ')';
  }
  hashCode() {
    var result = GLVariant__hashCode_impl_2eslaq(this.g99_1);
    result = imul(result, 31) + hashCode(this.h99_1) | 0;
    result = imul(result, 31) + this.i99_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j99_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this.g99_1 === tmp0_other_with_cast.g99_1))
      return false;
    if (!equals(this.h99_1, tmp0_other_with_cast.h99_1))
      return false;
    if (!(this.i99_1 === tmp0_other_with_cast.i99_1))
      return false;
    if (!(this.j99_1 === tmp0_other_with_cast.j99_1))
      return false;
    return true;
  }
}
class GlslBodyGenerator extends Visitor {
  constructor(kind, config) {
    super('');
    this.n9m_1 = kind;
    this.o9m_1 = config;
    this.p9m_1 = LinkedHashSet.l1();
    this.q9m_1 = new Indenter();
  }
  r9m() {
    return this.o9m_1;
  }
  u9k(stms) {
    var _iterator__ex2g4s = stms.a9n_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var stm = _iterator__ex2g4s.h1();
      this.t9k(stm);
    }
  }
  x9k(stm) {
    this.q9m_1.c3p(this.d9l(stm.b9n_1) + ' = ' + this.d9l(stm.c9n_1) + ';');
  }
  y9k(stm) {
    this.q9m_1.c3p('discard;');
  }
  z9k(stm) {
    this.q9m_1.c3p('break;');
  }
  a9l(stm) {
    this.q9m_1.c3p('continue;');
  }
  c9l(stm) {
    var result = stm.d9n_1;
    if (!(result == null)) {
      this.q9m_1.c3p('return ' + this.d9l(result) + ';');
    } else {
      this.q9m_1.c3p('return;');
    }
  }
  p9l(operand) {
    var tmp = this.c9m(operand.f9n_1) + '(';
    return tmp + joinToString_0(operand.g9n_1, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda(this)) + ')';
  }
  k9l(operand) {
    return '(' + operand.i9n_1 + '(' + this.d9l(operand.j9n_1) + ')' + ')';
  }
  l9l(operand) {
    return '(' + this.d9l(operand.l9n_1) + ' ' + operand.m9n_1 + ' ' + this.d9l(operand.n9n_1) + ')';
  }
  e9l(func) {
    var tmp = this.o9m_1.y9m(func.w3()) + '(';
    var tmp_0 = func.p9n();
    return tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda_0(this)) + ')';
  }
  m9l(ternary) {
    return '((' + this.d9l(ternary.r9n_1) + ') ? (' + this.d9l(ternary.s9n_1) + ') : (' + this.d9l(ternary.t9n_1) + '))';
  }
  v9k(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.q9m_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'if (' + this.d9l(stm.u9n_1) + ')';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.c3p(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.d3p();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.t9k(stm.v9n_1);
    }finally {
      this_0.e3p();
    }
    this_0.c3p('}');
    if (!(stm.w9n_1 == null)) {
      // Inline function 'korlibs.io.util.Indenter.line' call
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        tmp_0 = 'else' + ' {';
      }
      this_0.c3p(tmp_0);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      this_0.d3p();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
        this.t9k(ensureNotNull(stm.w9n_1));
      }finally {
        this_0.e3p();
      }
      this_0.c3p('}');
    }
  }
  w9k(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.q9m_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    var varType = this.c9m(stm.x9n_1.b2n());
    var loopVar = this.g9l(stm.x9n_1);
    var min = this.d9l(stm.y9n_1);
    var maxExclusive = this.d9l(stm.z9n_1);
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'for (' + varType + ' ' + loopVar + ' = (' + min + '); ' + loopVar + ' < (' + maxExclusive + '); ' + loopVar + '++)';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.c3p(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.d3p();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.t9k(stm.a9o_1);
    }finally {
      this_0.e3p();
    }
    this_0.c3p('}');
  }
  b9l(stm) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    this.q9m_1.c3p(stm.v9m(Companion_getInstance_65().u9l_1));
  }
  g9l(operand) {
    super.g9l(operand);
    var tmp;
    if (operand instanceof Output) {
      var tmp_0;
      switch (this.n9m_1.v3_1) {
        case 0:
          tmp_0 = 'gl_Position';
          break;
        case 1:
          tmp_0 = this.o9m_1.g9m();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = operand.x98_1;
    }
    return tmp;
  }
  h9l(temp) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.p9m_1.f(temp);
    return super.h9l(temp);
  }
  j9l(output) {
    return super.j9l(output);
  }
  q9l(operand) {
    return '' + operand.c9o_1;
  }
  r9l(operand) {
    var str = '' + operand.e9o_1;
    return contains(str, _Char___init__impl__6a9atx(46)) ? str : str + '.0';
  }
  s9l(operand) {
    return '' + operand.g9o_1;
  }
  n9l(operand) {
    return this.d9l(operand.i9o_1) + '.' + operand.j9o_1;
  }
  o9l(operand) {
    return this.d9l(operand.l9o_1) + '[' + this.d9l(operand.m9o_1) + ']';
  }
}
class ProgramLayout {
  static n9o(items, layoutSize, fixedLocation) {
    fixedLocation = fixedLocation === VOID ? -1 : fixedLocation;
    var $this = createThis(this);
    $this.x8t_1 = items;
    $this.y8t_1 = layoutSize;
    $this.z8t_1 = fixedLocation;
    $this.a8u_1 = 0;
    var tmp = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = $this.x8t_1;
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.f31();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s = this_0.f1();
    while (_iterator__ex2g4s.g1()) {
      var v = _iterator__ex2g4s.h1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout.alignments.<anonymous>' call
      var a = v.b2n().u9a_1.q9o_1;
      var tmp$ret$0 = a <= 1 ? 1 : a;
      this_1.l31(tmp$ret$0);
    }
    tmp.b8u_1 = this_1;
    var tmp_0 = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_2 = $this.x8t_1;
    // Inline function 'kotlin.also' call
    var this_3 = IntArrayList.f31();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s_0 = this_2.f1();
    while (_iterator__ex2g4s_0.g1()) {
      var v_0 = _iterator__ex2g4s_0.h1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout._positions.<anonymous>' call
      $this.a8u_1 = !(v_0.e9h_1 == null) ? v_0.e9h_1 : nextAlignedTo($this.a8u_1, v_0.b2n().u9a_1.q9o_1);
      var out = $this.a8u_1;
      $this.a8u_1 = $this.a8u_1 + v_0.b2n().x9a_1 | 0;
      this_3.l31(out);
    }
    tmp_0.c8u_1 = this_3;
    var tmp_1 = $this;
    var tmp0_elvis_lhs = maxOrNull($this.b8u_1);
    tmp_1.d8u_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = $this;
    var tmp0_elvis_lhs_0 = $this.y8t_1;
    tmp_2.e8u_1 = tmp0_elvis_lhs_0 == null ? nextAlignedTo($this.a8u_1, $this.d8u_1) : tmp0_elvis_lhs_0;
    return $this;
  }
  f1() {
    return this.x8t_1.f1();
  }
  static f8u(variables, layoutSize) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    return this.n9o(toFastList_0(variables), layoutSize);
  }
  r9o() {
    return joinToString(this.x8t_1, ', ', VOID, VOID, VOID, VOID, ProgramLayout$names$lambda);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this)) + '[' + this.r9o() + ', fixedLocation=' + this.z8t_1 + ']';
  }
}
class Attribute extends VariableWithOffset {
  static s9o(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    offset = offset === VOID ? null : offset;
    active = active === VOID ? true : active;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    divisor = divisor === VOID ? 0 : divisor;
    var $this = this.f9h(name, type, 1, precision, offset);
    $this.v90_1 = normalized;
    $this.w90_1 = active;
    $this.x90_1 = divisor;
    $this.y90_1 = fixedLocation;
    return $this;
  }
  static z90(name, type, normalized, precision, fixedLocation) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.s9o(name, type, normalized, null, true, precision, VOID, fixedLocation);
  }
  t9o(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    return Attribute.s9o(name, type, normalized, offset, active, precision, divisor, fixedLocation);
  }
  u9o(name, type, normalized, offset, active, precision, divisor, fixedLocation, $super) {
    name = name === VOID ? this.x98_1 : name;
    type = type === VOID ? this.b2n() : type;
    normalized = normalized === VOID ? this.v90_1 : normalized;
    offset = offset === VOID ? this.e9h_1 : offset;
    active = active === VOID ? this.w90_1 : active;
    precision = precision === VOID ? this.y98_1 : precision;
    divisor = divisor === VOID ? this.x90_1 : divisor;
    fixedLocation = fixedLocation === VOID ? this.y90_1 : fixedLocation;
    return $super === VOID ? this.t9o(name, type, normalized, offset, active, precision, divisor, fixedLocation) : $super.t9o.call(this, name, type, normalized, offset, active, precision, divisor, fixedLocation);
  }
  v9o(divisor) {
    return this.u9o(VOID, VOID, VOID, VOID, VOID, VOID, divisor);
  }
  toString() {
    return 'Attribute(' + this.x98_1 + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this.a99_1 === other.a99_1;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = this.b2n().equals(other.b2n());
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.n9a_1 === other.n9a_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.x98_1 === other.x98_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.v90_1 === (other instanceof Attribute ? other : THROW_CCE()).v90_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.e9h_1 == other.e9h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.w90_1 === other.w90_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    var out = (this.a99_1 + imul(this.b2n().hashCode(), 7) | 0) + imul(getStringHashCode(this.x98_1), 11) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.v90_1) | 0;
    out = imul(out, 7);
    var tmp = out;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.e9h_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.w90_1) | 0;
    return out;
  }
}
class Stm {}
class Stms extends Stm {
  constructor(stms) {
    super();
    this.a9n_1 = stms;
  }
  toString() {
    return 'Stms(stms=' + toString(this.a9n_1) + ')';
  }
  hashCode() {
    return hashCode(this.a9n_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals(this.a9n_1, tmp0_other_with_cast.a9n_1))
      return false;
    return true;
  }
}
class Set extends Stm {
  constructor(to, from) {
    super();
    this.b9n_1 = to;
    this.c9n_1 = from;
  }
  toString() {
    return 'Set(to=' + toString(this.b9n_1) + ', from=' + toString(this.c9n_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.b9n_1);
    result = imul(result, 31) + hashCode(this.c9n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Set))
      return false;
    var tmp0_other_with_cast = other instanceof Set ? other : THROW_CCE();
    if (!equals(this.b9n_1, tmp0_other_with_cast.b9n_1))
      return false;
    if (!equals(this.c9n_1, tmp0_other_with_cast.c9n_1))
      return false;
    return true;
  }
}
class Return extends Stm {
  constructor(result) {
    super();
    this.d9n_1 = result;
  }
  toString() {
    return 'Return(result=' + toString_1(this.d9n_1) + ')';
  }
  hashCode() {
    return this.d9n_1 == null ? 0 : hashCode(this.d9n_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Return))
      return false;
    var tmp0_other_with_cast = other instanceof Return ? other : THROW_CCE();
    if (!equals(this.d9n_1, tmp0_other_with_cast.d9n_1))
      return false;
    return true;
  }
}
class Break extends Stm {
  constructor() {
    Break_instance = null;
    super();
    Break_instance = this;
  }
  toString() {
    return 'Break';
  }
}
class Continue extends Stm {}
class Discard extends Stm {
  constructor() {
    Discard_instance = null;
    super();
    Discard_instance = this;
  }
  toString() {
    return 'Discard';
  }
}
class If extends Stm {
  constructor(cond, tbody, fbody) {
    fbody = fbody === VOID ? null : fbody;
    super();
    this.u9n_1 = cond;
    this.v9n_1 = tbody;
    this.w9n_1 = fbody;
  }
  toString() {
    return 'If(cond=' + toString(this.u9n_1) + ', tbody=' + toString(this.v9n_1) + ', fbody=' + toString_1(this.w9n_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.u9n_1);
    result = imul(result, 31) + hashCode(this.v9n_1) | 0;
    result = imul(result, 31) + (this.w9n_1 == null ? 0 : hashCode(this.w9n_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals(this.u9n_1, tmp0_other_with_cast.u9n_1))
      return false;
    if (!equals(this.v9n_1, tmp0_other_with_cast.v9n_1))
      return false;
    if (!equals(this.w9n_1, tmp0_other_with_cast.w9n_1))
      return false;
    return true;
  }
}
class ForSimple extends Stm {
  constructor(loopVar, min, maxExclusive, body) {
    super();
    this.x9n_1 = loopVar;
    this.y9n_1 = min;
    this.z9n_1 = maxExclusive;
    this.a9o_1 = body;
  }
  toString() {
    return 'ForSimple(loopVar=' + toString(this.x9n_1) + ', min=' + toString(this.y9n_1) + ', maxExclusive=' + toString(this.z9n_1) + ', body=' + toString(this.a9o_1) + ')';
  }
  hashCode() {
    var result = this.x9n_1.hashCode();
    result = imul(result, 31) + hashCode(this.y9n_1) | 0;
    result = imul(result, 31) + hashCode(this.z9n_1) | 0;
    result = imul(result, 31) + hashCode(this.a9o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ForSimple))
      return false;
    var tmp0_other_with_cast = other instanceof ForSimple ? other : THROW_CCE();
    if (!this.x9n_1.equals(tmp0_other_with_cast.x9n_1))
      return false;
    if (!equals(this.y9n_1, tmp0_other_with_cast.y9n_1))
      return false;
    if (!equals(this.z9n_1, tmp0_other_with_cast.z9n_1))
      return false;
    if (!equals(this.a9o_1, tmp0_other_with_cast.a9o_1))
      return false;
    return true;
  }
}
class Raw extends Stm {
  w9o(name) {
    return this.t9m_1.k3(name);
  }
  x9o(name, default_0) {
    var tmp0_elvis_lhs = this.w9o(name);
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  v9m(name, default_0, $super) {
    default_0 = default_0 === VOID ? '' : default_0;
    return $super === VOID ? this.x9o(name, default_0) : $super.x9o.call(this, name, default_0);
  }
}
class Program$ExpressionBuilder$Companion$INSTANCE$1 {}
class Companion_49 {
  constructor() {
    Companion_instance_58 = this;
    var tmp = this;
    tmp.y9o_1 = new Program$ExpressionBuilder$Companion$INSTANCE$1();
  }
}
class FuncBuilder extends Builder {
  static h9p(parent) {
    var $this = this.i9p(parent);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.f9p_1 = ArrayList.m1();
    return $this;
  }
  g9p(name, type) {
    // Inline function 'kotlin.also' call
    var this_0 = Arg.u9p(name, type);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.FuncBuilder.ARG.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.f9p_1.f(this_0);
    return this_0;
  }
}
class FuncDeclGetter {
  constructor(decl) {
    this.a9q_1 = decl;
  }
  ko(thisRef, property) {
    var tmp = this.a9q_1;
    return isInterface(tmp, FuncRef) ? tmp : THROW_CCE();
  }
}
class FuncProvider {
  constructor(rettype, varTypes, builder, block) {
    this.z9o_1 = rettype;
    this.a9p_1 = varTypes;
    this.b9p_1 = builder;
    this.c9p_1 = block;
  }
  i90(thisRef, property) {
    var tmp = property.callableName;
    var tmp_0 = this.b9p_1.a93(tmp, this.z9o_1, Program$Builder$FuncProvider$provideDelegate$lambda(this));
    return new FuncDeclGetter(tmp_0 instanceof FuncDecl ? tmp_0 : THROW_CCE());
  }
}
class Program$Builder$_funcs$1 extends Visitor {
  constructor($funcs, $box) {
    if ($box === VOID)
      $box = {};
    $box.c9q_1 = $funcs;
    super(Unit_instance, $box);
  }
  l9k(func) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.c9q_1;
    var key = func.w3();
    var tmp = func.p9k();
    var value = tmp instanceof FuncDecl ? tmp : THROW_CCE();
    this_0.r3(key, value);
  }
  q9k(func) {
    this.l9k(func);
    return Unit_instance;
  }
}
class Ternary extends Operand {
  static e9q(cond, otrue, ofalse) {
    var $this = this.f9q(otrue.b2n());
    $this.r9n_1 = cond;
    $this.s9n_1 = otrue;
    $this.t9n_1 = ofalse;
    return $this;
  }
  toString() {
    return 'Ternary(cond=' + toString(this.r9n_1) + ', otrue=' + toString(this.s9n_1) + ', ofalse=' + toString(this.t9n_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.r9n_1);
    result = imul(result, 31) + hashCode(this.s9n_1) | 0;
    result = imul(result, 31) + hashCode(this.t9n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ternary))
      return false;
    var tmp0_other_with_cast = other instanceof Ternary ? other : THROW_CCE();
    if (!equals(this.r9n_1, tmp0_other_with_cast.r9n_1))
      return false;
    if (!equals(this.s9n_1, tmp0_other_with_cast.s9n_1))
      return false;
    if (!equals(this.t9n_1, tmp0_other_with_cast.t9n_1))
      return false;
    return true;
  }
}
class Unop extends Operand {
  static g9q(op, right) {
    var $this = this.f9q(right.b2n());
    $this.i9n_1 = op;
    $this.j9n_1 = right;
    return $this;
  }
  toString() {
    return 'Unop(op=' + this.i9n_1 + ', right=' + toString(this.j9n_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.i9n_1);
    result = imul(result, 31) + hashCode(this.j9n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Unop))
      return false;
    var tmp0_other_with_cast = other instanceof Unop ? other : THROW_CCE();
    if (!(this.i9n_1 === tmp0_other_with_cast.i9n_1))
      return false;
    if (!equals(this.j9n_1, tmp0_other_with_cast.j9n_1))
      return false;
    return true;
  }
}
class Binop extends Operand {
  static h9q(left, op, right) {
    var $this = this.f9q(left.b2n());
    $this.l9n_1 = left;
    $this.m9n_1 = op;
    $this.n9n_1 = right;
    return $this;
  }
  toString() {
    return 'Binop(left=' + toString(this.l9n_1) + ', op=' + this.m9n_1 + ', right=' + toString(this.n9n_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.l9n_1);
    result = imul(result, 31) + getStringHashCode(this.m9n_1) | 0;
    result = imul(result, 31) + hashCode(this.n9n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals(this.l9n_1, tmp0_other_with_cast.l9n_1))
      return false;
    if (!(this.m9n_1 === tmp0_other_with_cast.m9n_1))
      return false;
    if (!equals(this.n9n_1, tmp0_other_with_cast.n9n_1))
      return false;
    return true;
  }
}
class IntLiteral extends Operand {
  static i9q(value) {
    var $this = this.f9q(VarType_Int1_getInstance());
    $this.c9o_1 = value;
    return $this;
  }
  toString() {
    return 'IntLiteral(value=' + this.c9o_1 + ')';
  }
  hashCode() {
    return this.c9o_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IntLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof IntLiteral ? other : THROW_CCE();
    if (!(this.c9o_1 === tmp0_other_with_cast.c9o_1))
      return false;
    return true;
  }
}
class FloatLiteral extends Operand {
  static j9q(value) {
    var $this = this.f9q(VarType_Float1_getInstance());
    $this.e9o_1 = value;
    return $this;
  }
  toString() {
    return 'FloatLiteral(value=' + this.e9o_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.e9o_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals(this.e9o_1, tmp0_other_with_cast.e9o_1))
      return false;
    return true;
  }
}
class BoolLiteral extends Operand {}
class Vector extends Operand {
  static k9q(type, ops) {
    var $this = this.f9q(type);
    $this.f9n_1 = type;
    $this.g9n_1 = ops;
    return $this;
  }
  b2n() {
    return this.f9n_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this.f9n_1.equals(other.f9n_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.g9n_1, other.g9n_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return imul(this.f9n_1.hashCode(), 7) + contentHashCode(this.g9n_1) | 0;
  }
  toString() {
    return 'Vector(type=' + this.f9n_1.toString() + ', ops=' + toString(this.g9n_1) + ')';
  }
}
class Swizzle extends Operand {
  static l9q(left, swizzle) {
    var $this = this.f9q(left.b2n().m9q(swizzle.length));
    $this.i9o_1 = left;
    $this.j9o_1 = swizzle;
    return $this;
  }
  toString() {
    return 'Swizzle(left=' + toString(this.i9o_1) + ', swizzle=' + this.j9o_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.i9o_1);
    result = imul(result, 31) + getStringHashCode(this.j9o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals(this.i9o_1, tmp0_other_with_cast.i9o_1))
      return false;
    if (!(this.j9o_1 === tmp0_other_with_cast.j9o_1))
      return false;
    return true;
  }
}
class ArrayAccess extends Operand {
  static n9q(left, index) {
    var $this = this.f9q(left.b2n());
    $this.l9o_1 = left;
    $this.m9o_1 = index;
    return $this;
  }
  toString() {
    return 'ArrayAccess(left=' + toString(this.l9o_1) + ', index=' + toString(this.m9o_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.l9o_1);
    result = imul(result, 31) + hashCode(this.m9o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ArrayAccess))
      return false;
    var tmp0_other_with_cast = other instanceof ArrayAccess ? other : THROW_CCE();
    if (!equals(this.l9o_1, tmp0_other_with_cast.l9o_1))
      return false;
    if (!equals(this.m9o_1, tmp0_other_with_cast.m9o_1))
      return false;
    return true;
  }
}
class BaseFunc extends Operand {
  static o9q(type) {
    return this.f9q(type);
  }
}
class Func extends BaseFunc {
  static t9q(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    var $this = this.o9q(type);
    $this.q9q_1 = name;
    $this.r9q_1 = ops;
    $this.s9q_1 = type;
    return $this;
  }
  w3() {
    return this.q9q_1;
  }
  p9n() {
    return this.r9q_1;
  }
  b2n() {
    return this.s9q_1;
  }
  static u9q(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    return this.t9q(name, toList_0(ops), type);
  }
  toString() {
    return 'Func(name=' + this.q9q_1 + ', ops=' + toString(this.r9q_1) + ', type=' + this.s9q_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.q9q_1);
    result = imul(result, 31) + hashCode(this.r9q_1) | 0;
    result = imul(result, 31) + this.s9q_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this.q9q_1 === tmp0_other_with_cast.q9q_1))
      return false;
    if (!equals(this.r9q_1, tmp0_other_with_cast.r9q_1))
      return false;
    if (!this.s9q_1.equals(tmp0_other_with_cast.s9q_1))
      return false;
    return true;
  }
}
class CustomFunc extends BaseFunc {
  static v9q(ref, ops) {
    var $this = this.o9q(ref.w9q());
    $this.n9k_1 = ref;
    $this.o9k_1 = ops;
    return $this;
  }
  p9k() {
    return this.n9k_1;
  }
  p9n() {
    return this.o9k_1;
  }
  w3() {
    return this.p9k().w3();
  }
}
class FuncRef {}
class BuilderContext {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.x9q_1 = ArrayList.m1();
    this.y9q_1 = 3;
  }
}
class Program {
  constructor(vertex, fragment, name) {
    name = name === VOID ? 'program-' + vertex.h9j_1 + '-' + fragment.h9j_1 : name;
    this.i8s_1 = vertex;
    this.j8s_1 = fragment;
    this.k8s_1 = name;
    this.l8s_1 = plus_0(this.i8s_1.m9j_1, this.j8s_1.m9j_1);
    this.m8s_1 = plus_0(this.i8s_1.n9j_1, this.j8s_1.n9j_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.m8s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.shader.Program.uniformBlocks.<anonymous>' call
      var tmp$ret$0 = item.g8t_1;
      destination.f(tmp$ret$0);
    }
    tmp.n8s_1 = distinct(destination);
    this.o8s_1 = plus_0(this.i8s_1.p9j_1, this.j8s_1.p9j_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = withIndex(this.l8s_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap.wc(capacity);
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var element = tmp0_iterator_0.h1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.graphics.shader.Program.uniformsToIndex.<anonymous>' call
      var pair = to(element.am_1, new UniformInProgram(element.am_1, element.zl_1));
      destination_0.r3(pair.im_1, pair.jm_1);
    }
    tmp_0.p8s_1 = destination_0;
    this.q8s_1 = plus_0(this.i8s_1.o9j_1, this.j8s_1.o9j_1);
    this.r8s_1 = (imul(this.i8s_1.hashCode(), 11) + imul(this.j8s_1.hashCode(), 7) | 0) + getStringHashCode(this.k8s_1) | 0;
  }
  hashCode() {
    return this.r8s_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof Program) {
        tmp_2 = this.i8s_1.equals(other.i8s_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = this.j8s_1.equals(other.j8s_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.k8s_1 === other.k8s_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  u6() {
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.q8s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$0 = item.x98_1;
      destination.f(tmp$ret$0);
    }
    var tmp = toString(destination);
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.l8s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var item_0 = tmp0_iterator_0.h1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$3 = item_0.x98_1;
      destination_0.f(tmp$ret$3);
    }
    return 'Program(name=' + this.k8s_1 + ', attributes=' + tmp + ', uniforms=' + toString(destination_0) + ')';
  }
  b9r(vertex, fragment, name) {
    return new Program(vertex, fragment, name);
  }
  c9r(vertex, fragment, name, $super) {
    vertex = vertex === VOID ? this.i8s_1 : vertex;
    fragment = fragment === VOID ? this.j8s_1 : fragment;
    name = name === VOID ? this.k8s_1 : name;
    return $super === VOID ? this.b9r(vertex, fragment, name) : $super.b9r.call(this, vertex, fragment, name);
  }
}
class Shader {
  constructor(type, stm, functions, name) {
    name = name === VOID ? null : name;
    this.e9j_1 = type;
    this.f9j_1 = stm;
    this.g9j_1 = functions;
    this.h9j_1 = name;
    this.i9j_1 = hashCode(this.f9j_1);
    this.j9j_1 = hashCode(this.g9j_1);
    this.k9j_1 = (imul(this.e9j_1.hashCode(), 17) + this.i9j_1 | 0) + imul(this.j9j_1, 53) | 0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new GlobalsProgramVisitor();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Shader.globals.<anonymous>' call
    this_0.t9k(this.f9j_1);
    tmp.l9j_1 = this_0;
    this.m9j_1 = this.l9j_1.w9j_1;
    this.n9j_1 = this.l9j_1.x9j_1;
    this.o9j_1 = this.l9j_1.u9j_1;
    this.p9j_1 = this.l9j_1.z9j_1;
  }
  d9r() {
    var tmp = this.f9j_1;
    return tmp instanceof Raw;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      if (other instanceof Shader) {
        tmp_3 = this.e9j_1.equals(other.e9j_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = this.k9j_1 === other.k9j_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(this.f9j_1, other.f9j_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(this.g9j_1, other.g9j_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    return this.k9j_1;
  }
  toString() {
    return 'Shader(type=' + this.e9j_1.toString() + ', stm=' + toString(this.f9j_1) + ', functions=' + toString(this.g9j_1) + ', name=' + this.h9j_1 + ')';
  }
}
class Varying extends Variable {
  static e9r(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.f9r(name, type, arrayCount, precision);
  }
  static l91(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.e9r(name, type, 1, precision);
  }
  toString() {
    return 'Varying(' + this.x98_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this.a99_1 === other.a99_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.b2n().equals(other.b2n());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n9a_1 === other.n9a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.x98_1 === other.x98_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.a99_1 + imul(this.b2n().hashCode(), 7) | 0) + imul(getStringHashCode(this.x98_1), 11) | 0;
  }
}
class Output extends Varying {
  static r9r() {
    Output_instance = null;
    var $this = this.l91('out', VarType_Float4_getInstance());
    Output_instance = $this;
    return $this;
  }
  toString() {
    return 'Output';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output) {
      tmp_2 = this.a99_1 === other.a99_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.b2n().equals(other.b2n());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n9a_1 === other.n9a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.x98_1 === other.x98_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.a99_1 + imul(this.b2n().hashCode(), 7) | 0) + imul(getStringHashCode(this.x98_1), 11) | 0;
  }
}
class Provider {
  constructor(index, stype) {
    this.g90_1 = index;
    this.h90_1 = stype;
  }
  i90(thisRef, property) {
    return Sampler.s9r(property.callableName, this.g90_1, this.h90_1);
  }
}
class Sampler extends Variable {
  static s9r(name, index, stype) {
    var $this = this.w9r(name, stype.v9r_1);
    $this.s8o_1 = index;
    $this.t8o_1 = stype;
    return $this;
  }
  toString() {
    return 'Sampler(' + this.x98_1 + ', ' + this.s8o_1 + ', ' + this.t8o_1.toString() + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Sampler) {
      tmp_2 = this.a99_1 === other.a99_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.b2n().equals(other.b2n());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n9a_1 === other.n9a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.x98_1 === other.x98_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.a99_1 + imul(this.b2n().hashCode(), 7) | 0) + imul(getStringHashCode(this.x98_1), 11) | 0;
  }
  ko(thisRef, property) {
    return this;
  }
}
class SamplerVarType extends Enum {
  constructor(name, ordinal, vtype) {
    super(name, ordinal);
    this.v9r_1 = vtype;
  }
}
class Uniform extends VariableWithOffset {
  static t9h(name, type, arrayCount, precision, offset, typedUniform) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.f9h(name, type, arrayCount, precision, offset);
    $this.s9h_1 = typedUniform;
    if (type.x9r()) {
      // Inline function 'kotlin.error' call
      var message = "Can't create uniform '" + name + "' with a sampler type '" + type.toString() + "', please use `Sampler` class instead";
      throw IllegalStateException.m5(toString(message));
    }
    return $this;
  }
  toString() {
    return 'Uniform(' + this.x98_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this.a99_1 === other.a99_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.b2n().equals(other.b2n());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n9a_1 === other.n9a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.x98_1 === other.x98_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.a99_1 + imul(this.b2n().hashCode(), 7) | 0) + imul(getStringHashCode(this.x98_1), 11) | 0;
  }
}
class Companion_50 {
  y9r(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Bool1_getInstance();
        break;
      case 2:
        tmp = VarType_Bool2_getInstance();
        break;
      case 3:
        tmp = VarType_Bool3_getInstance();
        break;
      case 4:
        tmp = VarType_Bool4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  z9r(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SByte1_getInstance();
        break;
      case 2:
        tmp = VarType_SByte2_getInstance();
        break;
      case 3:
        tmp = VarType_SByte3_getInstance();
        break;
      case 4:
        tmp = VarType_SByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  a9s(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UByte1_getInstance();
        break;
      case 2:
        tmp = VarType_UByte2_getInstance();
        break;
      case 3:
        tmp = VarType_UByte3_getInstance();
        break;
      case 4:
        tmp = VarType_UByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  b9s(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SShort1_getInstance();
        break;
      case 2:
        tmp = VarType_SShort2_getInstance();
        break;
      case 3:
        tmp = VarType_SShort3_getInstance();
        break;
      case 4:
        tmp = VarType_SShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  c9s(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UShort1_getInstance();
        break;
      case 2:
        tmp = VarType_UShort2_getInstance();
        break;
      case 3:
        tmp = VarType_UShort3_getInstance();
        break;
      case 4:
        tmp = VarType_UShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  d9s(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SInt1_getInstance();
        break;
      case 2:
        tmp = VarType_SInt2_getInstance();
        break;
      case 3:
        tmp = VarType_SInt3_getInstance();
        break;
      case 4:
        tmp = VarType_SInt4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  e9s(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Float2_getInstance();
        break;
      case 3:
        tmp = VarType_Float3_getInstance();
        break;
      case 4:
        tmp = VarType_Float4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  f9s(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Mat2_getInstance();
        break;
      case 3:
        tmp = VarType_Mat3_getInstance();
        break;
      case 4:
        tmp = VarType_Mat4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
}
class VarType extends Enum {
  constructor(name, ordinal, kind, elementCount, isMatrix) {
    isMatrix = isMatrix === VOID ? false : isMatrix;
    super(name, ordinal);
    this.u9a_1 = kind;
    this.v9a_1 = elementCount;
    this.w9a_1 = isMatrix;
    this.x9a_1 = imul(this.u9a_1.q9o_1, this.v9a_1);
  }
  m9q(length) {
    var tmp;
    switch (this.u9a_1.v3_1) {
      case 1:
        tmp = Companion_instance_59.z9r(length);
        break;
      case 2:
        tmp = Companion_instance_59.a9s(length);
        break;
      case 3:
        tmp = Companion_instance_59.b9s(length);
        break;
      case 4:
        tmp = Companion_instance_59.c9s(length);
        break;
      case 5:
        tmp = Companion_instance_59.d9s(length);
        break;
      case 6:
        tmp = Companion_instance_59.e9s(length);
        break;
      default:
        throw NotImplementedError.oe();
    }
    return tmp;
  }
  x9r() {
    return this.equals(VarType_Sampler1D_getInstance()) || this.equals(VarType_Sampler2D_getInstance()) || this.equals(VarType_Sampler3D_getInstance()) || this.equals(VarType_SamplerCube_getInstance());
  }
}
class Precision extends Enum {}
class Temp extends Variable {
  static z9q(id, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.f9r('temp' + id, type, arrayCount, precision);
  }
  static x91(id, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.z9q(id, type, 1, precision);
  }
  toString() {
    return 'Temp(' + this.x98_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp) {
      tmp_2 = this.a99_1 === other.a99_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.b2n().equals(other.b2n());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n9a_1 === other.n9a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.x98_1 === other.x98_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.a99_1 + imul(this.b2n().hashCode(), 7) | 0) + imul(getStringHashCode(this.x98_1), 11) | 0;
  }
}
class FuncDecl {
  constructor(name, rettype, args, stm) {
    this.h9m_1 = name;
    this.i9m_1 = rettype;
    this.j9m_1 = args;
    this.k9m_1 = stm;
    this.l9m_1 = this;
  }
  w3() {
    return this.h9m_1;
  }
  w9q() {
    return this.i9m_1;
  }
  toString() {
    return 'FuncDecl(name=' + this.h9m_1 + ', rettype=' + this.i9m_1.toString() + ', args=' + toString(this.j9m_1) + ', stm=' + toString(this.k9m_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.h9m_1);
    result = imul(result, 31) + this.i9m_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.j9m_1) | 0;
    result = imul(result, 31) + hashCode(this.k9m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FuncDecl))
      return false;
    var tmp0_other_with_cast = other instanceof FuncDecl ? other : THROW_CCE();
    if (!(this.h9m_1 === tmp0_other_with_cast.h9m_1))
      return false;
    if (!this.i9m_1.equals(tmp0_other_with_cast.i9m_1))
      return false;
    if (!equals(this.j9m_1, tmp0_other_with_cast.j9m_1))
      return false;
    if (!equals(this.k9m_1, tmp0_other_with_cast.k9m_1))
      return false;
    return true;
  }
}
class VarKind extends Enum {
  constructor(name, ordinal, bytesSize) {
    super(name, ordinal);
    this.q9o_1 = bytesSize;
  }
}
class UniformInProgram {
  constructor(uniform, index) {
    this.h9s_1 = uniform;
    this.i9s_1 = index;
  }
  toString() {
    return 'UniformInProgram(uniform=' + this.h9s_1.toString() + ', index=' + this.i9s_1 + ')';
  }
  hashCode() {
    var result = this.h9s_1.hashCode();
    result = imul(result, 31) + this.i9s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UniformInProgram))
      return false;
    var tmp0_other_with_cast = other instanceof UniformInProgram ? other : THROW_CCE();
    if (!this.h9s_1.equals(tmp0_other_with_cast.h9s_1))
      return false;
    if (!(this.i9s_1 === tmp0_other_with_cast.i9s_1))
      return false;
    return true;
  }
}
class Arg extends Variable {
  static u9p(name, type, arrayCount, precision) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.f9r(name, type, arrayCount, precision);
  }
  toString() {
    return 'Arg(' + this.x98_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Arg) {
      tmp_2 = this.a99_1 === other.a99_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.b2n().equals(other.b2n());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.n9a_1 === other.n9a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.x98_1 === other.x98_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.a99_1 + imul(this.b2n().hashCode(), 7) | 0) + imul(getStringHashCode(this.x98_1), 11) | 0;
  }
}
class ShaderType extends Enum {}
class sam$kotlinx_coroutines_DisposableHandle$0 {
  constructor(function_0) {
    this.j9s_1 = function_0;
  }
  o18() {
    return this.j9s_1();
  }
}
class ContextInfo {
  constructor() {
    var tmp = this;
    tmp.k9s_1 = KmlGl$ContextInfo$current$lambda;
  }
  toString() {
    return 'current=' + toString_1(this.k9s_1());
  }
}
class Companion_51 {
  constructor() {
    this.l9s_1 = 33309;
    this.m9s_1 = 33084;
    this.n9s_1 = 33085;
    this.o9s_1 = 256;
    this.p9s_1 = 1024;
    this.q9s_1 = 16384;
    this.r9s_1 = 0;
    this.s9s_1 = 1;
    this.t9s_1 = 0;
    this.u9s_1 = 1;
    this.v9s_1 = 2;
    this.w9s_1 = 3;
    this.x9s_1 = 4;
    this.y9s_1 = 5;
    this.z9s_1 = 6;
    this.a9t_1 = 0;
    this.b9t_1 = 1;
    this.c9t_1 = 768;
    this.d9t_1 = 769;
    this.e9t_1 = 770;
    this.f9t_1 = 771;
    this.g9t_1 = 772;
    this.h9t_1 = 773;
    this.i9t_1 = 774;
    this.j9t_1 = 775;
    this.k9t_1 = 776;
    this.l9t_1 = 32774;
    this.m9t_1 = 32777;
    this.n9t_1 = 32777;
    this.o9t_1 = 34877;
    this.p9t_1 = 32778;
    this.q9t_1 = 32779;
    this.r9t_1 = 32968;
    this.s9t_1 = 32969;
    this.t9t_1 = 32970;
    this.u9t_1 = 32971;
    this.v9t_1 = 32769;
    this.w9t_1 = 32770;
    this.x9t_1 = 32771;
    this.y9t_1 = 32772;
    this.z9t_1 = 32773;
    this.a9u_1 = 34962;
    this.b9u_1 = 34963;
    this.c9u_1 = 34964;
    this.d9u_1 = 34965;
    this.e9u_1 = 35040;
    this.f9u_1 = 35044;
    this.g9u_1 = 35048;
    this.h9u_1 = 34660;
    this.i9u_1 = 34661;
    this.j9u_1 = 34342;
    this.k9u_1 = 1028;
    this.l9u_1 = 1029;
    this.m9u_1 = 1032;
    this.n9u_1 = 3553;
    this.o9u_1 = 32879;
    this.p9u_1 = 2884;
    this.q9u_1 = 3042;
    this.r9u_1 = 3024;
    this.s9u_1 = 2960;
    this.t9u_1 = 2929;
    this.u9u_1 = 3089;
    this.v9u_1 = 32823;
    this.w9u_1 = 32926;
    this.x9u_1 = 32928;
    this.y9u_1 = 0;
    this.z9u_1 = 1280;
    this.a9v_1 = 1281;
    this.b9v_1 = 1282;
    this.c9v_1 = 1285;
    this.d9v_1 = 2304;
    this.e9v_1 = 2305;
    this.f9v_1 = 2849;
    this.g9v_1 = 33901;
    this.h9v_1 = 33902;
    this.i9v_1 = 2885;
    this.j9v_1 = 2886;
    this.k9v_1 = 2928;
    this.l9v_1 = 2930;
    this.m9v_1 = 2931;
    this.n9v_1 = 2932;
    this.o9v_1 = 2961;
    this.p9v_1 = 2962;
    this.q9v_1 = 2964;
    this.r9v_1 = 2965;
    this.s9v_1 = 2966;
    this.t9v_1 = 2967;
    this.u9v_1 = 2963;
    this.v9v_1 = 2968;
    this.w9v_1 = 34816;
    this.x9v_1 = 34817;
    this.y9v_1 = 34818;
    this.z9v_1 = 34819;
    this.a9w_1 = 36003;
    this.b9w_1 = 36004;
    this.c9w_1 = 36005;
    this.d9w_1 = 2978;
    this.e9w_1 = 3088;
    this.f9w_1 = 3106;
    this.g9w_1 = 3107;
    this.h9w_1 = 3317;
    this.i9w_1 = 3333;
    this.j9w_1 = 3379;
    this.k9w_1 = 3386;
    this.l9w_1 = 3408;
    this.m9w_1 = 3410;
    this.n9w_1 = 3411;
    this.o9w_1 = 3412;
    this.p9w_1 = 3413;
    this.q9w_1 = 3414;
    this.r9w_1 = 3415;
    this.s9w_1 = 10752;
    this.t9w_1 = 32824;
    this.u9w_1 = 32873;
    this.v9w_1 = 32936;
    this.w9w_1 = 32937;
    this.x9w_1 = 32938;
    this.y9w_1 = 32939;
    this.z9w_1 = 34466;
    this.a9x_1 = 34467;
    this.b9x_1 = 4352;
    this.c9x_1 = 4353;
    this.d9x_1 = 4354;
    this.e9x_1 = 33170;
    this.f9x_1 = 5120;
    this.g9x_1 = 5121;
    this.h9x_1 = 5122;
    this.i9x_1 = 5123;
    this.j9x_1 = 5124;
    this.k9x_1 = 5125;
    this.l9x_1 = 5126;
    this.m9x_1 = 5132;
    this.n9x_1 = 6402;
    this.o9x_1 = 6406;
    this.p9x_1 = 6407;
    this.q9x_1 = 6408;
    this.r9x_1 = 6409;
    this.s9x_1 = 6410;
    this.t9x_1 = 32819;
    this.u9x_1 = 32820;
    this.v9x_1 = 33635;
    this.w9x_1 = 35632;
    this.x9x_1 = 35633;
    this.y9x_1 = 34921;
    this.z9x_1 = 36347;
    this.a9y_1 = 36348;
    this.b9y_1 = 35661;
    this.c9y_1 = 35660;
    this.d9y_1 = 34930;
    this.e9y_1 = 36349;
    this.f9y_1 = 35663;
    this.g9y_1 = 35712;
    this.h9y_1 = 35714;
    this.i9y_1 = 35715;
    this.j9y_1 = 35717;
    this.k9y_1 = 35718;
    this.l9y_1 = 35719;
    this.m9y_1 = 35721;
    this.n9y_1 = 35722;
    this.o9y_1 = 35724;
    this.p9y_1 = 35725;
    this.q9y_1 = 512;
    this.r9y_1 = 513;
    this.s9y_1 = 514;
    this.t9y_1 = 515;
    this.u9y_1 = 516;
    this.v9y_1 = 517;
    this.w9y_1 = 518;
    this.x9y_1 = 519;
    this.y9y_1 = 7680;
    this.z9y_1 = 7681;
    this.a9z_1 = 7682;
    this.b9z_1 = 7683;
    this.c9z_1 = 5386;
    this.d9z_1 = 34055;
    this.e9z_1 = 34056;
    this.f9z_1 = 7936;
    this.g9z_1 = 7937;
    this.h9z_1 = 7938;
    this.i9z_1 = 7939;
    this.j9z_1 = 9728;
    this.k9z_1 = 9729;
    this.l9z_1 = 9984;
    this.m9z_1 = 9985;
    this.n9z_1 = 9986;
    this.o9z_1 = 9987;
    this.p9z_1 = 10240;
    this.q9z_1 = 10241;
    this.r9z_1 = 10242;
    this.s9z_1 = 10243;
    this.t9z_1 = 32882;
    this.u9z_1 = 5890;
    this.v9z_1 = 34067;
    this.w9z_1 = 34068;
    this.x9z_1 = 34069;
    this.y9z_1 = 34070;
    this.z9z_1 = 34071;
    this.aa0_1 = 34072;
    this.ba0_1 = 34073;
    this.ca0_1 = 34074;
    this.da0_1 = 34076;
    this.ea0_1 = 33984;
    this.fa0_1 = 33985;
    this.ga0_1 = 33986;
    this.ha0_1 = 33987;
    this.ia0_1 = 33988;
    this.ja0_1 = 33989;
    this.ka0_1 = 33990;
    this.la0_1 = 33991;
    this.ma0_1 = 33992;
    this.na0_1 = 33993;
    this.oa0_1 = 33994;
    this.pa0_1 = 33995;
    this.qa0_1 = 33996;
    this.ra0_1 = 33997;
    this.sa0_1 = 33998;
    this.ta0_1 = 33999;
    this.ua0_1 = 34000;
    this.va0_1 = 34001;
    this.wa0_1 = 34002;
    this.xa0_1 = 34003;
    this.ya0_1 = 34004;
    this.za0_1 = 34005;
    this.aa1_1 = 34006;
    this.ba1_1 = 34007;
    this.ca1_1 = 34008;
    this.da1_1 = 34009;
    this.ea1_1 = 34010;
    this.fa1_1 = 34011;
    this.ga1_1 = 34012;
    this.ha1_1 = 34013;
    this.ia1_1 = 34014;
    this.ja1_1 = 34015;
    this.ka1_1 = 34016;
    this.la1_1 = 10497;
    this.ma1_1 = 33071;
    this.na1_1 = 33648;
    this.oa1_1 = 35664;
    this.pa1_1 = 35665;
    this.qa1_1 = 35666;
    this.ra1_1 = 35667;
    this.sa1_1 = 35668;
    this.ta1_1 = 35669;
    this.ua1_1 = 35670;
    this.va1_1 = 35671;
    this.wa1_1 = 35672;
    this.xa1_1 = 35673;
    this.ya1_1 = 35674;
    this.za1_1 = 35675;
    this.aa2_1 = 35676;
    this.ba2_1 = 35678;
    this.ca2_1 = 35680;
    this.da2_1 = 34338;
    this.ea2_1 = 34339;
    this.fa2_1 = 34340;
    this.ga2_1 = 34341;
    this.ha2_1 = 34922;
    this.ia2_1 = 34373;
    this.ja2_1 = 34975;
    this.ka2_1 = 35738;
    this.la2_1 = 35739;
    this.ma2_1 = 35713;
    this.na2_1 = 35716;
    this.oa2_1 = 35720;
    this.pa2_1 = 36346;
    this.qa2_1 = 36344;
    this.ra2_1 = 36345;
    this.sa2_1 = 36336;
    this.ta2_1 = 36337;
    this.ua2_1 = 36338;
    this.va2_1 = 36339;
    this.wa2_1 = 36340;
    this.xa2_1 = 36341;
    this.ya2_1 = 36160;
    this.za2_1 = 36161;
    this.aa3_1 = 32854;
    this.ba3_1 = 32855;
    this.ca3_1 = 36194;
    this.da3_1 = 33189;
    this.ea3_1 = 6401;
    this.fa3_1 = 36168;
    this.ga3_1 = 36162;
    this.ha3_1 = 36163;
    this.ia3_1 = 36164;
    this.ja3_1 = 36176;
    this.ka3_1 = 36177;
    this.la3_1 = 36178;
    this.ma3_1 = 36179;
    this.na3_1 = 36180;
    this.oa3_1 = 36181;
    this.pa3_1 = 36048;
    this.qa3_1 = 36049;
    this.ra3_1 = 36050;
    this.sa3_1 = 36051;
    this.ta3_1 = 36064;
    this.ua3_1 = 36096;
    this.va3_1 = 33306;
    this.wa3_1 = 34041;
    this.xa3_1 = 36128;
    this.ya3_1 = 0;
    this.za3_1 = 36053;
    this.aa4_1 = 36054;
    this.ba4_1 = 36055;
    this.ca4_1 = 36057;
    this.da4_1 = 36061;
    this.ea4_1 = 36006;
    this.fa4_1 = 36007;
    this.ga4_1 = 34024;
    this.ha4_1 = 1286;
    this.ia4_1 = 37120;
    this.ja4_1 = 34836;
    this.ka4_1 = 3313;
    this.la4_1 = 3314;
    this.ma4_1 = 3316;
    this.na4_1 = 3315;
    this.oa4_1 = 3312;
    this.pa4_1 = 37441;
    this.qa4_1 = 36197;
    this.ra4_1 = 35345;
    this.sa4_1 = 35368;
    this.ta4_1 = 35380;
  }
}
class KmlGl {
  constructor() {
    this.v97_1 = new Mixin();
    this.w97_1 = new ContextInfo();
    this.x97_1 = null;
    var tmp = this;
    tmp.y97_1 = lazy(KmlGl$isFloatTextureSupported$delegate$lambda(this));
  }
  n13(_set____db54di) {
    this.v97_1.n13(_set____db54di);
  }
  o13() {
    return this.v97_1.o13();
  }
  k9b(texture) {
    throw NotImplementedError.oe();
  }
  l9f(program, shader) {
    throw NotImplementedError.oe();
  }
  k9f(program, index, name) {
    throw NotImplementedError.oe();
  }
  e9a(target, buffer) {
    throw NotImplementedError.oe();
  }
  d9e(target, framebuffer) {
    throw NotImplementedError.oe();
  }
  k9e(target, renderbuffer) {
    throw NotImplementedError.oe();
  }
  b9e(target, texture) {
    throw NotImplementedError.oe();
  }
  l9c(modeRGB, modeAlpha) {
    throw NotImplementedError.oe();
  }
  m9c(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    throw NotImplementedError.oe();
  }
  o9b(target, size, data, usage) {
    throw NotImplementedError.oe();
  }
  n9b(target, offset, size, data) {
    throw NotImplementedError.oe();
  }
  q38(mask) {
    throw NotImplementedError.oe();
  }
  d9c(red, green, blue, alpha) {
    throw NotImplementedError.oe();
  }
  f9c(d) {
    throw NotImplementedError.oe();
  }
  h9c(s) {
    throw NotImplementedError.oe();
  }
  r9e(red, green, blue, alpha) {
    throw NotImplementedError.oe();
  }
  c9f(shader) {
    throw NotImplementedError.oe();
  }
  e9f() {
    throw NotImplementedError.oe();
  }
  a9f(type) {
    throw NotImplementedError.oe();
  }
  h9d(mode) {
    throw NotImplementedError.oe();
  }
  ua4(n, items) {
    throw NotImplementedError.oe();
  }
  va4(n, items) {
    throw NotImplementedError.oe();
  }
  z9e(program) {
    throw NotImplementedError.oe();
  }
  wa4(n, items) {
    throw NotImplementedError.oe();
  }
  y9e(shader) {
    throw NotImplementedError.oe();
  }
  xa4(n, items) {
    throw NotImplementedError.oe();
  }
  q9e(func) {
    throw NotImplementedError.oe();
  }
  e9c(flag) {
    throw NotImplementedError.oe();
  }
  p9e(n, f) {
    throw NotImplementedError.oe();
  }
  q9c(cap) {
    throw NotImplementedError.oe();
  }
  j9d(index) {
    throw NotImplementedError.oe();
  }
  x9c(mode, first, count) {
    throw NotImplementedError.oe();
  }
  z9c(mode, count, type, indices) {
    throw NotImplementedError.oe();
  }
  r9c(cap) {
    throw NotImplementedError.oe();
  }
  n9d(index) {
    throw NotImplementedError.oe();
  }
  fd() {
    throw NotImplementedError.oe();
  }
  n9e(target, attachment, renderbuffertarget, renderbuffer) {
    throw NotImplementedError.oe();
  }
  m9e(target, attachment, textarget, texture, level) {
    throw NotImplementedError.oe();
  }
  o9e(mode) {
    throw NotImplementedError.oe();
  }
  ya4(n, buffers) {
    throw NotImplementedError.oe();
  }
  s9b(target) {
    throw NotImplementedError.oe();
  }
  za4(n, framebuffers) {
    throw NotImplementedError.oe();
  }
  aa5(n, renderbuffers) {
    throw NotImplementedError.oe();
  }
  ba5(n, textures) {
    throw NotImplementedError.oe();
  }
  w9e(program, name) {
    throw NotImplementedError.oe();
  }
  d9f() {
    throw NotImplementedError.oe();
  }
  ca5(pname, data) {
    throw NotImplementedError.oe();
  }
  da5(program, pname, params) {
    throw NotImplementedError.oe();
  }
  ea5(shader, pname, params) {
    throw NotImplementedError.oe();
  }
  fa5(shader, bufSize, length, infoLog) {
    throw NotImplementedError.oe();
  }
  z97(name) {
    throw NotImplementedError.oe();
  }
  m9f(program) {
    throw NotImplementedError.oe();
  }
  p9b(pname, param) {
    throw NotImplementedError.oe();
  }
  l9e(target, internalformat, width, height) {
    throw NotImplementedError.oe();
  }
  s9e(x, y, width, height) {
    throw NotImplementedError.oe();
  }
  b9f(shader, string) {
    throw NotImplementedError.oe();
  }
  t9c(func, ref, mask) {
    throw NotImplementedError.oe();
  }
  s9c(face, func, ref, mask) {
    throw NotImplementedError.oe();
  }
  g9c(mask) {
    throw NotImplementedError.oe();
  }
  w9c(face, mask) {
    throw NotImplementedError.oe();
  }
  v9c(fail, zfail, zpass) {
    throw NotImplementedError.oe();
  }
  u9c(face, sfail, dpfail, dppass) {
    throw NotImplementedError.oe();
  }
  q9b(target, level, internalformat, width, height, border, format, type, pixels) {
    throw NotImplementedError.oe();
  }
  r9b(target, level, internalformat, format, type, data) {
    throw NotImplementedError.oe();
  }
  j9b(target, pname, param) {
    throw NotImplementedError.oe();
  }
  f9b(location, count, value) {
    throw NotImplementedError.oe();
  }
  d99(location, v0) {
    throw NotImplementedError.oe();
  }
  y9a(location, count, value) {
    throw NotImplementedError.oe();
  }
  g9b(location, count, value) {
    throw NotImplementedError.oe();
  }
  z9a(location, count, value) {
    throw NotImplementedError.oe();
  }
  h9b(location, count, value) {
    throw NotImplementedError.oe();
  }
  a9b(location, count, value) {
    throw NotImplementedError.oe();
  }
  i9b(location, count, value) {
    throw NotImplementedError.oe();
  }
  b9b(location, count, value) {
    throw NotImplementedError.oe();
  }
  c9b(location, count, transpose, value) {
    throw NotImplementedError.oe();
  }
  d9b(location, count, transpose, value) {
    throw NotImplementedError.oe();
  }
  e9b(location, count, transpose, value) {
    throw NotImplementedError.oe();
  }
  x9e(program) {
    throw NotImplementedError.oe();
  }
  o9d(index, size, type, normalized, stride, pointer) {
    throw NotImplementedError.oe();
  }
  c9e(x, y, width, height) {
    throw NotImplementedError.oe();
  }
  n9c(cap, enable) {
    if (enable) {
      this.r9c(cap);
    } else {
      this.q9c(cap);
    }
    return enable;
  }
  y9c(mode, first, count, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  a9d(mode, count, type, indices, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  i9d(index, divisor) {
    unsupported();
  }
  v9d(target, index, buffer, offset, size) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  e99(program, name) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  f99(program, uniformBlockIndex, uniformBlockBinding) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  ga5(n, arrays) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  k9d(array) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  l9b() {
    return Companion_instance_55.x9i();
  }
  z9b() {
    return Unit_instance;
  }
  f9d(contextVersion) {
    return Unit_instance;
  }
  ha5(name, index) {
    throw NotImplementedError.oe();
  }
  h7j() {
    if (this.x97_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        var numExtensions = getIntegerv(this, 33309);
        if (numExtensions <= 0) {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.oe();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = until(0, numExtensions);
        var destination = ArrayList.m1();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = this_0.f1();
        while (tmp0_iterator.g1()) {
          var element = tmp0_iterator.h1();
          // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
          // Inline function 'korlibs.kgl.KmlGl.<get-extensions>.<anonymous>' call
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          var tmp0_safe_receiver = this.ha5(7939, element);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.f(tmp0_safe_receiver);
          }
        }
        tmp_0 = toSet(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          tmp_1 = toSet(split(this.z97(7939), [' ']));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp.x97_1 = tmp_0;
    }
    return ensureNotNull(this.x97_1);
  }
  p8k() {
    return this.h7j();
  }
  t8k() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y97_1;
    isFloatTextureSupported$factory();
    return this_0.b2();
  }
}
class KorgeReloadInternalImpl {
  ia5(clazz, context) {
    return clazz;
  }
  ja5(old, new_0) {
    return Unit_instance;
  }
}
class ReloadClassContext {
  constructor(injector, refreshedClasses, rootFolders) {
    this.ka5_1 = injector;
    this.la5_1 = refreshedClasses;
    this.ma5_1 = rootFolders;
  }
}
class KorgeReload {
  constructor() {
    KorgeReload_instance = this;
    this.na5_1 = null;
    this.oa5_1 = Companion_getInstance_2().ez('KorgeReload');
  }
  pa5(eventDispatcher) {
    if (!Companion_getInstance_3().vw().dx() || !(Companion_instance_1.bj('KORGE_AUTORELOAD') === 'true'))
      return Unit_instance;
    this.na5_1 = eventDispatcher;
  }
  qa5() {
    if (!Companion_getInstance_3().vw().dx())
      return Unit_instance;
    if (!(this.na5_1 == null))
      this.na5_1 = null;
  }
}
class Companion_52 {}
class Companion_53 {
  constructor() {
    Companion_instance_62 = this;
    var tmp = this;
    var tmp206_factors = Companion_getInstance_45().b8l_1;
    tmp.ra5_1 = new BlendMode(tmp206_factors, 'NORMAL');
    this.sa5_1 = this.ra5_1.ea9(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp207_factors = Companion_getInstance_45().f8v(Companion_getInstance_55().w8u_1, Companion_getInstance_55().d8v_1);
    tmp_0.ta5_1 = new BlendMode(tmp207_factors, 'NONE');
    var tmp_1 = this;
    var tmp208_factors = Companion_getInstance_45().d8l_1;
    tmp_1.ua5_1 = new BlendMode(tmp208_factors, 'ADD');
    var tmp_2 = this;
    var tmp209_factors = Companion_getInstance_45().f8v(Companion_getInstance_55().v8u_1, Companion_getInstance_55().z8u_1);
    tmp_2.va5_1 = new BlendMode(tmp209_factors, 'MULTIPLY');
    var tmp_3 = this;
    var tmp210_factors = Companion_getInstance_45().f8v(Companion_getInstance_55().w8u_1, Companion_getInstance_55().a8v_1);
    tmp_3.wa5_1 = new BlendMode(tmp210_factors, 'SCREEN');
    var tmp_4 = this;
    var tmp211_factors = Companion_getInstance_45().f8v(Companion_getInstance_55().d8v_1, Companion_getInstance_55().z8u_1);
    tmp_4.xa5_1 = new BlendMode(tmp211_factors, 'ERASE');
    var tmp_5 = this;
    var tmp212_factors = Companion_getInstance_45().f8v(Companion_getInstance_55().d8v_1, Companion_getInstance_55().b8v_1);
    tmp_5.ya5_1 = new BlendMode(tmp212_factors, 'MASK');
    var tmp_6 = this;
    var tmp213_factors = Companion_getInstance_45().f8v(Companion_getInstance_55().x8u_1, Companion_getInstance_55().u8u_1);
    tmp_6.za5_1 = new BlendMode(tmp213_factors, 'BELOW');
    var tmp_7 = this;
    var tmp214_factors = Companion_getInstance_45().e8v(Companion_getInstance_55().b8v_1, Companion_getInstance_55().u8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_56().j8v_1);
    tmp_7.aa6_1 = new BlendMode(tmp214_factors, 'SUBTRACT');
    var tmp_8 = this;
    var tmp215_factors = Companion_getInstance_45().e8v(Companion_getInstance_55().y8u_1, Companion_getInstance_55().d8v_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1);
    tmp_8.ba6_1 = new BlendMode(tmp215_factors, 'INVERT');
    var tmp_9 = this;
    var tmp216_factors = Companion_getInstance_45().e8v(Companion_getInstance_55().b8v_1, Companion_getInstance_55().u8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1);
    tmp_9.ca6_1 = new BlendMode(tmp216_factors, 'LIGHTEN');
    var tmp_10 = this;
    var tmp217_factors = Companion_getInstance_45().e8v(Companion_getInstance_55().b8v_1, Companion_getInstance_55().u8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1);
    tmp_10.da6_1 = new BlendMode(tmp217_factors, 'DARKEN');
    var tmp_11 = this;
    var tmp218_factors = Companion_getInstance_45().e8v(Companion_getInstance_55().b8v_1, Companion_getInstance_55().u8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1);
    tmp_11.ea6_1 = new BlendMode(tmp218_factors, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp219_factors = Companion_getInstance_45().e8v(Companion_getInstance_55().b8v_1, Companion_getInstance_55().u8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1);
    tmp_12.fa6_1 = new BlendMode(tmp219_factors, 'ALPHA');
    var tmp_13 = this;
    var tmp220_factors = Companion_getInstance_45().e8v(Companion_getInstance_55().b8v_1, Companion_getInstance_55().u8u_1, Companion_getInstance_55().w8u_1, Companion_getInstance_55().w8u_1);
    tmp_13.ga6_1 = new BlendMode(tmp220_factors, 'HARDLIGHT');
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.ha6_1 = [this.sa5_1, this.ta5_1, this.ra5_1, this.ua5_1, this.va5_1, this.wa5_1, this.xa5_1, this.ya5_1, this.za5_1, this.aa6_1, this.ba6_1, this.ca6_1, this.da6_1, this.ea6_1, this.fa6_1, this.ga6_1];
    var tmp_15 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.ha6_1;
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.blend.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$3 = ensureNotNull(element.ca9_1);
      destination.r3(tmp$ret$3, element);
    }
    tmp_15.ia6_1 = destination;
    this.ja6_1 = toList_0(this.ha6_1);
    var tmp_16 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_indices(this.ha6_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.wc(capacity_0);
    var tmp0_iterator = this_1.f1();
    while (tmp0_iterator.g1()) {
      var element_0 = tmp0_iterator.h1();
      // Inline function 'korlibs.korge.blend.Companion.TO_ORDINAL.<anonymous>' call
      var tmp$ret$6 = Companion_getInstance_70().ha6_1[element_0];
      destination_0.r3(tmp$ret$6, element_0);
    }
    tmp_16.ka6_1 = destination_0;
  }
}
class BlendMode {
  constructor(factors, name) {
    Companion_getInstance_70();
    name = name === VOID ? null : name;
    this.ba9_1 = factors;
    this.ca9_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.ba9_1);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.ca9_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.da9_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  hashCode() {
    return this.da9_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.ba9_1 === other.ba9_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.ca9_1 == other.ca9_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  toString() {
    var tmp0_elvis_lhs = this.ca9_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  }
  fa9(factors, name) {
    return new BlendMode(factors, name);
  }
  ea9(factors, name, $super) {
    factors = factors === VOID ? this.ba9_1 : factors;
    name = name === VOID ? this.ca9_1 : name;
    return $super === VOID ? this.fa9(factors, name) : $super.fa9.call(this, new AGBlending(factors), name);
  }
}
class InputKeys {
  constructor() {
    this.ga9_1 = booleanArray(Companion_getInstance_37().z8h_1);
    this.ha9_1 = booleanArray(Companion_getInstance_37().z8h_1);
    this.ia9_1 = false;
    this.ja9_1 = false;
    this.ka9_1 = false;
    this.la9_1 = false;
  }
  ma9(key) {
    return this.na9(key);
  }
  na9(key) {
    return this.ga9_1[key.v3_1];
  }
  oa9(key, up, shift, ctrl, alt, meta) {
    switch (up) {
      case true:
        this.ga9_1[key.v3_1] = false;
        break;
      case false:
        this.ga9_1[key.v3_1] = true;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.ia9_1 = shift || this.ma9(Companion_getInstance_37().n8i()) || this.ma9(Companion_getInstance_37().o8i());
    this.ja9_1 = ctrl || this.ma9(Companion_getInstance_37().l8i()) || this.ma9(Companion_getInstance_37().m8i());
    this.ka9_1 = alt || this.ma9(Companion_getInstance_37().p8i()) || this.ma9(Companion_getInstance_37().q8i());
    this.la9_1 = meta || this.ma9(Key_META_getInstance());
  }
  pa9(e) {
    switch (e.d8c_1.v3_1) {
      case 0:
      case 1:
        this.oa9(e.f8c_1, e.d8c_1.equals(Type_UP_getInstance()), this.ia9_1, this.ja9_1, this.ka9_1, this.la9_1);
        break;
      default:
        break;
    }
  }
  qa9(delta) {
  }
  ra9(delta) {
    arraycopy_4(this.ga9_1, 0, this.ha9_1, 0, this.ga9_1.length);
  }
}
class Companion_54 {
  constructor() {
    this.sa9_1 = 256;
  }
}
class Input {
  constructor() {
    this.ta9_1 = new Mixin();
    this.ua9_1 = Companion_getInstance_29().l8e_1;
    this.va9_1 = new TouchEvent();
    var tmp = this;
    tmp.wa9_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.xa9_1 = toDuration(400, DurationUnit_MILLISECONDS_getInstance());
    this.ya9_1 = 20.0;
    this.za9_1 = Vector2D.k2h(-1000.0, -1000.0);
    this.aaa_1 = Vector2D.k2h(-1000.0, -1000.0);
    this.baa_1 = 0;
    this.caa_1 = false;
    this.daa_1 = true;
    this.eaa_1 = false;
    this.faa_1 = new InputKeys();
    this.gaa_1 = booleanArray(256);
    this.haa_1 = booleanArray(256);
    this.iaa_1 = new Float64Array(256);
    this.jaa_1 = new Float64Array(256);
    this.kaa_1 = booleanArray(256);
    this.laa_1 = booleanArray(256);
    this.maa_1 = booleanArray(256);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.korge.input.Input.gamepads.<anonymous>' call
      var tmp$ret$2 = new GamepadInfo(item);
      destination.f(tmp$ret$2);
    }
    tmp_1.naa_1 = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_2.oaa_1 = ArrayList.m1();
  }
  n13(_set____db54di) {
    this.ta9_1.n13(_set____db54di);
  }
  o13() {
    return this.ta9_1.o13();
  }
  j8f() {
    return this.va9_1.j8f();
  }
  qaa() {
    return this.j8f().j1();
  }
  raa(touchEvent) {
    this.va9_1.t8f(touchEvent);
  }
  saa() {
    return this.za9_1;
  }
  taa(p, down) {
    if (down)
      this.aaa_1 = p;
    else
      this.za9_1 = p;
  }
  uaa(button, down) {
    this.baa_1 = setBits(this.baa_1, button.b8j_1, down);
  }
  vaa() {
    this.oaa_1.o3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.naa_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.input.Input.updateConnectedGamepads.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gamepad = this_0[_unary__edvuaz];
      if (gamepad.o8g_1) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.oaa_1.f(gamepad);
      }
    }
  }
  waa(keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.gaa_1.length - 1 | 0) : false) {
      this.gaa_1[pKeyCode] = b;
    }
  }
  xaa(delta) {
    var tmp221_safe_receiver = this.o13();
    if (tmp221_safe_receiver == null)
      null;
    else {
      tmp221_safe_receiver.o3();
    }
    this.faa_1.qa9(delta);
  }
  yaa(delta) {
    this.eaa_1 = false;
    this.faa_1.ra9(delta);
    endFrameOldKeys(this, delta);
  }
  zaa(e) {
    switch (e.d8c_1.v3_1) {
      case 1:
        this.waa(e.g8c_1, true);
        break;
      case 0:
        this.waa(e.g8c_1, false);
        break;
      case 2:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
}
class DefaultViewport {
  constructor() {
    DefaultViewport_instance = this;
    this.aab_1 = 1280;
    this.bab_1 = 720;
    this.cab_1 = Size2D.f2j(1280, 720);
  }
}
class Companion_55 {
  dab(str) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Props();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.logger.Companion.load.<anonymous>' call
    this_0.fab(str);
    return this_0;
  }
}
class Props {
  constructor(props) {
    props = props === VOID ? LinkedHashMap.vc() : props;
    this.eab_1 = props;
  }
  o3() {
    this.eab_1.o3();
  }
  gab(key, value) {
    return this.eab_1.r3(key, value);
  }
  r3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.gab(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  hab(from) {
    this.eab_1.t3(from);
  }
  t3(from) {
    return this.hab(from);
  }
  z13(key) {
    return this.eab_1.s3(key);
  }
  s3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.z13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  c14(key) {
    return this.eab_1.i3(key);
  }
  i3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.c14((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  bj(key) {
    return this.eab_1.k3(key);
  }
  k3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.bj((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  a1() {
    return this.eab_1.a1();
  }
  z1() {
    return this.eab_1.z1();
  }
  l3() {
    return this.eab_1.l3();
  }
  m3() {
    return this.eab_1.m3();
  }
  j1() {
    return this.eab_1.j1();
  }
  iab(str) {
    var _iterator__ex2g4s = split(str, ['\n']).f1();
    $l$loop_0: while (_iterator__ex2g4s.g1()) {
      var line = _iterator__ex2g4s.h1();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      // Inline function 'kotlin.text.trim' call
      var this_0 = parts.i1(0);
      var key = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.collections.getOrElse' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (0 <= 1 ? 1 < parts.j1() : false) {
        tmp = parts.i1(1);
      } else {
        // Inline function 'korlibs.korge.logger.Props.deserializeAdd.<anonymous>' call
        tmp = ' ';
      }
      var this_1 = tmp;
      var value = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.set' call
      this.eab_1.r3(key, value);
    }
  }
  fab(str) {
    this.o3();
    this.iab(str);
  }
}
class Entry {
  constructor(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.jab_1 = closeable;
  }
  kab() {
    var tmp226_safe_receiver = this.jab_1;
    if (tmp226_safe_receiver == null)
      null;
    else {
      tmp226_safe_receiver.u6();
    }
    this.jab_1 = null;
  }
  z33() {
    this.jab_1 = null;
  }
}
class AgAutoFreeManager {
  constructor() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.lab_1 = Pool.c39(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.mab_1 = FastIdentityMap();
    this.nab_1 = fastArrayListOf([]);
    this.oab_1 = 0;
    this.pab_1 = 60;
  }
  qab(closeable) {
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.mab_1;
      var res = get_0(this_0, closeable);
      if (!(res == null)) {
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.lab_1.g39();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>.<anonymous>' call
      this_1.jab_1 = closeable;
      var out = this_1;
      set(this_0, closeable, out);
    }
  }
  rab() {
    this.oab_1 = this.oab_1 + 1 | 0;
    if (this.oab_1 >= this.pab_1) {
      this.oab_1 = 0;
      this.sab();
    }
  }
  sab() {
    var _iterator__ex2g4s = this.nab_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var entry = _iterator__ex2g4s.h1();
      if (!contains_1(this.mab_1, entry.jab_1)) {
        var tmp227_safe_receiver = entry.jab_1;
        if (tmp227_safe_receiver == null)
          null;
        else {
          tmp227_safe_receiver.u6();
        }
        this.lab_1.h39(entry);
      }
    }
    this.nab_1.o3();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.mab_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.gc.<anonymous>' call
      var it_0 = ensureNotNull(get_0(this_0, it));
      this.nab_1.f(it_0);
    }
    clear(this.mab_1);
  }
  u6() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.nab_1.e14_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      array[_unary__edvuaz].kab();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.mab_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).kab();
    }
    this.nab_1.o3();
    this.lab_1.o3();
    clear(this.mab_1);
  }
}
class BitmapTextureInfo {
  constructor() {
    this.tab_1 = 0;
    this.uab_1 = TextureBase.zab(null, 0, 0);
    this.vab_1 = FastIdentityMap();
  }
  z33() {
    this.tab_1 = 0;
    this.uab_1.wab_1 = null;
    this.uab_1.yab_1 = -1;
    this.uab_1.aac(0);
    this.uab_1.bac(0);
    clear(this.vab_1);
  }
  toString() {
    return 'BitmapTextureInfo(textureBase=' + this.uab_1.toString() + ', usedMemory=' + this.tab_1 + ', slices=' + get_size(this.vab_1) + ')';
  }
}
class AgBitmapTextureManager {
  constructor(ag) {
    this.cac_1 = ag;
    this.dac_1 = new Long(0, 0);
    this.eac_1 = FastSmallSet.d36();
    this.fac_1 = FastSmallSet.d36();
    this.gac_1 = FastArrayList.g14();
    this.hac_1 = 60;
    this.iac_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.jac_1 = Pool.c39(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.kac_1 = FastIdentityMap();
    this.lac_1 = null;
    this.mac_1 = null;
    this.nac_1 = null;
    this.oac_1 = null;
    this.pac_1 = null;
    this.qac_1 = null;
    this.rac_1 = null;
    this.sac_1 = null;
    this.tac_1 = 0;
  }
  vac() {
    return this.eac_1.j1();
  }
  wac() {
    return this.fac_1.j1();
  }
  xac() {
    return this.gac_1.j1();
  }
  toString() {
    return this.yac();
  }
  yac() {
    return 'AgBitmapTextureManager(numCachedBitmaps=' + this.vac() + ', numReferencedBitmapsSinceGC=' + this.wac() + ', numReferencedBitmaps=' + this.xac() + ', maxCachedMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_11().c13(this.dac_1)) + ', managedTextureMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_11().c13(this.iac_1)) + ')';
  }
  zac(bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).uab_1);
  }
  aad(slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  }
  bad(slice) {
    return _getTexture(this, slice);
  }
  cad() {
    clearFastCacheAccess(this);
    this.tac_1 = this.tac_1 + 1 | 0;
    if (this.tac_1 >= this.hac_1) {
      this.tac_1 = 0;
      this.sab();
    }
  }
  sab() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.gac_1.e14_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var bmp = array[_unary__edvuaz];
      if (!this.fac_1.xl(bmp))
        if (this.dac_1.g2(this.iac_1) < 0 || this.iac_1.g2(new Long(0, 0)) < 0) {
          this.dad(bmp, 'GC');
        } else
          this.eac_1.e36(bmp);
    }
    this.gac_1.o3();
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.fac_1.z35_1.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.gac_1.f(element);
    }
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.eac_1.z35_1.f1();
    while (tmp0_iterator_0.g1()) {
      var element_0 = tmp0_iterator_0.h1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.gac_1.f(element_0);
    }
    this.fac_1.o3();
  }
  dad(bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.kac_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.Long.minus' call
    var this_0 = this.iac_1;
    var other = info.tab_1;
    tmp_0.iac_1 = this_0.h2(toLong(other));
    this.fac_1.f36(bmp);
    if (this.mac_1 === info || this.oac_1 === info) {
      clearFastCacheAccess(this);
    }
    info.uab_1.u6();
    this.jac_1.h39(info);
    this.eac_1.f36(bmp);
  }
  u6() {
    clearFastCacheAccess(this);
    var _iterator__ex2g4s = toList(get_keys(this.kac_1)).f1();
    while (_iterator__ex2g4s.g1()) {
      var bmp = _iterator__ex2g4s.h1();
      this.dad(bmp, 'close');
    }
    clear(this.kac_1);
    this.gac_1.o3();
    this.fac_1.o3();
    this.eac_1.o3();
    this.jac_1.o3();
  }
}
class AgBufferManager {
  constructor(ag) {
    this.ead_1 = ag;
    this.fad_1 = FastIdentityMap();
    this.gad_1 = FastSmallSet.d36();
    var tmp = this;
    tmp.had_1 = Pool.e39(VOID, AgBufferManager$bufferPool$lambda);
    this.iad_1 = 0;
    this.jad_1 = 60;
    this.kad_1 = Buffer.t10(0);
  }
  lad(cached) {
    this.gad_1.e36(cached);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.fad_1;
      var res = get_0(this_0, cached);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.had_1.g39();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>.<anonymous>' call
      this_1.s8n(cached.mad_1);
      var out = this_1;
      set(this_0, cached, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  rab() {
    removeCache(this);
    this.iad_1 = this.iad_1 + 1 | 0;
    if (this.iad_1 >= this.jad_1) {
      this.iad_1 = 0;
      this.sab();
    }
  }
  sab() {
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.gad_1.z35_1.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBufferManager.gc.<anonymous>' call
      this.nad(element);
    }
    this.gad_1.o3();
  }
  oad(buffer) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < buffer.j1()) {
      // Inline function 'korlibs.korge.render.AgBufferManager.delete.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = buffer.i1(_unary__edvuaz);
      this.nad(it);
    }
  }
  nad(buffer) {
    var buf = getAndRemove(this.fad_1, buffer);
    if (buf == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      buf.s8n(this.kad_1);
      this.had_1.h39(buf);
    }
  }
}
class AgCachedBuffer {
  constructor(data) {
    this.mad_1 = data;
  }
}
class BatchBuffers {
  constructor() {
    this.zad_1 = new AGBuffer();
    this.aae_1 = new AGBuffer();
    this.bae_1 = new AGBuffer();
    this.cae_1 = AGVertexArrayObject.s8t([AGVertexData.w8t(Companion_getInstance_73().wad_1, this.zad_1), AGVertexData.w8t(Companion_getInstance_73().xad_1, this.aae_1)], false);
  }
}
class Companion_56 {
  constructor() {
    Companion_instance_65 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Sampler.s9r('u_Tex' + tmp_3, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.pad_1 = tmp_2;
    this.qad_1 = 16383;
    this.rad_1 = 8192;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_4;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$2 = 'BatchBuilder2D.Companion[0]';
      this_0.v3g(level, tmp$ret$2);
      tmp_4 = Unit_instance;
    }
    this.sad_1 = Attribute.z90('a_Col2', VarType_UByte4_getInstance(), true, VOID, 3);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_5;
    if (this_1.u3g(level_0)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$4 = 'BatchBuilder2D.Companion[1]';
      this_1.v3g(level_0, tmp$ret$4);
      tmp_5 = Unit_instance;
    }
    this.tad_1 = Varying.l91('v_Col2', VarType_Float4_getInstance());
    this.uad_1 = Attribute.z90('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.vad_1 = Varying.l91('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_6;
    if (this_2.u3g(level_1)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$6 = 'BatchBuilder2D.Companion[2]';
      this_2.v3g(level_1, tmp$ret$6);
      tmp_6 = Unit_instance;
    }
    this.wad_1 = ProgramLayout.f8u([DefaultShaders_getInstance().q8x_1, DefaultShaders_getInstance().r8x_1, this.dae(), this.sad_1]);
    this.xad_1 = ProgramLayout.f8u([this.uad_1]);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.u3g(level_2)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$8 = 'BatchBuilder2D.Companion[3]';
      this_3.v3g(level_2, tmp$ret$8);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_4 = ProgramBuilderDefault.a92();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    this_4.f92(this_4.b92(), this_4.c92());
    this_4.f92(Companion_getInstance_73().vad_1, Companion_getInstance_73().uad_1);
    this_4.f92(Companion_getInstance_73().eae(), this_4.m92([this_4.j92(this_4.o92(Companion_getInstance_73().dae(), 'rgb'), this_4.o92(Companion_getInstance_73().dae(), 'a')), this_4.o92(Companion_getInstance_73().dae(), 'a')]));
    this_4.f92(Companion_getInstance_73().tad_1, Companion_getInstance_73().sad_1);
    this_4.f92(this_4.i92(), this_4.j92(this_4.j92(this_4.q8z(), this_4.r8z()), this_4.m92([this_4.k92(), this_4.l92(0.0), this_4.l92(1.0)])));
    var tmp_9 = VertexShader(this_4.n92());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_5 = ProgramBuilderDefault.a92();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    Companion_getInstance_73().fae(this_5);
    this_5.f92(this_5.i92(), this_5.j92(this_5.i92(), Companion_getInstance_73().eae()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_5.p95(this_5.o92(this_5.i92(), 'a'), this_5.l92(0.0));
    var body = this_5.w92();
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>.<anonymous>' call
    body.q93();
    var stmIf = new If(cond, body.y92());
    // Inline function 'kotlin.collections.plusAssign' call
    this_5.e92_1.f(stmIf);
    var tmp$ret$14 = FragmentShader(this_5.n92());
    tmp_8.yad_1 = new Program(tmp_9, tmp$ret$14, 'BatchBuilder2D.Tinted');
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_6.u3g(level_3)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D.Companion[4]';
      this_6.v3g(level_3, tmp$ret$15);
      tmp_10 = Unit_instance;
    }
  }
  dae() {
    return DefaultShaders_getInstance().s8x_1;
  }
  eae() {
    return DefaultShaders_getInstance().u8x_1;
  }
  fae(builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.createTextureLookup.<anonymous>' call
    var tmp = Companion_getInstance_73().vad_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.m93(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
  }
}
class BatchBuilder2D {
  constructor(ctx, reqMaxQuads) {
    Companion_getInstance_73();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_73().rad_1 : reqMaxQuads;
    this.ta7_1 = ctx;
    this.ua7_1 = reqMaxQuads;
    this.va7_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    // Inline function 'kotlin.math.min' call
    var a = this.ua7_1;
    var b = Companion_getInstance_73().qad_1;
    tmp.wa7_1 = Math.min(a, b);
    this.xa7_1 = this.ta7_1.fa7_1;
    this.ya7_1 = this.ta7_1.ma6_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_0;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$1 = 'BatchBuilder2D[0]';
      this_0.v3g(level, tmp$ret$1);
      tmp_0 = Unit_instance;
    }
    this.ta7_1.ha7_1.v1x(BatchBuilder2D$lambda(this));
    this.za7_1 = imul(this.wa7_1, 4);
    this.aa8_1 = imul(this.wa7_1, 6);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.u3g(level_0)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$3 = 'BatchBuilder2D[1]';
      this_1.v3g(level_0, tmp$ret$3);
      tmp_1 = Unit_instance;
    }
    this.ba8_1 = Buffer.t10(imul(24, this.za7_1));
    this.ca8_1 = new Int8Array(this.za7_1);
    this.da8_1 = Buffer.t10(imul(2, this.aa8_1));
    this.ea8_1 = get_u16(this.da8_1);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.u3g(level_1)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$5 = 'BatchBuilder2D[2]';
      this_2.v3g(level_1, tmp$ret$5);
      tmp_2 = Unit_instance;
    }
    this.fa8_1 = 0;
    this.ga8_1 = 0;
    this.ha8_1 = 0;
    this.ia8_1 = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.va7_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = null;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.ja8_1 = tmp_6;
    this.ka8_1 = false;
    this.la8_1 = Companion_getInstance_70().ra5_1;
    this.ma8_1 = Companion_getInstance_73().yad_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.u3g(level_2)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$9 = 'BatchBuilder2D[3]';
      this_3.v3g(level_2, tmp$ret$9);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    tmp_8.na8_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_4 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_9;
    if (this_4.u3g(level_3)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$11 = 'BatchBuilder2D[4]';
      this_4.v3g(level_3, tmp$ret$11);
      tmp_9 = Unit_instance;
    }
    this.oa8_1 = Companion_getInstance_48().i8l_1;
    this.pa8_1 = Companion_getInstance_49().k8l_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_5 = get_logger();
    var level_4 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_5.u3g(level_4)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$13 = 'BatchBuilder2D[5]';
      this_5.v3g(level_4, tmp$ret$13);
      tmp_10 = Unit_instance;
    }
    this.qa8_1 = _AGColorMask___init__impl__j38ai8_1();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_5 = Level_TRACE_getInstance();
    var tmp_11;
    if (this_6.u3g(level_5)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D[6]';
      this_6.v3g(level_5, tmp$ret$15);
      tmp_11 = Unit_instance;
    }
    this.ra8_1 = Companion_getInstance_46().w8l_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_7 = get_logger();
    var level_6 = Level_TRACE_getInstance();
    var tmp_12;
    if (this_7.u3g(level_6)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$17 = 'BatchBuilder2D[7]';
      this_7.v3g(level_6, tmp$ret$17);
      tmp_12 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_8 = get_logger();
    var level_7 = Level_TRACE_getInstance();
    var tmp_13;
    if (this_8.u3g(level_7)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$19 = 'BatchBuilder2D[11]';
      this_8.v3g(level_7, tmp$ret$19);
      tmp_13 = Unit_instance;
    }
    this.sa8_1 = new Signal();
    this.ta8_1 = new Signal();
    this.ua8_1 = fastArrayListOf([]);
    this.va8_1 = 0;
    this.wa8_1 = 0;
    this.xa8_1 = 0;
  }
  iae() {
    return this.ta7_1.aa7_1;
  }
  jae(value) {
    this.fa8_1 = value;
  }
  kae() {
    return this.fa8_1;
  }
  lae() {
    var inductionVariable = 0;
    var last = this.va7_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ja8_1[n] = null;
      }
       while (inductionVariable < last);
    this.ia8_1 = 0;
  }
  rab() {
    this.na8_1.z33();
  }
  mae() {
    return this.ra8_1;
  }
  nae(x, y, u, v, colorMul, texIndex) {
    this.ga8_1 = this.ga8_1 + this.oae(this.ba8_1, this.ga8_1, x, y, u, v, _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    var _unary__edvuaz = this.kae();
    this.jae(_unary__edvuaz + 1 | 0);
  }
  pae(x, y, u, v, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.ia8_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.nae(x, y, u, v, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.nae.call(this, x, y, u, v, new RGBA(colorMul), texIndex);
    }
    return tmp;
  }
  oae(vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.ca8_1[vp / 6 | 0] = toByte(texIndex);
    return 6;
  }
  qae(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.rae(6, 4);
    this.sae();
    var vp = this.ga8_1;
    var vd = this.ba8_1;
    vp = vp + this.oae(vd, vp, x0, y0, tex.b43(), tex.c43(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.oae(vd, vp, x1, y1, tex.d43(), tex.e43(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.oae(vd, vp, x2, y2, tex.f43(), tex.g43(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.oae(vd, vp, x3, y3, tex.h43(), tex.i43(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.ga8_1 = vp;
    this.jae(this.kae() + 4 | 0);
  }
  tae(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.ia8_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.qae(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.qae.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  }
  uae(vc) {
    this.ha8_1 = this.ha8_1 + _addIndices(this, this.ea8_1, this.ha8_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  }
  sae(vc, $super) {
    vc = vc === VOID ? this.kae() : vc;
    var tmp;
    if ($super === VOID) {
      this.uae(vc);
      tmp = Unit_instance;
    } else {
      tmp = $super.uae.call(this, vc);
    }
    return tmp;
  }
  vae(array, matrix, vcount, icount, texIndex) {
    this.rae(icount, vcount);
    var i16 = this.ea8_1;
    var ip = this.ha8_1;
    var vc = this.kae();
    var arrayIndices = array.wae_1;
    // Inline function 'kotlin.math.min' call
    var b = array.zae_1;
    var icount_0 = Math.min(icount, b);
    arraycopy_5(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.ga8_1;
    var src = get_i32(array.aaf_1);
    var dst = get_i32(this.ba8_1);
    arraycopy_6(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.ga8_1 / 6 | 0;
    arrayfill(this.ca8_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (matrix.o2i()) {
      applyMatrix(this, matrix, this.ga8_1, vcount);
    }
    this.fa8_1 = this.fa8_1 + vcount | 0;
    this.ga8_1 = this.ga8_1 + imul(vcount, 6) | 0;
    this.ha8_1 = this.ha8_1 + icount_0 | 0;
  }
  daf(array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.yae_1 : vcount;
    icount = icount === VOID ? array.zae_1 : icount;
    texIndex = texIndex === VOID ? this.ia8_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.vae(array, matrix, vcount, icount, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.vae.call(this, array, matrix, vcount, icount, texIndex);
    }
    return tmp;
  }
  rae(indices, vertices) {
    if (indices === 0 && vertices === 0)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.eaf();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var message = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException.m5(toString(message));
    }
    return doFlush;
  }
  faf(tex, smoothing, blendMode, program, icount, vcount) {
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.wab_1;
      this.rae(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_73().yad_1 : program;
      if (this.gaf(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this.gae();
      if (!contains_0(this.ja8_1, tex_0)) {
        this.ia8_1 = 0;
        this.ja8_1[0] = tex_0;
      }
      this.ka8_1 = smoothing;
      this.la8_1 = blendMode;
      this.ma8_1 = pprogram;
    }
  }
  haf(tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ja8_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.hasTex.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      if (this_0[_unary__edvuaz] === tex)
        return true;
    }
    return false;
  }
  gaf(tex, smoothing, blendMode, program) {
    var hasTex = this.haf(tex);
    if (!(this.ja8_1[0] === null) && !hasTex) {
      var inductionVariable = 1;
      var last = this.ja8_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.ja8_1[n] === null) {
            this.ja8_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.ja8_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.ja8_1[n_0]) {
          this.ia8_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return hasTex && this.ka8_1 === smoothing && this.la8_1 === blendMode && this.ma8_1 === program;
  }
  iaf(tex, smoothing, blendMode, program, icount, vcount) {
    this.faf(this.xa7_1.zac(tex), smoothing, blendMode, program, icount, vcount);
  }
  jaf(tex, smoothing, blendMode, program, icount, vcount) {
    this.faf(this.xa7_1.aad(tex).f41_1, smoothing, blendMode, program, icount, vcount);
  }
  kaf(tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.laf(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_instance);
  }
  aa9(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.j2y() : width;
    height = height === VOID ? tex.k2y() : height;
    m = m === VOID ? Companion_getInstance_8().i2m_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().g4r_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_70().ra5_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.kaf(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_instance;
    } else {
      tmp = $super.kaf.call(this, tex, x, y, width, height, m, filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  }
  laf(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.faf(tex.o33(), filtering, blendMode, program, 6, 4);
    this.maf(x, y, width, height, m, tex, colorMul);
  }
  maf(x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.tae(m.e2n(x0, y0), m.f2n(x0, y0), m.e2n(x1, y0), m.f2n(x1, y0), m.e2n(x1, y1), m.f2n(x1, y1), m.e2n(x0, y1), m.f2n(x0, y1), tex, colorMul);
  }
  naf() {
    this.na8_1.x39_1.bae_1.v8n(this.da8_1, 0, imul(this.ha8_1, 2));
  }
  oaf() {
    this.ta7_1.oaf();
    var inductionVariable = 0;
    var last = this.va7_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_42().l8r(VOID, this.ka8_1);
        this.ta7_1.va6_1.z8o(Companion_getInstance_73().pad_1[n], this.ja8_1[n], info);
      }
       while (inductionVariable < last);
  }
  gae() {
    if (this.va8_1 === this.ha8_1)
      return Unit_instance;
    this.oaf();
    this.wa8_1 = this.wa8_1 + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.ua8_1;
    var tmp233_frameBuffer = this.ta7_1.pa7_1.t8j_1;
    var tmp234_frameBufferInfo = this.ta7_1.pa7_1.c8m();
    var tmp235_vertexData = this.na8_1.x39_1.cae_1;
    var tmp236_indices = this.na8_1.x39_1.bae_1;
    var tmp237_program = this.ma8_1;
    var tmp238_drawType = Companion_getInstance_43().l8u_1;
    var tmp239_blending = this.la8_1.ba9_1;
    var tmp240_uniformBlocks = this.ta7_1.paf(this.ma8_1, false);
    var tmp241_textureUnits = this.ta7_1.va6_1.j13();
    var tmp242_stencilOpFunc = this.pa8_1;
    var tmp243_stencilRef = this.oa8_1;
    var tmp244_colorMask = this.qa8_1;
    var tmp245_scissor = this.ra8_1;
    var tmp246_drawOffset = imul(this.va8_1, 2);
    var tmp247_vertexCount = this.ha8_1 - this.va8_1 | 0;
    var element = new AGBatch(tmp233_frameBuffer, tmp234_frameBufferInfo, tmp235_vertexData, tmp236_indices, VOID, tmp237_program, tmp240_uniformBlocks, tmp241_textureUnits, tmp239_blending, tmp242_stencilOpFunc, tmp243_stencilRef, tmp244_colorMask, VOID, tmp245_scissor, VOID, tmp238_drawType, tmp246_drawOffset, tmp247_vertexCount);
    this_0.f(element);
    this.va8_1 = this.ha8_1;
  }
  qaf(uploadVertices, uploadIndices) {
    this.raf(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.va7_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ja8_1[n] = null;
      }
       while (inductionVariable < last);
    this.ia8_1 = 0;
  }
  hae(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.qaf(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.qaf.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  raf(uploadVertices, uploadIndices) {
    this.gae();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.ua8_1.a1()) {
      if (uploadVertices) {
        this.na8_1.x39_1.zad_1.v8n(this.ba8_1, 0, imul(this.ga8_1, 4));
        this.na8_1.x39_1.aae_1.r8n(this.ca8_1, 0, this.ga8_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.naf();
      }
      this.ta7_1.saf();
      draw_0(this.ya7_1, new AGMultiBatch(toList(this.ua8_1)));
      this.ua8_1.o3();
      this.sa8_1.x1x(this);
      this.xa8_1 = this.xa8_1 + 1 | 0;
      this.ta7_1.taf();
      this.na8_1.h1();
    }
    this.jae(0);
    this.ga8_1 = 0;
    this.va8_1 = 0;
    this.ha8_1 = 0;
  }
  eaf(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.raf(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.raf.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  uaf(vertexCount) {
    var oldVertexCount = this.kae();
    this.jae(vertexCount);
    try {
      this.sa8_1.x1x(this);
    }finally {
      this.jae(oldVertexCount);
    }
  }
}
class BoundsProvider {}
function get_actualVirtualWidth() {
  return toIntRound_0(this.jag().k2i_1);
}
function get_actualVirtualHeight() {
  return toIntRound_0(this.jag().l2i_1);
}
function get_virtualLeft() {
  return this.jag().p2i();
}
function get_virtualTop() {
  return this.jag().r2i();
}
function get_virtualRight() {
  return this.jag().q2i();
}
function get_virtualBottom() {
  return this.jag().s2i();
}
function get_windowToGlobalScaleAvg() {
  return get_scale(this.dag()).x2o();
}
function get_globalToWindowScaleAvg() {
  return this.hag().x2o();
}
function windowToGlobalCoords(pos) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = this.bag();
    if (this_0.n2i()) {
      tmp$ret$0 = pos;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.k2h(this_0.d2n(pos.i2h_1, pos.j2h_1), this_0.g2n(pos.i2h_1, pos.j2h_1));
  }
  return tmp$ret$0;
}
class Base {
  constructor() {
    this.vaf_1 = Companion_getInstance_8().l2m();
    this.waf_1 = MatrixTransform.v2o();
    this.xaf_1 = Companion_getInstance_8().l2m();
    this.yaf_1 = MatrixTransform.v2o();
    this.zaf_1 = Companion_getInstance_6().d2t(0, 0, 1280, 720);
  }
  aag(_set____db54di) {
    this.vaf_1 = _set____db54di;
  }
  bag() {
    return this.vaf_1;
  }
  cag(_set____db54di) {
    this.waf_1 = _set____db54di;
  }
  dag() {
    return this.waf_1;
  }
  eag(_set____db54di) {
    this.xaf_1 = _set____db54di;
  }
  fag() {
    return this.xaf_1;
  }
  gag(_set____db54di) {
    this.yaf_1 = _set____db54di;
  }
  hag() {
    return this.yaf_1;
  }
  iag(_set____db54di) {
    this.zaf_1 = _set____db54di;
  }
  jag() {
    return this.zaf_1;
  }
}
class Companion_57 {
  constructor() {
    Companion_instance_66 = this;
    this.tag_1 = ProgramLayout.f8u([DefaultShaders_getInstance().q8x_1, DefaultShaders_getInstance().s8x_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_0 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>.<anonymous>' call
    builder.f92(builder.i92(), builder.j92(builder.j92(this_0.q8z(), this_0.r8z()), builder.m92([this_0.q8x_1, builder.l92(0.0), builder.l92(1.0)])));
    builder.f92(this_0.u8x_1, this_0.s8x_1);
    tmp.uag_1 = VertexShader(builder.n92());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.a92();
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_1 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>.<anonymous>' call
    builder_0.f92(builder_0.i92(), this_1.u8x_1);
    tmp_0.vag_1 = FragmentShader(builder_0.n92());
    this.wag_1 = new Program(this.uag_1, this.vag_1);
  }
}
class LineRenderBatcher {
  constructor(ctx) {
    Companion_getInstance_74();
    this.xag_1 = ctx;
    this.yag_1 = new Signal();
    this.xag_1.ha7_1.v1x(LineRenderBatcher$lambda(this));
    this.zag_1 = this.xag_1.ma6_1;
    this.aah_1 = Colors_getInstance().w4w_1;
    this.bah_1 = new AGBuffer();
    this.cah_1 = AGVertexArrayObject.s8t([AGVertexData.w8t(Companion_getInstance_74().tag_1, this.bah_1)], false);
    this.dah_1 = 1024;
    this.eah_1 = allocDirect(Companion_instance_4, imul(24, this.dah_1));
    this.fah_1 = Matrix4.u2p();
    this.gah_1 = 0;
    this.hah_1 = 0;
    this.iah_1 = Companion_getInstance_70().ra5_1;
    this.jah_1 = Companion_getInstance_8().l2m();
  }
  kah(p0, p1, color0, color1, m) {
    return this.lah(p0.i2h_1, p0.j2h_1, p1.i2h_1, p1.j2h_1, this.aah_1, color1, m);
  }
  mah(p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.aah_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.jah_1 : m;
    var tmp;
    if ($super === VOID) {
      this.kah(p0, p1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.kah.call(this, p0, p1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  nah(x0, y0, x1, y1, color0, color1, m) {
    if (this.gah_1 >= (this.dah_1 - 2 | 0)) {
      this.fd();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  }
  oah(x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.aah_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.jah_1 : m;
    var tmp;
    if ($super === VOID) {
      this.nah(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.nah.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  lah(x0, y0, x1, y1, color0, color1, m) {
    return this.nah(x0, y0, x1, y1, color0, color1, m);
  }
  pah(path, m) {
    var lastPos = {_v: Vector2D.i2l()};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.i2l();
    var l = Vector2D.i2l();
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.m3y_1;
    var n_0 = 0;
    while (n_0 < this_0.j1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.h13(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.n3y_1.i1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.k2h(tmp, path.n3y_1.i1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!true) {
            this.mah(lastPos._v, it, VOID, VOID, m);
          }

          lastPos._v = it;
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.n3y_1.i1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.k2h(tmp_0, path.n3y_1.i1(_unary__edvuaz_3));
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!false) {
            this.mah(lastPos._v, it_0, VOID, VOID, m);
          }

          lastPos._v = it_0;
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.n3y_1.i1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.k2h(tmp_1, path.n3y_1.i1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.n3y_1.i1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.k2h(tmp_2, path.n3y_1.i1(_unary__edvuaz_7));
          var sum = Companion_getInstance_5().n2w(l, c) + Companion_getInstance_5().n2w(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos_0 = {_v: Vector2D.i2l()};
          var prevPos = {_v: Vector2D.i2l()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_12().f10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_15().e3w(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_15().e3w(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.mah(lastPos._v, it_1, VOID, VOID, m);
              }
              lastPos._v = it_1;
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos_0._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.n3y_1.i1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.k2h(tmp_3, path.n3y_1.i1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.n3y_1.i1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.k2h(tmp_4, path.n3y_1.i1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.n3y_1.i1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.k2h(tmp_5, path.n3y_1.i1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_5().n2w(l, c0) + Companion_getInstance_5().n2w(c0, c1) + Companion_getInstance_5().n2w(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_1 = {_v: Vector2D.i2l()};
          var prevPos_0 = {_v: Vector2D.i2l()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_12().f10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_15().d3w(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_15().d3w(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.mah(lastPos._v, it_2, VOID, VOID, m);
              }
              lastPos._v = it_2;
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_1._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          var p = i;
          if (!false) {
            this.mah(lastPos._v, p, VOID, VOID, m);
          }

          lastPos._v = p;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
      }
    }
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  }
  fd() {
    if (this.gah_1 > 0) {
      this.yag_1.x1x(this);
      this.bah_1.v8n(this.eah_1, 0, imul(this.hah_1, 4));
      this.xag_1.oaf();
      var tmp248_$receiver = this.zag_1;
      var tmp249_frameBuffer = this.xag_1.pa7_1;
      var tmp250_vertexData = this.cah_1;
      var tmp251_program = Companion_getInstance_74().wag_1;
      var tmp252_drawType = Companion_getInstance_43().k8u_1;
      var tmp253_vertexCount = this.gah_1;
      var tmp254_uniformBlocks = this.xag_1.qah(Companion_getInstance_74().wag_1);
      var tmp255_blending = this.iah_1.ba9_1;
      draw(tmp248_$receiver, tmp249_frameBuffer, tmp250_vertexData, tmp251_program, tmp252_drawType, tmp253_vertexCount, VOID, VOID, VOID, tmp255_blending, tmp254_uniformBlocks);
    }
    this.gah_1 = 0;
    this.hah_1 = 0;
  }
}
class FlushKind extends Enum {}
class DeviceDimensionsProvider {}
function get_devicePixelRatio() {
  return 1.0;
}
function get_pixelsPerInch() {
  return 96.0 * this.rah();
}
function get_pixelsPerLogicalInchRatio() {
  return this.sah() / 96.0;
}
function get_computedPixelRatio() {
  return this.rah() * this.tah();
}
class RenderContext {
  constructor(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads, windowConfig) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_instance : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_73().rad_1 : batchMaxQuads;
    windowConfig = windowConfig === VOID ? new Impl() : windowConfig;
    this.la6_1 = new Mixin();
    this.ma6_1 = ag;
    this.na6_1 = bp;
    this.oa6_1 = deviceDimensionsProvider;
    this.pa6_1 = stats;
    this.qa6_1 = coroutineContext;
    this.ra6_1 = batchMaxQuads;
    this.sa6_1 = windowConfig;
    this.ta6_1 = new BufferCache();
    this.ua6_1 = FastIdentityMap();
    this.va6_1 = AGTextureUnits.e8o();
    this.wa6_1 = Companion_getInstance_8().l2m();
    this.xa6_1 = Companion_getInstance_8().l2m();
    this.ya6_1 = Matrix4.u2p();
    this.za6_1 = Matrix4.u2p();
    this.aa7_1 = Companion_getInstance_8().l2m();
    this.ba7_1 = true;
    var tmp_0 = this;
    tmp_0.ca7_1 = Pool.e39(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.da7_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.ea7_1 = new AgAutoFreeManager();
    this.fa7_1 = new AgBitmapTextureManager(this.ma6_1);
    this.ga7_1 = new AgBufferManager(this.ma6_1);
    this.ha7_1 = new Signal();
    this.ia7_1 = 1.0;
    this.ja7_1 = Colors_getInstance().g4r_1;
    this.ka7_1 = new BatchBuilder2D(this, this.ra6_1);
    var tmp_2 = this;
    tmp_2.la7_1 = Pool.e39(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.ma7_1 = new RenderContext2D(this.ka7_1, this.fa7_1);
    this.na7_1 = true;
    this.oa7_1 = null;
    this.pa7_1 = this.ma6_1.h8k();
    this.qa7_1 = LinkedHashSet.l1();
    var tmp_3 = this;
    tmp_3.ra7_1 = Pool.e39(VOID, RenderContext$frameBuffers$lambda);
    this.sa7_1 = FastArrayList.g14();
  }
  n13(_set____db54di) {
    this.la6_1.n13(_set____db54di);
  }
  o13() {
    return this.la6_1.o13();
  }
  o8k() {
    return this.ma6_1.o8k();
  }
  q8k() {
    return this.ma6_1.q8k();
  }
  r8k() {
    return this.ma6_1.r8k();
  }
  s8k() {
    return this.ma6_1.s8k();
  }
  t8k() {
    return this.ma6_1.t8k();
  }
  sag(pos) {
    return this.na6_1.sag(pos);
  }
  aag(_set____db54di) {
    this.na6_1.aag(_set____db54di);
  }
  bag() {
    return this.na6_1.bag();
  }
  cag(_set____db54di) {
    this.na6_1.cag(_set____db54di);
  }
  dag() {
    return this.na6_1.dag();
  }
  eag(_set____db54di) {
    this.na6_1.eag(_set____db54di);
  }
  fag() {
    return this.na6_1.fag();
  }
  gag(_set____db54di) {
    this.na6_1.gag(_set____db54di);
  }
  hag() {
    return this.na6_1.hag();
  }
  iag(_set____db54di) {
    this.na6_1.iag(_set____db54di);
  }
  jag() {
    return this.na6_1.jag();
  }
  kag() {
    return this.na6_1.kag();
  }
  lag() {
    return this.na6_1.lag();
  }
  mag() {
    return this.na6_1.mag();
  }
  nag() {
    return this.na6_1.nag();
  }
  oag() {
    return this.na6_1.oag();
  }
  pag() {
    return this.na6_1.pag();
  }
  qag() {
    return this.na6_1.qag();
  }
  rag() {
    return this.na6_1.rag();
  }
  rah() {
    return this.oa6_1.rah();
  }
  sah() {
    return this.oa6_1.sah();
  }
  tah() {
    return this.oa6_1.tah();
  }
  uah() {
    return this.oa6_1.uah();
  }
  vah() {
    return this.sa6_1.vah();
  }
  taf() {
  }
  wah() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.da7_1;
    projViewMatUB$factory();
    return this_0.b2();
  }
  oaf() {
    if (this.ba7_1 && this.pa7_1.e8p()) {
      this.ya6_1 = ortho(Companion_getInstance_7(), Companion_getInstance_6().h2t(0, this.pa7_1.b8k_1, this.pa7_1.a8k_1, 0), -1.0, 1.0);
    } else {
      this.ya6_1 = ortho(Companion_getInstance_7(), Companion_getInstance_6().h2t(0, 0, this.pa7_1.a8k_1, this.pa7_1.b8k_1), -1.0, 1.0);
      this.ya6_1 = this.ya6_1.j2r(toMatrix4(this.wa6_1));
    }
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = this.wah();
      var _unary__edvuaz = this_0.n8t();
      this_0.v9h(_unary__edvuaz + 1 | 0);
      this_0.w9h(this_0.n8t() + 1 | 0);
      var blockSize = this_0.r8r_1;
      var index0 = imul(this_0.n8t() - 1 | 0, blockSize);
      var index1 = imul(this_0.n8t(), blockSize);
      var texBlockSize = this_0.o8r_1.s8z().j1();
      var texIndex0 = imul(this_0.n8t() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.n8t(), texBlockSize);
      if (this_0.n8t() > 0) {
        arraycopy_0(this_0.t8r_1, index0, this_0.t8r_1, index1, blockSize);
      } else {
        arrayfill_0(this_0.t8r_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.updateStandardUniforms.<anonymous>' call
      var $this$push = this_0.o8r_1;
      var it = this_0.u8r_1;
      it.m9i($this$push.q8z(), this.ya6_1);
      it.m9i($this$push.r8z(), this.za6_1);
      if (true && this_0.n8t() >= 1) {
        var equals = arrayequal(this_0.t8r_1, index0, this_0.t8r_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.n8t();
          this_0.v9h(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
  xah() {
    return coerceAtLeast_0(round(this.uah() * this.ia7_1), 1.0);
  }
  yah(kind) {
    this.ha7_1.x1x(kind);
  }
  ya8(kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.yah(kind);
      tmp = Unit_instance;
    } else {
      tmp = $super.yah.call(this, kind);
    }
    return tmp;
  }
  zah() {
    var tmp0_elvis_lhs = this.pa7_1;
    return tmp0_elvis_lhs == null ? this.h8k() : tmp0_elvis_lhs;
  }
  aai() {
    return this.zah() === this.h8k();
  }
  bai() {
    return this.h8k().a8k_1;
  }
  cai() {
    return this.h8k().b8k_1;
  }
  h8k() {
    return this.ma6_1.h8k();
  }
  dai(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.ma6_1.m8k(this.pa7_1.t8j_1, this.pa7_1.c8m(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  }
  eai(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().l4r_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_46().w8l_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.dai(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_instance;
    } else {
      tmp = $super.dai.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, scissor);
    }
    return tmp;
  }
  j8k() {
    this.ma6_1.j8k();
    this.ra7_1.j39(this.qa7_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.qa7_1.a1()) {
      this.qa7_1.o3();
    }
  }
  za8(bmp) {
    return this.fa7_1.aad(bmp);
  }
  fai(bmp) {
    return this.fa7_1.bad(bmp);
  }
  lad(buffer) {
    return this.ga7_1.lad(buffer);
  }
  gai(bmp) {
    return this.fa7_1.zac(bmp);
  }
  hai(closeable) {
    return this.ea7_1.qab(closeable);
  }
  iai() {
    this.ka7_1.lae();
  }
  cad() {
    this.ya8();
    this.j8k();
    this.ka7_1.rab();
    this.ea7_1.rab();
    this.fa7_1.cad();
    this.ga7_1.rab();
  }
  u6() {
    this.fa7_1.u6();
    this.ea7_1.u6();
  }
  jai(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    // Inline function 'kotlin.math.max' call
    var realWidth = Math.max(width, 64);
    // Inline function 'kotlin.math.max' call
    var realHeight = Math.max(height, 64);
    var rb = this.ra7_1.g39();
    if (onlyThisFrame) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.qa7_1.f(rb);
    }
    rb.q8p(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.h8q(hasDepth, hasStencil);
    rb.g8q(msamples);
    return rb;
  }
  kai(width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.jai(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.jai.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  }
  lai(rb) {
    this.qa7_1.n3(rb);
    this.ra7_1.h39(rb);
  }
  mai(frameBuffer) {
    this.sa7_1.f(this.pa7_1);
    this.pa7_1 = frameBuffer;
  }
  nai() {
    this.pa7_1 = this.sa7_1.q3(this.sa7_1.j1() - 1 | 0);
  }
  y8r(uniformBlock) {
    return this.ta6_1.y8r(uniformBlock);
  }
  oai(program) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.ua6_1;
      var res = get_0(this_0, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.RenderContext.get.<anonymous>' call
      var out = new AGProgramWithUniforms(program, this.ta6_1);
      set(this_0, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  paf(program, autoUpload) {
    if (autoUpload) {
      this.saf();
    }
    return this.oai(program).m8t();
  }
  qah(program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.paf(program, autoUpload) : $super.paf.call(this, program, autoUpload);
  }
  saf() {
    this.ta6_1.w8r();
  }
}
class RenderContext2D {
  constructor(batch, agBitmapTextureManager) {
    this.pai_1 = new Mixin();
    this.qai_1 = batch;
    this.rai_1 = agBitmapTextureManager;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger_0();
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$0 = 'RenderContext2D[0]';
      this_0.v3g(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.sai_1 = Size2D.f2j(0, 0);
    var tmp_0 = this;
    tmp_0.tai_1 = Pool.e39(VOID, RenderContext2D$mpool$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger_0();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.u3g(level_0)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$2 = 'RenderContext2D[1]';
      this_1.v3g(level_0, tmp$ret$2);
      tmp_1 = Unit_instance;
    }
    this.uai_1 = Companion_getInstance_8().i2m_1;
    this.vai_1 = Companion_getInstance_70().ra5_1;
    this.wai_1 = Colors_getInstance().g4r_1;
    this.xai_1 = true;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger_0();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.u3g(level_1)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$4 = 'RenderContext2D[2]';
      this_2.v3g(level_1, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
  }
  n13(_set____db54di) {
    this.pai_1.n13(_set____db54di);
  }
  o13() {
    return this.pai_1.o13();
  }
  d7i() {
    return this.qai_1.ta7_1;
  }
  j2y() {
    return this.sai_1.d2j_1;
  }
  k2y() {
    return this.sai_1.e2j_1;
  }
  yai(matrix) {
    this.uai_1 = matrix;
  }
  zai(rect, color, filtering, bmp, program) {
    var tmp258_$this = this.qai_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.getTexture' call
    var tmp259_tex = this.rai_1.aad(bmp);
    var tmp260_x = rect.i2i_1;
    var tmp261_y = rect.j2i_1;
    var tmp262_width = rect.k2i_1;
    var tmp263_height = rect.l2i_1;
    var tmp264_m = this.uai_1;
    var tmp265_blendMode = this.vai_1;
    tmp258_$this.kaf(tmp259_tex, tmp260_x, tmp261_y, tmp262_width, tmp263_height, tmp264_m, filtering, color, tmp265_blendMode, program);
  }
  aaj(rect, color, filtering, bmp, program, $super) {
    color = color === VOID ? this.wai_1 : color;
    filtering = filtering === VOID ? this.xai_1 : filtering;
    var tmp;
    if (bmp === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      tmp = get_Bitmaps_white();
    } else {
      tmp = bmp;
    }
    bmp = tmp;
    program = program === VOID ? null : program;
    var tmp_0;
    if ($super === VOID) {
      this.zai(rect, color, filtering, bmp, program);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.zai.call(this, rect, new RGBA(color), filtering, bmp, program);
    }
    return tmp_0;
  }
  baj(x, y, width, height, program, padding) {
    var ctx = this.qai_1.ta7_1;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.ka7_1;
    var this_1 = this_0.ta7_1;
    if (!(this_1.oa7_1 === this_0)) {
      this_1.oa7_1 = this_0;
      this_1.ya8();
    }
    var L = x - padding.t2l_1;
    var T = y - padding.q2l_1;
    var R = width + padding.x2l();
    var B = height + padding.y2l();
    var l = -padding.t2l_1;
    var t = -padding.q2l_1;
    var r = width + padding.r2l_1;
    var b = height + padding.s2l_1;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_75();
    var tmp$ret$0 = get_TEXTURED_ARRAY_QUAD_INDICES();
    var vertices = new TexturedVertexArray(6, tmp$ret$0);
    vertices.caj(0, L, T, R, B, this.uai_1, l, t, r, t, l, b, r, b, this.wai_1);
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    var tmp$ret$1 = get_Bitmaps_white();
    this_0.jaf(tmp$ret$1, this.xai_1, this.vai_1, program, 6, 4);
    this_0.daf(vertices, Companion_getInstance_8().j2m_1);
    ctx.yah(FlushKind_STATE_getInstance());
  }
  daj(scissor) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.uai_1;
      var p = Vector2D.k2l(scissor.p2i(), scissor.r2i());
      if (this_0.n2i()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.k2h(this_0.d2n(p.i2h_1, p.j2h_1), this_0.g2n(p.i2h_1, p.j2h_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_1 = this.uai_1;
      var p_0 = Vector2D.k2l(scissor.q2i(), scissor.s2i());
      if (this_1.n2i()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.k2h(this_1.d2n(p_0.i2h_1, p_0.j2h_1), this_1.g2n(p_0.i2h_1, p_0.j2h_1));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_46().q8v(tl.i2h_1, tl.j2h_1, br.i2h_1, br.j2h_1);
  }
}
class SDFShaders extends Builder {
  static waj() {
    SDFShaders_instance = null;
    var $this = this.v92();
    SDFShaders_instance = $this;
    var tmp = $this;
    var tmp_0 = $this.w93();
    var tmp_1 = $this.w93();
    var tmp_2 = $this.w93();
    var tmp_3 = $this.w93();
    tmp.gaj_1 = $this.g93(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda).i90($this, opInterpolate$factory());
    var tmp_4 = $this;
    var tmp_5 = $this.w93();
    var tmp_6 = $this.w93();
    var tmp_7 = $this.w93();
    tmp_4.haj_1 = $this.e93(tmp_5, tmp_6, VOID, tmp_7, SDFShaders$opUnion$delegate$lambda).i90($this, opUnion$factory());
    var tmp_8 = $this;
    var tmp_9 = $this.w93();
    var tmp_10 = $this.w93();
    var tmp_11 = $this.w93();
    tmp_8.iaj_1 = $this.e93(tmp_9, tmp_10, VOID, tmp_11, SDFShaders$opIntersect$delegate$lambda).i90($this, opIntersect$factory());
    var tmp_12 = $this;
    var tmp_13 = $this.w93();
    var tmp_14 = $this.w93();
    var tmp_15 = $this.w93();
    tmp_12.jaj_1 = $this.e93(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opSubtract$delegate$lambda).i90($this, opSubtract$factory());
    var tmp_16 = $this;
    var tmp_17 = $this.w93();
    var tmp_18 = $this.w93();
    var tmp_19 = $this.w93();
    tmp_16.kaj_1 = $this.e93(tmp_17, tmp_18, VOID, tmp_19, SDFShaders$opRound$delegate$lambda).i90($this, opRound$factory());
    var tmp_20 = $this;
    var tmp_21 = $this.w93();
    var tmp_22 = $this.w93();
    var tmp_23 = $this.w93();
    tmp_20.laj_1 = $this.e93(tmp_21, tmp_22, VOID, tmp_23, SDFShaders$opBorder$delegate$lambda).i90($this, opBorder$factory());
    var tmp_24 = $this;
    var tmp_25 = $this.w93();
    var tmp_26 = $this.w93();
    var tmp_27 = $this.w93();
    tmp_24.maj_1 = $this.e93(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opBorderInner$delegate$lambda).i90($this, opBorderInner$factory());
    var tmp_28 = $this;
    var tmp_29 = $this.w93();
    var tmp_30 = $this.w93();
    tmp_28.naj_1 = $this.c93(tmp_29, VOID, tmp_30, SDFShaders$opAA$delegate$lambda).i90($this, opAA$factory());
    var tmp_31 = $this;
    var tmp_32 = $this.w93();
    var tmp_33 = $this.w93();
    tmp_31.oaj_1 = $this.c93(tmp_32, VOID, tmp_33, SDFShaders$opAARev$delegate$lambda).i90($this, opAARev$factory());
    var tmp_34 = $this;
    var tmp_35 = $this.w93();
    var tmp_36 = $this.w93();
    var tmp_37 = $this.w93();
    var tmp_38 = $this.w93();
    tmp_34.paj_1 = $this.g93(tmp_35, tmp_36, tmp_37, VOID, tmp_38, SDFShaders$opSmoothUnion$delegate$lambda).i90($this, opSmoothUnion$factory());
    var tmp_39 = $this;
    var tmp_40 = $this.w93();
    var tmp_41 = $this.w93();
    var tmp_42 = $this.w93();
    var tmp_43 = $this.w93();
    tmp_39.qaj_1 = $this.g93(tmp_40, tmp_41, tmp_42, VOID, tmp_43, SDFShaders$opSmoothSubtraction$delegate$lambda).i90($this, opSmoothSubtraction$factory());
    var tmp_44 = $this;
    var tmp_45 = $this.w93();
    var tmp_46 = $this.w93();
    var tmp_47 = $this.w93();
    var tmp_48 = $this.w93();
    tmp_44.raj_1 = $this.g93(tmp_45, tmp_46, tmp_47, VOID, tmp_48, SDFShaders$opSmoothIntersection$delegate$lambda).i90($this, opSmoothIntersection$factory());
    var tmp_49 = $this;
    var tmp_50 = $this.x93();
    var tmp_51 = $this.w93();
    var tmp_52 = $this.w93();
    tmp_49.saj_1 = $this.e93(tmp_50, tmp_51, VOID, tmp_52, SDFShaders$circle$delegate$lambda).i90($this, circle$factory());
    var tmp_53 = $this;
    var tmp_54 = $this.x93();
    var tmp_55 = $this.x93();
    var tmp_56 = $this.a9r();
    var tmp_57 = $this.w93();
    tmp_53.taj_1 = $this.g93(tmp_54, tmp_55, tmp_56, VOID, tmp_57, SDFShaders$roundedBox$delegate$lambda).i90($this, roundedBox$factory());
    var tmp_58 = $this;
    var tmp_59 = $this.x93();
    var tmp_60 = $this.x93();
    var tmp_61 = $this.w93();
    tmp_58.uaj_1 = $this.e93(tmp_59, tmp_60, VOID, tmp_61, SDFShaders$box$delegate$lambda).i90($this, box$factory());
    var tmp_62 = $this;
    var tmp_63 = $this.a9r();
    var tmp_64 = $this.a9r();
    var tmp_65 = $this.a9r();
    tmp_62.vaj_1 = $this.e93(tmp_63, tmp_64, VOID, tmp_65, SDFShaders$opCombinePremultipliedColors$delegate$lambda).i90($this, opCombinePremultipliedColors$factory());
    return $this;
  }
  xaj() {
    return this.gaj_1.ko(this, opInterpolate$factory_0());
  }
  yaj() {
    return this.haj_1.ko(this, opUnion$factory_0());
  }
  zaj() {
    return this.iaj_1.ko(this, opIntersect$factory_0());
  }
  aak() {
    return this.jaj_1.ko(this, opSubtract$factory_0());
  }
  bak() {
    return this.kaj_1.ko(this, opRound$factory_0());
  }
  cak() {
    return this.laj_1.ko(this, opBorder$factory_0());
  }
  dak() {
    return this.maj_1.ko(this, opBorderInner$factory_0());
  }
  eak() {
    return this.naj_1.ko(this, opAA$factory_0());
  }
  fak() {
    return this.oaj_1.ko(this, opAARev$factory_0());
  }
  gak() {
    return this.paj_1.ko(this, opSmoothUnion$factory_0());
  }
  hak() {
    return this.qaj_1.ko(this, opSmoothSubtraction$factory_0());
  }
  iak() {
    return this.raj_1.ko(this, opSmoothIntersection$factory_0());
  }
  jak() {
    return this.saj_1.ko(this, circle$factory_0());
  }
  kak() {
    return this.taj_1.ko(this, roundedBox$factory_0());
  }
  lak() {
    return this.uaj_1.ko(this, box$factory_0());
  }
  mak() {
    return this.vaj_1.ko(this, opCombinePremultipliedColors$factory_0());
  }
}
class TextureBase {
  static nak(base, size) {
    var $this = createThis(this);
    $this.wab_1 = base;
    $this.xab_1 = size;
    $this.yab_1 = -1;
    return $this;
  }
  j1() {
    return this.xab_1;
  }
  static zab(base, width, height) {
    return this.nak(base, SizeInt.c2v(width, height));
  }
  aac(width) {
    this.xab_1 = SizeInt.c2v(width, this.k2y());
  }
  j2y() {
    return this.xab_1.a2v_1;
  }
  bac(height) {
    this.xab_1 = SizeInt.c2v(this.j2y(), height);
  }
  k2y() {
    return this.xab_1.b2v_1;
  }
  u6() {
    var tmp272_safe_receiver = this.wab_1;
    if (tmp272_safe_receiver == null)
      null;
    else {
      tmp272_safe_receiver.u6();
    }
    this.wab_1 = null;
  }
  uac(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp273_safe_receiver = this.wab_1;
    if (tmp273_safe_receiver == null)
      null;
    else
      tmp273_safe_receiver.d8r(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  toString() {
    return 'TextureBase(' + toString_1(this.wab_1) + ')';
  }
}
class TextureWithBitmapSlice {
  constructor(texture, bitmapSlice, scale, bounds) {
    this.oak_1 = texture;
    this.pak_1 = bitmapSlice;
    this.qak_1 = scale;
    this.rak_1 = bounds;
  }
  toString() {
    return 'TextureWithBitmapSlice(texture=' + this.oak_1.toString() + ', bitmapSlice=' + this.pak_1.toString() + ', scale=' + this.qak_1 + ', bounds=' + this.rak_1.toString() + ')';
  }
  hashCode() {
    var result = this.oak_1.hashCode();
    result = imul(result, 31) + this.pak_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.qak_1) | 0;
    result = imul(result, 31) + this.rak_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextureWithBitmapSlice))
      return false;
    var tmp0_other_with_cast = other instanceof TextureWithBitmapSlice ? other : THROW_CCE();
    if (!this.oak_1.equals(tmp0_other_with_cast.oak_1))
      return false;
    if (!this.pak_1.equals(tmp0_other_with_cast.pak_1))
      return false;
    if (!equals(this.qak_1, tmp0_other_with_cast.qak_1))
      return false;
    if (!this.rak_1.equals(tmp0_other_with_cast.rak_1))
      return false;
    return true;
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_67 = this;
    this.sak_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
}
class TexturedVertexArray {
  constructor(vcount, indices, icount) {
    Companion_getInstance_75();
    icount = icount === VOID ? indices.length : icount;
    this.wae_1 = indices;
    this.xae_1 = vcount;
    this.yae_1 = vcount;
    this.zae_1 = icount;
    this.aaf_1 = allocNoDirect(Companion_instance_4, imul(imul(6, this.xae_1), 4));
    this.baf_1 = this.aaf_1;
    this.caf_1 = 0;
  }
  tak(index, x, y, u, v, colMul) {
    this.uak(this.baf_1, imul(index, 6), x, y, u, v, _RGBA___get_value__impl__hhco8v(colMul));
  }
  uak(fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  }
  vak(index, x, y, width, height, matrix, bmp, colMul) {
    this.caj(index, x, y, width, height, matrix, bmp.b43(), bmp.c43(), bmp.d43(), bmp.e43(), bmp.h43(), bmp.i43(), bmp.f43(), bmp.g43(), colMul);
  }
  caj(index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix.n2m_1;
    var cf = matrix.p2m_1;
    var txf = matrix.r2m_1;
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix.q2m_1;
    var bf = matrix.o2m_1;
    var tyf = matrix.s2m_1;
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.baf_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.uak(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.uak(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.uak(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.uak(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  }
}
class ShrinkableTexturedVertexArray {
  constructor(vertices, vcount, icount) {
    vcount = vcount === VOID ? 0 : vcount;
    icount = icount === VOID ? 0 : icount;
    this.wak_1 = vertices;
    this.xak_1 = vcount;
    this.yak_1 = icount;
  }
  zak(x, y, u, v, colMul) {
    var _unary__edvuaz = this.xak_1;
    this.xak_1 = _unary__edvuaz + 1 | 0;
    this.wak_1.tak(_unary__edvuaz, x, y, u, v, colMul);
  }
  z33() {
    this.xak_1 = 0;
    this.yak_1 = 0;
  }
  toString() {
    return 'GrowableTexturedVertexArray(vcount=' + this.xak_1 + ', icount=' + this.yak_1 + ')';
  }
}
class ResourcesRoot {
  cal(path, file) {
    _get_mountable__707cy(this).o3i(path, file);
  }
  z87(injector) {
    var tmp = this;
    // Inline function 'korlibs.io.file.std.MountableVfs' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync' call
    // Inline function 'kotlin.also' call
    var this_0 = new MountableVfs(false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync.<anonymous>' call
    // Inline function 'korlibs.io.file.std.MountableVfs.<anonymous>' call
    // Inline function 'korlibs.korge.resources.ResourcesRoot.init.<anonymous>' call
    this.bal_1 = this_0;
    tmp.aal_1 = this_0.f22();
    this.cal('/', get_resourcesVfs());
  }
  toString() {
    return 'ResourcesRoot[' + _get_root__dd8asp(this).toString() + ']';
  }
}
class Counter {
  constructor(name) {
    this.dal_1 = name;
    this.eal_1 = 0.0;
    this.fal_1 = 0;
    this.gal_1 = 0.0;
  }
  hal() {
    return this.gal_1 / this.eal_1;
  }
  ial(count) {
    this.fal_1 = this.fal_1 + count | 0;
  }
  l8k() {
    this.gal_1 = this.gal_1 + this.fal_1;
    this.eal_1 = this.eal_1 + 1;
    this.fal_1 = 0;
  }
  toString() {
    return 'Counter(' + this.dal_1 + '): [frames=' + this.eal_1 + ', totalCount=' + this.gal_1 + ', countThisFrame=' + this.fal_1 + ', avgCountPerFrame=' + this.hal() + ']';
  }
}
class RCollection {
  constructor() {
    this.jal_1 = ArrayList.m1();
    this.kal_1 = LinkedHashMap.vc();
  }
}
class Stats {
  constructor() {
    this.lal_1 = new RCollection();
    this.mal_1 = new RCollection();
  }
  l8k() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.lal_1.jal_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.i1(_unary__edvuaz).l8k();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.mal_1.jal_1;
    var n_0 = 0;
    while (n_0 < this_1.j1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      this_1.i1(_unary__edvuaz_0).l8k();
    }
  }
  qal(name) {
    // Inline function 'korlibs.korge.stat.RCollection.getOrPut' call
    var this_0 = this.lal_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var this_1 = this_0.kal_1;
    var value = this_1.k3(name);
    var tmp;
    if (value == null) {
      // Inline function 'korlibs.korge.stat.RCollection.getOrPut.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'korlibs.korge.stat.Stats.counter.<anonymous>' call
      var this_2 = new Counter(name);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.stat.RCollection.getOrPut.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      this_0.jal_1.f(this_2);
      var answer = this_2;
      this_1.r3(name, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
}
class V2 {
  constructor(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) {
    fastStartTime = fastStartTime === VOID ? Companion_instance_3.m1w() : fastStartTime;
    fastDuration = fastDuration === VOID ? Companion_instance_3.n1w() : fastDuration;
    initialization = initialization === VOID ? null : initialization;
    this.ral_1 = key;
    this.sal_1 = initial;
    this.tal_1 = end;
    this.ual_1 = interpolator;
    this.val_1 = includeStart;
    this.wal_1 = fastStartTime;
    this.xal_1 = fastDuration;
    this.yal_1 = initialization;
    this.zal_1 = FastDuration__plus_impl_q1enab(this.wal_1, equals(this.xal_1, Companion_instance_3.n1w()) ? get_fastNanoseconds_0(0) : this.xal_1);
  }
  aam() {
    return toDuration_1(this.wal_1);
  }
  e6n() {
    return toDuration_1(this.xal_1);
  }
  bam(default_0) {
    return equals(this.xal_1, Companion_instance_3.n1w()) ? default_0 : this.zal_1;
  }
  e28() {
    if (!this.val_1) {
      this.sal_1 = this.ral_1.get();
    }
    var tmp278_safe_receiver = this.yal_1;
    if (tmp278_safe_receiver == null)
      null;
    else
      tmp278_safe_receiver();
  }
  cam(ratio) {
    this.ral_1.set(this.ual_1(new Ratio(ratio), this.sal_1, this.tal_1));
  }
  toString() {
    return 'V2(key=' + this.ral_1.callableName + ', range=[' + toString_1(this.sal_1) + '-' + toString_1(this.tal_1) + '], startTime=' + Duration__toString_impl_8d916b(this.aam()) + ', duration=' + Duration__toString_impl_8d916b(this.e6n()) + ')';
  }
  dam(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) {
    return new V2(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization);
  }
  eam(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization, $super) {
    key = key === VOID ? this.ral_1 : key;
    initial = initial === VOID ? this.sal_1 : initial;
    end = end === VOID ? this.tal_1 : end;
    interpolator = interpolator === VOID ? this.ual_1 : interpolator;
    includeStart = includeStart === VOID ? this.val_1 : includeStart;
    fastStartTime = fastStartTime === VOID ? this.wal_1 : fastStartTime;
    fastDuration = fastDuration === VOID ? this.xal_1 : fastDuration;
    initialization = initialization === VOID ? this.yal_1 : initialization;
    return $super === VOID ? this.dam(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) : $super.dam.call(this, key, initial, end, interpolator, includeStart, new FastDuration(fastStartTime), new FastDuration(fastDuration), initialization);
  }
  hashCode() {
    var result = hashCode(this.ral_1);
    result = imul(result, 31) + (this.sal_1 == null ? 0 : hashCode(this.sal_1)) | 0;
    result = imul(result, 31) + (this.tal_1 == null ? 0 : hashCode(this.tal_1)) | 0;
    result = imul(result, 31) + hashCode(this.ual_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.val_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.wal_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.xal_1) | 0;
    result = imul(result, 31) + (this.yal_1 == null ? 0 : hashCode(this.yal_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.ral_1, tmp0_other_with_cast.ral_1))
      return false;
    if (!equals(this.sal_1, tmp0_other_with_cast.sal_1))
      return false;
    if (!equals(this.tal_1, tmp0_other_with_cast.tal_1))
      return false;
    if (!equals(this.ual_1, tmp0_other_with_cast.ual_1))
      return false;
    if (!(this.val_1 === tmp0_other_with_cast.val_1))
      return false;
    if (!equals(this.wal_1, tmp0_other_with_cast.wal_1))
      return false;
    if (!equals(this.xal_1, tmp0_other_with_cast.xal_1))
      return false;
    if (!equals(this.yal_1, tmp0_other_with_cast.yal_1))
      return false;
    return true;
  }
}
class V2CallbackSupport {
  constructor() {
    V2CallbackSupport_instance = this;
    this.fam_1 = Unit_instance;
  }
}
class DEFAULT {}
class DialogInterface {}
function get_dialogInterface() {
  return this;
}
function alert(message, $completion) {
  unsupported();
}
function openFileDialog(filter, write, multi, currentDir, $completion) {
  unsupported();
}
class Unsupported {}
class FileFilter {
  static lam(entries) {
    var $this = createThis(this);
    $this.jam_1 = entries;
    var tmp = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = $this.jam_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.render.FileFilter.regexps.<anonymous>' call
      var list = element.jm_1;
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.f1();
    while (tmp0_iterator_0.g1()) {
      var item = tmp0_iterator_0.h1();
      // Inline function 'korlibs.render.FileFilter.regexps.<anonymous>' call
      var tmp$ret$3 = fromGlob(Companion_getInstance_1(), item);
      destination_0.f(tmp$ret$3);
    }
    tmp.kam_1 = destination_0;
    return $this;
  }
  static mam(entries) {
    return this.lam(toList_0(entries));
  }
  toString() {
    return 'FileFilter(entries=' + toString(this.jam_1) + ')';
  }
  hashCode() {
    return hashCode(this.jam_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FileFilter))
      return false;
    var tmp0_other_with_cast = other instanceof FileFilter ? other : THROW_CCE();
    if (!equals(this.jam_1, tmp0_other_with_cast.jam_1))
      return false;
    return true;
  }
}
class Impl {
  constructor(quality) {
    quality = quality === VOID ? Quality_AUTOMATIC_getInstance() : quality;
    this.nam_1 = quality;
  }
  vah() {
    return this.nam_1;
  }
}
class Companion_59 {
  constructor() {
    Companion_instance_68 = this;
    this.oam_1 = mapOf([to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
  pam(anchor) {
    return anchor.equals(Companion_getInstance_9().p2g_1) ? Cursor_RESIZE_NORTH_WEST_getInstance() : anchor.equals(Companion_getInstance_9().b2h()) ? Cursor_RESIZE_NORTH_getInstance() : anchor.equals(Companion_getInstance_9().r2g_1) ? Cursor_RESIZE_NORTH_EAST_getInstance() : anchor.equals(Companion_getInstance_9().c2h()) ? Cursor_RESIZE_WEST_getInstance() : anchor.equals(Companion_getInstance_9().d2h()) ? Cursor_RESIZE_EAST_getInstance() : anchor.equals(Companion_getInstance_9().v2g_1) ? Cursor_RESIZE_SOUTH_WEST_getInstance() : anchor.equals(Companion_getInstance_9().e2h()) ? Cursor_RESIZE_SOUTH_getInstance() : anchor.equals(Companion_getInstance_9().x2g_1) ? Cursor_RESIZE_SOUTH_EAST_getInstance() : null;
  }
}
class Cursor extends Enum {}
class MenuItem {
  constructor(text, enabled, children, action) {
    enabled = enabled === VOID ? true : enabled;
    children = children === VOID ? null : children;
    var tmp;
    if (action === VOID) {
      tmp = GameWindow$MenuItem$_init_$lambda_465oqx;
    } else {
      tmp = action;
    }
    action = tmp;
    this.sam_1 = text;
    this.tam_1 = enabled;
    this.uam_1 = children;
    this.vam_1 = action;
  }
  toString() {
    return 'MenuItem(text=' + this.sam_1 + ', enabled=' + this.tam_1 + ', children=' + toString_1(this.uam_1) + ', action=' + toString(this.vam_1) + ')';
  }
  hashCode() {
    var result = this.sam_1 == null ? 0 : getStringHashCode(this.sam_1);
    result = imul(result, 31) + getBooleanHashCode(this.tam_1) | 0;
    result = imul(result, 31) + (this.uam_1 == null ? 0 : hashCode(this.uam_1)) | 0;
    result = imul(result, 31) + hashCode(this.vam_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this.sam_1 == tmp0_other_with_cast.sam_1))
      return false;
    if (!(this.tam_1 === tmp0_other_with_cast.tam_1))
      return false;
    if (!equals(this.uam_1, tmp0_other_with_cast.uam_1))
      return false;
    if (!equals(this.vam_1, tmp0_other_with_cast.vam_1))
      return false;
    return true;
  }
}
class CoroutineKey {
  constructor() {
    CoroutineKey_instance = this;
    this.wam_1 = 60;
    this.xam_1 = Companion_getInstance_2().ez('GameWindow');
    this.yam_1 = new MenuItem(null);
  }
}
class Quality extends Enum {
  constructor(name, ordinal, level) {
    super(name, ordinal);
    this.map_1 = level;
    this.nap_1 = 4000000;
  }
  s3g() {
    return this.map_1;
  }
  oap(width, height, devicePixelRatio, targetPixels) {
    var tmp;
    switch (this.v3_1) {
      case 0:
        tmp = 1.0;
        break;
      case 1:
        tmp = devicePixelRatio;
        break;
      case 2:
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = listOf_0([devicePixelRatio, 2.0, 1.0]).f1();
          while (tmp0_iterator.g1()) {
            var element = tmp0_iterator.h1();
            // Inline function 'korlibs.render.Quality.computeTargetScale.<anonymous>' call
            if (imul(width, height) * element <= targetPixels) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }

        var tmp0_elvis_lhs = tmp$ret$1;
        tmp = tmp0_elvis_lhs == null ? 1.0 : tmp0_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  pap(width, height, devicePixelRatio, targetPixels, $super) {
    targetPixels = targetPixels === VOID ? this.nap_1 : targetPixels;
    return $super === VOID ? this.oap(width, height, devicePixelRatio, targetPixels) : $super.oap.call(this, width, height, devicePixelRatio, targetPixels);
  }
}
class GameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.qam_1 = $entry;
    this.ram_1 = this$0;
  }
  pe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, $completion), $completion);
  }
}
class _no_name_provided__qut3iv extends ObservableProperty {
  constructor($initialValue, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.vap_1 = this$0;
    super($initialValue, $box);
  }
  wap(property, oldValue, newValue) {
    var tmp281_safe_receiver = this.vap_1.qao_1;
    if (tmp281_safe_receiver == null)
      null;
    else
      tmp281_safe_receiver(newValue);
    return Unit_instance;
  }
  jo(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
    return this.wap(property, tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  }
}
class GameWindow extends BaseEventListener {
  static xap() {
    CoroutineKey_getInstance();
    var $this = this.i8a();
    $this.dan_1 = new Mixin();
    $this.ean_1 = Cursor_DEFAULT_getInstance();
    $this.fan_1 = false;
    $this.gan_1 = new AGDummy();
    $this.han_1 = SyncEventLoopCoroutineDispatcher.aaq();
    $this.ian_1 = GameWindowCoroutineDispatcher.laq();
    $this.jan_1 = new PauseEvent();
    $this.kan_1 = new ResumeEvent();
    $this.lan_1 = new StopEvent();
    $this.man_1 = new DestroyEvent();
    $this.nan_1 = new UpdateEvent();
    $this.oan_1 = new RenderEvent();
    $this.pan_1 = new InitEvent();
    $this.qan_1 = new DisposeEvent();
    $this.ran_1 = new FullScreenEvent();
    $this.san_1 = new ReshapeEvent();
    $this.tan_1 = new KeyEvent();
    $this.uan_1 = new MouseEvent();
    $this.van_1 = new GestureEvent();
    $this.wan_1 = new DropFileEvent();
    var tmp = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    tmp.xan_1 = new IntTimedCache(tmp_0, VOID, GameWindow$fpsCached$delegate$lambda($this));
    $this.yan_1 = 60;
    $this.zan_1 = 0;
    $this.aao_1 = 0;
    $this.bao_1 = true;
    $this.cao_1 = null;
    $this.dao_1 = false;
    $this.eao_1 = false;
    $this.fao_1 = Colors_getInstance().h4r_1;
    $this.gao_1 = new Signal();
    $this.hao_1 = new Signal();
    $this.iao_1 = null;
    $this.jao_1 = false;
    $this.kao_1 = true;
    $this.lao_1 = 0;
    $this.mao_1 = true;
    $this.nao_1 = false;
    var tmp_1 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_1.oao_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.pao_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    $this.qao_1 = null;
    var tmp_3 = $this;
    // Inline function 'kotlin.properties.Delegates.observable' call
    tmp_3.rao_1 = new _no_name_provided__qut3iv(true, $this);
    $this.sao_1 = false;
    $this.tao_1 = -1;
    $this.uao_1 = -1;
    $this.vao_1 = -1;
    $this.wao_1 = -1;
    $this.xao_1 = false;
    $this.yao_1 = false;
    $this.zao_1 = false;
    $this.aap_1 = 0;
    $this.bap_1 = Companion_instance_3.m1w();
    $this.cap_1 = new Lock();
    $this.dap_1 = booleanArray(Companion_getInstance_37().z8h_1);
    $this.eap_1 = 0;
    $this.fap_1 = 0.0;
    $this.gap_1 = 0.0;
    $this.hap_1 = 0.0;
    $this.iap_1 = false;
    $this.jap_1 = new GamepadInfoEmitter($this);
    return $this;
  }
  n13(_set____db54di) {
    this.dan_1.n13(_set____db54di);
  }
  o13() {
    return this.dan_1.o13();
  }
  gam() {
    return Unsupported_instance;
  }
  maq(windowRect) {
  }
  naq(force, config) {
  }
  oaq(force, config, $super) {
    force = force === VOID ? true : force;
    config = config === VOID ? null : config;
    var tmp;
    if ($super === VOID) {
      this.naq(force, config);
      tmp = Unit_instance;
    } else {
      tmp = $super.naq.call(this, force, config);
    }
    return tmp;
  }
  paq() {
  }
  qaq(_set____db54di) {
    this.ean_1 = _set____db54di;
  }
  raq() {
    return this.ean_1;
  }
  a2() {
    return CoroutineKey_getInstance();
  }
  saq() {
    return this.gan_1;
  }
  taq() {
    return this.ian_1;
  }
  uaq(coroutineContext) {
    return coroutineContext.xn(this.taq());
  }
  qap($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.gd();
    return this.uaq(tmp$ret$0);
  }
  vaq(block) {
    return this.k8a(Companion_getInstance_20(), block);
  }
  sap() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = 1000000.0 / this.waq();
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  tap() {
    return 60;
  }
  xaq(name, time) {
  }
  waq() {
    return _get_fpsCached__581dty(this);
  }
  yaq(value) {
    return Unit_instance;
  }
  j2y() {
    return this.zan_1;
  }
  k2y() {
    return this.aao_1;
  }
  zaq(_set____db54di) {
    this.cao_1 = _set____db54di;
  }
  aar(_set____db54di) {
    this.dao_1 = _set____db54di;
  }
  bar() {
    return this.dao_1;
  }
  car(_set____db54di) {
    this.eao_1 = _set____db54di;
  }
  dar(_set____db54di) {
    this.fao_1 = _set____db54di;
  }
  ear() {
    return this.fao_1;
  }
  far(value) {
    return Unit_instance;
  }
  vah() {
    return Quality_AUTOMATIC_getInstance();
  }
  gar(value) {
    this.jao_1 = value;
    this.hao_1.x1x(value);
    if (value) {
      invoke(this.gao_1);
    }
  }
  har() {
    return this.jao_1;
  }
  iar(width, height) {
    return Unit_instance;
  }
  jar(exitCode) {
    return this.k1d(exitCode);
  }
  kar(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.jar(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.jar.call(this, exitCode);
    }
    return tmp;
  }
  k1d(exitCode) {
    if (this.nao_1)
      return Unit_instance;
    this.nao_1 = true;
    this.mao_1 = false;
    this.lao_1 = exitCode;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = CoroutineKey_getInstance().xam_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.render.GameWindow.close.<anonymous>' call
      var tmp$ret$0 = 'GameWindow.close';
      this_0.v3g(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.taq().u6();
    cancelChildren(this.taq());
  }
  lar(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.k1d(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.k1d.call(this, exitCode);
    }
    return tmp;
  }
  mar($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_waitClose__fhnm35(this, $completion), $completion);
  }
  nar(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8(this, entry, $completion), $completion);
  }
  oar(_set____db54di) {
    return this.rao_1.no(this, continuousRenderMode$factory(), _set____db54di);
  }
  par() {
    return this.rao_1.lo(this, continuousRenderMode$factory_0());
  }
  qar(doUpdate, doRender, frameStartTime) {
    var startTime = PerformanceCounter_getInstance().j88();
    if (doRender) {
      var tmp = this;
      // Inline function 'korlibs.time.measureTime' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark = Monotonic_instance.bk();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      this.rar(doUpdate, true);
      tmp.oao_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    }
    if (doUpdate) {
      var tmp_0 = this;
      // Inline function 'korlibs.time.measureTime' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark_0 = Monotonic_instance.bk();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      if (!doRender) {
        this.rar(true, false);
      }
      this.sar(frameStartTime);
      tmp_0.pao_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark_0);
    }
    var endTime = PerformanceCounter_getInstance().k88();
    return FastDuration__minus_impl_evs237_0(endTime, startTime);
  }
  rap(doUpdate, doRender, frameStartTime, $super) {
    doUpdate = doUpdate === VOID ? true : doUpdate;
    doRender = doRender === VOID ? true : doRender;
    frameStartTime = frameStartTime === VOID ? PerformanceCounter_getInstance().k88() : frameStartTime;
    return $super === VOID ? this.qar(doUpdate, doRender, frameStartTime) : $super.qar.call(this, doUpdate, doRender, new FastDuration(frameStartTime)).p1w_1;
  }
  rar(doUpdate, doRender) {
    if (doRender) {
      if (this.zao_1) {
        this.zao_1 = false;
        this.saq().i8k();
      }
      if (this.sao_1) {
        this.sao_1 = false;
        this.saq().h8k().p8p(this.tao_1, this.uao_1, this.vao_1, this.wao_1);
        this.tar(this.tao_1, this.uao_1, this.vao_1, this.wao_1);
      }
    }
    if (this.xao_1) {
      this.xao_1 = false;
      println('---------------- Trigger AG.initialized ag.mainFrameBuffer.setSize (' + this.j2y() + ', ' + this.k2y() + ') --------------');
      // Inline function 'korlibs.event.reset' call
      var this_0 = this.pan_1;
      this_0.d8b_1 = false;
      // Inline function 'korlibs.event.reset.<anonymous>' call
      this.v8a(this_0);
    }
    try {
      this.uar(doUpdate, doRender);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  l8k() {
    this.aap_1 = 0;
  }
  var() {
    this.aap_1 = this.aap_1 + 1 | 0;
  }
  sar(startTime) {
    var tmp = this;
    // Inline function 'korlibs.time.fastMeasureTime' call
    var stopwatch = new Stopwatch();
    // Inline function 'korlibs.render.GameWindow.frameUpdate.<anonymous>' call
    this.war();
    tmp.bap_1 = stopwatch.p88();
    try {
      var now = PerformanceCounter_getInstance().j88();
      var consumed = minus(now, startTime);
      var tmp0_elvis_lhs = this.taq().jaq_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
        tmp_0 = Duration__times_impl_sfuzvp(this.sap(), 10);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var timeForTasks = tmp_0;
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$2 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
      var finalTimeForTasks = max(timeForTasks, tmp$ret$2);
      this.taq().xar(finalTimeForTasks);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
      } else {
        throw $p;
      }
    }
  }
  war() {
  }
  uar(update, render) {
    // Inline function 'korlibs.render.GameWindow.updateRenderLock' call
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.cap_1;
      this_0.w1w();
      try {
        // Inline function 'korlibs.event.reset' call
        var this_1 = this.oan_1;
        this_1.d8b_1 = false;
        // Inline function 'korlibs.render.GameWindow.dispatchRenderEvent.<anonymous>.<anonymous>' call
        this_1.n8b_1 = update;
        this_1.o8b_1 = render;
        this.v8a(this_1);
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
  }
  yar(type, files) {
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.wan_1;
    this_0.d8b_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchDropfileEvent.<anonymous>' call
    this_0.f8e_1 = type;
    this_0.g8e_1 = files;
    return this.v8a(this_0);
  }
  tar(x, y, width, height) {
    this.zar(x, y, width, height, width, height);
  }
  zar(x, y, width, height, fullWidth, fullHeight) {
    this.saq().h8k().q8p(x, y, width, height, fullWidth, fullHeight);
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.san_1;
    this_0.d8b_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchReshapeEventEx.<anonymous>' call
    this_0.w8b_1 = x;
    this_0.x8b_1 = y;
    this_0.y8b_1 = width;
    this_0.z8b_1 = height;
    this.v8a(this_0);
  }
  i8g() {
    this.jap_1.i8g();
  }
  u8g(info) {
    this.jap_1.u8g(info);
  }
  w8g(out) {
    return this.jap_1.w8g(out);
  }
  aas(out, $super) {
    out = out === VOID ? IntArrayList.f31() : out;
    return $super === VOID ? this.w8g(out) : $super.w8g.call(this, out);
  }
  bas(data, $completion) {
  }
  cas($completion) {
    return null;
  }
}
class Companion_60 {
  constructor() {
    Companion_instance_69 = this;
    this.das_1 = new GameWindowCreationConfig();
  }
}
class GameWindowCreationConfig {
  constructor(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable) {
    Companion_getInstance_77();
    multithreaded = multithreaded === VOID ? null : multithreaded;
    hdr = hdr === VOID ? null : hdr;
    msaa = msaa === VOID ? null : msaa;
    checkGl = checkGl === VOID ? false : checkGl;
    logGl = logGl === VOID ? false : logGl;
    cacheGl = cacheGl === VOID ? false : cacheGl;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    decorated = decorated === VOID ? true : decorated;
    transparent = transparent === VOID ? false : transparent;
    resizable = resizable === VOID ? true : resizable;
    this.eas_1 = multithreaded;
    this.fas_1 = hdr;
    this.gas_1 = msaa;
    this.has_1 = checkGl;
    this.ias_1 = logGl;
    this.jas_1 = cacheGl;
    this.kas_1 = fullscreen;
    this.las_1 = decorated;
    this.mas_1 = transparent;
    this.nas_1 = resizable;
  }
  toString() {
    return 'GameWindowCreationConfig(multithreaded=' + this.eas_1 + ', hdr=' + this.fas_1 + ', msaa=' + this.gas_1 + ', checkGl=' + this.has_1 + ', logGl=' + this.ias_1 + ', cacheGl=' + this.jas_1 + ', fullscreen=' + this.kas_1 + ', decorated=' + this.las_1 + ', transparent=' + this.mas_1 + ', resizable=' + this.nas_1 + ')';
  }
  hashCode() {
    var result = this.eas_1 == null ? 0 : getBooleanHashCode(this.eas_1);
    result = imul(result, 31) + (this.fas_1 == null ? 0 : getBooleanHashCode(this.fas_1)) | 0;
    result = imul(result, 31) + (this.gas_1 == null ? 0 : this.gas_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.has_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ias_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jas_1) | 0;
    result = imul(result, 31) + (this.kas_1 == null ? 0 : getBooleanHashCode(this.kas_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.las_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.mas_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.nas_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWindowCreationConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameWindowCreationConfig ? other : THROW_CCE();
    if (!(this.eas_1 == tmp0_other_with_cast.eas_1))
      return false;
    if (!(this.fas_1 == tmp0_other_with_cast.fas_1))
      return false;
    if (!(this.gas_1 == tmp0_other_with_cast.gas_1))
      return false;
    if (!(this.has_1 === tmp0_other_with_cast.has_1))
      return false;
    if (!(this.ias_1 === tmp0_other_with_cast.ias_1))
      return false;
    if (!(this.jas_1 === tmp0_other_with_cast.jas_1))
      return false;
    if (!(this.kas_1 == tmp0_other_with_cast.kas_1))
      return false;
    if (!(this.las_1 === tmp0_other_with_cast.las_1))
      return false;
    if (!(this.mas_1 === tmp0_other_with_cast.mas_1))
      return false;
    if (!(this.nas_1 === tmp0_other_with_cast.nas_1))
      return false;
    return true;
  }
}
class TextClipboardData {
  constructor(text, contentType) {
    contentType = contentType === VOID ? null : contentType;
    this.oas_1 = text;
    this.pas_1 = contentType;
  }
  toString() {
    return 'TextClipboardData(text=' + this.oas_1 + ', contentType=' + this.pas_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.oas_1);
    result = imul(result, 31) + (this.pas_1 == null ? 0 : getStringHashCode(this.pas_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextClipboardData))
      return false;
    var tmp0_other_with_cast = other instanceof TextClipboardData ? other : THROW_CCE();
    if (!(this.oas_1 === tmp0_other_with_cast.oas_1))
      return false;
    if (!(this.pas_1 == tmp0_other_with_cast.pas_1))
      return false;
    return true;
  }
}
class TimedTask_0 {
  constructor(time, continuation, callback) {
    this.qas_1 = time;
    this.ras_1 = continuation;
    this.sas_1 = callback;
    this.tas_1 = null;
  }
}
class Companion_61 {
  constructor() {
    Companion_instance_70 = this;
    this.uas_1 = Companion_getInstance_2().ez('GameWindow');
  }
}
class sam$kotlinx_coroutines_DisposableHandle$0_0 {
  constructor(function_0) {
    this.vas_1 = function_0;
  }
  o18() {
    return this.vas_1();
  }
}
class GameWindowCoroutineDispatcher extends CoroutineDispatcher {
  static laq(nowProvider, fast) {
    Companion_getInstance_78();
    var tmp;
    if (nowProvider === VOID) {
      tmp = GameWindowCoroutineDispatcher$_init_$lambda_ooms1e;
    } else {
      tmp = nowProvider;
    }
    nowProvider = tmp;
    fast = fast === VOID ? false : fast;
    var $this = this.t1b();
    $this.caq_1 = nowProvider;
    $this.daq_1 = fast;
    $this.eaq_1 = new TGenQueue();
    var tmp_0 = $this;
    var tmp_1 = Companion_instance_0;
    tmp_0.faq_1 = tmp_1.b3a(VOID, GameWindowCoroutineDispatcher$timedTasks$lambda);
    $this.gaq_1 = new NonRecursiveLock();
    $this.haq_1 = get_fastMilliseconds_0(0);
    $this.iaq_1 = get_fastMilliseconds_0(0);
    $this.jaq_1 = null;
    $this.kaq_1 = Companion_getInstance_2().ez('Korgw.GameWindow.TooManyCallbacks');
    return $this;
  }
  was(block) {
    if (block == null)
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.gaq_1;
      this_0.w1w();
      try {
        this.eaq_1.l3a(block);
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
  }
  v1b(context, block) {
    return this.was(block);
  }
  xas() {
    return this.caq_1().p1w_1;
  }
  d1c(timeMillis, continuation) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.t4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    this.yas(tmp$ret$0, continuation);
  }
  yas(time, continuation) {
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(this.xas(), time), continuation, null);
    continuation.c18(GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda(task));
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.gaq_1;
      this_0.w1w();
      try {
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.scheduleResumeAfterDelay.<anonymous>' call
        this.faq_1.y34(task);
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
  }
  e1c(timeMillis, block, context) {
    var tmp = this.xas();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.t4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(tmp, tmp$ret$0), null, block);
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_1 = this.gaq_1;
      this_1.w1w();
      try {
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.invokeOnTimeout.<anonymous>' call
        this.faq_1.y34(task);
        break $l$block;
      }finally {
        this_1.z1w();
      }
    }
    var tmp_0 = GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this, task);
    return new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_0);
  }
  xar(availableTime) {
    this.zas(get_fast(availableTime));
  }
  zas(availableTime) {
    try {
      var startTime = this.xas();
      var processedTimedTasks = 0;
      var processedTasks = 0;
      var tmp = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_0: while (true) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
          var this_0 = this.gaq_1;
          this_0.w1w();
          try {
            // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
            var tmp_0;
            var tmp_1;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!this.faq_1.a1()) {
              tmp_1 = this.daq_1 || FastDuration__compareTo_impl_4fhnj7(startTime, this.faq_1.h3a().qas_1) >= 0;
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = this.faq_1.i3a();
            } else {
              tmp_0 = null;
            }
            tmp$ret$2 = tmp_0;
            break $l$block;
          }finally {
            this_0.z1w();
          }
        }
        var tmp_2;
        if (tmp$ret$2 == null) {
          break $l$loop_0;
        } else {
          tmp_2 = tmp$ret$2;
        }
        var item = tmp_2;
        try {
          if (!(item.tas_1 == null)) {
            var tmp282_safe_receiver = item.ras_1;
            if (tmp282_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception = ensureNotNull(item.tas_1);
              var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
              tmp282_safe_receiver.id(tmp$ret$3);
            }
            if (!(item.sas_1 == null)) {
              var tmp283_safe_receiver = item.tas_1;
              if (tmp283_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp283_safe_receiver);
              }
            }
          } else {
            var tmp284_safe_receiver = item.ras_1;
            if (tmp284_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
              tmp284_safe_receiver.id(tmp$ret$5);
            }
            var tmp285_safe_receiver = item.sas_1;
            if (tmp285_safe_receiver == null)
              null;
            else {
              tmp285_safe_receiver.p1a();
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        finally {
          processedTimedTasks = processedTimedTasks + 1 | 0;
        }
        var elapsedTime = FastDuration__minus_impl_evs237(this.xas(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, availableTime) >= 0) {
          this.aat(elapsedTime, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_0;
        }
      }
      tmp.haq_1 = stopwatch.p88();
      var tmp_3 = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch_0 = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_2: while (true) {
        var tmp$ret$10;
        $l$block_0: {
          // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
          var this_1 = this.gaq_1;
          this_1.w1w();
          try {
            // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
            var tmp_4;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!this.eaq_1.a1()) {
              tmp_4 = this.eaq_1.m3a();
            } else {
              tmp_4 = null;
            }
            tmp$ret$10 = tmp_4;
            break $l$block_0;
          }finally {
            this_1.z1w();
          }
        }
        var tmp_5;
        if (tmp$ret$10 == null) {
          break $l$loop_2;
        } else {
          tmp_5 = tmp$ret$10;
        }
        var task = tmp_5;
        // Inline function 'korlibs.time.fastMeasureTime' call
        var stopwatch_1 = new Stopwatch();
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        try {
          task.p1a();
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            printStackTrace(e_0);
          } else {
            throw $p;
          }
        }
        finally {
          processedTasks = processedTasks + 1 | 0;
        }
        var time = stopwatch_1.p88();
        var elapsed = FastDuration__minus_impl_evs237(this.xas(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsed, availableTime) >= 0) {
          this.aat(elapsed, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_2;
        }
      }
      tmp_3.iaq_1 = stopwatch_0.p88();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace(e_1);
      } else {
        throw $p;
      }
    }
  }
  aat(elapsedTime, availableTime, processedTimedTasks, processedTasks) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var this_0 = this.kaq_1;
    var level = Level_WARN_getInstance();
    var tmp;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.informTooManyCallbacksToHandleInThisFrame.<anonymous>' call
      var tmp$ret$0 = 'Too many callbacks to handle in this frame elapsedTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(elapsedTime)) + ', availableTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(availableTime)) + ' pending timedTasks=' + this.faq_1.e3a_1 + ', tasks=' + this.eaq_1.j1() + ', processedTimedTasks=' + processedTimedTasks + ', processedTasks=' + processedTasks;
      this_0.v3g(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  u6() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(2, DurationUnit_SECONDS_getInstance());
    this.xar(tmp$ret$1);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_78().uas_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.close.<anonymous>' call
      var tmp$ret$2 = 'GameWindowCoroutineDispatcher.close';
      this_0.v3g(level, tmp$ret$2);
      tmp = Unit_instance;
    }
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.faq_1.a1()) {
        break $l$loop;
      }
      var tmp286_safe_receiver = this.faq_1.i3a().ras_1;
      if (tmp286_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp286_safe_receiver.id(tmp$ret$5);
      }
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.eaq_1.a1()) {
        break $l$loop_0;
      }
      this.eaq_1.m3a().p1a();
    }
  }
  toString() {
    return 'GameWindowCoroutineDispatcher(setNow=setNow, fast=' + this.daq_1 + ')';
  }
}
class SyncEventLoopCoroutineDispatcher extends CoroutineDispatcher {
  static bat(eventLoop) {
    var $this = this.t1b();
    $this.zap_1 = eventLoop;
    return $this;
  }
  static aaq(precise, immediateRun) {
    precise = precise === VOID ? true : precise;
    immediateRun = immediateRun === VOID ? false : immediateRun;
    return this.bat(new SyncEventLoop(precise, immediateRun));
  }
  u6() {
    this.zap_1.u6();
  }
  v1b(context, block) {
    this.zap_1.q89(SyncEventLoopCoroutineDispatcher$dispatch$lambda(block));
  }
  d1c(timeMillis, continuation) {
    var cancelled = {_v: null};
    continuation.c18(SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda(cancelled));
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    this.zap_1.r89(tmp, SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(cancelled, continuation));
  }
  e1c(timeMillis, block, context) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    return toDisposable(this.zap_1.r89(tmp, SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda(block)));
  }
}
class Companion_62 {}
class UpdateEvent extends Event {
  constructor(fastDeltaTime) {
    fastDeltaTime = fastDeltaTime === VOID ? Companion_instance_3.m1w() : fastDeltaTime;
    super();
    this.eat_1 = fastDeltaTime;
  }
  fat() {
    return toDuration_1(this.eat_1);
  }
  b2n() {
    return Companion_instance_71;
  }
  toString() {
    return 'UpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.eat_1) + ')';
  }
}
class AGOpenglFactory {
  paa() {
    // Inline function 'kotlin.js.unsafeCast' call
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }
}
class KmlGlJsCanvas extends KmlGl {
  constructor(canvas, glOpts) {
    super();
    this.kat_1 = canvas;
    this.lat_1 = glOpts;
    this.mat_1 = 1;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    if (null == null) {
      var tmp2_safe_receiver = this.kat_1.getContext('webgl2', this.lat_1);
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
        this.mat_1 = 2;
        tmp_1 = tmp2_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = null;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this.kat_1.getContext('webgl', this.lat_1) : tmp1_elvis_lhs;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp3_safe_receiver = tmp2_elvis_lhs == null ? this.kat_1.getContext('experimental-webgl', this.lat_1) : tmp2_elvis_lhs;
    var tmp_2;
    if (tmp3_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      println('Created WebGL version=' + this.mat_1 + ', opts=' + JSON.stringify(this.lat_1));
      tmp_2 = tmp3_safe_receiver;
    }
    var tmp4_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp4_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      tmp4_safe_receiver.getExtension('OES_standard_derivatives');
      tmp4_safe_receiver.getExtension('OES_texture_float');
      tmp4_safe_receiver.getExtension('OES_texture_float_linear');
      tmp4_safe_receiver.getExtension('OES_element_index_uint');
      tmp_3 = tmp4_safe_receiver;
    }
    var tmp3_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      try {
        var tmp5_safe_receiver = document.body;
        if (tmp5_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          var tmp_5 = document.createElement('div');
          var this_0 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>.<anonymous>' call
          this_0.style.color = 'red';
          this_0.style.font = '30px Arial';
          this_0.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp5_safe_receiver.prepend(this_0);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var message = "Can't get webgl context";
      throw IllegalStateException.m5(toString(message));
    } else {
      tmp_4 = tmp3_elvis_lhs;
    }
    tmp.nat_1 = tmp_4;
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_6.oat_1 = fillArrayVal(Array(8192), null);
    this.pat_1 = toMutableList(reversed_0(until(1, this.oat_1.length)));
    var tmp_7 = this;
    tmp_7.qat_1 = lazy(KmlGlJsCanvas$extensions$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.rat_1 = lazy(KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this));
    this.sat_1 = new WebGLExtension(this, 'ANGLE_instanced_arrays', 2, listOf_0(['drawArraysInstanced', 'drawElementsInstanced', 'vertexAttribDivisor']), 'ANGLE');
    this.tat_1 = new WebGLExtension(this, 'OES_vertex_array_object', 2, listOf_0(['createVertexArrayOES', 'deleteVertexArrayOES', 'isVertexArrayOES', 'bindVertexArrayOES']), 'OES');
  }
  l9b() {
    return Companion_instance_55.y9i(this.mat_1);
  }
  k9b(texture) {
    return this.nat_1.activeTexture(texture);
  }
  l9f(program, shader) {
    return this.nat_1.attachShader(get_3(program, this), get_3(shader, this));
  }
  k9f(program, index, name) {
    return this.nat_1.bindAttribLocation(get_3(program, this), index, name);
  }
  e9a(target, buffer) {
    return this.nat_1.bindBuffer(target, get_3(buffer, this));
  }
  d9e(target, framebuffer) {
    return this.nat_1.bindFramebuffer(target, get_3(framebuffer, this));
  }
  k9e(target, renderbuffer) {
    return this.nat_1.bindRenderbuffer(target, get_3(renderbuffer, this));
  }
  b9e(target, texture) {
    return this.nat_1.bindTexture(target, get_3(texture, this));
  }
  l9c(modeRGB, modeAlpha) {
    return this.nat_1.blendEquationSeparate(modeRGB, modeAlpha);
  }
  m9c(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.nat_1.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  o9b(target, size, data, usage) {
    return this.nat_1.bufferData(target, get_arrayUByte(sliceBuffer(data, 0, size)), usage);
  }
  n9b(target, offset, size, data) {
    return this.nat_1.bufferSubData(target, offset, get_arrayUByte(sliceBuffer(data, 0, size)));
  }
  q38(mask) {
    return this.nat_1.clear(mask);
  }
  d9c(red, green, blue, alpha) {
    return this.nat_1.clearColor(red, green, blue, alpha);
  }
  f9c(d) {
    return this.nat_1.clearDepth(d);
  }
  h9c(s) {
    return this.nat_1.clearStencil(s);
  }
  r9e(red, green, blue, alpha) {
    return this.nat_1.colorMask(red, green, blue, alpha);
  }
  c9f(shader) {
    return this.nat_1.compileShader(get_3(shader, this));
  }
  e9f() {
    return alloc(this.nat_1.createProgram(), this);
  }
  a9f(type) {
    return alloc(this.nat_1.createShader(type), this);
  }
  h9d(mode) {
    return this.nat_1.cullFace(mode);
  }
  ua4(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.nat_1.deleteBuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  va4(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.nat_1.deleteFramebuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  z9e(program) {
    return this.nat_1.deleteProgram(get_3(program, this));
  }
  wa4(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.nat_1.deleteRenderbuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  y9e(shader) {
    return this.nat_1.deleteShader(get_3(shader, this));
  }
  xa4(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.nat_1.deleteTexture(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  q9e(func) {
    return this.nat_1.depthFunc(func);
  }
  e9c(flag) {
    return this.nat_1.depthMask(flag);
  }
  p9e(n, f) {
    return this.nat_1.depthRange(n, f);
  }
  q9c(cap) {
    return this.nat_1.disable(cap);
  }
  j9d(index) {
    return this.nat_1.disableVertexAttribArray(index);
  }
  x9c(mode, first, count) {
    return this.nat_1.drawArrays(mode, first, count);
  }
  z9c(mode, count, type, indices) {
    return this.nat_1.drawElements(mode, count, type, indices);
  }
  r9c(cap) {
    return this.nat_1.enable(cap);
  }
  n9d(index) {
    return this.nat_1.enableVertexAttribArray(index);
  }
  fd() {
    return this.nat_1.flush();
  }
  n9e(target, attachment, renderbuffertarget, renderbuffer) {
    return this.nat_1.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_3(renderbuffer, this));
  }
  m9e(target, attachment, textarget, texture, level) {
    return this.nat_1.framebufferTexture2D(target, attachment, textarget, get_3(texture, this), level);
  }
  o9e(mode) {
    return this.nat_1.frontFace(mode);
  }
  ya4(n, buffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(buffers)[p] = alloc(this.nat_1.createBuffer(), this);
      }
       while (inductionVariable < n);
  }
  s9b(target) {
    return this.nat_1.generateMipmap(target);
  }
  za4(n, framebuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(framebuffers)[p] = alloc(this.nat_1.createFramebuffer(), this);
      }
       while (inductionVariable < n);
  }
  aa5(n, renderbuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(renderbuffers)[p] = alloc(this.nat_1.createRenderbuffer(), this);
      }
       while (inductionVariable < n);
  }
  ba5(n, textures) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(textures)[p] = alloc(this.nat_1.createTexture(), this);
      }
       while (inductionVariable < n);
  }
  w9e(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    var prg = get_3(program, this);
    if (prg.uniforms === undefined)
      prg.uniforms = {};
    if (prg.uniforms[name] === undefined) {
      prg.uniforms[name] = alloc(this.nat_1.getUniformLocation(prg, name), this);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return prg.uniforms[name];
  }
  d9f() {
    return this.nat_1.getError();
  }
  ca5(pname, data) {
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(data)[0] = this.nat_1.getParameter(pname);
  }
  da5(program, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp7_safe_receiver = this.nat_1.getProgramInfoLog(get_3(program, this));
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.length;
      var tmp0_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.nat_1.getProgramParameter(get_3(program, this), pname);
    }
  }
  ea5(shader, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp10_safe_receiver = this.nat_1.getShaderInfoLog(get_3(shader, this));
      var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.length;
      var tmp0_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.nat_1.getShaderParameter(get_3(shader, this), pname);
    }
  }
  fa5(shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs = this.nat_1.getShaderInfoLog(get_3(shader, this));
    var str = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(length)[0] = str.length;
    putAsciiString(infoLog, str);
  }
  z97(name) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.nat_1.getParameter(name);
  }
  m9f(program) {
    return this.nat_1.linkProgram(get_3(program, this));
  }
  p9b(pname, param) {
    return this.nat_1.pixelStorei(pname, param);
  }
  l9e(target, internalformat, width, height) {
    return this.nat_1.renderbufferStorage(target, internalformat, width, height);
  }
  s9e(x, y, width, height) {
    return this.nat_1.scissor(x, y, width, height);
  }
  b9f(shader, string) {
    return this.nat_1.shaderSource(get_3(shader, this), string);
  }
  t9c(func, ref, mask) {
    return this.nat_1.stencilFunc(func, ref, mask);
  }
  s9c(face, func, ref, mask) {
    return this.nat_1.stencilFuncSeparate(face, func, ref, mask);
  }
  g9c(mask) {
    return this.nat_1.stencilMask(mask);
  }
  w9c(face, mask) {
    return this.nat_1.stencilMaskSeparate(face, mask);
  }
  v9c(fail, zfail, zpass) {
    return this.nat_1.stencilOp(fail, zfail, zpass);
  }
  u9c(face, sfail, dpfail, dppass) {
    return this.nat_1.stencilOpSeparate(face, sfail, dpfail, dppass);
  }
  q9b(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp;
    // Inline function 'korlibs.kgl.KmlGl.FLOAT' call
    if (type === 5126) {
      tmp = pixels == null ? null : get_arrayFloat(pixels);
    } else {
      tmp = pixels == null ? null : get_arrayUByte(pixels);
    }
    var vpixels = tmp;
    this.nat_1.texImage2D(target, level, internalformat, width, height, border, format, type, vpixels);
  }
  r9b(target, level, internalformat, format, type, data) {
    // Inline function 'korlibs.math.toInt' call
    var tmp$ret$0 = !data.l4p_1 && data.v4q() ? 1 : 0;
    this.nat_1.pixelStorei(37441, tmp$ret$0);
    this.nat_1.texImage2D(target, level, internalformat, format, type, (data instanceof HtmlNativeImage ? data : THROW_CCE()).o7h_1);
    this.nat_1.pixelStorei(37441, 0);
  }
  j9b(target, pname, param) {
    return this.nat_1.texParameteri(target, pname, param);
  }
  f9b(location, count, value) {
    return this.nat_1.uniform1fv(get_3(location, this), get_arrayFloat(value).subarray(0, imul(count, 1)));
  }
  d99(location, v0) {
    return this.nat_1.uniform1i(get_3(location, this), v0);
  }
  y9a(location, count, value) {
    return this.nat_1.uniform1iv(get_3(location, this), get_arrayInt(value).subarray(0, imul(count, 1)));
  }
  g9b(location, count, value) {
    return this.nat_1.uniform2fv(get_3(location, this), get_arrayFloat(value).subarray(0, imul(count, 2)));
  }
  z9a(location, count, value) {
    return this.nat_1.uniform2iv(get_3(location, this), get_arrayInt(value).subarray(0, imul(count, 2)));
  }
  h9b(location, count, value) {
    return this.nat_1.uniform3fv(get_3(location, this), get_arrayFloat(value).subarray(0, imul(count, 3)));
  }
  a9b(location, count, value) {
    return this.nat_1.uniform3iv(get_3(location, this), get_arrayInt(value).subarray(0, imul(count, 3)));
  }
  i9b(location, count, value) {
    return this.nat_1.uniform4fv(get_3(location, this), get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  b9b(location, count, value) {
    return this.nat_1.uniform4iv(get_3(location, this), get_arrayInt(value).subarray(0, imul(count, 4)));
  }
  c9b(location, count, transpose, value) {
    return this.nat_1.uniformMatrix2fv(get_3(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  d9b(location, count, transpose, value) {
    return this.nat_1.uniformMatrix3fv(get_3(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 9)));
  }
  e9b(location, count, transpose, value) {
    return this.nat_1.uniformMatrix4fv(get_3(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 16)));
  }
  x9e(program) {
    return this.nat_1.useProgram(get_3(program, this));
  }
  o9d(index, size, type, normalized, stride, pointer) {
    return this.nat_1.vertexAttribPointer(index, size, type, normalized, stride, pointer.q2());
  }
  c9e(x, y, width, height) {
    return this.nat_1.viewport(x, y, width, height);
  }
  h7j() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.qat_1;
    extensions$factory();
    return this_0.b2();
  }
  t8k() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.rat_1;
    isFloatTextureSupported$factory_0();
    return this_0.b2();
  }
  q8k() {
    return this.sat_1.bau();
  }
  y9c(mode, first, count, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.nat_1.drawArraysInstanced(mode, first, count, instancecount);
  }
  a9d(mode, count, type, indices, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.nat_1.drawElementsInstanced(mode, count, type, indices, instancecount);
  }
  i9d(index, divisor) {
    // Inline function 'kotlin.js.asDynamic' call
    this.nat_1.vertexAttribDivisor(index, divisor);
  }
  r8k() {
    return get_versionInt(this) >= 2;
  }
  v9d(target, index, buffer, offset, size) {
    // Inline function 'kotlin.js.asDynamic' call
    this.nat_1.bindBufferRange(target, index, get_3(buffer, this), offset, size);
  }
  e99(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return this.nat_1.getUniformBlockIndex(get_3(program, this), name);
  }
  f99(program, uniformBlockIndex, uniformBlockBinding) {
    // Inline function 'kotlin.js.asDynamic' call
    this.nat_1.uniformBlockBinding(get_3(program, this), uniformBlockIndex, uniformBlockBinding);
  }
  s8k() {
    return this.tat_1.bau();
  }
  ga5(n, arrays) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.nat_1.createVertexArray();
        setInt32(arrays, i, alloc(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  k9d(array) {
    // Inline function 'kotlin.js.asDynamic' call
    this.nat_1.bindVertexArray(get_3(array, this));
  }
}
class WebGLExtension {
  constructor(canvas, name, coreSince, functions, suffix) {
    coreSince = coreSince === VOID ? 1000 : coreSince;
    functions = functions === VOID ? emptyList() : functions;
    suffix = suffix === VOID ? '' : suffix;
    this.uat_1 = canvas;
    this.vat_1 = name;
    this.wat_1 = coreSince;
    this.xat_1 = functions;
    this.yat_1 = suffix;
    this.zat_1 = false;
    this.aau_1 = null;
  }
  b2() {
    if (!this.zat_1) {
      this.zat_1 = true;
      this.aau_1 = this.uat_1.nat_1.getExtension(this.vat_1);
      var _iterator__ex2g4s = this.xat_1.f1();
      while (_iterator__ex2g4s.g1()) {
        var func = _iterator__ex2g4s.h1();
        var base = removeSuffix(func, this.yat_1);
        var vfunc = this.aau_1[func];
        if (typeof vfunc === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          this.uat_1.nat_1[base] = vfunc.bind(this.aau_1);
        }
      }
    }
    return this.aau_1;
  }
  bau() {
    return this.uat_1.mat_1 >= this.wat_1 || this.b2() != null;
  }
}
class KorgeReloadInternal$1 extends KorgeReloadInternalImpl {}
class JsGameWindow extends GameWindow {
  static ab2() {
    return this.xap();
  }
}
class NodeJsGameWindow extends JsGameWindow {
  static oaz() {
    return this.ab2();
  }
}
class BrowserCanvasJsGameWindow$close$slambda {
  constructor(this$0) {
    this.bb2_1 = this$0;
  }
  pe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0(this, $completion), $completion);
  }
}
class BrowserCanvasJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.cb2_1 = $entry;
    this.db2_1 = this$0;
  }
  pe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1(this, $completion), $completion);
  }
}
class BrowserCanvasJsGameWindow extends JsGameWindow {
  static cax(canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    var $this = this.ab2();
    $this.naw_1 = canvas;
    $this.oaw_1 = AGWebgl(new AGConfig(), $this.naw_1);
    $this.paw_1 = new DialogInterfaceJs();
    $this.qaw_1 = null;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.raw_1 = [GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_SYSTEM_getInstance()];
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.saw_1 = [GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
    $this.taw_1 = new GamepadInfo();
    $this.uaw_1 = Quality_AUTOMATIC_getInstance();
    $this.vaw_1 = 1.0;
    $this.waw_1 = new TouchBuilder();
    $this.xaw_1 = Cursor_DEFAULT_getInstance();
    $this.yaw_1 = null;
    $this.zaw_1 = null;
    // Inline function 'kotlin.js.asDynamic' call
    window.canvas = $this.naw_1;
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = $this.saq();
    // Inline function 'kotlin.js.asDynamic' call
    window.gl = $this.saq().p96_1;
    if (get_isCanvasCreatedAndHandled()) {
      var tmp24_safe_receiver = document.body;
      if (tmp24_safe_receiver == null)
        null;
      else
        tmp24_safe_receiver.appendChild($this.naw_1);
      var tmp25_safe_receiver = document.body;
      var tmp26_safe_receiver = tmp25_safe_receiver == null ? null : tmp25_safe_receiver.style;
      if (tmp26_safe_receiver == null)
        null;
      else {
        tmp26_safe_receiver.margin = '0px';
      }
      var tmp27_safe_receiver = document.body;
      var tmp28_safe_receiver = tmp27_safe_receiver == null ? null : tmp27_safe_receiver.style;
      if (tmp28_safe_receiver == null)
        null;
      else {
        tmp28_safe_receiver.padding = '0px';
      }
      var tmp29_safe_receiver = document.body;
      var tmp30_safe_receiver = tmp29_safe_receiver == null ? null : tmp29_safe_receiver.style;
      if (tmp30_safe_receiver == null)
        null;
      else {
        tmp30_safe_receiver.overflowX = 'hidden';
      }
      var tmp31_safe_receiver = document.body;
      var tmp32_safe_receiver = tmp31_safe_receiver == null ? null : tmp31_safe_receiver.style;
      if (tmp32_safe_receiver == null)
        null;
      else {
        tmp32_safe_receiver.overflowY = 'hidden';
      }
    }
    $this.naw_1.addEventListener('wheel', BrowserCanvasJsGameWindow$lambda($this));
    $this.naw_1.addEventListener('mouseenter', BrowserCanvasJsGameWindow$lambda_0($this));
    $this.naw_1.addEventListener('mouseleave', BrowserCanvasJsGameWindow$lambda_1($this));
    $this.naw_1.addEventListener('mouseover', BrowserCanvasJsGameWindow$lambda_2($this));
    $this.naw_1.addEventListener('mousemove', BrowserCanvasJsGameWindow$lambda_3($this));
    $this.naw_1.addEventListener('mouseout', BrowserCanvasJsGameWindow$lambda_4($this));
    $this.naw_1.addEventListener('mouseup', BrowserCanvasJsGameWindow$lambda_5($this));
    $this.naw_1.addEventListener('mousedown', BrowserCanvasJsGameWindow$lambda_6($this));
    $this.naw_1.addEventListener('click', BrowserCanvasJsGameWindow$lambda_7($this));
    $this.naw_1.addEventListener('touchstart', BrowserCanvasJsGameWindow$lambda_8($this));
    $this.naw_1.addEventListener('touchmove', BrowserCanvasJsGameWindow$lambda_9($this));
    $this.naw_1.addEventListener('touchend', BrowserCanvasJsGameWindow$lambda_10($this));
    var tmp_1 = window;
    tmp_1.addEventListener('keypress', BrowserCanvasJsGameWindow$lambda_11($this));
    var tmp_2 = window;
    tmp_2.addEventListener('keydown', BrowserCanvasJsGameWindow$lambda_12($this));
    var tmp_3 = window;
    tmp_3.addEventListener('keyup', BrowserCanvasJsGameWindow$lambda_13($this));
    var tmp_4 = window;
    tmp_4.addEventListener('resize', BrowserCanvasJsGameWindow$lambda_14($this));
    $this.naw_1.ondragenter = BrowserCanvasJsGameWindow$lambda_15($this);
    $this.naw_1.ondragexit = BrowserCanvasJsGameWindow$lambda_16($this);
    $this.naw_1.ondragleave = BrowserCanvasJsGameWindow$lambda_17($this);
    $this.naw_1.ondragover = BrowserCanvasJsGameWindow$lambda_18;
    $this.naw_1.ondragstart = BrowserCanvasJsGameWindow$lambda_19($this);
    $this.naw_1.ondragend = BrowserCanvasJsGameWindow$lambda_20($this);
    $this.naw_1.ondrop = BrowserCanvasJsGameWindow$lambda_21($this);
    onResized($this);
    var tmp_5 = $this;
    tmp_5.aax_1 = BrowserCanvasJsGameWindow$lambda_22($this);
    $this.bax_1 = null;
    return $this;
  }
  fb2() {
    return window.devicePixelRatio;
  }
  rah() {
    return this.fb2() <= 0.0 ? 1.0 : isNaN_0(this.fb2()) ? 1.0 : isInfinite(this.fb2()) ? 1.0 : this.fb2();
  }
  saq() {
    return this.oaw_1;
  }
  gam() {
    return this.paw_1;
  }
  eb2() {
    if (this.qaw_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        var e = $p;
        tmp_1 = false;
        tmp_0 = tmp_1;
      }
      tmp.qaw_1 = tmp_0;
    }
    return ensureNotNull(this.qaw_1);
  }
  war() {
    try {
      if (navigator.getGamepads != null) {
        // Inline function 'kotlin.js.unsafeCast' call
        var gamepads = navigator.getGamepads();
        this.i8g();
        var inductionVariable = 0;
        var last = gamepads.length;
        if (inductionVariable < last)
          $l$loop_0: do {
            var gamepadId = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.render.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var controller = tmp;
            if (!(controller.mapping === 'standard'))
              continue $l$loop_0;
            var gamepad = this.taw_1;
            gamepad.p8g_1 = controller.id;
            var inductionVariable_0 = 0;
            // Inline function 'kotlin.math.min' call
            var a = controller.buttons.length;
            var b = this.raw_1.length;
            var last_0 = Math.min(a, b);
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp_0 = gamepad.q8g_1;
                var tmp_1 = this.raw_1[n].m8h();
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0[tmp_1] = controller.buttons[n].value;
              }
               while (inductionVariable_0 < last_0);
            var inductionVariable_1 = 0;
            // Inline function 'kotlin.math.min' call
            var a_0 = controller.axes.length;
            var b_0 = this.saw_1.length;
            var last_1 = Math.min(a_0, b_0);
            if (inductionVariable_1 < last_1)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var isX = (n_0 % 2 | 0) === 0;
                var isY = !isX;
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var value = controller.axes[n_0];
                var valueWithoutDeadRange = Companion_instance_24.h8h(value, VOID, n_0 <= 3);
                gamepad.q8g_1[this.saw_1[n_0].m8h()] = isY ? -valueWithoutDeadRange : valueWithoutDeadRange;
              }
               while (inductionVariable_1 < last_1);
            this.u8g(gamepad);
          }
           while (inductionVariable < last);
        this.aas();
      }
    } catch ($p) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = CoroutineKey_getInstance().xam_1;
      var level = Level_ERROR_getInstance();
      var tmp_2;
      if (this_0.u3g(level)) {
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.updateGamepads.<anonymous>' call
        this_0.v3g(level, e);
        tmp_2 = Unit_instance;
      }
    }
  }
  far(value) {
    if (!this.uaw_1.equals(value)) {
      this.uaw_1 = value;
      onResized(this);
    }
  }
  vah() {
    return this.uaw_1;
  }
  yaq(value) {
    document.title = value;
  }
  j2y() {
    return this.naw_1.clientWidth;
  }
  k2y() {
    return this.naw_1.clientHeight;
  }
  qaq(value) {
    this.xaw_1 = value;
    var tmp = this.naw_1.style;
    var tmp_0;
    if (value instanceof Cursor) {
      switch (value.v3_1) {
        case 0:
          tmp_0 = 'default';
          break;
        case 1:
          tmp_0 = 'crosshair';
          break;
        case 2:
          tmp_0 = 'text';
          break;
        case 3:
          tmp_0 = 'pointer';
          break;
        case 4:
          tmp_0 = 'move';
          break;
        case 5:
          tmp_0 = 'wait';
          break;
        case 6:
          tmp_0 = 'e-resize';
          break;
        case 7:
          tmp_0 = 'w-resize';
          break;
        case 8:
          tmp_0 = 's-resize';
          break;
        case 9:
          tmp_0 = 'n-resize';
          break;
        case 10:
          tmp_0 = 'ne-resize';
          break;
        case 11:
          tmp_0 = 'nw-resize';
          break;
        case 12:
          tmp_0 = 'se-resize';
          break;
        case 13:
          tmp_0 = 'sw-resize';
          break;
        default:
          tmp_0 = 'default';
          break;
      }
    } else {
      tmp_0 = 'default';
    }
    tmp.cursor = tmp_0;
  }
  raq() {
    return this.xaw_1;
  }
  zaq(value) {
    this.yaw_1 = value;
    if (!(value == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var link = document.querySelector("link[rel*='icon']");
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = toHtmlNative(value).f7i();
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp21_safe_receiver = document.getElementsByTagName('head')[0];
      if (tmp21_safe_receiver == null)
        null;
      else
        tmp21_safe_receiver.appendChild(link);
    } else {
      var tmp22_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp22_safe_receiver == null)
        null;
      else {
        tmp22_safe_receiver.remove();
      }
    }
  }
  aar(value) {
    if (!(this.bar() === value)) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        // Inline function 'kotlin.Companion.success' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<set-fullscreen>.<anonymous>' call
        var tmp_0;
        if (value) {
          tmp_0 = this.naw_1.requestFullscreen();
        } else {
          tmp_0 = document.exitFullscreen();
        }
        var value_0 = tmp_0;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
    }
  }
  bar() {
    return !(document.fullscreenElement == null);
  }
  car(value) {
    this.naw_1.style.visibility = value ? 'visible' : 'hidden';
  }
  iar(width, height) {
  }
  k1d(exitCode) {
    var tmp = MainScope();
    launchImmediately_0(tmp, BrowserCanvasJsGameWindow$close$slambda_0(this));
    this.zaw_1 = null;
  }
  nar(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_0(this, entry, $completion), $completion);
  }
  maq(windowRect) {
    ensureSoftKeyboardInput(this);
    var tmp39_safe_receiver = this.bax_1;
    var tmp40_safe_receiver = tmp39_safe_receiver == null ? null : tmp39_safe_receiver.style;
    if (tmp40_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp40_safe_receiver.left = '' + windowRect.p2i() / this.vaw_1 + 'px';
      tmp40_safe_receiver.top = '' + (windowRect.r2i() / this.vaw_1 - 16) + 'px';
      tmp40_safe_receiver.width = '' + windowRect.k2i_1 / this.vaw_1 + 'px';
      tmp40_safe_receiver.font = '32px Arial';
      tmp40_safe_receiver.height = '1px';
      tmp40_safe_receiver.opacity = '0';
      tmp40_safe_receiver.background = 'transparent';
      tmp40_safe_receiver.color = 'transparent';
      println('BOUNDS.setInputRectangle:' + tmp40_safe_receiver.left + ',' + tmp40_safe_receiver.top + ',' + tmp40_safe_receiver.width + ',' + tmp40_safe_receiver.height);
    }
  }
  naq(force, config) {
    var tmp41_safe_receiver = document.body;
    if (tmp41_safe_receiver == null)
      null;
    else
      tmp41_safe_receiver.appendChild(ensureNotNull(this.bax_1));
    var tmp42_safe_receiver = this.bax_1;
    if (tmp42_safe_receiver == null)
      null;
    else {
      tmp42_safe_receiver.focus();
    }
  }
  paq() {
    var tmp43_safe_receiver = this.bax_1;
    if (tmp43_safe_receiver == null)
      null;
    else {
      tmp43_safe_receiver.blur();
    }
    var tmp44_safe_receiver = document.body;
    if (tmp44_safe_receiver == null)
      null;
    else
      tmp44_safe_receiver.removeChild(ensureNotNull(this.bax_1));
  }
}
class DialogInterfaceJs {
  ham(message, $completion) {
    window.alert(message);
  }
  iam(filter, write, multi, currentDir, $completion) {
    var deferred = CompletableDeferred();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var input = document.createElement('input');
    input.style.position = 'absolute';
    input.style.top = '0px';
    input.style.left = '0px';
    input.style.visibility = 'hidden';
    input.type = 'file';
    input.multiple = multi;
    input.onchange = DialogInterfaceJs$openFileDialog$lambda(input, deferred);
    input.oncancel = DialogInterfaceJs$openFileDialog$lambda_0;
    var tmp46_safe_receiver = document.body;
    if (tmp46_safe_receiver == null)
      null;
    else
      tmp46_safe_receiver.appendChild(input);
    input.click();
    var tmp = window;
    tmp.setTimeout(DialogInterfaceJs$openFileDialog$lambda_1(input), 100);
    return deferred.v17($completion);
  }
}
//endregion
function _get_now__e6dlkr($this) {
  return $this.l89_1().hk_1;
}
function _queueAfter($this, time, interval, task) {
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
    var this_0 = $this.i89_1;
    this_0.w1w();
    try {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop._queueAfter.<anonymous>' call
      var task_0 = new TimedTask($this, _get_now__e6dlkr($this), time, interval, task);
      if ($this.j89_1) {
        $this.n89_1.y34(task_0);
      } else {
        Console_getInstance().a3g(['WARNING: QUEUED TASK time=' + Duration__toString_impl_8d916b(time) + ' interval=' + interval + ' without running']);
      }
      $this.i89_1.c1x();
      break $l$block;
    }finally {
      this_0.z1w();
    }
  }
  return task_0;
}
function SyncEventLoop$nowProvider$lambda(this$0) {
  return function () {
    return new Duration(ValueTimeMark__elapsedNow_impl_eonqvs(this$0.k89_1));
  };
}
function SyncEventLoop$timedTasks$lambda(a, b) {
  return a.c89(b);
}
function SyncEventLoop$uncatchedExceptionHandler$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
function paused$factory($b0) {
  return getPropertyCallableRef('paused', 0, KMutableProperty0, function () {
    return $b0.y3d_1;
  }, function (value) {
    return $b0.z3d(value);
  });
}
function __updateChildListenerCount($this, type, delta) {
  if (delta === 0)
    return Unit_instance;
  if ($this.h8a_1 == null)
    $this.h8a_1 = FastIdentityMap();
  var tmp18_safe_receiver = $this.h8a_1;
  if (tmp18_safe_receiver == null)
    null;
  else {
    var tmp0_elvis_lhs = get_0(ensureNotNull($this.h8a_1), type);
    set(tmp18_safe_receiver, type, (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) + delta | 0);
  }
  var tmp19_safe_receiver = $this.f8a_1;
  if (tmp19_safe_receiver == null)
    null;
  else {
    __updateChildListenerCount(tmp19_safe_receiver, type, delta);
  }
}
function __updateChildListenerCount_0($this, child, add) {
  var tmp20_safe_receiver = child.h8a_1;
  if (tmp20_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.fastForEach' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = tmp20_safe_receiver.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.event.BaseEventListener.__updateChildListenerCount.<anonymous>' call
      var i = ensureNotNull(get_0(tmp20_safe_receiver, it));
      __updateChildListenerCount($this, it, add ? +i : -i | 0);
    }
  }
}
var Companion_instance_8;
function Companion_getInstance_16() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_17() {
  return Companion_instance_9;
}
var Companion_instance_10;
function Companion_getInstance_18() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_19() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_20() {
  if (Companion_instance_12 === VOID)
    new Companion_3();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_21() {
  if (Companion_instance_13 === VOID)
    new Companion_4();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_22() {
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_23() {
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_24() {
  return Companion_instance_16;
}
var Type_UP_instance;
var Type_DOWN_instance;
var Type_TYPE_instance;
var Companion_instance_17;
function Companion_getInstance_25() {
  Type_initEntries();
  if (Companion_instance_17 === VOID)
    new Companion_8();
  return Companion_instance_17;
}
function values() {
  return [Type_UP_getInstance(), Type_DOWN_getInstance(), Type_TYPE_getInstance()];
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_UP_instance = new Type('UP', 0);
  Type_DOWN_instance = new Type('DOWN', 1);
  Type_TYPE_instance = new Type('TYPE', 2);
  Companion_getInstance_25();
}
function Type_UP_getInstance() {
  Type_initEntries();
  return Type_UP_instance;
}
function Type_DOWN_getInstance() {
  Type_initEntries();
  return Type_DOWN_instance;
}
function Type_TYPE_getInstance() {
  Type_initEntries();
  return Type_TYPE_instance;
}
var Type_MOVE_instance;
var Type_DRAG_instance;
var Type_UP_instance_0;
var Type_DOWN_instance_0;
var Type_CLICK_instance;
var Type_ENTER_instance;
var Type_EXIT_instance;
var Type_SCROLL_instance;
var Companion_instance_18;
function Companion_getInstance_26() {
  Type_initEntries_0();
  if (Companion_instance_18 === VOID)
    new Companion_9();
  return Companion_instance_18;
}
function values_0() {
  return [Type_MOVE_getInstance(), Type_DRAG_getInstance(), Type_UP_getInstance_0(), Type_DOWN_getInstance_0(), Type_CLICK_getInstance(), Type_ENTER_getInstance(), Type_EXIT_getInstance(), Type_SCROLL_getInstance()];
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_MOVE_instance = new Type_0('MOVE', 0);
  Type_DRAG_instance = new Type_0('DRAG', 1);
  Type_UP_instance_0 = new Type_0('UP', 2);
  Type_DOWN_instance_0 = new Type_0('DOWN', 3);
  Type_CLICK_instance = new Type_0('CLICK', 4);
  Type_ENTER_instance = new Type_0('ENTER', 5);
  Type_EXIT_instance = new Type_0('EXIT', 6);
  Type_SCROLL_instance = new Type_0('SCROLL', 7);
  Companion_getInstance_26();
}
var ScrollDeltaMode_PIXEL_instance;
var ScrollDeltaMode_LINE_instance;
var ScrollDeltaMode_PAGE_instance;
var ScrollDeltaMode_entriesInitialized;
function ScrollDeltaMode_initEntries() {
  if (ScrollDeltaMode_entriesInitialized)
    return Unit_instance;
  ScrollDeltaMode_entriesInitialized = true;
  ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
  ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
  ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
}
function MouseEvent$requestLock$lambda() {
  return Unit_instance;
}
function Type_MOVE_getInstance() {
  Type_initEntries_0();
  return Type_MOVE_instance;
}
function Type_DRAG_getInstance() {
  Type_initEntries_0();
  return Type_DRAG_instance;
}
function Type_UP_getInstance_0() {
  Type_initEntries_0();
  return Type_UP_instance_0;
}
function Type_DOWN_getInstance_0() {
  Type_initEntries_0();
  return Type_DOWN_instance_0;
}
function Type_CLICK_getInstance() {
  Type_initEntries_0();
  return Type_CLICK_instance;
}
function Type_ENTER_getInstance() {
  Type_initEntries_0();
  return Type_ENTER_instance;
}
function Type_EXIT_getInstance() {
  Type_initEntries_0();
  return Type_EXIT_instance;
}
function Type_SCROLL_getInstance() {
  Type_initEntries_0();
  return Type_SCROLL_instance;
}
function ScrollDeltaMode_PIXEL_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PIXEL_instance;
}
function ScrollDeltaMode_LINE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_LINE_instance;
}
function ScrollDeltaMode_PAGE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PAGE_instance;
}
var Type_MAGNIFY_instance;
var Type_ROTATE_instance;
var Type_SWIPE_instance;
var Type_SMART_MAGNIFY_instance;
var Companion_instance_19;
function Companion_getInstance_27() {
  Type_initEntries_1();
  if (Companion_instance_19 === VOID)
    new Companion_10();
  return Companion_instance_19;
}
function values_1() {
  return [Type_MAGNIFY_getInstance(), Type_ROTATE_getInstance(), Type_SWIPE_getInstance(), Type_SMART_MAGNIFY_getInstance()];
}
var Type_entriesInitialized_1;
function Type_initEntries_1() {
  if (Type_entriesInitialized_1)
    return Unit_instance;
  Type_entriesInitialized_1 = true;
  Type_MAGNIFY_instance = new Type_1('MAGNIFY', 0);
  Type_ROTATE_instance = new Type_1('ROTATE', 1);
  Type_SWIPE_instance = new Type_1('SWIPE', 2);
  Type_SMART_MAGNIFY_instance = new Type_1('SMART_MAGNIFY', 3);
  Companion_getInstance_27();
}
function Type_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_MAGNIFY_instance;
}
function Type_ROTATE_getInstance() {
  Type_initEntries_1();
  return Type_ROTATE_instance;
}
function Type_SWIPE_getInstance() {
  Type_initEntries_1();
  return Type_SWIPE_instance;
}
function Type_SMART_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_SMART_MAGNIFY_instance;
}
var Type_START_instance;
var Type_END_instance;
var Type_DROP_instance;
var Companion_instance_20;
function Companion_getInstance_28() {
  Type_initEntries_2();
  if (Companion_instance_20 === VOID)
    new Companion_11();
  return Companion_instance_20;
}
function values_2() {
  return [Type_START_getInstance(), Type_END_getInstance(), Type_DROP_getInstance()];
}
var Type_entriesInitialized_2;
function Type_initEntries_2() {
  if (Type_entriesInitialized_2)
    return Unit_instance;
  Type_entriesInitialized_2 = true;
  Type_START_instance = new Type_2('START', 0);
  Type_END_instance = new Type_2('END', 1);
  Type_DROP_instance = new Type_2('DROP', 2);
  Companion_getInstance_28();
}
function Type_START_getInstance() {
  Type_initEntries_2();
  return Type_START_instance;
}
function Type_END_getInstance() {
  Type_initEntries_2();
  return Type_END_instance;
}
function Type_DROP_getInstance() {
  Type_initEntries_2();
  return Type_DROP_instance;
}
var Status_ADD_instance;
var Status_KEEP_instance;
var Status_REMOVE_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_ADD_instance = new Status('ADD', 0);
  Status_KEEP_instance = new Status('KEEP', 1);
  Status_REMOVE_instance = new Status('REMOVE', 2);
}
var Kind_FINGER_instance;
var Kind_MOUSE_instance;
var Kind_STYLUS_instance;
var Kind_ERASER_instance;
var Kind_UNKNOWN_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_FINGER_instance = new Kind('FINGER', 0);
  Kind_MOUSE_instance = new Kind('MOUSE', 1);
  Kind_STYLUS_instance = new Kind('STYLUS', 2);
  Kind_ERASER_instance = new Kind('ERASER', 3);
  Kind_UNKNOWN_instance = new Kind('UNKNOWN', 4);
}
var Companion_instance_21;
function Companion_getInstance_29() {
  if (Companion_instance_21 === VOID)
    new Companion_12();
  return Companion_instance_21;
}
function Status_ADD_getInstance() {
  Status_initEntries();
  return Status_ADD_instance;
}
function Status_KEEP_getInstance() {
  Status_initEntries();
  return Status_KEEP_instance;
}
function Status_REMOVE_getInstance() {
  Status_initEntries();
  return Status_REMOVE_instance;
}
function Kind_FINGER_getInstance() {
  Kind_initEntries();
  return Kind_FINGER_instance;
}
function Kind_MOUSE_getInstance() {
  Kind_initEntries();
  return Kind_MOUSE_instance;
}
var Type_START_instance_0;
var Type_END_instance_0;
var Type_MOVE_instance_0;
var Type_HOVER_instance;
var Type_UNKNOWN_instance;
var Companion_instance_22;
function Companion_getInstance_30() {
  Type_initEntries_3();
  if (Companion_instance_22 === VOID)
    new Companion_13();
  return Companion_instance_22;
}
function values_3() {
  return [Type_START_getInstance_0(), Type_END_getInstance_0(), Type_MOVE_getInstance_0(), Type_HOVER_getInstance(), Type_UNKNOWN_getInstance()];
}
var Type_entriesInitialized_3;
function Type_initEntries_3() {
  if (Type_entriesInitialized_3)
    return Unit_instance;
  Type_entriesInitialized_3 = true;
  Type_START_instance_0 = new Type_3('START', 0);
  Type_END_instance_0 = new Type_3('END', 1);
  Type_MOVE_instance_0 = new Type_3('MOVE', 2);
  Type_HOVER_instance = new Type_3('HOVER', 3);
  Type_UNKNOWN_instance = new Type_3('UNKNOWN', 4);
  Companion_getInstance_30();
}
var Companion_instance_23;
function Companion_getInstance_31() {
  return Companion_instance_23;
}
function TouchEvent$toString$lambda(it) {
  return it.toString();
}
function Type_START_getInstance_0() {
  Type_initEntries_3();
  return Type_START_instance_0;
}
function Type_END_getInstance_0() {
  Type_initEntries_3();
  return Type_END_instance_0;
}
function Type_MOVE_getInstance_0() {
  Type_initEntries_3();
  return Type_MOVE_instance_0;
}
function Type_HOVER_getInstance() {
  Type_initEntries_3();
  return Type_HOVER_instance;
}
function Type_UNKNOWN_getInstance() {
  Type_initEntries_3();
  return Type_UNKNOWN_instance;
}
function invoke_0(_this__u8e3s4, block) {
  block(_this__u8e3s4);
  return _this__u8e3s4;
}
var Mode_JS_instance;
var Mode_Android_instance;
var Mode_IOS_instance;
var Mode_entriesInitialized;
function Mode_initEntries() {
  if (Mode_entriesInitialized)
    return Unit_instance;
  Mode_entriesInitialized = true;
  Mode_JS_instance = new Mode('JS', 0);
  Mode_Android_instance = new Mode('Android', 1);
  Mode_IOS_instance = new Mode('IOS', 2);
}
function Mode_JS_getInstance() {
  Mode_initEntries();
  return Mode_JS_instance;
}
var BatteryStatus_CHARGING_instance;
var BatteryStatus_DISCHARGING_instance;
var BatteryStatus_FULL_instance;
var BatteryStatus_UNKNOWN_instance;
var BatteryStatus_entriesInitialized;
function BatteryStatus_initEntries() {
  if (BatteryStatus_entriesInitialized)
    return Unit_instance;
  BatteryStatus_entriesInitialized = true;
  BatteryStatus_CHARGING_instance = new BatteryStatus('CHARGING', 0);
  BatteryStatus_DISCHARGING_instance = new BatteryStatus('DISCHARGING', 1);
  BatteryStatus_FULL_instance = new BatteryStatus('FULL', 2);
  BatteryStatus_UNKNOWN_instance = new BatteryStatus('UNKNOWN', 3);
}
var Companion_instance_24;
function Companion_getInstance_32() {
  return Companion_instance_24;
}
function BatteryStatus_UNKNOWN_getInstance() {
  BatteryStatus_initEntries();
  return BatteryStatus_UNKNOWN_instance;
}
var Companion_instance_25;
function Companion_getInstance_33() {
  return Companion_instance_25;
}
var Type_CONNECTED_instance;
var Type_DISCONNECTED_instance;
var Companion_instance_26;
function Companion_getInstance_34() {
  Type_initEntries_4();
  if (Companion_instance_26 === VOID)
    new Companion_17();
  return Companion_instance_26;
}
function values_4() {
  return [Type_CONNECTED_getInstance(), Type_DISCONNECTED_getInstance()];
}
var Type_entriesInitialized_4;
function Type_initEntries_4() {
  if (Type_entriesInitialized_4)
    return Unit_instance;
  Type_entriesInitialized_4 = true;
  Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
  Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
  Companion_getInstance_34();
}
function Type_CONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_CONNECTED_instance;
}
function Type_DISCONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_DISCONNECTED_instance;
}
var GameButton_LEFT_instance;
var GameButton_RIGHT_instance;
var GameButton_UP_instance;
var GameButton_DOWN_instance;
var GameButton_BUTTON_SOUTH_instance;
var GameButton_BUTTON_EAST_instance;
var GameButton_BUTTON_WEST_instance;
var GameButton_BUTTON_NORTH_instance;
var GameButton_SELECT_instance;
var GameButton_START_instance;
var GameButton_SYSTEM_instance;
var GameButton_L1_instance;
var GameButton_R1_instance;
var GameButton_L2_instance;
var GameButton_R2_instance;
var GameButton_L3_instance;
var GameButton_R3_instance;
var GameButton_LX_instance;
var GameButton_LY_instance;
var GameButton_RX_instance;
var GameButton_RY_instance;
var GameButton_BUTTON4_instance;
var GameButton_BUTTON5_instance;
var GameButton_BUTTON6_instance;
var GameButton_BUTTON7_instance;
var GameButton_BUTTON8_instance;
var GameButton_RECORD_instance;
var GameButton_DPADX_instance;
var GameButton_DPADY_instance;
var Companion_instance_27;
function Companion_getInstance_35() {
  GameButton_initEntries();
  if (Companion_instance_27 === VOID)
    new Companion_18();
  return Companion_instance_27;
}
function values_5() {
  return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance(), GameButton_RECORD_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
}
var GameButton_entriesInitialized;
function GameButton_initEntries() {
  if (GameButton_entriesInitialized)
    return Unit_instance;
  GameButton_entriesInitialized = true;
  GameButton_LEFT_instance = new GameButton('LEFT', 0);
  GameButton_RIGHT_instance = new GameButton('RIGHT', 1);
  GameButton_UP_instance = new GameButton('UP', 2);
  GameButton_DOWN_instance = new GameButton('DOWN', 3);
  GameButton_BUTTON_SOUTH_instance = new GameButton('BUTTON_SOUTH', 4);
  GameButton_BUTTON_EAST_instance = new GameButton('BUTTON_EAST', 5);
  GameButton_BUTTON_WEST_instance = new GameButton('BUTTON_WEST', 6);
  GameButton_BUTTON_NORTH_instance = new GameButton('BUTTON_NORTH', 7);
  GameButton_SELECT_instance = new GameButton('SELECT', 8);
  GameButton_START_instance = new GameButton('START', 9);
  GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10);
  GameButton_L1_instance = new GameButton('L1', 11);
  GameButton_R1_instance = new GameButton('R1', 12);
  GameButton_L2_instance = new GameButton('L2', 13);
  GameButton_R2_instance = new GameButton('R2', 14);
  GameButton_L3_instance = new GameButton('L3', 15);
  GameButton_R3_instance = new GameButton('R3', 16);
  GameButton_LX_instance = new GameButton('LX', 17);
  GameButton_LY_instance = new GameButton('LY', 18);
  GameButton_RX_instance = new GameButton('RX', 19);
  GameButton_RY_instance = new GameButton('RY', 20);
  GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21);
  GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22);
  GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23);
  GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24);
  GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25);
  GameButton_RECORD_instance = new GameButton('RECORD', 26);
  GameButton_DPADX_instance = new GameButton('DPADX', 27);
  GameButton_DPADY_instance = new GameButton('DPADY', 28);
  Companion_getInstance_35();
}
var GameStick_LEFT_instance;
var GameStick_RIGHT_instance;
var Companion_instance_28;
function Companion_getInstance_36() {
  GameStick_initEntries();
  if (Companion_instance_28 === VOID)
    new Companion_19();
  return Companion_instance_28;
}
function values_6() {
  return [GameStick_LEFT_getInstance(), GameStick_RIGHT_getInstance()];
}
var GameStick_entriesInitialized;
function GameStick_initEntries() {
  if (GameStick_entriesInitialized)
    return Unit_instance;
  GameStick_entriesInitialized = true;
  GameStick_LEFT_instance = new GameStick('LEFT', 0, 0);
  GameStick_RIGHT_instance = new GameStick('RIGHT', 1, 1);
  Companion_getInstance_36();
}
function GameButton_LEFT_getInstance() {
  GameButton_initEntries();
  return GameButton_LEFT_instance;
}
function GameButton_RIGHT_getInstance() {
  GameButton_initEntries();
  return GameButton_RIGHT_instance;
}
function GameButton_UP_getInstance() {
  GameButton_initEntries();
  return GameButton_UP_instance;
}
function GameButton_DOWN_getInstance() {
  GameButton_initEntries();
  return GameButton_DOWN_instance;
}
function GameButton_BUTTON_SOUTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_SOUTH_instance;
}
function GameButton_BUTTON_EAST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_EAST_instance;
}
function GameButton_BUTTON_WEST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_WEST_instance;
}
function GameButton_BUTTON_NORTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_NORTH_instance;
}
function GameButton_SELECT_getInstance() {
  GameButton_initEntries();
  return GameButton_SELECT_instance;
}
function GameButton_START_getInstance() {
  GameButton_initEntries();
  return GameButton_START_instance;
}
function GameButton_SYSTEM_getInstance() {
  GameButton_initEntries();
  return GameButton_SYSTEM_instance;
}
function GameButton_L1_getInstance() {
  GameButton_initEntries();
  return GameButton_L1_instance;
}
function GameButton_R1_getInstance() {
  GameButton_initEntries();
  return GameButton_R1_instance;
}
function GameButton_L2_getInstance() {
  GameButton_initEntries();
  return GameButton_L2_instance;
}
function GameButton_R2_getInstance() {
  GameButton_initEntries();
  return GameButton_R2_instance;
}
function GameButton_L3_getInstance() {
  GameButton_initEntries();
  return GameButton_L3_instance;
}
function GameButton_R3_getInstance() {
  GameButton_initEntries();
  return GameButton_R3_instance;
}
function GameButton_LX_getInstance() {
  GameButton_initEntries();
  return GameButton_LX_instance;
}
function GameButton_LY_getInstance() {
  GameButton_initEntries();
  return GameButton_LY_instance;
}
function GameButton_RX_getInstance() {
  GameButton_initEntries();
  return GameButton_RX_instance;
}
function GameButton_RY_getInstance() {
  GameButton_initEntries();
  return GameButton_RY_instance;
}
function GameButton_BUTTON4_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON4_instance;
}
function GameButton_BUTTON5_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON5_instance;
}
function GameButton_BUTTON6_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON6_instance;
}
function GameButton_BUTTON7_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON7_instance;
}
function GameButton_BUTTON8_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON8_instance;
}
function GameButton_RECORD_getInstance() {
  GameButton_initEntries();
  return GameButton_RECORD_instance;
}
function GameButton_DPADX_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADX_instance;
}
function GameButton_DPADY_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADY_instance;
}
function GameStick_LEFT_getInstance() {
  GameStick_initEntries();
  return GameStick_LEFT_instance;
}
function GameStick_RIGHT_getInstance() {
  GameStick_initEntries();
  return GameStick_RIGHT_instance;
}
var Key_SPACE_instance;
var Key_APOSTROPHE_instance;
var Key_COMMA_instance;
var Key_MINUS_instance;
var Key_PLUS_instance;
var Key_PERIOD_instance;
var Key_SLASH_instance;
var Key_N0_instance;
var Key_N1_instance;
var Key_N2_instance;
var Key_N3_instance;
var Key_N4_instance;
var Key_N5_instance;
var Key_N6_instance;
var Key_N7_instance;
var Key_N8_instance;
var Key_N9_instance;
var Key_N11_instance;
var Key_N12_instance;
var Key_N3D_MODE_instance;
var Key_SEMICOLON_instance;
var Key_EQUAL_instance;
var Key_AT_instance;
var Key_A_instance;
var Key_B_instance;
var Key_C_instance;
var Key_D_instance;
var Key_E_instance;
var Key_F_instance;
var Key_G_instance;
var Key_H_instance;
var Key_I_instance;
var Key_J_instance;
var Key_K_instance;
var Key_L_instance;
var Key_M_instance;
var Key_N_instance;
var Key_O_instance;
var Key_P_instance;
var Key_Q_instance;
var Key_R_instance;
var Key_S_instance;
var Key_T_instance;
var Key_U_instance;
var Key_V_instance;
var Key_W_instance;
var Key_X_instance;
var Key_Y_instance;
var Key_Z_instance;
var Key_LEFT_BRACKET_instance;
var Key_BACKSLASH_instance;
var Key_RIGHT_BRACKET_instance;
var Key_GRAVE_ACCENT_instance;
var Key_WORLD_1_instance;
var Key_WORLD_2_instance;
var Key_ESCAPE_instance;
var Key_META_instance;
var Key_ENTER_instance;
var Key_TAB_instance;
var Key_BACKSPACE_instance;
var Key_INSERT_instance;
var Key_DELETE_instance;
var Key_RIGHT_instance;
var Key_LEFT_instance;
var Key_DOWN_instance;
var Key_UP_instance;
var Key_PAGE_UP_instance;
var Key_PAGE_DOWN_instance;
var Key_FUNCTION_instance;
var Key_HELP_instance;
var Key_MUTE_instance;
var Key_VOLUME_DOWN_instance;
var Key_VOLUME_UP_instance;
var Key_VOLUME_MUTE_instance;
var Key_HOME_instance;
var Key_END_instance;
var Key_CAPS_LOCK_instance;
var Key_SCROLL_LOCK_instance;
var Key_NUM_LOCK_instance;
var Key_PRINT_SCREEN_instance;
var Key_PAUSE_instance;
var Key_F1_instance;
var Key_F2_instance;
var Key_F3_instance;
var Key_F4_instance;
var Key_F5_instance;
var Key_F6_instance;
var Key_F7_instance;
var Key_F8_instance;
var Key_F9_instance;
var Key_F10_instance;
var Key_F11_instance;
var Key_F12_instance;
var Key_F13_instance;
var Key_F14_instance;
var Key_F15_instance;
var Key_F16_instance;
var Key_F17_instance;
var Key_F18_instance;
var Key_F19_instance;
var Key_F20_instance;
var Key_F21_instance;
var Key_F22_instance;
var Key_F23_instance;
var Key_F24_instance;
var Key_F25_instance;
var Key_KP_0_instance;
var Key_KP_1_instance;
var Key_KP_2_instance;
var Key_KP_3_instance;
var Key_KP_4_instance;
var Key_KP_5_instance;
var Key_KP_6_instance;
var Key_KP_7_instance;
var Key_KP_8_instance;
var Key_KP_9_instance;
var Key_KP_DECIMAL_instance;
var Key_KP_DIVIDE_instance;
var Key_KP_MULTIPLY_instance;
var Key_KP_SUBTRACT_instance;
var Key_KP_ADD_instance;
var Key_KP_COMMA_instance;
var Key_KP_DOT_instance;
var Key_KP_ENTER_instance;
var Key_KP_EQUAL_instance;
var Key_KP_SEPARATOR_instance;
var Key_KP_LEFT_PAREN_instance;
var Key_KP_RIGHT_PAREN_instance;
var Key_SHIFT_instance;
var Key_CONTROL_instance;
var Key_ALT_instance;
var Key_SUPER_instance;
var Key_MENU_instance;
var Key_BACK_instance;
var Key_BACKQUOTE_instance;
var Key_QUOTE_instance;
var Key_KP_UP_instance;
var Key_KP_DOWN_instance;
var Key_KP_LEFT_instance;
var Key_KP_RIGHT_instance;
var Key_UNDERLINE_instance;
var Key_SELECT_KEY_instance;
var Key_CANCEL_instance;
var Key_CLEAR_instance;
var Key_OPEN_BRACKET_instance;
var Key_CLOSE_BRACKET_instance;
var Key_PLAY_instance;
var Key_NONAME_instance;
var Key_FINAL_instance;
var Key_OEM102_instance;
var Key_OEM1_instance;
var Key_OEM2_instance;
var Key_OEM3_instance;
var Key_OEM4_instance;
var Key_OEM5_instance;
var Key_OEM6_instance;
var Key_OEM7_instance;
var Key_OEM8_instance;
var Key_LEFT_MENU_instance;
var Key_RIGHT_MENU_instance;
var Key_SLEEP_instance;
var Key_SNAPSHOT_instance;
var Key_INFO_instance;
var Key_XBUTTON1_instance;
var Key_XBUTTON2_instance;
var Key_XBUTTON3_instance;
var Key_XBUTTON4_instance;
var Key_XBUTTON5_instance;
var Key_XBUTTON6_instance;
var Key_XBUTTON7_instance;
var Key_XBUTTON8_instance;
var Key_XBUTTON9_instance;
var Key_XBUTTON10_instance;
var Key_XBUTTON11_instance;
var Key_XBUTTON12_instance;
var Key_XBUTTON13_instance;
var Key_XBUTTON14_instance;
var Key_XBUTTON15_instance;
var Key_XBUTTON16_instance;
var Key_XBUTTON_A_instance;
var Key_XBUTTON_B_instance;
var Key_XBUTTON_C_instance;
var Key_XBUTTON_L1_instance;
var Key_XBUTTON_L2_instance;
var Key_XBUTTON_MODE_instance;
var Key_XBUTTON_R1_instance;
var Key_XBUTTON_R2_instance;
var Key_XBUTTON_SELECT_instance;
var Key_XBUTTON_START_instance;
var Key_XBUTTON_THUMBL_instance;
var Key_XBUTTON_THUMBR_instance;
var Key_XBUTTON_X_instance;
var Key_XBUTTON_Y_instance;
var Key_XBUTTON_Z_instance;
var Key_DPAD_CENTER_instance;
var Key_DPAD_DOWN_instance;
var Key_DPAD_DOWN_LEFT_instance;
var Key_DPAD_DOWN_RIGHT_instance;
var Key_DPAD_LEFT_instance;
var Key_DPAD_RIGHT_instance;
var Key_DPAD_UP_instance;
var Key_DPAD_UP_LEFT_instance;
var Key_DPAD_UP_RIGHT_instance;
var Key_DVR_instance;
var Key_EISU_instance;
var Key_ENDCALL_instance;
var Key_ENVELOPE_instance;
var Key_EXPLORER_instance;
var Key_FOCUS_instance;
var Key_FORWARD_instance;
var Key_GRAVE_instance;
var Key_GUIDE_instance;
var Key_HEADSETHOOK_instance;
var Key_ABNT_C1_instance;
var Key_ABNT_C2_instance;
var Key_ATTN_instance;
var Key_CRSEL_instance;
var Key_EREOF_instance;
var Key_EXECUTE_instance;
var Key_EXSEL_instance;
var Key_ICO_CLEAR_instance;
var Key_ICO_HELP_instance;
var Key_HENKAN_instance;
var Key_PAIRING_instance;
var Key_APP_SWITCH_instance;
var Key_ASSIST_instance;
var Key_AVR_INPUT_instance;
var Key_AVR_POWER_instance;
var Key_BOOKMARK_instance;
var Key_BREAK_instance;
var Key_CAPTIONS_instance;
var Key_CAMERA_instance;
var Key_CALL_instance;
var Key_CALENDAR_instance;
var Key_BRIGHTNESS_DOWN_instance;
var Key_BRIGHTNESS_UP_instance;
var Key_CHANNEL_DOWN_instance;
var Key_CHANNEL_UP_instance;
var Key_CALCULATOR_instance;
var Key_CONTACTS_instance;
var Key_NOTIFICATION_instance;
var Key_COPY_instance;
var Key_CUT_instance;
var Key_PASTE_instance;
var Key_SEARCH_instance;
var Key_SETTINGS_instance;
var Key_SOFT_LEFT_instance;
var Key_SOFT_RIGHT_instance;
var Key_SOFT_SLEEP_instance;
var Key_STAR_instance;
var Key_STB_INPUT_instance;
var Key_STB_POWER_instance;
var Key_STEM_1_instance;
var Key_STEM_2_instance;
var Key_STEM_3_instance;
var Key_STEM_PRIMARY_instance;
var Key_SWITCH_CHARSET_instance;
var Key_SYM_instance;
var Key_SYSRQ_instance;
var Key_NUM_instance;
var Key_TV_instance;
var Key_TV_ANTENNA_CABLE_instance;
var Key_TV_AUDIO_DESCRIPTION_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
var Key_TV_CONTENTS_MENU_instance;
var Key_TV_DATA_SERVICE_instance;
var Key_TV_INPUT_instance;
var Key_TV_INPUT_COMPONENT_1_instance;
var Key_TV_INPUT_COMPONENT_2_instance;
var Key_TV_INPUT_COMPOSITE_1_instance;
var Key_TV_INPUT_COMPOSITE_2_instance;
var Key_TV_INPUT_HDMI_1_instance;
var Key_TV_INPUT_HDMI_2_instance;
var Key_TV_INPUT_HDMI_3_instance;
var Key_TV_INPUT_HDMI_4_instance;
var Key_TV_INPUT_VGA_1_instance;
var Key_TV_MEDIA_CONTEXT_MENU_instance;
var Key_TV_NETWORK_instance;
var Key_TV_NUMBER_ENTRY_instance;
var Key_TV_POWER_instance;
var Key_TV_RADIO_SERVICE_instance;
var Key_TV_SATELLITE_instance;
var Key_TV_SATELLITE_BS_instance;
var Key_TV_SATELLITE_CS_instance;
var Key_TV_SATELLITE_SERVICE_instance;
var Key_TV_TELETEXT_instance;
var Key_TV_TERRESTRIAL_ANALOG_instance;
var Key_TV_TERRESTRIAL_DIGITAL_instance;
var Key_TV_TIMER_PROGRAMMING_instance;
var Key_TV_ZOOM_MODE_instance;
var Key_VOICE_ASSIST_instance;
var Key_WAKEUP_instance;
var Key_WINDOW_instance;
var Key_YEN_instance;
var Key_ZENKAKU_HANKAKU_instance;
var Key_ZOOM_IN_instance;
var Key_ZOOM_OUT_instance;
var Key_SYSTEM_NAVIGATION_DOWN_instance;
var Key_SYSTEM_NAVIGATION_LEFT_instance;
var Key_SYSTEM_NAVIGATION_RIGHT_instance;
var Key_SYSTEM_NAVIGATION_UP_instance;
var Key_PICTSYMBOLS_instance;
var Key_POUND_instance;
var Key_POWER_instance;
var Key_PROG_BLUE_instance;
var Key_PROG_GREEN_instance;
var Key_PROG_RED_instance;
var Key_PROG_YELLOW_instance;
var Key_RO_instance;
var Key_OEM_ATTN_instance;
var Key_OEM_AUTO_instance;
var Key_OEM_AX_instance;
var Key_OEM_BACKTAB_instance;
var Key_OEM_CLEAR_instance;
var Key_OEM_COMMA_instance;
var Key_OEM_COPY_instance;
var Key_OEM_CUSEL_instance;
var Key_OEM_ENLW_instance;
var Key_OEM_FINISH_instance;
var Key_OEM_FJ_LOYA_instance;
var Key_OEM_FJ_MASSHOU_instance;
var Key_OEM_FJ_ROYA_instance;
var Key_OEM_FJ_TOUROKU_instance;
var Key_OEM_JUMP_instance;
var Key_OEM_MINUS_instance;
var Key_OEM_PA1_instance;
var Key_OEM_PA2_instance;
var Key_OEM_PA3_instance;
var Key_OEM_PERIOD_instance;
var Key_OEM_PLUS_instance;
var Key_OEM_RESET_instance;
var Key_OEM_WSCTRL_instance;
var Key_PA1_instance;
var Key_PACKET_instance;
var Key_PROCESSKEY_instance;
var Key_ZOOM_instance;
var Key_NONE_instance;
var Key_ACCEPT_instance;
var Key_APPS_instance;
var Key_BROWSER_BACK_instance;
var Key_BROWSER_FAVORITES_instance;
var Key_BROWSER_FORWARD_instance;
var Key_BROWSER_HOME_instance;
var Key_BROWSER_REFRESH_instance;
var Key_BROWSER_SEARCH_instance;
var Key_BROWSER_STOP_instance;
var Key_CAPITAL_instance;
var Key_CONVERT_instance;
var Key_ICO_00_instance;
var Key_JUNJA_instance;
var Key_KANA_instance;
var Key_KANJI_instance;
var Key_KATAKANA_HIRAGANA_instance;
var Key_LANGUAGE_SWITCH_instance;
var Key_MUHENKAN_instance;
var Key_LAUNCH_APP1_instance;
var Key_LAUNCH_APP2_instance;
var Key_LAUNCH_MAIL_instance;
var Key_LAUNCH_MEDIA_SELECT_instance;
var Key_LEFT_BUTTON_instance;
var Key_MIDDLE_BUTTON_instance;
var Key_MUSIC_instance;
var Key_MEDIA_NEXT_TRACK_instance;
var Key_MEDIA_PLAY_PAUSE_instance;
var Key_MEDIA_PREV_TRACK_instance;
var Key_MEDIA_STOP_instance;
var Key_MEDIA_PLAY_instance;
var Key_MEDIA_PAUSE_instance;
var Key_MEDIA_AUDIO_TRACK_instance;
var Key_MEDIA_CLOSE_instance;
var Key_MEDIA_EJECT_instance;
var Key_MEDIA_FAST_FORWARD_instance;
var Key_MEDIA_RECORD_instance;
var Key_MEDIA_REWIND_instance;
var Key_MEDIA_SKIP_BACKWARD_instance;
var Key_MEDIA_SKIP_FORWARD_instance;
var Key_MEDIA_STEP_BACKWARD_instance;
var Key_MEDIA_STEP_FORWARD_instance;
var Key_MEDIA_TOP_MENU_instance;
var Key_MODECHANGE_instance;
var Key_NEXT_instance;
var Key_NONCONVERT_instance;
var Key_OEM_FJ_JISHO_instance;
var Key_PRIOR_instance;
var Key_RIGHT_BUTTON_instance;
var Key_LAST_CHANNEL_instance;
var Key_MANNER_MODE_instance;
var Key_NAVIGATE_IN_instance;
var Key_NAVIGATE_NEXT_instance;
var Key_NAVIGATE_OUT_instance;
var Key_NAVIGATE_PREVIOUS_instance;
var Key_HYPHEN_instance;
var Key_UNDEFINED_instance;
var Key_UNKNOWN_instance;
var Companion_instance_29;
function Companion_getInstance_37() {
  Key_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_20();
  return Companion_instance_29;
}
var Key_entriesInitialized;
function Key_initEntries() {
  if (Key_entriesInitialized)
    return Unit_instance;
  Key_entriesInitialized = true;
  Key_SPACE_instance = new Key('SPACE', 0);
  Key_APOSTROPHE_instance = new Key('APOSTROPHE', 1);
  Key_COMMA_instance = new Key('COMMA', 2);
  Key_MINUS_instance = new Key('MINUS', 3);
  Key_PLUS_instance = new Key('PLUS', 4);
  Key_PERIOD_instance = new Key('PERIOD', 5);
  Key_SLASH_instance = new Key('SLASH', 6);
  Key_N0_instance = new Key('N0', 7);
  Key_N1_instance = new Key('N1', 8);
  Key_N2_instance = new Key('N2', 9);
  Key_N3_instance = new Key('N3', 10);
  Key_N4_instance = new Key('N4', 11);
  Key_N5_instance = new Key('N5', 12);
  Key_N6_instance = new Key('N6', 13);
  Key_N7_instance = new Key('N7', 14);
  Key_N8_instance = new Key('N8', 15);
  Key_N9_instance = new Key('N9', 16);
  Key_N11_instance = new Key('N11', 17);
  Key_N12_instance = new Key('N12', 18);
  Key_N3D_MODE_instance = new Key('N3D_MODE', 19);
  Key_SEMICOLON_instance = new Key('SEMICOLON', 20);
  Key_EQUAL_instance = new Key('EQUAL', 21);
  Key_AT_instance = new Key('AT', 22);
  Key_A_instance = new Key('A', 23);
  Key_B_instance = new Key('B', 24);
  Key_C_instance = new Key('C', 25);
  Key_D_instance = new Key('D', 26);
  Key_E_instance = new Key('E', 27);
  Key_F_instance = new Key('F', 28);
  Key_G_instance = new Key('G', 29);
  Key_H_instance = new Key('H', 30);
  Key_I_instance = new Key('I', 31);
  Key_J_instance = new Key('J', 32);
  Key_K_instance = new Key('K', 33);
  Key_L_instance = new Key('L', 34);
  Key_M_instance = new Key('M', 35);
  Key_N_instance = new Key('N', 36);
  Key_O_instance = new Key('O', 37);
  Key_P_instance = new Key('P', 38);
  Key_Q_instance = new Key('Q', 39);
  Key_R_instance = new Key('R', 40);
  Key_S_instance = new Key('S', 41);
  Key_T_instance = new Key('T', 42);
  Key_U_instance = new Key('U', 43);
  Key_V_instance = new Key('V', 44);
  Key_W_instance = new Key('W', 45);
  Key_X_instance = new Key('X', 46);
  Key_Y_instance = new Key('Y', 47);
  Key_Z_instance = new Key('Z', 48);
  Key_LEFT_BRACKET_instance = new Key('LEFT_BRACKET', 49);
  Key_BACKSLASH_instance = new Key('BACKSLASH', 50);
  Key_RIGHT_BRACKET_instance = new Key('RIGHT_BRACKET', 51);
  Key_GRAVE_ACCENT_instance = new Key('GRAVE_ACCENT', 52);
  Key_WORLD_1_instance = new Key('WORLD_1', 53);
  Key_WORLD_2_instance = new Key('WORLD_2', 54);
  Key_ESCAPE_instance = new Key('ESCAPE', 55);
  Key_META_instance = new Key('META', 56);
  Key_ENTER_instance = new Key('ENTER', 57);
  Key_TAB_instance = new Key('TAB', 58);
  Key_BACKSPACE_instance = new Key('BACKSPACE', 59);
  Key_INSERT_instance = new Key('INSERT', 60);
  Key_DELETE_instance = new Key('DELETE', 61);
  Key_RIGHT_instance = new Key('RIGHT', 62);
  Key_LEFT_instance = new Key('LEFT', 63);
  Key_DOWN_instance = new Key('DOWN', 64);
  Key_UP_instance = new Key('UP', 65);
  Key_PAGE_UP_instance = new Key('PAGE_UP', 66);
  Key_PAGE_DOWN_instance = new Key('PAGE_DOWN', 67);
  Key_FUNCTION_instance = new Key('FUNCTION', 68);
  Key_HELP_instance = new Key('HELP', 69);
  Key_MUTE_instance = new Key('MUTE', 70);
  Key_VOLUME_DOWN_instance = new Key('VOLUME_DOWN', 71);
  Key_VOLUME_UP_instance = new Key('VOLUME_UP', 72);
  Key_VOLUME_MUTE_instance = new Key('VOLUME_MUTE', 73);
  Key_HOME_instance = new Key('HOME', 74);
  Key_END_instance = new Key('END', 75);
  Key_CAPS_LOCK_instance = new Key('CAPS_LOCK', 76);
  Key_SCROLL_LOCK_instance = new Key('SCROLL_LOCK', 77);
  Key_NUM_LOCK_instance = new Key('NUM_LOCK', 78);
  Key_PRINT_SCREEN_instance = new Key('PRINT_SCREEN', 79);
  Key_PAUSE_instance = new Key('PAUSE', 80);
  Key_F1_instance = new Key('F1', 81);
  Key_F2_instance = new Key('F2', 82);
  Key_F3_instance = new Key('F3', 83);
  Key_F4_instance = new Key('F4', 84);
  Key_F5_instance = new Key('F5', 85);
  Key_F6_instance = new Key('F6', 86);
  Key_F7_instance = new Key('F7', 87);
  Key_F8_instance = new Key('F8', 88);
  Key_F9_instance = new Key('F9', 89);
  Key_F10_instance = new Key('F10', 90);
  Key_F11_instance = new Key('F11', 91);
  Key_F12_instance = new Key('F12', 92);
  Key_F13_instance = new Key('F13', 93);
  Key_F14_instance = new Key('F14', 94);
  Key_F15_instance = new Key('F15', 95);
  Key_F16_instance = new Key('F16', 96);
  Key_F17_instance = new Key('F17', 97);
  Key_F18_instance = new Key('F18', 98);
  Key_F19_instance = new Key('F19', 99);
  Key_F20_instance = new Key('F20', 100);
  Key_F21_instance = new Key('F21', 101);
  Key_F22_instance = new Key('F22', 102);
  Key_F23_instance = new Key('F23', 103);
  Key_F24_instance = new Key('F24', 104);
  Key_F25_instance = new Key('F25', 105);
  Key_KP_0_instance = new Key('KP_0', 106);
  Key_KP_1_instance = new Key('KP_1', 107);
  Key_KP_2_instance = new Key('KP_2', 108);
  Key_KP_3_instance = new Key('KP_3', 109);
  Key_KP_4_instance = new Key('KP_4', 110);
  Key_KP_5_instance = new Key('KP_5', 111);
  Key_KP_6_instance = new Key('KP_6', 112);
  Key_KP_7_instance = new Key('KP_7', 113);
  Key_KP_8_instance = new Key('KP_8', 114);
  Key_KP_9_instance = new Key('KP_9', 115);
  Key_KP_DECIMAL_instance = new Key('KP_DECIMAL', 116);
  Key_KP_DIVIDE_instance = new Key('KP_DIVIDE', 117);
  Key_KP_MULTIPLY_instance = new Key('KP_MULTIPLY', 118);
  Key_KP_SUBTRACT_instance = new Key('KP_SUBTRACT', 119);
  Key_KP_ADD_instance = new Key('KP_ADD', 120);
  Key_KP_COMMA_instance = new Key('KP_COMMA', 121);
  Key_KP_DOT_instance = new Key('KP_DOT', 122);
  Key_KP_ENTER_instance = new Key('KP_ENTER', 123);
  Key_KP_EQUAL_instance = new Key('KP_EQUAL', 124);
  Key_KP_SEPARATOR_instance = new Key('KP_SEPARATOR', 125);
  Key_KP_LEFT_PAREN_instance = new Key('KP_LEFT_PAREN', 126);
  Key_KP_RIGHT_PAREN_instance = new Key('KP_RIGHT_PAREN', 127);
  Key_SHIFT_instance = new Key('SHIFT', 128);
  Key_CONTROL_instance = new Key('CONTROL', 129);
  Key_ALT_instance = new Key('ALT', 130);
  Key_SUPER_instance = new Key('SUPER', 131);
  Key_MENU_instance = new Key('MENU', 132);
  Key_BACK_instance = new Key('BACK', 133);
  Key_BACKQUOTE_instance = new Key('BACKQUOTE', 134);
  Key_QUOTE_instance = new Key('QUOTE', 135);
  Key_KP_UP_instance = new Key('KP_UP', 136);
  Key_KP_DOWN_instance = new Key('KP_DOWN', 137);
  Key_KP_LEFT_instance = new Key('KP_LEFT', 138);
  Key_KP_RIGHT_instance = new Key('KP_RIGHT', 139);
  Key_UNDERLINE_instance = new Key('UNDERLINE', 140);
  Key_SELECT_KEY_instance = new Key('SELECT_KEY', 141);
  Key_CANCEL_instance = new Key('CANCEL', 142);
  Key_CLEAR_instance = new Key('CLEAR', 143);
  Key_OPEN_BRACKET_instance = new Key('OPEN_BRACKET', 144);
  Key_CLOSE_BRACKET_instance = new Key('CLOSE_BRACKET', 145);
  Key_PLAY_instance = new Key('PLAY', 146);
  Key_NONAME_instance = new Key('NONAME', 147);
  Key_FINAL_instance = new Key('FINAL', 148);
  Key_OEM102_instance = new Key('OEM102', 149);
  Key_OEM1_instance = new Key('OEM1', 150);
  Key_OEM2_instance = new Key('OEM2', 151);
  Key_OEM3_instance = new Key('OEM3', 152);
  Key_OEM4_instance = new Key('OEM4', 153);
  Key_OEM5_instance = new Key('OEM5', 154);
  Key_OEM6_instance = new Key('OEM6', 155);
  Key_OEM7_instance = new Key('OEM7', 156);
  Key_OEM8_instance = new Key('OEM8', 157);
  Key_LEFT_MENU_instance = new Key('LEFT_MENU', 158);
  Key_RIGHT_MENU_instance = new Key('RIGHT_MENU', 159);
  Key_SLEEP_instance = new Key('SLEEP', 160);
  Key_SNAPSHOT_instance = new Key('SNAPSHOT', 161);
  Key_INFO_instance = new Key('INFO', 162);
  Key_XBUTTON1_instance = new Key('XBUTTON1', 163);
  Key_XBUTTON2_instance = new Key('XBUTTON2', 164);
  Key_XBUTTON3_instance = new Key('XBUTTON3', 165);
  Key_XBUTTON4_instance = new Key('XBUTTON4', 166);
  Key_XBUTTON5_instance = new Key('XBUTTON5', 167);
  Key_XBUTTON6_instance = new Key('XBUTTON6', 168);
  Key_XBUTTON7_instance = new Key('XBUTTON7', 169);
  Key_XBUTTON8_instance = new Key('XBUTTON8', 170);
  Key_XBUTTON9_instance = new Key('XBUTTON9', 171);
  Key_XBUTTON10_instance = new Key('XBUTTON10', 172);
  Key_XBUTTON11_instance = new Key('XBUTTON11', 173);
  Key_XBUTTON12_instance = new Key('XBUTTON12', 174);
  Key_XBUTTON13_instance = new Key('XBUTTON13', 175);
  Key_XBUTTON14_instance = new Key('XBUTTON14', 176);
  Key_XBUTTON15_instance = new Key('XBUTTON15', 177);
  Key_XBUTTON16_instance = new Key('XBUTTON16', 178);
  Key_XBUTTON_A_instance = new Key('XBUTTON_A', 179);
  Key_XBUTTON_B_instance = new Key('XBUTTON_B', 180);
  Key_XBUTTON_C_instance = new Key('XBUTTON_C', 181);
  Key_XBUTTON_L1_instance = new Key('XBUTTON_L1', 182);
  Key_XBUTTON_L2_instance = new Key('XBUTTON_L2', 183);
  Key_XBUTTON_MODE_instance = new Key('XBUTTON_MODE', 184);
  Key_XBUTTON_R1_instance = new Key('XBUTTON_R1', 185);
  Key_XBUTTON_R2_instance = new Key('XBUTTON_R2', 186);
  Key_XBUTTON_SELECT_instance = new Key('XBUTTON_SELECT', 187);
  Key_XBUTTON_START_instance = new Key('XBUTTON_START', 188);
  Key_XBUTTON_THUMBL_instance = new Key('XBUTTON_THUMBL', 189);
  Key_XBUTTON_THUMBR_instance = new Key('XBUTTON_THUMBR', 190);
  Key_XBUTTON_X_instance = new Key('XBUTTON_X', 191);
  Key_XBUTTON_Y_instance = new Key('XBUTTON_Y', 192);
  Key_XBUTTON_Z_instance = new Key('XBUTTON_Z', 193);
  Key_DPAD_CENTER_instance = new Key('DPAD_CENTER', 194);
  Key_DPAD_DOWN_instance = new Key('DPAD_DOWN', 195);
  Key_DPAD_DOWN_LEFT_instance = new Key('DPAD_DOWN_LEFT', 196);
  Key_DPAD_DOWN_RIGHT_instance = new Key('DPAD_DOWN_RIGHT', 197);
  Key_DPAD_LEFT_instance = new Key('DPAD_LEFT', 198);
  Key_DPAD_RIGHT_instance = new Key('DPAD_RIGHT', 199);
  Key_DPAD_UP_instance = new Key('DPAD_UP', 200);
  Key_DPAD_UP_LEFT_instance = new Key('DPAD_UP_LEFT', 201);
  Key_DPAD_UP_RIGHT_instance = new Key('DPAD_UP_RIGHT', 202);
  Key_DVR_instance = new Key('DVR', 203);
  Key_EISU_instance = new Key('EISU', 204);
  Key_ENDCALL_instance = new Key('ENDCALL', 205);
  Key_ENVELOPE_instance = new Key('ENVELOPE', 206);
  Key_EXPLORER_instance = new Key('EXPLORER', 207);
  Key_FOCUS_instance = new Key('FOCUS', 208);
  Key_FORWARD_instance = new Key('FORWARD', 209);
  Key_GRAVE_instance = new Key('GRAVE', 210);
  Key_GUIDE_instance = new Key('GUIDE', 211);
  Key_HEADSETHOOK_instance = new Key('HEADSETHOOK', 212);
  Key_ABNT_C1_instance = new Key('ABNT_C1', 213);
  Key_ABNT_C2_instance = new Key('ABNT_C2', 214);
  Key_ATTN_instance = new Key('ATTN', 215);
  Key_CRSEL_instance = new Key('CRSEL', 216);
  Key_EREOF_instance = new Key('EREOF', 217);
  Key_EXECUTE_instance = new Key('EXECUTE', 218);
  Key_EXSEL_instance = new Key('EXSEL', 219);
  Key_ICO_CLEAR_instance = new Key('ICO_CLEAR', 220);
  Key_ICO_HELP_instance = new Key('ICO_HELP', 221);
  Key_HENKAN_instance = new Key('HENKAN', 222);
  Key_PAIRING_instance = new Key('PAIRING', 223);
  Key_APP_SWITCH_instance = new Key('APP_SWITCH', 224);
  Key_ASSIST_instance = new Key('ASSIST', 225);
  Key_AVR_INPUT_instance = new Key('AVR_INPUT', 226);
  Key_AVR_POWER_instance = new Key('AVR_POWER', 227);
  Key_BOOKMARK_instance = new Key('BOOKMARK', 228);
  Key_BREAK_instance = new Key('BREAK', 229);
  Key_CAPTIONS_instance = new Key('CAPTIONS', 230);
  Key_CAMERA_instance = new Key('CAMERA', 231);
  Key_CALL_instance = new Key('CALL', 232);
  Key_CALENDAR_instance = new Key('CALENDAR', 233);
  Key_BRIGHTNESS_DOWN_instance = new Key('BRIGHTNESS_DOWN', 234);
  Key_BRIGHTNESS_UP_instance = new Key('BRIGHTNESS_UP', 235);
  Key_CHANNEL_DOWN_instance = new Key('CHANNEL_DOWN', 236);
  Key_CHANNEL_UP_instance = new Key('CHANNEL_UP', 237);
  Key_CALCULATOR_instance = new Key('CALCULATOR', 238);
  Key_CONTACTS_instance = new Key('CONTACTS', 239);
  Key_NOTIFICATION_instance = new Key('NOTIFICATION', 240);
  Key_COPY_instance = new Key('COPY', 241);
  Key_CUT_instance = new Key('CUT', 242);
  Key_PASTE_instance = new Key('PASTE', 243);
  Key_SEARCH_instance = new Key('SEARCH', 244);
  Key_SETTINGS_instance = new Key('SETTINGS', 245);
  Key_SOFT_LEFT_instance = new Key('SOFT_LEFT', 246);
  Key_SOFT_RIGHT_instance = new Key('SOFT_RIGHT', 247);
  Key_SOFT_SLEEP_instance = new Key('SOFT_SLEEP', 248);
  Key_STAR_instance = new Key('STAR', 249);
  Key_STB_INPUT_instance = new Key('STB_INPUT', 250);
  Key_STB_POWER_instance = new Key('STB_POWER', 251);
  Key_STEM_1_instance = new Key('STEM_1', 252);
  Key_STEM_2_instance = new Key('STEM_2', 253);
  Key_STEM_3_instance = new Key('STEM_3', 254);
  Key_STEM_PRIMARY_instance = new Key('STEM_PRIMARY', 255);
  Key_SWITCH_CHARSET_instance = new Key('SWITCH_CHARSET', 256);
  Key_SYM_instance = new Key('SYM', 257);
  Key_SYSRQ_instance = new Key('SYSRQ', 258);
  Key_NUM_instance = new Key('NUM', 259);
  Key_TV_instance = new Key('TV', 260);
  Key_TV_ANTENNA_CABLE_instance = new Key('TV_ANTENNA_CABLE', 261);
  Key_TV_AUDIO_DESCRIPTION_instance = new Key('TV_AUDIO_DESCRIPTION', 262);
  Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_DOWN', 263);
  Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_UP', 264);
  Key_TV_CONTENTS_MENU_instance = new Key('TV_CONTENTS_MENU', 265);
  Key_TV_DATA_SERVICE_instance = new Key('TV_DATA_SERVICE', 266);
  Key_TV_INPUT_instance = new Key('TV_INPUT', 267);
  Key_TV_INPUT_COMPONENT_1_instance = new Key('TV_INPUT_COMPONENT_1', 268);
  Key_TV_INPUT_COMPONENT_2_instance = new Key('TV_INPUT_COMPONENT_2', 269);
  Key_TV_INPUT_COMPOSITE_1_instance = new Key('TV_INPUT_COMPOSITE_1', 270);
  Key_TV_INPUT_COMPOSITE_2_instance = new Key('TV_INPUT_COMPOSITE_2', 271);
  Key_TV_INPUT_HDMI_1_instance = new Key('TV_INPUT_HDMI_1', 272);
  Key_TV_INPUT_HDMI_2_instance = new Key('TV_INPUT_HDMI_2', 273);
  Key_TV_INPUT_HDMI_3_instance = new Key('TV_INPUT_HDMI_3', 274);
  Key_TV_INPUT_HDMI_4_instance = new Key('TV_INPUT_HDMI_4', 275);
  Key_TV_INPUT_VGA_1_instance = new Key('TV_INPUT_VGA_1', 276);
  Key_TV_MEDIA_CONTEXT_MENU_instance = new Key('TV_MEDIA_CONTEXT_MENU', 277);
  Key_TV_NETWORK_instance = new Key('TV_NETWORK', 278);
  Key_TV_NUMBER_ENTRY_instance = new Key('TV_NUMBER_ENTRY', 279);
  Key_TV_POWER_instance = new Key('TV_POWER', 280);
  Key_TV_RADIO_SERVICE_instance = new Key('TV_RADIO_SERVICE', 281);
  Key_TV_SATELLITE_instance = new Key('TV_SATELLITE', 282);
  Key_TV_SATELLITE_BS_instance = new Key('TV_SATELLITE_BS', 283);
  Key_TV_SATELLITE_CS_instance = new Key('TV_SATELLITE_CS', 284);
  Key_TV_SATELLITE_SERVICE_instance = new Key('TV_SATELLITE_SERVICE', 285);
  Key_TV_TELETEXT_instance = new Key('TV_TELETEXT', 286);
  Key_TV_TERRESTRIAL_ANALOG_instance = new Key('TV_TERRESTRIAL_ANALOG', 287);
  Key_TV_TERRESTRIAL_DIGITAL_instance = new Key('TV_TERRESTRIAL_DIGITAL', 288);
  Key_TV_TIMER_PROGRAMMING_instance = new Key('TV_TIMER_PROGRAMMING', 289);
  Key_TV_ZOOM_MODE_instance = new Key('TV_ZOOM_MODE', 290);
  Key_VOICE_ASSIST_instance = new Key('VOICE_ASSIST', 291);
  Key_WAKEUP_instance = new Key('WAKEUP', 292);
  Key_WINDOW_instance = new Key('WINDOW', 293);
  Key_YEN_instance = new Key('YEN', 294);
  Key_ZENKAKU_HANKAKU_instance = new Key('ZENKAKU_HANKAKU', 295);
  Key_ZOOM_IN_instance = new Key('ZOOM_IN', 296);
  Key_ZOOM_OUT_instance = new Key('ZOOM_OUT', 297);
  Key_SYSTEM_NAVIGATION_DOWN_instance = new Key('SYSTEM_NAVIGATION_DOWN', 298);
  Key_SYSTEM_NAVIGATION_LEFT_instance = new Key('SYSTEM_NAVIGATION_LEFT', 299);
  Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key('SYSTEM_NAVIGATION_RIGHT', 300);
  Key_SYSTEM_NAVIGATION_UP_instance = new Key('SYSTEM_NAVIGATION_UP', 301);
  Key_PICTSYMBOLS_instance = new Key('PICTSYMBOLS', 302);
  Key_POUND_instance = new Key('POUND', 303);
  Key_POWER_instance = new Key('POWER', 304);
  Key_PROG_BLUE_instance = new Key('PROG_BLUE', 305);
  Key_PROG_GREEN_instance = new Key('PROG_GREEN', 306);
  Key_PROG_RED_instance = new Key('PROG_RED', 307);
  Key_PROG_YELLOW_instance = new Key('PROG_YELLOW', 308);
  Key_RO_instance = new Key('RO', 309);
  Key_OEM_ATTN_instance = new Key('OEM_ATTN', 310);
  Key_OEM_AUTO_instance = new Key('OEM_AUTO', 311);
  Key_OEM_AX_instance = new Key('OEM_AX', 312);
  Key_OEM_BACKTAB_instance = new Key('OEM_BACKTAB', 313);
  Key_OEM_CLEAR_instance = new Key('OEM_CLEAR', 314);
  Key_OEM_COMMA_instance = new Key('OEM_COMMA', 315);
  Key_OEM_COPY_instance = new Key('OEM_COPY', 316);
  Key_OEM_CUSEL_instance = new Key('OEM_CUSEL', 317);
  Key_OEM_ENLW_instance = new Key('OEM_ENLW', 318);
  Key_OEM_FINISH_instance = new Key('OEM_FINISH', 319);
  Key_OEM_FJ_LOYA_instance = new Key('OEM_FJ_LOYA', 320);
  Key_OEM_FJ_MASSHOU_instance = new Key('OEM_FJ_MASSHOU', 321);
  Key_OEM_FJ_ROYA_instance = new Key('OEM_FJ_ROYA', 322);
  Key_OEM_FJ_TOUROKU_instance = new Key('OEM_FJ_TOUROKU', 323);
  Key_OEM_JUMP_instance = new Key('OEM_JUMP', 324);
  Key_OEM_MINUS_instance = new Key('OEM_MINUS', 325);
  Key_OEM_PA1_instance = new Key('OEM_PA1', 326);
  Key_OEM_PA2_instance = new Key('OEM_PA2', 327);
  Key_OEM_PA3_instance = new Key('OEM_PA3', 328);
  Key_OEM_PERIOD_instance = new Key('OEM_PERIOD', 329);
  Key_OEM_PLUS_instance = new Key('OEM_PLUS', 330);
  Key_OEM_RESET_instance = new Key('OEM_RESET', 331);
  Key_OEM_WSCTRL_instance = new Key('OEM_WSCTRL', 332);
  Key_PA1_instance = new Key('PA1', 333);
  Key_PACKET_instance = new Key('PACKET', 334);
  Key_PROCESSKEY_instance = new Key('PROCESSKEY', 335);
  Key_ZOOM_instance = new Key('ZOOM', 336);
  Key_NONE_instance = new Key('NONE', 337);
  Key_ACCEPT_instance = new Key('ACCEPT', 338);
  Key_APPS_instance = new Key('APPS', 339);
  Key_BROWSER_BACK_instance = new Key('BROWSER_BACK', 340);
  Key_BROWSER_FAVORITES_instance = new Key('BROWSER_FAVORITES', 341);
  Key_BROWSER_FORWARD_instance = new Key('BROWSER_FORWARD', 342);
  Key_BROWSER_HOME_instance = new Key('BROWSER_HOME', 343);
  Key_BROWSER_REFRESH_instance = new Key('BROWSER_REFRESH', 344);
  Key_BROWSER_SEARCH_instance = new Key('BROWSER_SEARCH', 345);
  Key_BROWSER_STOP_instance = new Key('BROWSER_STOP', 346);
  Key_CAPITAL_instance = new Key('CAPITAL', 347);
  Key_CONVERT_instance = new Key('CONVERT', 348);
  Key_ICO_00_instance = new Key('ICO_00', 349);
  Key_JUNJA_instance = new Key('JUNJA', 350);
  Key_KANA_instance = new Key('KANA', 351);
  Key_KANJI_instance = new Key('KANJI', 352);
  Key_KATAKANA_HIRAGANA_instance = new Key('KATAKANA_HIRAGANA', 353);
  Key_LANGUAGE_SWITCH_instance = new Key('LANGUAGE_SWITCH', 354);
  Key_MUHENKAN_instance = new Key('MUHENKAN', 355);
  Key_LAUNCH_APP1_instance = new Key('LAUNCH_APP1', 356);
  Key_LAUNCH_APP2_instance = new Key('LAUNCH_APP2', 357);
  Key_LAUNCH_MAIL_instance = new Key('LAUNCH_MAIL', 358);
  Key_LAUNCH_MEDIA_SELECT_instance = new Key('LAUNCH_MEDIA_SELECT', 359);
  Key_LEFT_BUTTON_instance = new Key('LEFT_BUTTON', 360);
  Key_MIDDLE_BUTTON_instance = new Key('MIDDLE_BUTTON', 361);
  Key_MUSIC_instance = new Key('MUSIC', 362);
  Key_MEDIA_NEXT_TRACK_instance = new Key('MEDIA_NEXT_TRACK', 363);
  Key_MEDIA_PLAY_PAUSE_instance = new Key('MEDIA_PLAY_PAUSE', 364);
  Key_MEDIA_PREV_TRACK_instance = new Key('MEDIA_PREV_TRACK', 365);
  Key_MEDIA_STOP_instance = new Key('MEDIA_STOP', 366);
  Key_MEDIA_PLAY_instance = new Key('MEDIA_PLAY', 367);
  Key_MEDIA_PAUSE_instance = new Key('MEDIA_PAUSE', 368);
  Key_MEDIA_AUDIO_TRACK_instance = new Key('MEDIA_AUDIO_TRACK', 369);
  Key_MEDIA_CLOSE_instance = new Key('MEDIA_CLOSE', 370);
  Key_MEDIA_EJECT_instance = new Key('MEDIA_EJECT', 371);
  Key_MEDIA_FAST_FORWARD_instance = new Key('MEDIA_FAST_FORWARD', 372);
  Key_MEDIA_RECORD_instance = new Key('MEDIA_RECORD', 373);
  Key_MEDIA_REWIND_instance = new Key('MEDIA_REWIND', 374);
  Key_MEDIA_SKIP_BACKWARD_instance = new Key('MEDIA_SKIP_BACKWARD', 375);
  Key_MEDIA_SKIP_FORWARD_instance = new Key('MEDIA_SKIP_FORWARD', 376);
  Key_MEDIA_STEP_BACKWARD_instance = new Key('MEDIA_STEP_BACKWARD', 377);
  Key_MEDIA_STEP_FORWARD_instance = new Key('MEDIA_STEP_FORWARD', 378);
  Key_MEDIA_TOP_MENU_instance = new Key('MEDIA_TOP_MENU', 379);
  Key_MODECHANGE_instance = new Key('MODECHANGE', 380);
  Key_NEXT_instance = new Key('NEXT', 381);
  Key_NONCONVERT_instance = new Key('NONCONVERT', 382);
  Key_OEM_FJ_JISHO_instance = new Key('OEM_FJ_JISHO', 383);
  Key_PRIOR_instance = new Key('PRIOR', 384);
  Key_RIGHT_BUTTON_instance = new Key('RIGHT_BUTTON', 385);
  Key_LAST_CHANNEL_instance = new Key('LAST_CHANNEL', 386);
  Key_MANNER_MODE_instance = new Key('MANNER_MODE', 387);
  Key_NAVIGATE_IN_instance = new Key('NAVIGATE_IN', 388);
  Key_NAVIGATE_NEXT_instance = new Key('NAVIGATE_NEXT', 389);
  Key_NAVIGATE_OUT_instance = new Key('NAVIGATE_OUT', 390);
  Key_NAVIGATE_PREVIOUS_instance = new Key('NAVIGATE_PREVIOUS', 391);
  Key_HYPHEN_instance = new Key('HYPHEN', 392);
  Key_UNDEFINED_instance = new Key('UNDEFINED', 393);
  Key_UNKNOWN_instance = new Key('UNKNOWN', 394);
  Companion_getInstance_37();
}
function Key_SPACE_getInstance() {
  Key_initEntries();
  return Key_SPACE_instance;
}
function Key_APOSTROPHE_getInstance() {
  Key_initEntries();
  return Key_APOSTROPHE_instance;
}
function Key_COMMA_getInstance() {
  Key_initEntries();
  return Key_COMMA_instance;
}
function Key_MINUS_getInstance() {
  Key_initEntries();
  return Key_MINUS_instance;
}
function Key_PLUS_getInstance() {
  Key_initEntries();
  return Key_PLUS_instance;
}
function Key_PERIOD_getInstance() {
  Key_initEntries();
  return Key_PERIOD_instance;
}
function Key_SLASH_getInstance() {
  Key_initEntries();
  return Key_SLASH_instance;
}
function Key_N0_getInstance() {
  Key_initEntries();
  return Key_N0_instance;
}
function Key_N1_getInstance() {
  Key_initEntries();
  return Key_N1_instance;
}
function Key_N2_getInstance() {
  Key_initEntries();
  return Key_N2_instance;
}
function Key_N3_getInstance() {
  Key_initEntries();
  return Key_N3_instance;
}
function Key_N4_getInstance() {
  Key_initEntries();
  return Key_N4_instance;
}
function Key_N5_getInstance() {
  Key_initEntries();
  return Key_N5_instance;
}
function Key_N6_getInstance() {
  Key_initEntries();
  return Key_N6_instance;
}
function Key_N7_getInstance() {
  Key_initEntries();
  return Key_N7_instance;
}
function Key_N8_getInstance() {
  Key_initEntries();
  return Key_N8_instance;
}
function Key_N9_getInstance() {
  Key_initEntries();
  return Key_N9_instance;
}
function Key_SEMICOLON_getInstance() {
  Key_initEntries();
  return Key_SEMICOLON_instance;
}
function Key_A_getInstance() {
  Key_initEntries();
  return Key_A_instance;
}
function Key_B_getInstance() {
  Key_initEntries();
  return Key_B_instance;
}
function Key_C_getInstance() {
  Key_initEntries();
  return Key_C_instance;
}
function Key_D_getInstance() {
  Key_initEntries();
  return Key_D_instance;
}
function Key_E_getInstance() {
  Key_initEntries();
  return Key_E_instance;
}
function Key_F_getInstance() {
  Key_initEntries();
  return Key_F_instance;
}
function Key_G_getInstance() {
  Key_initEntries();
  return Key_G_instance;
}
function Key_H_getInstance() {
  Key_initEntries();
  return Key_H_instance;
}
function Key_I_getInstance() {
  Key_initEntries();
  return Key_I_instance;
}
function Key_J_getInstance() {
  Key_initEntries();
  return Key_J_instance;
}
function Key_K_getInstance() {
  Key_initEntries();
  return Key_K_instance;
}
function Key_L_getInstance() {
  Key_initEntries();
  return Key_L_instance;
}
function Key_M_getInstance() {
  Key_initEntries();
  return Key_M_instance;
}
function Key_N_getInstance() {
  Key_initEntries();
  return Key_N_instance;
}
function Key_O_getInstance() {
  Key_initEntries();
  return Key_O_instance;
}
function Key_P_getInstance() {
  Key_initEntries();
  return Key_P_instance;
}
function Key_Q_getInstance() {
  Key_initEntries();
  return Key_Q_instance;
}
function Key_R_getInstance() {
  Key_initEntries();
  return Key_R_instance;
}
function Key_S_getInstance() {
  Key_initEntries();
  return Key_S_instance;
}
function Key_T_getInstance() {
  Key_initEntries();
  return Key_T_instance;
}
function Key_U_getInstance() {
  Key_initEntries();
  return Key_U_instance;
}
function Key_V_getInstance() {
  Key_initEntries();
  return Key_V_instance;
}
function Key_W_getInstance() {
  Key_initEntries();
  return Key_W_instance;
}
function Key_X_getInstance() {
  Key_initEntries();
  return Key_X_instance;
}
function Key_Y_getInstance() {
  Key_initEntries();
  return Key_Y_instance;
}
function Key_Z_getInstance() {
  Key_initEntries();
  return Key_Z_instance;
}
function Key_ESCAPE_getInstance() {
  Key_initEntries();
  return Key_ESCAPE_instance;
}
function Key_META_getInstance() {
  Key_initEntries();
  return Key_META_instance;
}
function Key_ENTER_getInstance() {
  Key_initEntries();
  return Key_ENTER_instance;
}
function Key_TAB_getInstance() {
  Key_initEntries();
  return Key_TAB_instance;
}
function Key_BACKSPACE_getInstance() {
  Key_initEntries();
  return Key_BACKSPACE_instance;
}
function Key_INSERT_getInstance() {
  Key_initEntries();
  return Key_INSERT_instance;
}
function Key_DELETE_getInstance() {
  Key_initEntries();
  return Key_DELETE_instance;
}
function Key_RIGHT_getInstance() {
  Key_initEntries();
  return Key_RIGHT_instance;
}
function Key_LEFT_getInstance() {
  Key_initEntries();
  return Key_LEFT_instance;
}
function Key_DOWN_getInstance() {
  Key_initEntries();
  return Key_DOWN_instance;
}
function Key_UP_getInstance() {
  Key_initEntries();
  return Key_UP_instance;
}
function Key_PAGE_UP_getInstance() {
  Key_initEntries();
  return Key_PAGE_UP_instance;
}
function Key_PAGE_DOWN_getInstance() {
  Key_initEntries();
  return Key_PAGE_DOWN_instance;
}
function Key_HOME_getInstance() {
  Key_initEntries();
  return Key_HOME_instance;
}
function Key_END_getInstance() {
  Key_initEntries();
  return Key_END_instance;
}
function Key_F1_getInstance() {
  Key_initEntries();
  return Key_F1_instance;
}
function Key_F2_getInstance() {
  Key_initEntries();
  return Key_F2_instance;
}
function Key_F3_getInstance() {
  Key_initEntries();
  return Key_F3_instance;
}
function Key_F4_getInstance() {
  Key_initEntries();
  return Key_F4_instance;
}
function Key_F5_getInstance() {
  Key_initEntries();
  return Key_F5_instance;
}
function Key_F6_getInstance() {
  Key_initEntries();
  return Key_F6_instance;
}
function Key_F7_getInstance() {
  Key_initEntries();
  return Key_F7_instance;
}
function Key_F8_getInstance() {
  Key_initEntries();
  return Key_F8_instance;
}
function Key_F9_getInstance() {
  Key_initEntries();
  return Key_F9_instance;
}
function Key_F10_getInstance() {
  Key_initEntries();
  return Key_F10_instance;
}
function Key_F11_getInstance() {
  Key_initEntries();
  return Key_F11_instance;
}
function Key_F12_getInstance() {
  Key_initEntries();
  return Key_F12_instance;
}
function Key_F13_getInstance() {
  Key_initEntries();
  return Key_F13_instance;
}
function Key_F14_getInstance() {
  Key_initEntries();
  return Key_F14_instance;
}
function Key_F15_getInstance() {
  Key_initEntries();
  return Key_F15_instance;
}
function Key_F16_getInstance() {
  Key_initEntries();
  return Key_F16_instance;
}
function Key_F17_getInstance() {
  Key_initEntries();
  return Key_F17_instance;
}
function Key_F18_getInstance() {
  Key_initEntries();
  return Key_F18_instance;
}
function Key_F19_getInstance() {
  Key_initEntries();
  return Key_F19_instance;
}
function Key_F20_getInstance() {
  Key_initEntries();
  return Key_F20_instance;
}
function Key_F21_getInstance() {
  Key_initEntries();
  return Key_F21_instance;
}
function Key_F22_getInstance() {
  Key_initEntries();
  return Key_F22_instance;
}
function Key_F23_getInstance() {
  Key_initEntries();
  return Key_F23_instance;
}
function Key_F24_getInstance() {
  Key_initEntries();
  return Key_F24_instance;
}
function Key_F25_getInstance() {
  Key_initEntries();
  return Key_F25_instance;
}
function Key_SHIFT_getInstance() {
  Key_initEntries();
  return Key_SHIFT_instance;
}
function Key_CONTROL_getInstance() {
  Key_initEntries();
  return Key_CONTROL_instance;
}
function Key_ALT_getInstance() {
  Key_initEntries();
  return Key_ALT_instance;
}
function Key_SUPER_getInstance() {
  Key_initEntries();
  return Key_SUPER_instance;
}
function Key_QUOTE_getInstance() {
  Key_initEntries();
  return Key_QUOTE_instance;
}
function Key_UNKNOWN_getInstance() {
  Key_initEntries();
  return Key_UNKNOWN_instance;
}
var MouseButton_LEFT_instance;
var MouseButton_MIDDLE_instance;
var MouseButton_RIGHT_instance;
var MouseButton_BUTTON3_instance;
var MouseButton_BUTTON4_instance;
var MouseButton_BUTTON5_instance;
var MouseButton_BUTTON6_instance;
var MouseButton_BUTTON7_instance;
var MouseButton_BUTTON_WHEEL_instance;
var MouseButton_BUTTON_UNKNOWN_instance;
var MouseButton_NONE_instance;
var Companion_instance_30;
function Companion_getInstance_38() {
  MouseButton_initEntries();
  if (Companion_instance_30 === VOID)
    new Companion_21();
  return Companion_instance_30;
}
function values_7() {
  return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
}
var MouseButton_entriesInitialized;
function MouseButton_initEntries() {
  if (MouseButton_entriesInitialized)
    return Unit_instance;
  MouseButton_entriesInitialized = true;
  MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
  MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
  MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
  MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
  MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
  MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
  MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
  MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
  MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
  MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 10);
  MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
  Companion_getInstance_38();
}
function MouseButton_LEFT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_LEFT_instance;
}
function MouseButton_MIDDLE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_MIDDLE_instance;
}
function MouseButton_RIGHT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_RIGHT_instance;
}
function MouseButton_BUTTON3_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON3_instance;
}
function MouseButton_BUTTON4_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON4_instance;
}
function MouseButton_BUTTON5_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON5_instance;
}
function MouseButton_BUTTON6_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON6_instance;
}
function MouseButton_BUTTON7_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON7_instance;
}
function MouseButton_BUTTON_WHEEL_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_WHEEL_instance;
}
function MouseButton_BUTTON_UNKNOWN_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_UNKNOWN_instance;
}
function MouseButton_NONE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_NONE_instance;
}
var SoftKeyboardType_DEFAULT_instance;
var SoftKeyboardType_ASCII_CAPABLE_instance;
var SoftKeyboardType_NUMBERS_AND_PUNCTUATION_instance;
var SoftKeyboardType_URL_instance;
var SoftKeyboardType_NUMBER_PAD_instance;
var SoftKeyboardType_PHONE_PAD_instance;
var SoftKeyboardType_NAME_PHONE_PAD_instance;
var SoftKeyboardType_EMAIL_ADDRESS_instance;
var SoftKeyboardType_DECIMAL_PAD_instance;
var SoftKeyboardType_TWITTER_instance;
var SoftKeyboardType_WEB_SEARCH_instance;
var SoftKeyboardType_ASCII_CAPABLE_NUMBER_PAD_instance;
var SoftKeyboardType_ALPHABET_instance;
var SoftKeyboardType_entriesInitialized;
function SoftKeyboardType_initEntries() {
  if (SoftKeyboardType_entriesInitialized)
    return Unit_instance;
  SoftKeyboardType_entriesInitialized = true;
  SoftKeyboardType_DEFAULT_instance = new SoftKeyboardType('DEFAULT', 0);
  SoftKeyboardType_ASCII_CAPABLE_instance = new SoftKeyboardType('ASCII_CAPABLE', 1);
  SoftKeyboardType_NUMBERS_AND_PUNCTUATION_instance = new SoftKeyboardType('NUMBERS_AND_PUNCTUATION', 2);
  SoftKeyboardType_URL_instance = new SoftKeyboardType('URL', 3);
  SoftKeyboardType_NUMBER_PAD_instance = new SoftKeyboardType('NUMBER_PAD', 4);
  SoftKeyboardType_PHONE_PAD_instance = new SoftKeyboardType('PHONE_PAD', 5);
  SoftKeyboardType_NAME_PHONE_PAD_instance = new SoftKeyboardType('NAME_PHONE_PAD', 6);
  SoftKeyboardType_EMAIL_ADDRESS_instance = new SoftKeyboardType('EMAIL_ADDRESS', 7);
  SoftKeyboardType_DECIMAL_PAD_instance = new SoftKeyboardType('DECIMAL_PAD', 8);
  SoftKeyboardType_TWITTER_instance = new SoftKeyboardType('TWITTER', 9);
  SoftKeyboardType_WEB_SEARCH_instance = new SoftKeyboardType('WEB_SEARCH', 10);
  SoftKeyboardType_ASCII_CAPABLE_NUMBER_PAD_instance = new SoftKeyboardType('ASCII_CAPABLE_NUMBER_PAD', 11);
  SoftKeyboardType_ALPHABET_instance = new SoftKeyboardType('ALPHABET', 12);
}
var SoftKeyboardReturnKeyType_DEFAULT_instance;
var SoftKeyboardReturnKeyType_GO_instance;
var SoftKeyboardReturnKeyType_JOIN_instance;
var SoftKeyboardReturnKeyType_NEXT_instance;
var SoftKeyboardReturnKeyType_ROUTE_instance;
var SoftKeyboardReturnKeyType_SEARCH_instance;
var SoftKeyboardReturnKeyType_DONE_instance;
var SoftKeyboardReturnKeyType_EMERGENCY_CALL_instance;
var SoftKeyboardReturnKeyType_CONTINUE_instance;
var SoftKeyboardReturnKeyType_entriesInitialized;
function SoftKeyboardReturnKeyType_initEntries() {
  if (SoftKeyboardReturnKeyType_entriesInitialized)
    return Unit_instance;
  SoftKeyboardReturnKeyType_entriesInitialized = true;
  SoftKeyboardReturnKeyType_DEFAULT_instance = new SoftKeyboardReturnKeyType('DEFAULT', 0);
  SoftKeyboardReturnKeyType_GO_instance = new SoftKeyboardReturnKeyType('GO', 1);
  SoftKeyboardReturnKeyType_JOIN_instance = new SoftKeyboardReturnKeyType('JOIN', 2);
  SoftKeyboardReturnKeyType_NEXT_instance = new SoftKeyboardReturnKeyType('NEXT', 3);
  SoftKeyboardReturnKeyType_ROUTE_instance = new SoftKeyboardReturnKeyType('ROUTE', 4);
  SoftKeyboardReturnKeyType_SEARCH_instance = new SoftKeyboardReturnKeyType('SEARCH', 5);
  SoftKeyboardReturnKeyType_DONE_instance = new SoftKeyboardReturnKeyType('DONE', 6);
  SoftKeyboardReturnKeyType_EMERGENCY_CALL_instance = new SoftKeyboardReturnKeyType('EMERGENCY_CALL', 7);
  SoftKeyboardReturnKeyType_CONTINUE_instance = new SoftKeyboardReturnKeyType('CONTINUE', 8);
}
function SoftKeyboardType_DEFAULT_getInstance() {
  SoftKeyboardType_initEntries();
  return SoftKeyboardType_DEFAULT_instance;
}
function SoftKeyboardReturnKeyType_DEFAULT_getInstance() {
  SoftKeyboardReturnKeyType_initEntries();
  return SoftKeyboardReturnKeyType_DEFAULT_instance;
}
var Companion_instance_31;
function Companion_getInstance_39() {
  if (Companion_instance_31 === VOID)
    new Companion_22();
  return Companion_instance_31;
}
function draw(_this__u8e3s4, frameBuffer, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
  indices = indices === VOID ? null : indices;
  indexType = indexType === VOID ? Companion_getInstance_44().w8k_1 : indexType;
  drawOffset = drawOffset === VOID ? 0 : drawOffset;
  blending = blending === VOID ? Companion_getInstance_45().a8l_1 : blending;
  uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_61().e8l_1 : uniformBlocks;
  textureUnits = textureUnits === VOID ? Companion_instance_32.g8l() : textureUnits;
  stencilRef = stencilRef === VOID ? Companion_getInstance_48().i8l_1 : stencilRef;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_49().k8l_1 : stencilOpFunc;
  colorMask = colorMask === VOID ? Companion_getInstance_50().o8l_1 : colorMask;
  depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_51().s8l_1 : depthAndFrontFace;
  scissor = scissor === VOID ? Companion_getInstance_46().w8l_1 : scissor;
  cullFace = cullFace === VOID ? Companion_getInstance_52().y8l_1 : cullFace;
  instances = instances === VOID ? 1 : instances;
  return _this__u8e3s4.n8k(frameBuffer.t8j_1, frameBuffer.c8m(), vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances);
}
function draw_0(_this__u8e3s4, batch) {
  return batch.s8m(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, batch) {
  return batch.s8m(_this__u8e3s4);
}
var Companion_instance_32;
function Companion_getInstance_40() {
  return Companion_instance_32;
}
var Companion_instance_33;
function Companion_getInstance_41() {
  return Companion_instance_33;
}
function markAsDirty($this) {
}
function checkBitmaps($this, bmp) {
  if (!bmp.v4q()) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.w8p_1;
    var level = Level_ERROR_getInstance();
    var tmp;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.graphics.AGTexture.checkBitmaps.<anonymous>' call
      var tmp$ret$0 = 'Trying to upload a non-premultiplied bitmap: ' + toString(bmp) + '. This will cause rendering artifacts';
      this_0.v3g(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
}
function _AGTextureUnitInfoArray___init__impl__c77rdb(data) {
  return data;
}
function _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this) {
  return $this;
}
function _AGTextureUnitInfoArray___init__impl__c77rdb_0(size) {
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    tmp_0[tmp] = _AGTextureUnitInfo___get_data__impl__oupy3n(Companion_getInstance_42().y8o_1);
    tmp = tmp + 1 | 0;
  }
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp_0);
}
function AGTextureUnitInfoArray__set_impl_s95rfh($this, index, value) {
  _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index] = _AGTextureUnitInfo___get_data__impl__oupy3n(value);
}
function AGTextureUnitInfoArray__get_impl_xhvpef($this, index) {
  return Companion_getInstance_42().g8r(_AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index]);
}
function AGTextureUnitInfoArray__copyOf_impl_z2w8z3($this) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this).slice();
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp$ret$1);
}
function AGTextureUnitInfoArray__toString_impl_kr9cgh($this) {
  return 'AGTextureUnitInfoArray(data=' + toString($this) + ')';
}
function AGTextureUnitInfoArray__hashCode_impl_siosps($this) {
  return hashCode($this);
}
function _AGTextureUnitInfo___init__impl__s1tthu(data) {
  return data;
}
function _AGTextureUnitInfo___get_data__impl__oupy3n($this) {
  return $this;
}
var Companion_instance_34;
function Companion_getInstance_42() {
  if (Companion_instance_34 === VOID)
    new Companion_25();
  return Companion_instance_34;
}
function _AGTextureUnitInfo___get_wrap__impl__dwp6l($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 0 | 0) & 3;
  return _AGWrapMode___init__impl__x5wmya(tmp$ret$0);
}
function _AGTextureUnitInfo___get_linear__impl__jak6ny($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 2 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 3 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_kind__impl__6xtjoz($this) {
  return _AGTextureTargetKind___init__impl__4zdmch(extract(_AGTextureUnitInfo___get_data__impl__oupy3n($this), 8, 5));
}
function AGTextureUnitInfo__withKind_impl_aa0b04($this, kind) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert5(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGTextureTargetKind___get_ordinal__impl__gjzc5p(kind), 8));
}
function AGTextureUnitInfo__withWrap_impl_akwb6y($this, wrap) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert2(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGWrapMode___get_ordinal__impl__rc38w2(wrap), 0));
}
function AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), linear, 2));
}
function AGTextureUnitInfo__withTrilinear_impl_vhkcy2($this, trilinear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), trilinear, 3));
}
function AGTextureUnitInfo__withLinearTrilinear_impl_aactvz($this, linear, trilinear) {
  return AGTextureUnitInfo__withTrilinear_impl_vhkcy2(AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear), trilinear);
}
function AGTextureUnitInfo__toString_impl_7im6je($this) {
  return 'AGTextureUnitInfo(wrap=' + AGWrapMode__toString_impl_8bjnw2(_AGTextureUnitInfo___get_wrap__impl__dwp6l($this)) + ', linear=' + _AGTextureUnitInfo___get_linear__impl__jak6ny($this) + ', trilinear=' + _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) + ', kind=' + AGTextureTargetKind__toString_impl_68648p(_AGTextureUnitInfo___get_kind__impl__6xtjoz($this)) + ')';
}
function AGTextureUnitInfo__hashCode_impl_e8jq9h($this) {
  return $this;
}
function AGTextureUnitInfo__equals_impl_j2jlgn($this, other) {
  if (!(other instanceof AGTextureUnitInfo))
    return false;
  if (!($this === (other instanceof AGTextureUnitInfo ? other.m8r_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDrawType___init__impl__emm6mb(ordinal) {
  return ordinal;
}
var Companion_instance_35;
function Companion_getInstance_43() {
  if (Companion_instance_35 === VOID)
    new Companion_26();
  return Companion_instance_35;
}
function AGDrawType__toString_impl_eonaeb($this) {
  return $this === Companion_getInstance_43().h8u_1 ? 'POINTS' : $this === Companion_getInstance_43().i8u_1 ? 'LINE_STRIP' : $this === Companion_getInstance_43().j8u_1 ? 'LINE_LOOP' : $this === Companion_getInstance_43().k8u_1 ? 'LINES' : $this === Companion_getInstance_43().l8u_1 ? 'TRIANGLES' : $this === Companion_getInstance_43().m8u_1 ? 'TRIANGLE_STRIP' : $this === Companion_getInstance_43().n8u_1 ? 'TRIANGLE_FAN' : '-';
}
function AGDrawType__hashCode_impl_ylaury($this) {
  return $this;
}
function AGDrawType__equals_impl_rtafo6($this, other) {
  if (!(other instanceof AGDrawType))
    return false;
  if (!($this === (other instanceof AGDrawType ? other.o8u_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGIndexType___init__impl__yqnmb7(ordinal) {
  return ordinal;
}
function _AGIndexType___get_bytesSize__impl__lsf184($this) {
  return $this === Companion_getInstance_44().u8k_1 ? 0 : $this === Companion_getInstance_44().v8k_1 ? 1 : $this === Companion_getInstance_44().w8k_1 ? 2 : $this === Companion_getInstance_44().x8k_1 ? 4 : -1;
}
var Companion_instance_36;
function Companion_getInstance_44() {
  if (Companion_instance_36 === VOID)
    new Companion_27();
  return Companion_instance_36;
}
function AGIndexType__toString_impl_hjqwm3($this) {
  return $this === Companion_getInstance_44().u8k_1 ? 'null' : $this === Companion_getInstance_44().v8k_1 ? 'UBYTE' : $this === Companion_getInstance_44().w8k_1 ? 'USHORT' : $this === Companion_getInstance_44().x8k_1 ? 'UINT' : '-';
}
function AGIndexType__hashCode_impl_47f06s($this) {
  return $this;
}
function AGIndexType__equals_impl_goy6ag($this, other) {
  if (!(other instanceof AGIndexType))
    return false;
  if (!($this === (other instanceof AGIndexType ? other.p8u_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlending___init__impl__upt3bq(data) {
  return data;
}
function _AGBlending___get_data__impl__7m3zd1($this) {
  return $this;
}
function _AGBlending___get_srcRGB__impl__jvh03e($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 0 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_srcA__impl__ftmwxe($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 4 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstRGB__impl__nz9ogp($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 8 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstA__impl__l7q6tv($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 12 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_eqRGB__impl__7pv8oi($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 16 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function _AGBlending___get_eqA__impl__2j4ray($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 18 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function AGBlending__withSRC_impl_hh0mjq($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 0), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 4));
}
function AGBlending__withSRC$default_impl_uuu5hz($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withSRC_impl_hh0mjq($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).r8u.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).q8u_1;
  }
  return tmp;
}
function AGBlending__withDST_impl_y1hpet($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 8), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 12));
}
function AGBlending__withDST$default_impl_leu6qg($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withDST_impl_y1hpet($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).s8u.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).q8u_1;
  }
  return tmp;
}
function AGBlending__withEQ_impl_e9gm04($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert2(insert2(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendEquation___get_ordinal__impl__895p3q(rgb), 16), _AGBlendEquation___get_ordinal__impl__895p3q(a), 18));
}
function AGBlending__withEQ$default_impl_iltiw7($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withEQ_impl_e9gm04($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).t8u.call(new AGBlending($this), new AGBlendEquation(rgb), new AGBlendEquation(a)).q8u_1;
  }
  return tmp;
}
function _AGBlending___get_enabled__impl__s7igz6($this) {
  return !($this === Companion_getInstance_45().z8k_1);
}
function AGBlending__toString_impl_d5hic6($this) {
  return 'Blending(outRGB = (srcRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcRGB__impl__jvh03e($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqRGB__impl__7pv8oi($this)) + ' (dstRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstRGB__impl__nz9ogp($this)) + '), outA = (srcA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcA__impl__ftmwxe($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqA__impl__2j4ray($this)) + ' (dstA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstA__impl__l7q6tv($this)) + '))';
}
var Companion_instance_37;
function Companion_getInstance_45() {
  if (Companion_instance_37 === VOID)
    new Companion_28();
  return Companion_instance_37;
}
function AGBlending__hashCode_impl_ywnf51($this) {
  return $this;
}
function AGBlending__equals_impl_rp3dmf($this, other) {
  if (!(other instanceof AGBlending))
    return false;
  if (!($this === (other instanceof AGBlending ? other.q8u_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_38;
function Companion_getInstance_46() {
  if (Companion_instance_38 === VOID)
    new Companion_29();
  return Companion_instance_38;
}
function _AGFrameBufferInfo___init__impl__dbxiro(dataLong) {
  return dataLong;
}
function _AGFrameBufferInfo___get_dataLong__impl__7vov5d($this) {
  return $this;
}
function _AGFrameBufferInfo___get_data__impl__7q146j($this) {
  return get_low(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___get_data2__impl__rgyo5b($this) {
  return get_high(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___init__impl__dbxiro_0(data, data2) {
  return _AGFrameBufferInfo___init__impl__dbxiro(fromLowHigh(Companion_getInstance_0(), data, data2));
}
function _AGFrameBufferInfo___get_width__impl__yhp94z($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_height__impl__yfespa($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_x__impl__6dzfjj($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_y__impl__mfn1io($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_size__impl__uw80y4($this) {
  return Companion_instance_49.y8v(_AGFrameBufferInfo___get_width__impl__yhp94z($this), _AGFrameBufferInfo___get_height__impl__yfespa($this));
}
function _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 28 | 0) & 1) === 0);
}
function _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 29 | 0) & 1) === 0);
}
function _get_samplesBits__rfaq0u($this) {
  // Inline function 'korlibs.memory.extract2' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 30 | 0) & 3;
}
function _AGFrameBufferInfo___get_samples__impl__7k555s($this) {
  return 1 << _get_samplesBits__rfaq0u($this);
}
function _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj($this) {
  return _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) && _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this);
}
function AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(_AGFrameBufferInfo___get_data__impl__7q146j($this), insert14(insert14(_AGFrameBufferInfo___get_data2__impl__rgyo5b($this), x, 0), y, 14));
}
function AGFrameBufferInfo__withSize_impl_sc5iep($this, width, height) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert14(insert14(_AGFrameBufferInfo___get_data__impl__7q146j($this), width, 0), height, 14), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withBounds_impl_sg0n3x($this, x, y, width, height) {
  return AGFrameBufferInfo__withSize_impl_sc5iep(AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y), width, height);
}
function AGFrameBufferInfo__withHasDepth_impl_fjgbiv($this, hasDepth) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasDepth, 28), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withHasStencil_impl_nbaemo($this, hasStencil) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasStencil, 29), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withSamples_impl_83818f($this, samples) {
  return withSamplesBits($this, ilog2(samples));
}
function withSamplesBits($this, bits) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert2(_AGFrameBufferInfo___get_data__impl__7q146j($this), bits, 30), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__toString_impl_xecyr8($this) {
  return 'AGFrameBufferInfo(width=' + _AGFrameBufferInfo___get_width__impl__yhp94z($this) + ', height=' + _AGFrameBufferInfo___get_height__impl__yfespa($this) + ', hasDepth=' + _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) + ', hasStencil=' + _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) + ', samples=' + _AGFrameBufferInfo___get_samples__impl__7k555s($this) + ')';
}
var Companion_instance_39;
function Companion_getInstance_47() {
  if (Companion_instance_39 === VOID)
    new Companion_30();
  return Companion_instance_39;
}
function AGFrameBufferInfo__hashCode_impl_fvl6f1($this) {
  return $this.hashCode();
}
var AGFinish_instance;
function AGFinish_getInstance() {
  return AGFinish_instance;
}
function _AGStencilReference___init__impl__rta8vg(data) {
  return data;
}
function _AGStencilReference___get_data__impl__j5p6bn($this) {
  return $this;
}
function _AGStencilReference___init__impl__rta8vg_0(front, back) {
  return _AGStencilReference___init__impl__rta8vg(fromLowHigh(Companion_getInstance_0(), front, back));
}
var Companion_instance_40;
function Companion_getInstance_48() {
  if (Companion_instance_40 === VOID)
    new Companion_31();
  return Companion_instance_40;
}
function _AGStencilReference___get_front__impl__6ggyy0($this) {
  return get_low(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_back__impl__mm7fqe($this) {
  return get_high(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskFront__impl__oc0s46($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 16 | 0) & 255;
}
function _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskBack__impl__mths73($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 16 | 0) & 255;
}
function AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), referenceValue, 0), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), referenceValueBack, 0));
}
function AGStencilReference__withReferenceValue$default_impl_2trj0v($this, referenceValue, referenceValueBack, $super) {
  referenceValueBack = referenceValueBack === VOID ? referenceValue : referenceValueBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).k8w.call(new AGStencilReference($this), referenceValue, referenceValueBack).j8w_1;
  }
  return tmp;
}
function AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), readMask, 8), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), readMaskBack, 8));
}
function AGStencilReference__withReadMask$default_impl_7mdffx($this, readMask, readMaskBack, $super) {
  readMaskBack = readMaskBack === VOID ? readMask : readMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).l8w.call(new AGStencilReference($this), readMask, readMaskBack).j8w_1;
  }
  return tmp;
}
function AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), writeMask, 16), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), writeMaskBack, 16));
}
function AGStencilReference__withWriteMask$default_impl_b7j7b4($this, writeMask, writeMaskBack, $super) {
  writeMaskBack = writeMaskBack === VOID ? writeMask : writeMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).m8w.call(new AGStencilReference($this), writeMask, writeMaskBack).j8w_1;
  }
  return tmp;
}
function AGStencilReference__toString_impl_qu5r8s($this) {
  return 'AGStencilReference(front=[referenceValue=' + _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) + ', readMask=' + _AGStencilReference___get_readMaskFront__impl__oc0s46($this) + ', writeMask=' + _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) + '], back=[referenceValue=' + _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) + ', readMask=' + _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) + ', writeMask=' + _AGStencilReference___get_writeMaskBack__impl__mths73($this) + '])';
}
function AGStencilReference__hashCode_impl_52zufx($this) {
  return $this.hashCode();
}
function AGStencilReference__equals_impl_kj05j($this, other) {
  if (!(other instanceof AGStencilReference))
    return false;
  var tmp0_other_with_cast = other instanceof AGStencilReference ? other.j8w_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function _AGStencilOpFunc___init__impl__t3f62q(data) {
  return data;
}
function _AGStencilOpFunc___get_data__impl__jitrg1($this) {
  return $this;
}
var Companion_instance_41;
function Companion_getInstance_49() {
  if (Companion_instance_41 === VOID)
    new Companion_32();
  return Companion_instance_41;
}
function _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 31 | 0) & 1) === 0);
}
function _AGStencilOpFunc___get_compareModeFront__impl__uctsey($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 0 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 3 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 6 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 9 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 12 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 15 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 18 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 21 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function AGStencilOpFunc__withEnabled_impl_mpcwmr($this, enabled) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert(_AGStencilOpFunc___get_data__impl__jitrg1($this), enabled, 31));
}
function AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGCompareMode___get_ordinal__impl__ikvlmz(compareMode), 0), _AGCompareMode___get_ordinal__impl__ikvlmz(compareModeBack), 12));
}
function AGStencilOpFunc__withCompareMode$default_impl_rzbauv($this, compareMode, compareModeBack, $super) {
  compareModeBack = compareModeBack === VOID ? compareMode : compareModeBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).e8x.call(new AGStencilOpFunc($this), new AGCompareMode(compareMode), new AGCompareMode(compareModeBack)).d8x_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPass), 3), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPassBack), 15));
}
function AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo($this, actionOnBothPass, actionOnBothPassBack, $super) {
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).f8x.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnBothPassBack)).d8x_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFail), 6), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFailBack), 18));
}
function AGStencilOpFunc__withActionOnDepthFail$default_impl_n96pyd($this, actionOnDepthFail, actionOnDepthFailBack, $super) {
  actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).g8x.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthFailBack)).d8x_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFail), 9), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFailBack), 21));
}
function AGStencilOpFunc__withActionOnDepthPassStencilFail$default_impl_4acstw($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack, $super) {
  actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).h8x.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnDepthPassStencilFailBack)).d8x_1;
  }
  return tmp;
}
function AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack) {
  return AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35(AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te(AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack), actionOnDepthFail, actionOnDepthFailBack), actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
}
function AGStencilOpFunc__withAction$default_impl_jx9cm1($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack, $super) {
  actionOnDepthFail = actionOnDepthFail === VOID ? actionOnBothPass : actionOnDepthFail;
  actionOnDepthPassStencilFail = actionOnDepthPassStencilFail === VOID ? actionOnDepthFail : actionOnDepthPassStencilFail;
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
  actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).i8x.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnBothPassBack), new AGStencilOp(actionOnDepthFailBack), new AGStencilOp(actionOnDepthPassStencilFailBack)).d8x_1;
  }
  return tmp;
}
function AGStencilOpFunc__toString_impl_pl8quy($this) {
  if (!_AGStencilOpFunc___get_enabled__impl__hxq8wy($this))
    return 'AGStencilOpFunc(enabled=false)';
  return 'AGStencilOpFunc(enabled=' + _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) + ', front=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeFront__impl__uctsey($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this)) + ']], back=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this)) + ']])';
}
function AGStencilOpFunc__hashCode_impl_nopebb($this) {
  return $this;
}
function AGStencilOpFunc__equals_impl_y44i4z($this, other) {
  if (!(other instanceof AGStencilOpFunc))
    return false;
  if (!($this === (other instanceof AGStencilOpFunc ? other.d8x_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGColorMask___init__impl__j38ai8(data) {
  return data;
}
function _AGColorMask___get_data__impl__swj1bz($this) {
  return $this;
}
function _AGColorMask___get_red__impl__opo1fo($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 0 | 0) & 1) === 0);
}
function _AGColorMask___get_green__impl__d3m1w2($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 1 | 0) & 1) === 0);
}
function _AGColorMask___get_blue__impl__42l0s1($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 2 | 0) & 1) === 0);
}
function _AGColorMask___get_alpha__impl__xmrqzb($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 3 | 0) & 1) === 0);
}
function _AGColorMask___init__impl__j38ai8_0(red, green, blue, alpha) {
  return _AGColorMask___init__impl__j38ai8(insert(insert(insert(insert(0, red, 0), green, 1), blue, 2), alpha, 3));
}
function _AGColorMask___init__impl__j38ai8_1(value) {
  value = value === VOID ? true : value;
  return _AGColorMask___init__impl__j38ai8_0(value, value, value, value);
}
function AGColorMask__toString_impl_5i5oqg($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.h();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.AGColorMask.toString.<anonymous>' call
  this_0.ic('AGColorMask(');
  this_0.ic(_AGColorMask___get_red__impl__opo1fo($this) ? 'R' : 'r');
  this_0.ic(_AGColorMask___get_green__impl__d3m1w2($this) ? 'G' : 'g');
  this_0.ic(_AGColorMask___get_blue__impl__42l0s1($this) ? 'B' : 'b');
  this_0.ic(_AGColorMask___get_alpha__impl__xmrqzb($this) ? 'A' : 'a');
  this_0.ic(')');
  return this_0.toString();
}
var Companion_instance_42;
function Companion_getInstance_50() {
  if (Companion_instance_42 === VOID)
    new Companion_33();
  return Companion_instance_42;
}
function AGColorMask__hashCode_impl_g9082f($this) {
  return $this;
}
function AGColorMask__equals_impl_mrih8l($this, other) {
  if (!(other instanceof AGColorMask))
    return false;
  if (!($this === (other instanceof AGColorMask ? other.j8x_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDepthAndFrontFace___init__impl__ra8x65(data) {
  return data;
}
function _AGDepthAndFrontFace___get_data__impl__v8zkce($this) {
  return $this;
}
var Companion_instance_43;
function Companion_getInstance_51() {
  if (Companion_instance_43 === VOID)
    new Companion_34();
  return Companion_instance_43;
}
function _AGDepthAndFrontFace___get_depthNear__impl__cir3a1($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 0, 12);
}
function _AGDepthAndFrontFace___get_depthFar__impl__g0cno8($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 12, 12);
}
function _AGDepthAndFrontFace___get_depthMask__impl__ouijn($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 24 | 0) & 1) === 0);
}
function _AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 26 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGDepthAndFrontFace___get_frontFace__impl__w07k4s($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 30 | 0) & 3;
  return _AGFrontFace___init__impl__vsm7rb(tmp$ret$0);
}
function AGDepthAndFrontFace__withDepth_impl_wsx82k($this, near, far) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insertScaledf01(insertScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), near, 0, 12), far, 12, 12));
}
function AGDepthAndFrontFace__withDepthMask_impl_610nhs($this, depthMask) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), depthMask, 24));
}
function AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs($this, depthFunc) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert3(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGCompareMode___get_ordinal__impl__ikvlmz(depthFunc), 26));
}
function AGDepthAndFrontFace__withFrontFace_impl_mwk87t($this, frontFace) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert2(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGFrontFace___get_ordinal__impl__d4iagj(frontFace), 30));
}
function AGDepthAndFrontFace__toString_impl_c305m3($this) {
  return 'AGDepthAndFrontFace(data=' + $this + ')';
}
function AGDepthAndFrontFace__hashCode_impl_xu62ey($this) {
  return $this;
}
function _AGCullFace___init__impl__ckmjdg(ordinal) {
  return ordinal;
}
function _AGCullFace___get_ordinal__impl__jd1wps($this) {
  return $this;
}
var Companion_instance_44;
function Companion_getInstance_52() {
  if (Companion_instance_44 === VOID)
    new Companion_35();
  return Companion_instance_44;
}
function AGCullFace__toString_impl_7d891w($this) {
  return $this === Companion_getInstance_52().y8l_1 ? 'NONE' : $this === Companion_getInstance_52().b8m_1 ? 'BOTH' : $this === Companion_getInstance_52().z8l_1 ? 'FRONT' : $this === Companion_getInstance_52().a8m_1 ? 'BACK' : '-';
}
function AGCullFace__hashCode_impl_t4e5ur($this) {
  return $this;
}
function AGCullFace__equals_impl_wgngjr($this, other) {
  if (!(other instanceof AGCullFace))
    return false;
  if (!($this === (other instanceof AGCullFace ? other.n8x_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGTextureTargetKind___init__impl__4zdmch(ordinal) {
  return ordinal;
}
function _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) {
  return $this;
}
function AGTextureTargetKind__toString_impl_68648p($this) {
  return $this === Companion_getInstance_53().i8q_1 ? 'TEXTURE_2D' : $this === Companion_getInstance_53().j8q_1 ? 'TEXTURE_3D' : $this === Companion_getInstance_53().k8q_1 ? 'TEXTURE_CUBE_MAP' : $this === Companion_getInstance_53().l8q_1 ? 'EXTERNAL_TEXTURE' : 'AGTextureTargetKind(' + _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) + ')';
}
function _AGTextureTargetKind___get_dims__impl__k3cmhd($this) {
  return $this === Companion_getInstance_53().i8q_1 ? 2 : $this === Companion_getInstance_53().j8q_1 ? 3 : $this === Companion_getInstance_53().k8q_1 ? 3 : $this === Companion_getInstance_53().l8q_1 ? 3 : 0;
}
var Companion_instance_45;
function Companion_getInstance_53() {
  if (Companion_instance_45 === VOID)
    new Companion_36();
  return Companion_instance_45;
}
function AGTextureTargetKind__hashCode_impl_rzc11k($this) {
  return $this;
}
function AGTextureTargetKind__equals_impl_q2tams($this, other) {
  if (!(other instanceof AGTextureTargetKind))
    return false;
  if (!($this === (other instanceof AGTextureTargetKind ? other.n8q_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGWrapMode___init__impl__x5wmya(ordinal) {
  return ordinal;
}
function _AGWrapMode___get_ordinal__impl__rc38w2($this) {
  return $this;
}
var Companion_instance_46;
function Companion_getInstance_54() {
  if (Companion_instance_46 === VOID)
    new Companion_37();
  return Companion_instance_46;
}
function AGWrapMode__toString_impl_8bjnw2($this) {
  return $this === Companion_getInstance_54().h8r_1 ? 'CLAMP_TO_EDGE' : $this === Companion_getInstance_54().i8r_1 ? 'REPEAT' : $this === Companion_getInstance_54().j8r_1 ? 'MIRRORED_REPEAT' : '<' + _AGWrapMode___get_ordinal__impl__rc38w2($this) + '>';
}
function AGWrapMode__hashCode_impl_u2pkox($this) {
  return $this;
}
function AGWrapMode__equals_impl_4aw0kl($this, other) {
  if (!(other instanceof AGWrapMode))
    return false;
  if (!($this === (other instanceof AGWrapMode ? other.j8y_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendFactor___init__impl__iqtmxr(ordinal) {
  return ordinal;
}
function _AGBlendFactor___get_ordinal__impl__r9efzn($this) {
  return $this;
}
var Companion_instance_47;
function Companion_getInstance_55() {
  if (Companion_instance_47 === VOID)
    new Companion_38();
  return Companion_instance_47;
}
function AGBlendFactor__toString_impl_1hr6m1($this) {
  return $this === Companion_getInstance_55().u8u_1 ? 'DESTINATION_ALPHA' : $this === Companion_getInstance_55().v8u_1 ? 'DESTINATION_COLOR' : $this === Companion_getInstance_55().w8u_1 ? 'ONE' : $this === Companion_getInstance_55().x8u_1 ? 'ONE_MINUS_DESTINATION_ALPHA' : $this === Companion_getInstance_55().y8u_1 ? 'ONE_MINUS_DESTINATION_COLOR' : $this === Companion_getInstance_55().z8u_1 ? 'ONE_MINUS_SOURCE_ALPHA' : $this === Companion_getInstance_55().a8v_1 ? 'ONE_MINUS_SOURCE_COLOR' : $this === Companion_getInstance_55().b8v_1 ? 'SOURCE_ALPHA' : $this === Companion_getInstance_55().c8v_1 ? 'SOURCE_COLOR' : $this === Companion_getInstance_55().d8v_1 ? 'ZERO' : '-';
}
function _AGBlendFactor___get_op__impl__b5pfnd($this) {
  var tmp;
  if ($this === Companion_getInstance_55().u8u_1) {
    tmp = 'dstA';
  } else if ($this === Companion_getInstance_55().v8u_1) {
    tmp = 'dstRGB';
  } else if ($this === Companion_getInstance_55().w8u_1) {
    tmp = '1';
  } else if ($this === Companion_getInstance_55().x8u_1) {
    tmp = '(1 - dstA)';
  } else if ($this === Companion_getInstance_55().y8u_1) {
    tmp = '(1 - dstRGB)';
  } else if ($this === Companion_getInstance_55().z8u_1) {
    tmp = '(1 - srcA)';
  } else if ($this === Companion_getInstance_55().a8v_1) {
    tmp = '(1 - srcRGB)';
  } else if ($this === Companion_getInstance_55().b8v_1) {
    tmp = 'srcA';
  } else if ($this === Companion_getInstance_55().c8v_1) {
    tmp = 'srcRGB';
  } else if ($this === Companion_getInstance_55().d8v_1) {
    tmp = '0';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendFactor__hashCode_impl_n8x3ew($this) {
  return $this;
}
function AGBlendFactor__equals_impl_dlauac($this, other) {
  if (!(other instanceof AGBlendFactor))
    return false;
  if (!($this === (other instanceof AGBlendFactor ? other.k8y_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendEquation___init__impl__fpv7c2(ordinal) {
  return ordinal;
}
function _AGBlendEquation___get_ordinal__impl__895p3q($this) {
  return $this;
}
var Companion_instance_48;
function Companion_getInstance_56() {
  if (Companion_instance_48 === VOID)
    new Companion_39();
  return Companion_instance_48;
}
function AGBlendEquation__toString_impl_5t2sx6($this) {
  return $this === Companion_getInstance_56().h8v_1 ? 'ADD' : $this === Companion_getInstance_56().i8v_1 ? 'SUBTRACT' : $this === Companion_getInstance_56().j8v_1 ? 'REVERSE_SUBTRACT' : '-';
}
function _AGBlendEquation___get_op__impl__7f9os6($this) {
  var tmp;
  if ($this === Companion_getInstance_56().h8v_1) {
    tmp = '+';
  } else if ($this === Companion_getInstance_56().i8v_1) {
    tmp = '-';
  } else if ($this === Companion_getInstance_56().j8v_1) {
    tmp = 'r-';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendEquation__hashCode_impl_fy33vp($this) {
  return $this;
}
function AGBlendEquation__equals_impl_yykk3b($this, other) {
  if (!(other instanceof AGBlendEquation))
    return false;
  if (!($this === (other instanceof AGBlendEquation ? other.l8y_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGSize___init__impl__h9blcq(data) {
  return data;
}
function AGSize__with_impl_qn6qww($this, width, height) {
  return _AGSize___init__impl__h9blcq(insert_0(insert_0(0, width, 0, 16), height, 16, 16));
}
var Companion_instance_49;
function Companion_getInstance_57() {
  return Companion_instance_49;
}
function _AGStencilOp___init__impl__llpkv6(ordinal) {
  return ordinal;
}
function _AGStencilOp___get_ordinal__impl__xkavfu($this) {
  return $this;
}
var Companion_instance_50;
function Companion_getInstance_58() {
  if (Companion_instance_50 === VOID)
    new Companion_41();
  return Companion_instance_50;
}
function AGStencilOp__toString_impl_1dm6fq($this) {
  return $this === Companion_getInstance_58().v8w_1 ? 'DECREMENT_SATURATE' : $this === Companion_getInstance_58().w8w_1 ? 'DECREMENT_WRAP' : $this === Companion_getInstance_58().x8w_1 ? 'INCREMENT_SATURATE' : $this === Companion_getInstance_58().y8w_1 ? 'INCREMENT_WRAP' : $this === Companion_getInstance_58().z8w_1 ? 'INVERT' : $this === Companion_getInstance_58().a8x_1 ? 'KEEP' : $this === Companion_getInstance_58().b8x_1 ? 'SET' : $this === Companion_getInstance_58().c8x_1 ? 'ZERO' : '-';
}
function AGStencilOp__hashCode_impl_n4s38l($this) {
  return $this;
}
function AGStencilOp__equals_impl_rq4p55($this, other) {
  if (!(other instanceof AGStencilOp))
    return false;
  if (!($this === (other instanceof AGStencilOp ? other.n8y_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGCompareMode___init__impl__j8kqbb(ordinal) {
  return ordinal;
}
function _AGCompareMode___get_ordinal__impl__ikvlmz($this) {
  return $this;
}
var Companion_instance_51;
function Companion_getInstance_59() {
  if (Companion_instance_51 === VOID)
    new Companion_42();
  return Companion_instance_51;
}
function AGCompareMode__toString_impl_gs33a9($this) {
  return $this === Companion_getInstance_59().n8w_1 ? 'ALWAYS' : $this === Companion_getInstance_59().o8w_1 ? 'EQUAL' : $this === Companion_getInstance_59().p8w_1 ? 'GREATER' : $this === Companion_getInstance_59().q8w_1 ? 'GREATER_EQUAL' : $this === Companion_getInstance_59().r8w_1 ? 'LESS' : $this === Companion_getInstance_59().s8w_1 ? 'LESS_EQUAL' : $this === Companion_getInstance_59().t8w_1 ? 'NEVER' : $this === Companion_getInstance_59().u8w_1 ? 'NOT_EQUAL' : '-';
}
function AGCompareMode__inverted_impl_7xxk8m($this) {
  return $this === Companion_getInstance_59().n8w_1 ? Companion_getInstance_59().t8w_1 : $this === Companion_getInstance_59().o8w_1 ? Companion_getInstance_59().u8w_1 : $this === Companion_getInstance_59().p8w_1 ? Companion_getInstance_59().s8w_1 : $this === Companion_getInstance_59().q8w_1 ? Companion_getInstance_59().r8w_1 : $this === Companion_getInstance_59().r8w_1 ? Companion_getInstance_59().q8w_1 : $this === Companion_getInstance_59().s8w_1 ? Companion_getInstance_59().p8w_1 : $this === Companion_getInstance_59().t8w_1 ? Companion_getInstance_59().n8w_1 : $this === Companion_getInstance_59().u8w_1 ? Companion_getInstance_59().o8w_1 : Companion_getInstance_59().t8w_1;
}
function AGCompareMode__hashCode_impl_whv1w0($this) {
  return $this;
}
function AGCompareMode__equals_impl_rbniy4($this, other) {
  if (!(other instanceof AGCompareMode))
    return false;
  if (!($this === (other instanceof AGCompareMode ? other.o8y_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGFrontFace___init__impl__vsm7rb(ordinal) {
  return ordinal;
}
function _AGFrontFace___get_ordinal__impl__d4iagj($this) {
  return $this;
}
var Companion_instance_52;
function Companion_getInstance_60() {
  if (Companion_instance_52 === VOID)
    new Companion_43();
  return Companion_instance_52;
}
function toAGScissor(_this__u8e3s4) {
  if (_this__u8e3s4 == null)
    return Companion_getInstance_46().w8l_1;
  return AGScissor.p8v(numberToInt(_this__u8e3s4.i2i_1), numberToInt(_this__u8e3s4.j2i_1), numberToInt(_this__u8e3s4.k2i_1), numberToInt(_this__u8e3s4.l2i_1));
}
function plus_5(_this__u8e3s4, scissor) {
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x(_this__u8e3s4, Vector2D.k2l(scissor.p2i(), scissor.r2i())), Vector2D.k2l(scissor.q2i(), scissor.s2i()));
}
function applyMatrixBounds(_this__u8e3s4, m) {
  var x0 = m.h2n(_this__u8e3s4.p2i(), _this__u8e3s4.r2i());
  var x1 = m.h2n(_this__u8e3s4.q2i(), _this__u8e3s4.r2i());
  var x2 = m.h2n(_this__u8e3s4.p2i(), _this__u8e3s4.s2i());
  var x3 = m.h2n(_this__u8e3s4.q2i(), _this__u8e3s4.s2i());
  var y0 = m.i2n(_this__u8e3s4.p2i(), _this__u8e3s4.r2i());
  var y1 = m.i2n(_this__u8e3s4.q2i(), _this__u8e3s4.r2i());
  var y2 = m.i2n(_this__u8e3s4.p2i(), _this__u8e3s4.s2i());
  var y3 = m.i2n(_this__u8e3s4.q2i(), _this__u8e3s4.s2i());
  return Companion_getInstance_46().h2t(numberToInt(min(x0, x1, x2, x3)), numberToInt(min(y0, y1, y2, y3)), numberToInt(max_0(x0, x1, x2, x3)), numberToInt(max_0(y0, y1, y2, y3)));
}
var AGBufferKind_INDEX_instance;
var AGBufferKind_VERTEX_instance;
var AGBufferKind_UNIFORM_instance;
var AGBufferKind_entriesInitialized;
function AGBufferKind_initEntries() {
  if (AGBufferKind_entriesInitialized)
    return Unit_instance;
  AGBufferKind_entriesInitialized = true;
  AGBufferKind_INDEX_instance = new AGBufferKind('INDEX', 0);
  AGBufferKind_VERTEX_instance = new AGBufferKind('VERTEX', 1);
  AGBufferKind_UNIFORM_instance = new AGBufferKind('UNIFORM', 2);
}
function AGBufferKind_INDEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_INDEX_instance;
}
function AGBufferKind_VERTEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_VERTEX_instance;
}
function AGBufferKind_UNIFORM_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_UNIFORM_instance;
}
var ProjViewUB_instance;
function ProjViewUB_getInstance() {
  if (ProjViewUB_instance === VOID)
    new ProjViewUB();
  return ProjViewUB_instance;
}
var DefaultShaders_instance;
function DefaultShaders_getInstance() {
  if (DefaultShaders_instance === VOID)
    new DefaultShaders();
  return DefaultShaders_instance;
}
function u_Tex$factory() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.p92();
  }, null);
}
function u_TexEx$factory() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.r92();
  }, null);
}
function u_Tex$factory_0() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.p92();
  }, null);
}
function u_TexEx$factory_0() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.r92();
  }, null);
}
function u_ProjMat$factory() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.q8z();
  }, null);
}
function u_ViewMat$factory() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.r8z();
  }, null);
}
function u_ProjMat$factory_0() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.q8z();
  }, null);
}
function u_ViewMat$factory_0() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.r8z();
  }, null);
}
function get_ENABLE_UNIFORM_BLOCKS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_UNIFORM_BLOCKS;
}
var ENABLE_UNIFORM_BLOCKS;
function get_ENABLE_VERTEX_ARRAY_OBJECTS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_VERTEX_ARRAY_OBJECTS;
}
var ENABLE_VERTEX_ARRAY_OBJECTS;
function set_gl(_this__u8e3s4, _set____db54di) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var this_0 = gl$delegate;
  var property = gl$factory();
  var value = this_0.t13_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.r13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_gl(_this__u8e3s4) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = gl$delegate;
    var property = gl$factory_0();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var gl$delegate;
function useProgram($this, program) {
  var gl = $this.p96_1;
  var map = $this.t96_1;
  if ($this.u96_1 == null) {
    $this.u96_1 = gl.z97(35724);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_39().n8j_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$0 = 'GL_VERSION=' + gl.z97(7938);
      this_0.v3g(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_39().n8j_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.u3g(level_0)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$2 = 'GL_SHADING_LANGUAGE_VERSION=' + $this.u96_1;
      this_1.v3g(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_39().n8j_1;
    var level_1 = Level_INFO_getInstance();
    var tmp_1;
    if (this_2.u3g(level_1)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$4 = 'GL_UNIFORM_BUFFER_OFFSET_ALIGNMENT=' + getInteger(gl, 35380);
      this_2.v3g(level_1, tmp$ret$4);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_3 = Companion_getInstance_39().n8j_1;
    var level_2 = Level_INFO_getInstance();
    var tmp_2;
    if (this_3.u3g(level_2)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$6 = 'gl.versionString=' + get_versionString(gl);
      this_3.v3g(level_2, tmp$ret$6);
      tmp_2 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_4 = Companion_getInstance_39().n8j_1;
    var level_3 = Level_INFO_getInstance();
    var tmp_3;
    if (this_4.u3g(level_3)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$8 = 'gl.versionInt=' + get_versionInt(gl);
      this_4.v3g(level_3, tmp$ret$8);
      tmp_3 = Unit_instance;
    }
  }
  // Inline function 'kotlin.collections.getOrPut' call
  var value = map.k3(program);
  var tmp_4;
  if (value == null) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_5 = new GLBaseProgram($this.s96_1, GLShaderCompiler_getInstance().c98(gl, $this.a98(), program, program.k8s_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>' call
    this_5.g98();
    var programInfo = this_5.f98_1;
    var programId = programInfo.h98_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = program.o8s_1.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
      var location = programInfo.c99(gl, element.x98_1);
      gl.d99(location, element.s8o_1);
    }
    if (programInfo.l98_1.k99()) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_6 = program.n8s_1;
      var n = 0;
      while (n < this_6.j1()) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = this_6.i1(_unary__edvuaz);
        var index = gl.e99(programId, it.w3());
        gl.f99(programId, index, it.i8t_1);
      }
    }
    var answer = this_5;
    map.r3(program, answer);
    tmp_4 = answer;
  } else {
    tmp_4 = value;
  }
  var nprogram = tmp_4;
  if (!equals($this.d97_1, nprogram)) {
    $this.d97_1 = nprogram;
    nprogram.g98();
  }
}
function resetObjects($this) {
  $this.w96_1 = null;
  $this.h97_1 = Companion_getInstance_46().v8l_1;
  $this.x96_1 = Companion_getInstance_45().y8k_1;
  $this.y96_1 = Companion_getInstance_52().x8l_1;
  $this.z96_1 = Companion_getInstance_49().j8l_1;
  $this.a97_1 = Companion_getInstance_48().h8l_1;
  $this.b97_1 = Companion_getInstance_50().l8l_1;
  $this.c97_1 = Companion_getInstance_51().r8l_1;
  $this.e97_1.o3();
  $this.d97_1 = null;
  $this.s97_1 = -1;
  $this.q97_1 = 0;
  $this.r97_1 = Companion_instance_49.m8y();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.n97_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.resetObjects.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    this_0[_unary__edvuaz].z33();
  }
}
function deletePendingObjects($this) {
  while (true) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = $this.s96_1.z99_1;
      this_0.w1w();
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this.s96_1.a9a_1.a1()) {
          // Inline function 'kotlin.also' call
          var this_1 = toList($this.s96_1.a9a_1);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>.<anonymous>' call
          $this.s96_1.a9a_1.o3();
          tmp = this_1;
        } else {
          return Unit_instance;
        }
        tmp$ret$3 = tmp;
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
    var n = 0;
    while (n < tmp$ret$3.j1()) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      tmp$ret$3.i1(_unary__edvuaz).d9a();
    }
  }
}
function bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated) {
  var gl = $this.p96_1;
  if (reallocated == null)
    null;
  else {
    reallocated.n3a(false);
  }
  if (updated == null)
    null;
  else {
    updated.n3a(false);
  }
  if (buffer == null) {
    gl.e9a(toGl_6(target), 0);
    return null;
  }
  var bufferInfo = _get_gl__ndc1ty(buffer, $this);
  if (!onlyUpdate) {
    gl.e9a(toGl_6(target), bufferInfo.h9a_1);
  }
  $this.k9a(buffer, AGOpengl$bindBuffer$lambda(buffer, bufferInfo, onlyUpdate, gl, target, reallocated, updated));
  return bufferInfo;
}
function bindBuffer$default($this, buffer, target, onlyUpdate, reallocated, updated, $super) {
  onlyUpdate = onlyUpdate === VOID ? false : onlyUpdate;
  reallocated = reallocated === VOID ? null : reallocated;
  updated = updated === VOID ? null : updated;
  return bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated);
}
function writeUniform($this, uniform, programInfo, data, source) {
  var gl = $this.p96_1;
  var location = programInfo.c99(gl, uniform.x98_1);
  var uniformType = uniform.b2n();
  var arrayCount = uniform.n9a_1;
  if (uniformType.u9a_1.v3_1 === 6) {
    switch (uniformType.v3_1) {
      case 1:
        gl.c9b(location, arrayCount, false, data);
        break;
      case 2:
        var inductionVariable = 0;
        if (inductionVariable < 3)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            arraycopy_0(data, imul(n, 16), $this.m97_1, imul(n, 12), 12);
          }
           while (inductionVariable < 3);
        gl.d9b(location, arrayCount, false, $this.m97_1);
        break;
      case 3:
        gl.e9b(location, arrayCount, false, data);
        break;
      default:
        switch (uniformType.v9a_1) {
          case 1:
            gl.f9b(location, arrayCount, data);
            break;
          case 2:
            gl.g9b(location, arrayCount, data);
            break;
          case 3:
            gl.h9b(location, arrayCount, data);
            break;
          case 4:
            gl.i9b(location, arrayCount, data);
            break;
        }

        break;
    }
  } else {
    switch (uniformType.v9a_1) {
      case 1:
        gl.y9a(location, arrayCount, data);
        break;
      case 2:
        gl.z9a(location, arrayCount, data);
        break;
      case 3:
        gl.a9b(location, arrayCount, data);
        break;
      case 4:
        gl.b9b(location, arrayCount, data);
        break;
    }
  }
}
function textureUnitParameters($this, implForcedTexTarget, wrap, minFilter, magFilter, dims) {
  var gl = $this.p96_1;
  var params = $this.n97_1[$this.q97_1];
  var glTarget = toGl_8(implForcedTexTarget);
  params.m99_1 = wrap;
  var glWrap = toGl_9(wrap);
  gl.j9b(glTarget, 10242, glWrap);
  gl.j9b(glTarget, 10243, glWrap);
  if (dims >= 3) {
    gl.j9b(glTarget, 32882, glWrap);
  }
  params.n99_1 = minFilter;
  params.o99_1 = magFilter;
  gl.j9b(glTarget, 10241, minFilter);
  gl.j9b(glTarget, 10240, magFilter);
}
function createBufferForBitmap($this, bmp) {
  var tmp;
  if (bmp == null) {
    tmp = null;
  } else {
    if (bmp instanceof NativeImage) {
      unsupported('Should not call createBufferForBitmap with a NativeImage');
    } else {
      if (bmp instanceof Bitmap8) {
        // Inline function 'kotlin.also' call
        var this_0 = Buffer.t10(bmp.x2u());
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
        arraycopy_3(bmp.n4z(), 0, get_i8(this_0), 0, bmp.x2u());
        tmp = this_0;
      } else {
        if (bmp instanceof FloatBitmap32) {
          // Inline function 'kotlin.also' call
          var this_1 = Buffer.t10(imul(imul(bmp.x2u(), 4), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          arraycopy_2(bmp.c53_1, 0, get_f32(this_1), 0, imul(bmp.x2u(), 4));
          tmp = this_1;
        } else {
          // Inline function 'kotlin.also' call
          var this_2 = Buffer.t10(imul(bmp.x2u(), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          var abmp = bmp.v4q() ? bmp.q4p().r4p() : bmp.q4p().g51();
          arraycopy_1(abmp.z4o_1, 0, get_i32(this_2), 0, abmp.x2u());
          tmp = this_2;
        }
      }
    }
  }
  return tmp;
}
function selectTextureUnit($this, index) {
  var old = $this.q97_1;
  if (!($this.q97_1 === index)) {
    $this.q97_1 = index;
    if (index >= 0) {
      $this.p96_1.k9b(33984 + index | 0);
    }
  }
  return old;
}
function _get_gl__ndc1ty(_this__u8e3s4, $this) {
  return gl(_this__u8e3s4, $this.s96_1);
}
function _get_gl__ndc1ty_0(_this__u8e3s4, $this) {
  return gl_0(_this__u8e3s4, $this.s96_1);
}
function _get_gl__ndc1ty_1(_this__u8e3s4, $this) {
  return gl_1(_this__u8e3s4, $this.s96_1);
}
function AGOpengl$glslConfig$delegate$lambda(this$0) {
  return function () {
    return new GlslConfig(this$0.p96_1.l9b(), this$0.p96_1);
  };
}
function AGOpengl$bindBuffer$lambda($buffer, $bufferInfo, $onlyUpdate, $gl, $target, $reallocated, $updated) {
  return function (it) {
    var tmp0_elvis_lhs = $buffer.q8n_1;
    var mem = tmp0_elvis_lhs == null ? Buffer.t10(0) : tmp0_elvis_lhs;
    $bufferInfo.m9b(mem.y10());
    var tmp;
    if ($onlyUpdate) {
      $gl.e9a(toGl_6($target), $bufferInfo.h9a_1);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($bufferInfo.i9a_1 < mem.y10()) {
      $bufferInfo.i9a_1 = mem.y10();
      $gl.o9b(toGl_6($target), mem.y10(), mem, 35048);
      var tmp109_safe_receiver = $reallocated;
      if (tmp109_safe_receiver == null)
        null;
      else {
        tmp109_safe_receiver.n3a(true);
      }
      tmp_0 = Unit_instance;
    } else {
      $gl.n9b(toGl_6($target), 0, mem.y10(), mem);
      tmp_0 = Unit_instance;
    }
    var tmp110_safe_receiver = $updated;
    if (tmp110_safe_receiver == null)
      null;
    else {
      tmp110_safe_receiver.n3a(true);
    }
    return Unit_instance;
  };
}
function AGOpengl$textureBind$lambda($tex, $target, $gl, this$0, $glTex) {
  return function (it) {
    var rbmp = $tex.b8q_1;
    var tmp127_safe_receiver = (rbmp == null ? true : rbmp instanceof MultiBitmap) ? rbmp : null;
    var tmp0_elvis_lhs = tmp127_safe_receiver == null ? null : tmp127_safe_receiver.c8r_1;
    var bmps = tmp0_elvis_lhs == null ? listOf(rbmp) : tmp0_elvis_lhs;
    var requestMipmaps = $tex.y8p_1;
    $tex.c8q_1 = $tex.e8r(rbmp, requestMipmaps);
    var totalSize = 0.0;
    var iterator = bmps.f1();
    var index = 0;
    while (iterator.g1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var bmp = iterator.h1();
      var isFloat = bmp instanceof FloatBitmap32;
      var tmp;
      if (bmp instanceof Bitmap8) {
        tmp = 6409;
      } else {
        tmp = 6408;
      }
      var type = tmp;
      var texTarget = $target === Companion_getInstance_53().k8q_1 ? 34069 + index_0 | 0 : toGl_8($target);
      var internalFormat = isFloat && (_GLVariant___get_isWebGL__impl__bbd1dd($gl.l9b()) && _GLVariant___get_version__impl__9nyfwa($gl.l9b()) >= 2) ? 34836 : type;
      var format = type;
      var texType = isFloat ? 5126 : 5121;
      if (_GLVariant___get_os__impl__aswhdw($gl.l9b()).lw()) {
        $gl.p9b(3313, 0);
        $gl.p9b(3312, 1);
      }
      if (bmp == null) {
        $gl.q9b(toGl_8($target), 0, type, $tex.j2y(), $tex.k2y(), 0, type, 5121, null);
      } else {
        if (bmp instanceof NativeImage) {
          if (!(bmp.x2u() === 0)) {
            $gl.r9b(texTarget, 0, type, type, 5121, bmp);
          }
        } else {
          if (bmp instanceof NullBitmap) {
            $gl.q9b(texTarget, 0, internalFormat, bmp.j2y(), bmp.k2y(), 0, format, texType, null);
          } else {
            var buffer = createBufferForBitmap(this$0, bmp);
            if (!(buffer == null) && !(bmp.j2y() === 0) && !(bmp.k2y() === 0) && !(get_size_0(buffer) === 0)) {
              $gl.q9b(texTarget, 0, internalFormat, bmp.j2y(), bmp.k2y(), 0, format, texType, buffer);
            }
          }
        }
      }
      totalSize = totalSize + imul(imul($tex.j2y(), $tex.k2y()), 4);
      if (_GLVariant___get_supportTextureLevel__impl__3yeu62($gl.l9b())) {
        var tmp_0;
        if ($tex.c8q_1) {
          var tmp1_elvis_lhs = $tex.z8p_1;
          tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        } else {
          tmp_0 = 0;
        }
        $gl.j9b(3553, 33084, tmp_0);
        var tmp_1;
        if ($tex.c8q_1) {
          var tmp2_elvis_lhs = $tex.a8q_1;
          tmp_1 = tmp2_elvis_lhs == null ? 1000 : tmp2_elvis_lhs;
        } else {
          tmp_1 = 0;
        }
        $gl.j9b(3553, 33085, tmp_1);
      }
      if ($tex.c8q_1) {
        $gl.s9b(texTarget);
      }
    }
    $glTex.m9b(totalSize);
    return Unit_instance;
  };
}
function gl$delegate$lambda($this$PropertyThis) {
  _init_properties_AGOpengl_kt__dtzqx7();
  return new GLVAO($this$PropertyThis);
}
function gl$factory() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function gl$factory_0() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function glslConfig$factory() {
  return getPropertyCallableRef('glslConfig', 1, KProperty1, function (receiver) {
    return receiver.a98();
  }, null);
}
var properties_initialized_AGOpengl_kt_5em8g9;
function _init_properties_AGOpengl_kt__dtzqx7() {
  if (!properties_initialized_AGOpengl_kt_5em8g9) {
    properties_initialized_AGOpengl_kt_5em8g9 = true;
    ENABLE_UNIFORM_BLOCKS = !(Companion_instance_1.bj('DISABLE_UNIFORM_BLOCKS') === 'true');
    ENABLE_VERTEX_ARRAY_OBJECTS = !(Companion_instance_1.bj('DISABLE_VERTEX_ARRAY_OBJECTS') === 'true');
    gl$delegate = new PropertyThis(VOID, gl$delegate$lambda);
  }
}
function fromGl(_this__u8e3s4, value) {
  var tmp;
  switch (value) {
    case 3553:
      tmp = Companion_getInstance_53().i8q_1;
      break;
    case 32879:
      tmp = Companion_getInstance_53().j8q_1;
      break;
    case 34067:
      tmp = Companion_getInstance_53().k8q_1;
      break;
    case 36197:
      tmp = Companion_getInstance_53().l8q_1;
      break;
    case 34069:
      tmp = Companion_getInstance_53().k8q_1;
      break;
    case 34070:
      tmp = Companion_getInstance_53().k8q_1;
      break;
    case 34071:
      tmp = Companion_getInstance_53().k8q_1;
      break;
    case 34072:
      tmp = Companion_getInstance_53().k8q_1;
      break;
    case 34073:
      tmp = Companion_getInstance_53().k8q_1;
      break;
    case 34074:
      tmp = Companion_getInstance_53().k8q_1;
      break;
    default:
      var reason = 'Unknown TextureTargetKind: ' + value;
      throw NotImplementedError.oe('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_56().h8v_1) {
    tmp = 32774;
  } else if (_this__u8e3s4 === Companion_getInstance_56().i8v_1) {
    tmp = 32778;
  } else if (_this__u8e3s4 === Companion_getInstance_56().j8v_1) {
    tmp = 32779;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_55().u8u_1) {
    tmp = 772;
  } else if (_this__u8e3s4 === Companion_getInstance_55().v8u_1) {
    tmp = 774;
  } else if (_this__u8e3s4 === Companion_getInstance_55().w8u_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_55().x8u_1) {
    tmp = 773;
  } else if (_this__u8e3s4 === Companion_getInstance_55().y8u_1) {
    tmp = 775;
  } else if (_this__u8e3s4 === Companion_getInstance_55().z8u_1) {
    tmp = 771;
  } else if (_this__u8e3s4 === Companion_getInstance_55().a8v_1) {
    tmp = 769;
  } else if (_this__u8e3s4 === Companion_getInstance_55().b8v_1) {
    tmp = 770;
  } else if (_this__u8e3s4 === Companion_getInstance_55().c8v_1) {
    tmp = 768;
  } else if (_this__u8e3s4 === Companion_getInstance_55().d8v_1) {
    tmp = 0;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_1(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_59().n8w_1) {
    tmp = 519;
  } else if (_this__u8e3s4 === Companion_getInstance_59().o8w_1) {
    tmp = 514;
  } else if (_this__u8e3s4 === Companion_getInstance_59().p8w_1) {
    tmp = 516;
  } else if (_this__u8e3s4 === Companion_getInstance_59().q8w_1) {
    tmp = 518;
  } else if (_this__u8e3s4 === Companion_getInstance_59().r8w_1) {
    tmp = 513;
  } else if (_this__u8e3s4 === Companion_getInstance_59().s8w_1) {
    tmp = 515;
  } else if (_this__u8e3s4 === Companion_getInstance_59().t8w_1) {
    tmp = 512;
  } else if (_this__u8e3s4 === Companion_getInstance_59().u8w_1) {
    tmp = 517;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_2(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_58().v8w_1 ? 7683 : _this__u8e3s4 === Companion_getInstance_58().w8w_1 ? 34056 : _this__u8e3s4 === Companion_getInstance_58().x8w_1 ? 7682 : _this__u8e3s4 === Companion_getInstance_58().y8w_1 ? 34055 : _this__u8e3s4 === Companion_getInstance_58().z8w_1 ? 5386 : _this__u8e3s4 === Companion_getInstance_58().a8x_1 ? 7680 : _this__u8e3s4 === Companion_getInstance_58().b8x_1 ? 7681 : _this__u8e3s4 === Companion_getInstance_58().c8x_1 ? 0 : 0;
}
function toGl_3(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_43().h8u_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_43().i8u_1) {
    tmp = 3;
  } else if (_this__u8e3s4 === Companion_getInstance_43().j8u_1) {
    tmp = 2;
  } else if (_this__u8e3s4 === Companion_getInstance_43().k8u_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_43().m8u_1) {
    tmp = 5;
  } else if (_this__u8e3s4 === Companion_getInstance_43().n8u_1) {
    tmp = 6;
  } else if (_this__u8e3s4 === Companion_getInstance_43().l8u_1) {
    tmp = 4;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_4(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_44().u8k_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_44().v8k_1) {
    tmp = 5121;
  } else if (_this__u8e3s4 === Companion_getInstance_44().w8k_1) {
    tmp = 5123;
  } else if (_this__u8e3s4 === Companion_getInstance_44().x8k_1) {
    tmp = 5125;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_5(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_52().b8m_1) {
    tmp = 1032;
  } else if (_this__u8e3s4 === Companion_getInstance_52().z8l_1) {
    tmp = 1028;
  } else if (_this__u8e3s4 === Companion_getInstance_52().a8m_1) {
    tmp = 1029;
  } else {
    var reason = 'Invalid AGCullFace(' + AGCullFace__toString_impl_7d891w(_this__u8e3s4) + ')';
    throw NotImplementedError.oe('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl_6(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.v3_1) {
    case 0:
      tmp = 34963;
      break;
    case 1:
      tmp = 34962;
      break;
    case 2:
      tmp = 35345;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_7(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.u9a_1.v3_1) {
    case 0:
      tmp = 35670;
      break;
    case 1:
      tmp = 5120;
      break;
    case 2:
      tmp = 5121;
      break;
    case 3:
      tmp = 5122;
      break;
    case 4:
      tmp = 5123;
      break;
    case 5:
      tmp = 5125;
      break;
    case 6:
      tmp = 5126;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_8(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_53().i8q_1 ? 3553 : _this__u8e3s4 === Companion_getInstance_53().j8q_1 ? 32879 : _this__u8e3s4 === Companion_getInstance_53().k8q_1 ? 34067 : _this__u8e3s4 === Companion_getInstance_53().l8q_1 ? 36197 : _AGTextureTargetKind___get_ordinal__impl__gjzc5p(_this__u8e3s4);
}
function toGl_9(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_54().h8r_1 ? 33071 : _this__u8e3s4 === Companion_getInstance_54().i8r_1 ? 10497 : _this__u8e3s4 === Companion_getInstance_54().j8r_1 ? 33648 : 33071;
}
function toGl_10(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_60().k8x_1) {
    tmp = 2305;
  } else if (_this__u8e3s4 === Companion_getInstance_60().m8x_1) {
    tmp = 2304;
  } else if (_this__u8e3s4 === Companion_getInstance_60().l8x_1) {
    tmp = 2305;
  } else {
    get_unreachable();
  }
  return tmp;
}
function gl(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda(state));
}
function gl_0(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_0(state, _this__u8e3s4));
}
function gl_1(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_1(state));
}
function createOnce(_this__u8e3s4, state, block) {
  if (_this__u8e3s4.w8n_1 == null || !(_this__u8e3s4.x8n_1 === state.s99_1.r8j_1)) {
    _this__u8e3s4.x8n_1 = state.s99_1.r8j_1;
    _this__u8e3s4.b8o();
    _this__u8e3s4.w8n_1 = block(_this__u8e3s4);
  }
  var tmp = _this__u8e3s4.w8n_1;
  return (!(tmp == null) ? isInterface(tmp, AGNativeObject) : false) ? tmp : THROW_CCE();
}
function gl$lambda($state) {
  return function (it) {
    return new GLBuffer($state);
  };
}
function gl$lambda_0($state, $this_gl) {
  return function (it) {
    return new GLFrameBuffer($state, $this_gl);
  };
}
function gl$lambda_1($state) {
  return function (it) {
    return new GLTexture($state);
  };
}
function get_versionString(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionString$delegate;
    var property = versionString$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionString$delegate;
function get_versionInt(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionInt$delegate;
    var property = versionInt$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionInt$delegate;
function createShader($this, gl, type, str, debugName) {
  var shaderId = gl.a9f(type);
  gl.b9f(shaderId, str);
  gl.c9f(shaderId);
  // Inline function 'korlibs.kgl.KmlGl.COMPILE_STATUS' call
  var out = getShaderiv(gl, shaderId, 35713);
  var errorInt = gl.d9f();
  // Inline function 'korlibs.kgl.KmlGl.GTRUE' call
  if (!(out === 1)) {
    var error = getShaderInfoLog(gl, shaderId);
    throw ShaderException.k96(str, error, errorInt, gl, debugName, type, out);
  }
  return shaderId;
}
var GLShaderCompiler_instance;
function GLShaderCompiler_getInstance() {
  if (GLShaderCompiler_instance === VOID)
    new GLShaderCompiler();
  return GLShaderCompiler_instance;
}
function versionString$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp;
  if (_GLVariant___get_isWebGL__impl__bbd1dd($this$PropertyThis.l9b())) {
    tmp = _GLVariant___get_version__impl__9nyfwa($this$PropertyThis.l9b()) === 1 ? '1.00' : '3.00';
  } else {
    // Inline function 'korlibs.kgl.KmlGl.SHADING_LANGUAGE_VERSION' call
    tmp = $this$PropertyThis.z97(35724);
  }
  return tmp;
}
function versionInt$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp146_safe_receiver = Regex.ni('(\\d+\\.\\d+)').pi(get_versionString($this$PropertyThis));
  var tmp147_safe_receiver = tmp146_safe_receiver == null ? null : tmp146_safe_receiver.b2();
  var tmp148_safe_receiver = tmp147_safe_receiver == null ? null : replace(tmp147_safe_receiver, '.', '');
  var tmp;
  if (tmp148_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp = toString(trim(isCharSequence(tmp148_safe_receiver) ? tmp148_safe_receiver : THROW_CCE()));
  }
  var tmp149_safe_receiver = tmp;
  var tmp0_elvis_lhs = tmp149_safe_receiver == null ? null : toIntOrNull(tmp149_safe_receiver);
  return tmp0_elvis_lhs == null ? 100 : tmp0_elvis_lhs;
}
function versionString$factory() {
  return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
    return get_versionString(receiver);
  }, null);
}
function versionInt$factory() {
  return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
    return get_versionInt(receiver);
  }, null);
}
var properties_initialized_GLShaderCompiler_kt_k11ei3;
function _init_properties_GLShaderCompiler_kt__3td561() {
  if (!properties_initialized_GLShaderCompiler_kt_k11ei3) {
    properties_initialized_GLShaderCompiler_kt_k11ei3 = true;
    versionString$delegate = new PropertyThis(VOID, versionString$delegate$lambda);
    versionInt$delegate = new PropertyThis(VOID, versionInt$delegate$lambda);
  }
}
var Kind_COMMAND_instance;
var Kind_DRAW_instance;
var Kind_DRAW_DETAILS_instance;
var Kind_CLEAR_instance;
var Kind_METRICS_instance;
var Kind_FLIP_instance;
var Kind_READ_instance;
var Kind_REPAINT_instance;
var Kind_DISPOSE_instance;
var Kind_TEXTURE_UPLOAD_instance;
var Kind_CLOSE_instance;
var Kind_FRAME_BUFFER_instance;
var Kind_BUFFER_instance;
var Kind_TEXTURE_instance;
var Kind_SHADER_instance;
var Kind_OTHER_instance;
var Kind_UNIFORM_instance;
var Kind_UNIFORM_VALUES_instance;
var Kind_SCISSORS_instance;
var Kind_VIEWPORT_instance;
var Kind_VERTEX_instance;
var Kind_ENABLE_DISABLE_instance;
var Kind_CONTEXT_LOST_instance;
var Kind_FLUSH_instance;
var Kind_entriesInitialized_0;
function Kind_initEntries_0() {
  if (Kind_entriesInitialized_0)
    return Unit_instance;
  Kind_entriesInitialized_0 = true;
  Kind_COMMAND_instance = new Kind_0('COMMAND', 0);
  Kind_DRAW_instance = new Kind_0('DRAW', 1);
  Kind_DRAW_DETAILS_instance = new Kind_0('DRAW_DETAILS', 2);
  Kind_CLEAR_instance = new Kind_0('CLEAR', 3);
  Kind_METRICS_instance = new Kind_0('METRICS', 4);
  Kind_FLIP_instance = new Kind_0('FLIP', 5);
  Kind_READ_instance = new Kind_0('READ', 6);
  Kind_REPAINT_instance = new Kind_0('REPAINT', 7);
  Kind_DISPOSE_instance = new Kind_0('DISPOSE', 8);
  Kind_TEXTURE_UPLOAD_instance = new Kind_0('TEXTURE_UPLOAD', 9);
  Kind_CLOSE_instance = new Kind_0('CLOSE', 10);
  Kind_FRAME_BUFFER_instance = new Kind_0('FRAME_BUFFER', 11);
  Kind_BUFFER_instance = new Kind_0('BUFFER', 12);
  Kind_TEXTURE_instance = new Kind_0('TEXTURE', 13);
  Kind_SHADER_instance = new Kind_0('SHADER', 14);
  Kind_OTHER_instance = new Kind_0('OTHER', 15);
  Kind_UNIFORM_instance = new Kind_0('UNIFORM', 16);
  Kind_UNIFORM_VALUES_instance = new Kind_0('UNIFORM_VALUES', 17);
  Kind_SCISSORS_instance = new Kind_0('SCISSORS', 18);
  Kind_VIEWPORT_instance = new Kind_0('VIEWPORT', 19);
  Kind_VERTEX_instance = new Kind_0('VERTEX', 20);
  Kind_ENABLE_DISABLE_instance = new Kind_0('ENABLE_DISABLE', 21);
  Kind_CONTEXT_LOST_instance = new Kind_0('CONTEXT_LOST', 22);
  Kind_FLUSH_instance = new Kind_0('FLUSH', 23);
}
function Kind_COMMAND_getInstance() {
  Kind_initEntries_0();
  return Kind_COMMAND_instance;
}
function Kind_FLIP_getInstance() {
  Kind_initEntries_0();
  return Kind_FLIP_instance;
}
var Companion_instance_53;
function Companion_getInstance_61() {
  if (Companion_instance_53 === VOID)
    new Companion_44();
  return Companion_instance_53;
}
function UniformBlock$Gen$uniform$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp0_elvis_lhs = this$0.h8z_1;
    var this_0 = TypedUniform.k9g(tmp0_elvis_lhs == null ? 'unknown' + this$0.g8z_1.v8z() : tmp0_elvis_lhs, this$0.i8z_1, this$0.j8z_1, this$0.g8z_1, this$0.k8z_1, this$0.l8z_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Gen.uniform$delegate.<anonymous>.<anonymous>' call
    this$0.g8z_1.k8t_1.f(this_0);
    return this_0;
  };
}
var Companion_instance_54;
function Companion_getInstance_62() {
  return Companion_instance_54;
}
function _get_bufferSize__mp12kq($this) {
  return $this.t8r_1.y10() / $this.r8r_1 | 0;
}
function align($this, size) {
  var tmp = $this;
  // Inline function 'kotlin.math.max' call
  var a = $this.p9g_1;
  tmp.p9g_1 = Math.max(a, size);
  while (!(($this.o9g_1 % size | 0) === 0)) {
    $this.o9g_1 = $this.o9g_1 + 1 | 0;
  }
  return $this;
}
function UBLayoutBuilder$size$delegate$lambda(this$0) {
  return function () {
    align(this$0, this$0.p9g_1);
    return this$0.o9g_1;
  };
}
function uniform$factory() {
  return getPropertyCallableRef('uniform', 1, KProperty1, function (receiver) {
    return receiver.l9g();
  }, null);
}
function size$factory() {
  return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
    return receiver.j1();
  }, null);
}
function _GLVariant___init__impl__cjzpjb(data) {
  return data;
}
function _GLVariant___get_data__impl__nn46ye($this) {
  return $this;
}
function _GLVariant___get_isES__impl__yezzg8($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 0 | 0) & 1) === 0);
}
function _GLVariant___get_isWebGL__impl__bbd1dd($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 1 | 0) & 1) === 0);
}
function _GLVariant___get_version__impl__9nyfwa($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_GLVariant___get_data__impl__nn46ye($this) >>> 8 | 0) & 255;
}
function _GLVariant___get_os__impl__aswhdw($this) {
  var tmp = Companion_getInstance_4().gw_1;
  // Inline function 'korlibs.memory.extract8' call
  var tmp$ret$0 = (_GLVariant___get_data__impl__nn46ye($this) >>> 16 | 0) & 255;
  var tmp0_elvis_lhs = getOrNull(tmp, tmp$ret$0);
  return tmp0_elvis_lhs == null ? Os_UNKNOWN_getInstance() : tmp0_elvis_lhs;
}
function _GLVariant___get_supportTextureLevel__impl__3yeu62($this) {
  return !_GLVariant___get_isWebGL__impl__bbd1dd($this) && !_GLVariant___get_isES__impl__yezzg8($this);
}
var Companion_instance_55;
function Companion_getInstance_63() {
  return Companion_instance_55;
}
function GLVariant__toString_impl_o5yi3l($this) {
  return 'GLVariant(data=' + $this + ')';
}
function GLVariant__hashCode_impl_2eslaq($this) {
  return $this;
}
function GLVariant__equals_impl_kmlw2($this, other) {
  if (!(other instanceof GLVariant))
    return false;
  if (!($this === (other instanceof GLVariant ? other.w9i_1 : THROW_CCE())))
    return false;
  return true;
}
function toNewGlslString(_this__u8e3s4, config) {
  return toNewGlslStringResult(_this__u8e3s4, config).a9j_1;
}
function toNewGlslStringResult(_this__u8e3s4, config) {
  return (new GlslGenerator(_this__u8e3s4.e9j_1, config)).s9j(_this__u8e3s4);
}
var Companion_instance_56;
function Companion_getInstance_64() {
  if (Companion_instance_56 === VOID)
    new Companion_47();
  return Companion_instance_56;
}
function GlslGenerator$generateResult$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp = a.x98_1;
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp$ret$1 = b.x98_1;
  return compareValues(tmp, tmp$ret$1);
}
function GlslGenerator$generateResult$lambda(this$0, $types, $allFuncs) {
  return function ($this$Indenter) {
    var tmp;
    if (!this$0.r9j_1.j99_1) {
      var suffix = _GLVariant___get_isES__impl__yezzg8(this$0.r9j_1.g99_1) ? ' es' : '';
      $this$Indenter.c3p('#version ' + this$0.r9j_1.i99_1 + suffix);
      tmp = Unit_instance;
    }
    var tmp_0;
    if (this$0.q9j_1.equals(ShaderType_FRAGMENT_getInstance())) {
      $this$Indenter.c3p('#extension GL_OES_standard_derivatives : enable');
      tmp_0 = Unit_instance;
    }
    $this$Indenter.c3p('#ifdef GL_ES');
    $this$Indenter.c3p('precision mediump float;');
    $this$Indenter.c3p('#endif');
    var _iterator__ex2g4s = $types.u9j_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var it = _iterator__ex2g4s.h1();
      var layout = this$0.r9j_1.z9l() && this$0.r9j_1.i99_1 >= 410 ? 'layout(location = ' + it.y90_1 + ') ' : '';
      $this$Indenter.c3p(layout + this$0.a9m() + ' ' + this$0.b9m(it.y98_1) + this$0.c9m(it.b2n()) + ' ' + it.x98_1 + this$0.d9m(it) + ';');
    }
    var _iterator__ex2g4s_0 = $types.z9j_1.f1();
    while (_iterator__ex2g4s_0.g1()) {
      var it_0 = _iterator__ex2g4s_0.h1();
      var layout_0 = this$0.r9j_1.z9l() ? '' : '';
      $this$Indenter.c3p(layout_0 + this$0.e9m() + ' ' + this$0.b9m(it_0.y98_1) + this$0.c9m(it_0.b2n()) + ' ' + it_0.x98_1 + this$0.d9m(it_0) + ';');
    }
    var tmp_1;
    if (this$0.r9j_1.k99()) {
      var _iterator__ex2g4s_1 = $types.y9j_1.f1();
      while (_iterator__ex2g4s_1.g1()) {
        var block = _iterator__ex2g4s_1.h1();
        $this$Indenter.c3p('layout(std140) uniform ' + block.w3() + ' {');
        var _iterator__ex2g4s_2 = block.s8z().f1();
        while (_iterator__ex2g4s_2.g1()) {
          var uniform = _iterator__ex2g4s_2.h1();
          $this$Indenter.c3p('  ' + this$0.b9m(uniform.y98_1) + this$0.c9m(uniform.b2n()) + ' ' + uniform.x98_1 + this$0.d9m(uniform) + ';');
        }
        $this$Indenter.c3p('};');
      }
      tmp_1 = Unit_instance;
    } else {
      var _iterator__ex2g4s_3 = $types.w9j_1.f1();
      while (_iterator__ex2g4s_3.g1()) {
        var it_1 = _iterator__ex2g4s_3.h1();
        $this$Indenter.c3p(this$0.e9m() + ' ' + this$0.b9m(it_1.y98_1) + this$0.c9m(it_1.b2n()) + ' ' + it_1.x98_1 + this$0.d9m(it_1) + ';');
      }
      tmp_1 = Unit_instance;
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = $types.v9j_1;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = GlslGenerator$generateResult$lambda$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_2);
    var iterator = sortedWith(this_0, tmp$ret$0).f1();
    var index = 0;
    $l$loop: while (iterator.g1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var it_2 = iterator.h1();
      if (it_2 instanceof Output)
        continue $l$loop;
      var INOUT = !this$0.r9j_1.z9l() ? this$0.f9m() : it_2.x98_1 === this$0.r9j_1.g9m() && this$0.q9j_1.equals(ShaderType_FRAGMENT_getInstance()) ? this$0.f9m() : this$0.q9j_1.equals(ShaderType_VERTEX_getInstance()) ? this$0.f9m() : this$0.a9m();
      $this$Indenter.c3p(INOUT + ' ' + this$0.b9m(it_2.y98_1) + this$0.c9m(it_2.b2n()) + ' ' + it_2.x98_1 + ';');
    }
    var _iterator__ex2g4s_4 = $allFuncs.f1();
    while (_iterator__ex2g4s_4.g1()) {
      var func = _iterator__ex2g4s_4.h1();
      var gen = new GlslBodyGenerator(this$0.q9j_1, this$0.r9j_1);
      gen.s9k(func);
      // Inline function 'kotlin.collections.map' call
      var this_1 = func.j9m_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$2 = this$0.c9m(item.jm_1) + ' ' + item.im_1;
        destination.f(tmp$ret$2);
      }
      var argsStrings = destination;
      // Inline function 'korlibs.io.util.Indenter.line' call
      var str = this$0.c9m(func.i9m_1) + ' ' + func.h9m_1 + '(' + joinToString(argsStrings, ', ') + ')';
      var tmp_3;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(str) === 0) {
        tmp_3 = '{';
      } else {
        tmp_3 = str + ' {';
      }
      $this$Indenter.c3p(tmp_3);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      $this$Indenter.d3p();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var _iterator__ex2g4s_5 = gen.p9m_1.f1();
        while (_iterator__ex2g4s_5.g1()) {
          var temp = _iterator__ex2g4s_5.h1();
          $this$Indenter.c3p(this$0.b9m(temp.y98_1) + this$0.c9m(temp.b2n()) + ' ' + temp.x98_1 + ';');
        }
        $this$Indenter.b3p(gen.q9m_1);
      }finally {
        $this$Indenter.e3p();
      }
      $this$Indenter.c3p('}');
    }
    return Unit_instance;
  };
}
var Companion_instance_57;
function Companion_getInstance_65() {
  if (Companion_instance_57 === VOID)
    new Companion_48();
  return Companion_instance_57;
}
function errorType($this, type) {
  invalidOp("Don't know how to serialize type " + type.toString());
}
function GlslBodyGenerator$visit$lambda(this$0) {
  return function (it) {
    return this$0.d9l(it);
  };
}
function GlslBodyGenerator$visit$lambda_0(this$0) {
  return function (it) {
    return this$0.d9l(it);
  };
}
function ProgramLayout$names$lambda(it) {
  return it.x98_1;
}
var Break_instance;
function Break_getInstance() {
  if (Break_instance === VOID)
    new Break();
  return Break_instance;
}
var Discard_instance;
function Discard_getInstance() {
  if (Discard_instance === VOID)
    new Discard();
  return Discard_instance;
}
var Companion_instance_58;
function Companion_getInstance_66() {
  if (Companion_instance_58 === VOID)
    new Companion_49();
  return Companion_instance_58;
}
function Program$Builder$FuncProvider$provideDelegate$lambda(this$0) {
  return function ($this$FUNC) {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.a9p_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.graphics.shader.FuncProvider.provideDelegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var tmp$ret$0 = $this$FUNC.g9p('p' + index_0, item);
      destination.f(tmp$ret$0);
    }
    var args = destination;
    this$0.c9p_1($this$FUNC, args);
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.i1(0));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_0($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.i1(0), it.i1(1));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_1($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.i1(0), it.i1(1), it.i1(2));
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda($block, $max) {
  return function ($this$ELSE) {
    $block($this$ELSE, $max);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0($ref, $middle, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.m93($ref, $middle + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_LIST$lambda($ref, $min, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.n93($ref, $min + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
var Output_instance;
function Output_getInstance() {
  if (Output_instance === VOID)
    Output.r9r();
  return Output_instance;
}
function Sampler_0(index, stype) {
  return new Provider(index, stype);
}
var SamplerVarType_Sampler1D_instance;
var SamplerVarType_Sampler2D_instance;
var SamplerVarType_Sampler3D_instance;
var SamplerVarType_SamplerCube_instance;
var SamplerVarType_entriesInitialized;
function SamplerVarType_initEntries() {
  if (SamplerVarType_entriesInitialized)
    return Unit_instance;
  SamplerVarType_entriesInitialized = true;
  SamplerVarType_Sampler1D_instance = new SamplerVarType('Sampler1D', 0, VarType_Sampler1D_getInstance());
  SamplerVarType_Sampler2D_instance = new SamplerVarType('Sampler2D', 1, VarType_Sampler2D_getInstance());
  SamplerVarType_Sampler3D_instance = new SamplerVarType('Sampler3D', 2, VarType_Sampler3D_getInstance());
  SamplerVarType_SamplerCube_instance = new SamplerVarType('SamplerCube', 3, VarType_SamplerCube_getInstance());
}
var VarType_TVOID_instance;
var VarType_Mat2_instance;
var VarType_Mat3_instance;
var VarType_Mat4_instance;
var VarType_Sampler1D_instance;
var VarType_Sampler2D_instance;
var VarType_Sampler3D_instance;
var VarType_SamplerCube_instance;
var VarType_Int1_instance;
var VarType_Float1_instance;
var VarType_Float2_instance;
var VarType_Float3_instance;
var VarType_Float4_instance;
var VarType_Short1_instance;
var VarType_Short2_instance;
var VarType_Short3_instance;
var VarType_Short4_instance;
var VarType_Bool1_instance;
var VarType_Bool2_instance;
var VarType_Bool3_instance;
var VarType_Bool4_instance;
var VarType_Byte4_instance;
var VarType_SByte1_instance;
var VarType_SByte2_instance;
var VarType_SByte3_instance;
var VarType_SByte4_instance;
var VarType_UByte1_instance;
var VarType_UByte2_instance;
var VarType_UByte3_instance;
var VarType_UByte4_instance;
var VarType_SShort1_instance;
var VarType_SShort2_instance;
var VarType_SShort3_instance;
var VarType_SShort4_instance;
var VarType_UShort1_instance;
var VarType_UShort2_instance;
var VarType_UShort3_instance;
var VarType_UShort4_instance;
var VarType_SInt1_instance;
var VarType_SInt2_instance;
var VarType_SInt3_instance;
var VarType_SInt4_instance;
var Companion_instance_59;
function Companion_getInstance_67() {
  return Companion_instance_59;
}
function values_8() {
  return [VarType_TVOID_getInstance(), VarType_Mat2_getInstance(), VarType_Mat3_getInstance(), VarType_Mat4_getInstance(), VarType_Sampler1D_getInstance(), VarType_Sampler2D_getInstance(), VarType_Sampler3D_getInstance(), VarType_SamplerCube_getInstance(), VarType_Int1_getInstance(), VarType_Float1_getInstance(), VarType_Float2_getInstance(), VarType_Float3_getInstance(), VarType_Float4_getInstance(), VarType_Short1_getInstance(), VarType_Short2_getInstance(), VarType_Short3_getInstance(), VarType_Short4_getInstance(), VarType_Bool1_getInstance(), VarType_Bool2_getInstance(), VarType_Bool3_getInstance(), VarType_Bool4_getInstance(), VarType_Byte4_getInstance(), VarType_SByte1_getInstance(), VarType_SByte2_getInstance(), VarType_SByte3_getInstance(), VarType_SByte4_getInstance(), VarType_UByte1_getInstance(), VarType_UByte2_getInstance(), VarType_UByte3_getInstance(), VarType_UByte4_getInstance(), VarType_SShort1_getInstance(), VarType_SShort2_getInstance(), VarType_SShort3_getInstance(), VarType_SShort4_getInstance(), VarType_UShort1_getInstance(), VarType_UShort2_getInstance(), VarType_UShort3_getInstance(), VarType_UShort4_getInstance(), VarType_SInt1_getInstance(), VarType_SInt2_getInstance(), VarType_SInt3_getInstance(), VarType_SInt4_getInstance()];
}
var VarType_entriesInitialized;
function VarType_initEntries() {
  if (VarType_entriesInitialized)
    return Unit_instance;
  VarType_entriesInitialized = true;
  VarType_TVOID_instance = new VarType('TVOID', 0, VarKind_TBYTE_getInstance(), 0);
  VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
  VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
  VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
  VarType_Sampler1D_instance = new VarType('Sampler1D', 4, VarKind_TINT_getInstance(), 1);
  VarType_Sampler2D_instance = new VarType('Sampler2D', 5, VarKind_TINT_getInstance(), 1);
  VarType_Sampler3D_instance = new VarType('Sampler3D', 6, VarKind_TINT_getInstance(), 1);
  VarType_SamplerCube_instance = new VarType('SamplerCube', 7, VarKind_TINT_getInstance(), 1);
  VarType_Int1_instance = new VarType('Int1', 8, VarKind_TINT_getInstance(), 1);
  VarType_Float1_instance = new VarType('Float1', 9, VarKind_TFLOAT_getInstance(), 1);
  VarType_Float2_instance = new VarType('Float2', 10, VarKind_TFLOAT_getInstance(), 2);
  VarType_Float3_instance = new VarType('Float3', 11, VarKind_TFLOAT_getInstance(), 3);
  VarType_Float4_instance = new VarType('Float4', 12, VarKind_TFLOAT_getInstance(), 4);
  VarType_Short1_instance = new VarType('Short1', 13, VarKind_TSHORT_getInstance(), 1);
  VarType_Short2_instance = new VarType('Short2', 14, VarKind_TSHORT_getInstance(), 2);
  VarType_Short3_instance = new VarType('Short3', 15, VarKind_TSHORT_getInstance(), 3);
  VarType_Short4_instance = new VarType('Short4', 16, VarKind_TSHORT_getInstance(), 4);
  VarType_Bool1_instance = new VarType('Bool1', 17, VarKind_TBOOL_getInstance(), 1);
  VarType_Bool2_instance = new VarType('Bool2', 18, VarKind_TBOOL_getInstance(), 2);
  VarType_Bool3_instance = new VarType('Bool3', 19, VarKind_TBOOL_getInstance(), 3);
  VarType_Bool4_instance = new VarType('Bool4', 20, VarKind_TBOOL_getInstance(), 4);
  VarType_Byte4_instance = new VarType('Byte4', 21, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SByte1_instance = new VarType('SByte1', 22, VarKind_TBYTE_getInstance(), 1);
  VarType_SByte2_instance = new VarType('SByte2', 23, VarKind_TBYTE_getInstance(), 2);
  VarType_SByte3_instance = new VarType('SByte3', 24, VarKind_TBYTE_getInstance(), 3);
  VarType_SByte4_instance = new VarType('SByte4', 25, VarKind_TBYTE_getInstance(), 4);
  VarType_UByte1_instance = new VarType('UByte1', 26, VarKind_TUNSIGNED_BYTE_getInstance(), 1);
  VarType_UByte2_instance = new VarType('UByte2', 27, VarKind_TUNSIGNED_BYTE_getInstance(), 2);
  VarType_UByte3_instance = new VarType('UByte3', 28, VarKind_TUNSIGNED_BYTE_getInstance(), 3);
  VarType_UByte4_instance = new VarType('UByte4', 29, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SShort1_instance = new VarType('SShort1', 30, VarKind_TSHORT_getInstance(), 1);
  VarType_SShort2_instance = new VarType('SShort2', 31, VarKind_TSHORT_getInstance(), 2);
  VarType_SShort3_instance = new VarType('SShort3', 32, VarKind_TSHORT_getInstance(), 3);
  VarType_SShort4_instance = new VarType('SShort4', 33, VarKind_TSHORT_getInstance(), 4);
  VarType_UShort1_instance = new VarType('UShort1', 34, VarKind_TUNSIGNED_SHORT_getInstance(), 1);
  VarType_UShort2_instance = new VarType('UShort2', 35, VarKind_TUNSIGNED_SHORT_getInstance(), 2);
  VarType_UShort3_instance = new VarType('UShort3', 36, VarKind_TUNSIGNED_SHORT_getInstance(), 3);
  VarType_UShort4_instance = new VarType('UShort4', 37, VarKind_TUNSIGNED_SHORT_getInstance(), 4);
  VarType_SInt1_instance = new VarType('SInt1', 38, VarKind_TINT_getInstance(), 1);
  VarType_SInt2_instance = new VarType('SInt2', 39, VarKind_TINT_getInstance(), 2);
  VarType_SInt3_instance = new VarType('SInt3', 40, VarKind_TINT_getInstance(), 3);
  VarType_SInt4_instance = new VarType('SInt4', 41, VarKind_TINT_getInstance(), 4);
}
var Precision_DEFAULT_instance;
var Precision_LOW_instance;
var Precision_MEDIUM_instance;
var Precision_HIGH_instance;
var Precision_entriesInitialized;
function Precision_initEntries() {
  if (Precision_entriesInitialized)
    return Unit_instance;
  Precision_entriesInitialized = true;
  Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
  Precision_LOW_instance = new Precision('LOW', 1);
  Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
  Precision_HIGH_instance = new Precision('HIGH', 3);
}
function FragmentShader(info) {
  return FragmentShader_0(info.im_1, info.jm_1);
}
var VarKind_TBOOL_instance;
var VarKind_TBYTE_instance;
var VarKind_TUNSIGNED_BYTE_instance;
var VarKind_TSHORT_instance;
var VarKind_TUNSIGNED_SHORT_instance;
var VarKind_TINT_instance;
var VarKind_TFLOAT_instance;
var VarKind_entriesInitialized;
function VarKind_initEntries() {
  if (VarKind_entriesInitialized)
    return Unit_instance;
  VarKind_entriesInitialized = true;
  VarKind_TBOOL_instance = new VarKind('TBOOL', 0, 1);
  VarKind_TBYTE_instance = new VarKind('TBYTE', 1, 1);
  VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 2, 1);
  VarKind_TSHORT_instance = new VarKind('TSHORT', 3, 2);
  VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 4, 2);
  VarKind_TINT_instance = new VarKind('TINT', 5, 4);
  VarKind_TFLOAT_instance = new VarKind('TFLOAT', 6, 4);
}
var ShaderType_VERTEX_instance;
var ShaderType_FRAGMENT_instance;
var ShaderType_entriesInitialized;
function ShaderType_initEntries() {
  if (ShaderType_entriesInitialized)
    return Unit_instance;
  ShaderType_entriesInitialized = true;
  ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
  ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
}
function VertexShader(info) {
  return VertexShader_0(info.im_1, info.jm_1);
}
function FragmentShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_FRAGMENT_getInstance(), stm, funcs);
}
function VertexShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_VERTEX_getInstance(), stm, funcs);
}
function SamplerVarType_Sampler2D_getInstance() {
  SamplerVarType_initEntries();
  return SamplerVarType_Sampler2D_instance;
}
function VarType_TVOID_getInstance() {
  VarType_initEntries();
  return VarType_TVOID_instance;
}
function VarType_Mat2_getInstance() {
  VarType_initEntries();
  return VarType_Mat2_instance;
}
function VarType_Mat3_getInstance() {
  VarType_initEntries();
  return VarType_Mat3_instance;
}
function VarType_Mat4_getInstance() {
  VarType_initEntries();
  return VarType_Mat4_instance;
}
function VarType_Sampler1D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler1D_instance;
}
function VarType_Sampler2D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler2D_instance;
}
function VarType_Sampler3D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler3D_instance;
}
function VarType_SamplerCube_getInstance() {
  VarType_initEntries();
  return VarType_SamplerCube_instance;
}
function VarType_Int1_getInstance() {
  VarType_initEntries();
  return VarType_Int1_instance;
}
function VarType_Float1_getInstance() {
  VarType_initEntries();
  return VarType_Float1_instance;
}
function VarType_Float2_getInstance() {
  VarType_initEntries();
  return VarType_Float2_instance;
}
function VarType_Float3_getInstance() {
  VarType_initEntries();
  return VarType_Float3_instance;
}
function VarType_Float4_getInstance() {
  VarType_initEntries();
  return VarType_Float4_instance;
}
function VarType_Short1_getInstance() {
  VarType_initEntries();
  return VarType_Short1_instance;
}
function VarType_Short2_getInstance() {
  VarType_initEntries();
  return VarType_Short2_instance;
}
function VarType_Short3_getInstance() {
  VarType_initEntries();
  return VarType_Short3_instance;
}
function VarType_Short4_getInstance() {
  VarType_initEntries();
  return VarType_Short4_instance;
}
function VarType_Bool1_getInstance() {
  VarType_initEntries();
  return VarType_Bool1_instance;
}
function VarType_Bool2_getInstance() {
  VarType_initEntries();
  return VarType_Bool2_instance;
}
function VarType_Bool3_getInstance() {
  VarType_initEntries();
  return VarType_Bool3_instance;
}
function VarType_Bool4_getInstance() {
  VarType_initEntries();
  return VarType_Bool4_instance;
}
function VarType_Byte4_getInstance() {
  VarType_initEntries();
  return VarType_Byte4_instance;
}
function VarType_SByte1_getInstance() {
  VarType_initEntries();
  return VarType_SByte1_instance;
}
function VarType_SByte2_getInstance() {
  VarType_initEntries();
  return VarType_SByte2_instance;
}
function VarType_SByte3_getInstance() {
  VarType_initEntries();
  return VarType_SByte3_instance;
}
function VarType_SByte4_getInstance() {
  VarType_initEntries();
  return VarType_SByte4_instance;
}
function VarType_UByte1_getInstance() {
  VarType_initEntries();
  return VarType_UByte1_instance;
}
function VarType_UByte2_getInstance() {
  VarType_initEntries();
  return VarType_UByte2_instance;
}
function VarType_UByte3_getInstance() {
  VarType_initEntries();
  return VarType_UByte3_instance;
}
function VarType_UByte4_getInstance() {
  VarType_initEntries();
  return VarType_UByte4_instance;
}
function VarType_SShort1_getInstance() {
  VarType_initEntries();
  return VarType_SShort1_instance;
}
function VarType_SShort2_getInstance() {
  VarType_initEntries();
  return VarType_SShort2_instance;
}
function VarType_SShort3_getInstance() {
  VarType_initEntries();
  return VarType_SShort3_instance;
}
function VarType_SShort4_getInstance() {
  VarType_initEntries();
  return VarType_SShort4_instance;
}
function VarType_UShort1_getInstance() {
  VarType_initEntries();
  return VarType_UShort1_instance;
}
function VarType_UShort2_getInstance() {
  VarType_initEntries();
  return VarType_UShort2_instance;
}
function VarType_UShort3_getInstance() {
  VarType_initEntries();
  return VarType_UShort3_instance;
}
function VarType_UShort4_getInstance() {
  VarType_initEntries();
  return VarType_UShort4_instance;
}
function VarType_SInt1_getInstance() {
  VarType_initEntries();
  return VarType_SInt1_instance;
}
function VarType_SInt2_getInstance() {
  VarType_initEntries();
  return VarType_SInt2_instance;
}
function VarType_SInt3_getInstance() {
  VarType_initEntries();
  return VarType_SInt3_instance;
}
function VarType_SInt4_getInstance() {
  VarType_initEntries();
  return VarType_SInt4_instance;
}
function Precision_DEFAULT_getInstance() {
  Precision_initEntries();
  return Precision_DEFAULT_instance;
}
function Precision_LOW_getInstance() {
  Precision_initEntries();
  return Precision_LOW_instance;
}
function Precision_MEDIUM_getInstance() {
  Precision_initEntries();
  return Precision_MEDIUM_instance;
}
function Precision_HIGH_getInstance() {
  Precision_initEntries();
  return Precision_HIGH_instance;
}
function VarKind_TBOOL_getInstance() {
  VarKind_initEntries();
  return VarKind_TBOOL_instance;
}
function VarKind_TBYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TBYTE_instance;
}
function VarKind_TUNSIGNED_BYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_BYTE_instance;
}
function VarKind_TSHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TSHORT_instance;
}
function VarKind_TUNSIGNED_SHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_SHORT_instance;
}
function VarKind_TINT_getInstance() {
  VarKind_initEntries();
  return VarKind_TINT_instance;
}
function VarKind_TFLOAT_getInstance() {
  VarKind_initEntries();
  return VarKind_TFLOAT_instance;
}
function ShaderType_VERTEX_getInstance() {
  ShaderType_initEntries();
  return ShaderType_VERTEX_instance;
}
function ShaderType_FRAGMENT_getInstance() {
  ShaderType_initEntries();
  return ShaderType_FRAGMENT_instance;
}
function toDisposable(_this__u8e3s4) {
  var tmp = toDisposable$lambda(_this__u8e3s4);
  return new sam$kotlinx_coroutines_DisposableHandle$0(tmp);
}
function toDisposable$lambda($this_toDisposable) {
  return function () {
    $this_toDisposable.u6();
    return Unit_instance;
  };
}
function putAsciiString(_this__u8e3s4, str) {
  var n = 0;
  var inductionVariable = 0;
  var last = str.length;
  while (inductionVariable < last) {
    var c = charSequenceGet(str, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_size_0(_this__u8e3s4) >= n) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      setInt8(_this__u8e3s4, _unary__edvuaz, tmp$ret$0);
    }
  }
  if (get_size_0(_this__u8e3s4) >= n) {
    var _unary__edvuaz_0 = n;
    n = _unary__edvuaz_0 + 1 | 0;
    setInt8(_this__u8e3s4, _unary__edvuaz_0, 0);
  }
  return _this__u8e3s4;
}
function toAsciiString(_this__u8e3s4) {
  var out = '';
  var inductionVariable = 0;
  var last = get_size_0(_this__u8e3s4);
  if (inductionVariable < last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = getInt8(_this__u8e3s4, n);
      if (b === 0)
        break $l$loop;
      out = out + toString_0(numberToChar(b));
    }
     while (inductionVariable < last);
  return out;
}
function KmlGl$ContextInfo$current$lambda() {
  return null;
}
var Companion_instance_60;
function Companion_getInstance_68() {
  return Companion_instance_60;
}
function KmlGl$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.h7j().f3('GL_OES_texture_float') || this$0.h7j().f3('GL_ARB_texture_float');
  };
}
function isFloatTextureSupported$factory() {
  return getPropertyCallableRef('isFloatTextureSupported', 1, KProperty1, function (receiver) {
    return receiver.t8k();
  }, null);
}
var logger;
var tempNBufferByte;
function get_tempNBuffer1() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return tempNBuffer1;
}
var tempNBuffer1;
var tempNBuffer4;
function getIntegerv(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getIntegerv.<anonymous>' call
  _this__u8e3s4.ca5(pname, it);
  return getInt32(it, 0);
}
function getInteger(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return getIntegerv(_this__u8e3s4, pname);
}
function genVertexArray(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genVertexArray.<anonymous>' call
  _this__u8e3s4.ga5(1, it);
  return getInt32(it, 0);
}
function getProgramiv(_this__u8e3s4, program, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getProgramiv.<anonymous>' call
  _this__u8e3s4.da5(program, type, it);
  return getInt32(it, 0);
}
function getShaderiv(_this__u8e3s4, shader, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getShaderiv.<anonymous>' call
  _this__u8e3s4.ea5(shader, type, it);
  return getInt32(it, 0);
}
function getShaderInfoLog(_this__u8e3s4, shader) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.getInfoLog' call
  // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
  var size = getShaderiv(_this__u8e3s4, shader, 35716);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>' call
  var sizev = allocDirect(Companion_instance_4, 4);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>.<anonymous>' call
  var mbuffer = allocDirect(Companion_instance_4, size);
  _this__u8e3s4.fa5(shader, size, sizev, mbuffer);
  return toAsciiString(mbuffer);
}
function genBuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genBuffer.<anonymous>' call
  _this__u8e3s4.ya4(1, it);
  return getInt32(it, 0);
}
function deleteBuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteBuffer.<anonymous>' call
  _this__u8e3s4.ua4(1, it);
  getInt32(it, 0);
}
function genTexture(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genTexture.<anonymous>' call
  _this__u8e3s4.ba5(1, it);
  return getInt32(it, 0);
}
function deleteTexture(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteTexture.<anonymous>' call
  _this__u8e3s4.xa4(1, it);
  getInt32(it, 0);
}
function genRenderbuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genRenderbuffer.<anonymous>' call
  _this__u8e3s4.aa5(1, it);
  return getInt32(it, 0);
}
function genFramebuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genFramebuffer.<anonymous>' call
  _this__u8e3s4.za4(1, it);
  return getInt32(it, 0);
}
function deleteRenderbuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteRenderbuffer.<anonymous>' call
  _this__u8e3s4.wa4(1, it);
  getInt32(it, 0);
}
function deleteFramebuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$19brt5v_w0wivk();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteFramebuffer.<anonymous>' call
  _this__u8e3s4.va4(1, it);
  getInt32(it, 0);
}
function _get_tempNBuffer1_$accessor$19brt5v_w0wivk() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return get_tempNBuffer1();
}
var properties_initialized_KmlGlExt_kt_yrhd4c;
function _init_properties_KmlGlExt_kt__r5nfv2() {
  if (!properties_initialized_KmlGlExt_kt_yrhd4c) {
    properties_initialized_KmlGlExt_kt_yrhd4c = true;
    logger = Companion_getInstance_2().ez('KmlGlException');
    tempNBufferByte = Buffer.t10(1, true);
    tempNBuffer1 = Buffer.t10(4, true);
    tempNBuffer4 = Buffer.t10(16, true);
  }
}
var KorgeReload_instance;
function KorgeReload_getInstance() {
  if (KorgeReload_instance === VOID)
    new KorgeReload();
  return KorgeReload_instance;
}
var Companion_instance_61;
function Companion_getInstance_69() {
  return Companion_instance_61;
}
function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_8().i2m_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().g4r_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_70().sa5_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
}
function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_8().i2m_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().g4r_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_70().sa5_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  var scale = textSize / _this__u8e3s4.b5m();
  var m2 = m.v2n(x, y).m2n(scale, scale);
  var dx = 0.0;
  var dy = 0.0;
  // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
  // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
  var this_0 = ctx.ka7_1;
  var this_1 = this_0.ta7_1;
  if (!(this_1.oa7_1 === this_0)) {
    this_1.oa7_1 = this_0;
    this_1.ya8();
  }
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  var tmp;
  if (inductionVariable <= last) {
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c1 = Char__toInt_impl_vasixd(charSequenceGet(str, n));
      if (c1 === 10) {
        dx = 0.0;
        dy = dy + _this__u8e3s4.b5m();
        continue $l$loop;
      }
      // Inline function 'kotlin.text.getOrElse' call
      var index = n + 1 | 0;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (0 <= index ? index <= (charSequenceLength(str) - 1 | 0) : false) {
        tmp_0 = charSequenceGet(str, index);
      } else {
        // Inline function 'korlibs.korge.bitmapfont.drawText.<anonymous>.<anonymous>' call
        tmp_0 = _Char___init__impl__6a9atx(32);
      }
      var tmp$ret$1 = tmp_0;
      var c2 = Char__toInt_impl_vasixd(tmp$ret$1);
      var glyph = _this__u8e3s4.i1(c1);
      var tex = glyph.f5k_1;
      var tmp199_tex = ctx.za8(tex);
      var tmp200_x = dx + glyph.g5k_1;
      var tmp201_y = dy + glyph.h5k_1;
      var tmp202_width = tex.o41_1;
      var tmp203_height = tex.p41_1;
      var tmp204_m = get_immutable(m2);
      this_0.aa9(tmp199_tex, tmp200_x, tmp201_y, tmp202_width, tmp203_height, tmp204_m, filtering, colMul, blendMode);
      var tmp205_safe_receiver = _this__u8e3s4.e5m().i1(Companion_instance_5.c5k(c1, c2));
      var tmp0_elvis_lhs = tmp205_safe_receiver == null ? null : tmp205_safe_receiver.x5l_1;
      var kerningOffset = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      dx = dx + (glyph.i5k_1 + kerningOffset | 0);
    }
     while (inductionVariable <= last);
    tmp = Unit_instance;
  }
}
var debugBmpFontOrNull;
function *_generator_debugBmpFont__zhh4ef($completion) {
  if (debugBmpFontOrNull == null) {
    var tmp = readBitmap(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    debugBmpFontOrNull = debugBmpFont_0(slice(tmp));
  }
  return ensureNotNull(debugBmpFontOrNull);
}
function debugBmpFont($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_debugBmpFont__zhh4ef($completion), $completion);
}
function debugBmpFont_0(tex) {
  var fntAdvance = 7.0;
  var fntWidth = 8.0;
  var fntHeight = 8.0;
  var fntBlockX = 2.0;
  var fntBlockY = 2.0;
  var fntBlockWidth = 12.0;
  var fntBlockHeight = 12.0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var base = fntHeight - 1.0;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = until(0, 256);
  var result = LinkedHashMap.wc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var tmp0_iterator = this_0.f1();
  while (tmp0_iterator.g1()) {
    var element = tmp0_iterator.h1();
    // Inline function 'korlibs.korge.bitmapfont.debugBmpFont.<anonymous>' call
    var x = element % 16 | 0;
    var y = element / 16 | 0;
    var tmp$ret$0 = new Glyph(fntHeight, element, tex.v42(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
    result.r3(element, tmp$ret$0);
  }
  var glyphs = toIntMap(result);
  var kernings = IntMap.t37();
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(base), glyphs, kernings, name, null);
}
function get_DEBUG_FONT_BYTES() {
  return fromBase64('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');
}
var Companion_instance_62;
function Companion_getInstance_70() {
  if (Companion_instance_62 === VOID)
    new Companion_53();
  return Companion_instance_62;
}
var Companion_instance_63;
function Companion_getInstance_71() {
  return Companion_instance_63;
}
function endFrameOldKeys($this, delta) {
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var prev = $this.haa_1[n];
      var curr = $this.gaa_1[n];
      $this.maa_1[n] = (prev && !curr);
      $this.laa_1[n] = (!prev && curr);
      if (curr) {
        var _array__4zh2yp = $this.iaa_1;
        _array__4zh2yp[n] = _array__4zh2yp[n] + _FastDuration___get_fastNanoseconds__impl__9kjwbr(delta);
      } else {
        $this.iaa_1[n] = 0.0;
        $this.jaa_1[n] = 0.0;
      }
      var triggerPress = false;
      var pressingTime = get_fastNanoseconds($this.iaa_1[n]);
      if ($this.iaa_1[n] > 0) {
        var tmp222_subject = _FastDuration___get_fastMilliseconds__impl__pe68va(pressingTime);
        var timeBarrier = (0.0 <= tmp222_subject ? tmp222_subject <= 1.0 : false) ? get_fastMilliseconds(0.0) : (1.0 <= tmp222_subject ? tmp222_subject <= 300.0 : false) ? get_fastMilliseconds(100.0) : (300.0 <= tmp222_subject ? tmp222_subject <= 1000.0 : false) ? get_fastMilliseconds(50.0) : get_fastMilliseconds(20.0);
        var elapsedTime = FastDuration__minus_impl_evs237(pressingTime, get_fastNanoseconds($this.jaa_1[n]));
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, timeBarrier) >= 0) {
          triggerPress = true;
        }
      }
      if (triggerPress) {
        $this.jaa_1[n] = $this.iaa_1[n];
      }
      $this.kaa_1[n] = triggerPress;
    }
     while (inductionVariable < 256);
  arraycopy_4($this.gaa_1, 0, $this.haa_1, 0, 256);
}
function Input$_isTouchDeviceGen$lambda() {
  return AGOpenglFactory_instance.paa();
}
var DefaultViewport_instance;
function DefaultViewport_getInstance() {
  if (DefaultViewport_instance === VOID)
    new DefaultViewport();
  return DefaultViewport_instance;
}
function *_generator_configureLoggerFromProperties__heiqlb(file, $completion) {
  try {
    var tmp = file.y22(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    configureLoggerFromProperties_0(tmp);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function configureLoggerFromProperties(file, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_configureLoggerFromProperties__heiqlb(file, $completion), $completion);
}
function configureLoggerFromProperties_0(str) {
  var props = Companion_instance_64.dab(str);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = props.z1().f1();
  while (_iterator__ex2g4s.g1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.h1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.a2();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.b2();
    try {
      var tmp = Companion_getInstance_2().ez(key);
      // Inline function 'kotlin.text.toUpperCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = value.toUpperCase();
      tmp.n3g(valueOf(tmp$ret$4));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
}
var Companion_instance_64;
function Companion_getInstance_72() {
  return Companion_instance_64;
}
function AgAutoFreeManager$entryPool$lambda(it) {
  it.z33();
  return Unit_instance;
}
function AgAutoFreeManager$entryPool$lambda_0(it) {
  return new Entry();
}
function getTextureInfo($this, bitmap) {
  if ($this.lac_1 === bitmap && ensureNotNull($this.mac_1).uab_1.yab_1 === bitmap.n4p_1)
    return ensureNotNull($this.mac_1);
  if ($this.nac_1 === bitmap && ensureNotNull($this.oac_1).uab_1.yab_1 === bitmap.n4p_1)
    return ensureNotNull($this.oac_1);
  $this.fac_1.e36(bitmap);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = $this.kac_1;
    var res = get_0(this_0, bitmap);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = $this.jac_1.g39();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>.<anonymous>' call
    var base = this_1.uab_1;
    base.yab_1 = -1;
    var tmp = base;
    var tmp_0;
    if (bitmap instanceof MultiBitmap) {
      tmp_0 = Companion_getInstance_53().k8q_1;
    } else {
      tmp_0 = Companion_getInstance_53().i8q_1;
    }
    tmp.wab_1 = new AGTexture(tmp_0);
    base.aac(bitmap.j2y());
    base.bac(bitmap.k2y());
    var out = this_1;
    set(this_0, bitmap, out);
    tmp$ret$0 = out;
  }
  var textureInfo = tmp$ret$0;
  $this.nac_1 = $this.lac_1;
  $this.oac_1 = $this.mac_1;
  var base_0 = textureInfo.uab_1;
  $this.lac_1 = bitmap;
  $this.mac_1 = textureInfo;
  if (!(bitmap.n4p_1 === base_0.yab_1)) {
    base_0.yab_1 = bitmap.n4p_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.Long.minus' call
    var this_2 = $this.iac_1;
    var other = textureInfo.tab_1;
    tmp_1.iac_1 = this_2.h2(toLong(other));
    try {
      base_0.uac(bitmap, bitmap.p4p_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
    }finally {
      textureInfo.tab_1 = _get_estimateSizeInBytes__tshb4c(bitmap, $this);
      var tmp_2 = $this;
      // Inline function 'kotlin.Long.plus' call
      var this_3 = $this.iac_1;
      var other_0 = textureInfo.tab_1;
      tmp_2.iac_1 = this_3.c4(toLong(other_0));
    }
    bitmap.a4r();
  }
  return textureInfo;
}
function _get_estimateSizeInBytes__tshb4c(_this__u8e3s4, $this) {
  return imul(_this__u8e3s4.k2y(), imul(_this__u8e3s4.j2y(), _this__u8e3s4.t4q()) / 8 | 0);
}
function _getTexture($this, slice) {
  if ($this.pac_1 === slice)
    return ensureNotNull($this.qac_1);
  if ($this.rac_1 === slice)
    return ensureNotNull($this.sac_1);
  var info = getTextureInfo($this, slice.o33());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = info.vab_1;
    var res = get_0(this_0, slice);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager._getTexture.<anonymous>' call
    var tmp;
    if (slice instanceof RectSlice) {
      tmp = Texture_1(info.uab_1).x42(RectangleInt.d2u(slice.p2i(), slice.r2i(), slice.o41_1, slice.p41_1));
    } else {
      tmp = Companion_instance_7.p43(info.uab_1, slice);
    }
    var out = tmp;
    set(this_0, slice, out);
    tmp$ret$0 = out;
  }
  var texture = tmp$ret$0;
  $this.rac_1 = $this.pac_1;
  $this.sac_1 = $this.qac_1;
  $this.pac_1 = slice;
  $this.qac_1 = texture;
  return texture;
}
function clearFastCacheAccess($this) {
  $this.lac_1 = null;
  $this.mac_1 = null;
  $this.nac_1 = null;
  $this.oac_1 = null;
  $this.pac_1 = null;
  $this.qac_1 = null;
  $this.rac_1 = null;
  $this.sac_1 = null;
}
function AgBitmapTextureManager$textureInfoPool$lambda(it) {
  it.z33();
  return Unit_instance;
}
function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
  return new BitmapTextureInfo();
}
function removeCache($this) {
}
function AgBufferManager$bufferPool$lambda(it) {
  return new AGBuffer();
}
function get_logger() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return logger_0;
}
var logger_0;
function get_BB_MAX_TEXTURES() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return BB_MAX_TEXTURES;
}
var BB_MAX_TEXTURES;
function BatchBuilder2D$Companion$createTextureLookup$lambda($$this$apply) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.f92($this$IF_ELSE_BINARY_LOOKUP.i92(), $this$IF_ELSE_BINARY_LOOKUP.q92(Companion_getInstance_73().pad_1[n], $this$IF_ELSE_BINARY_LOOKUP.o92($$this$apply.b92(), 'xy')));
    return Unit_instance;
  };
}
function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
  return 6;
}
function applyMatrix($this, matrix, idx, vcount) {
  var f32 = get_f32($this.ba8_1);
  var idx_0 = idx;
  var ma = matrix.n2m_1;
  var mb = matrix.o2m_1;
  var mc = matrix.p2m_1;
  var md = matrix.q2m_1;
  var mtx = matrix.r2m_1;
  var mty = matrix.s2m_1;
  var inductionVariable = 0;
  if (inductionVariable < vcount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = Vector2D.u2n(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
      var pt = Companion_getInstance_8().x2m(ma, mb, mc, md, mtx, mty, p);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, pt.i2h_1);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, pt.j2h_1);
      idx_0 = idx_0 + 6 | 0;
    }
     while (inductionVariable < vcount);
}
function checkAvailable($this, indices, vertices) {
  return ($this.ha8_1 + indices | 0) < $this.aa8_1 && ($this.ga8_1 + vertices | 0) < $this.za7_1;
}
var Companion_instance_65;
function Companion_getInstance_73() {
  if (Companion_instance_65 === VOID)
    new Companion_56();
  return Companion_instance_65;
}
function BatchBuilder2D$lambda(this$0) {
  return function (it) {
    var tmp;
    switch (it.v3_1) {
      case 0:
        this$0.gae();
        tmp = Unit_instance;
        break;
      case 1:
        this$0.hae();
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  };
}
function BatchBuilder2D$buffers$lambda(it) {
  return new BatchBuffers();
}
var properties_initialized_BatchBuilder2D_kt_532b2j;
function _init_properties_BatchBuilder2D_kt__vdn94j() {
  if (!properties_initialized_BatchBuilder2D_kt_532b2j) {
    properties_initialized_BatchBuilder2D_kt_532b2j = true;
    logger_0 = Companion_getInstance_2().ez('BatchBuilder2D');
    BB_MAX_TEXTURES = Companion_getInstance_3().lw() && Companion_getInstance_3().tw().wv_1 && Companion_getInstance_3().tw().bw() ? 1 : 4;
  }
}
function get_debugLineRenderContext(_this__u8e3s4) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = debugLineRenderContext$delegate;
    var property = debugLineRenderContext$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var debugLineRenderContext$delegate;
var Companion_instance_66;
function Companion_getInstance_74() {
  if (Companion_instance_66 === VOID)
    new Companion_57();
  return Companion_instance_66;
}
function addVertex($this, x, y, color, m) {
  setFloat32($this.eah_1, $this.hah_1 + 0 | 0, m.e2n(x, y));
  setFloat32($this.eah_1, $this.hah_1 + 1 | 0, m.f2n(x, y));
  setInt32($this.eah_1, $this.hah_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
  $this.hah_1 = $this.hah_1 + (Companion_getInstance_74().tag_1.e8u_1 / 4 | 0) | 0;
  $this.gah_1 = $this.gah_1 + 1 | 0;
}
function LineRenderBatcher$lambda(this$0) {
  return function (it) {
    this$0.fd();
    return Unit_instance;
  };
}
function debugLineRenderContext$delegate$lambda($this$PropertyThis) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  return new LineRenderBatcher($this$PropertyThis);
}
function debugLineRenderContext$factory() {
  return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
    return get_debugLineRenderContext(receiver);
  }, null);
}
var properties_initialized_LineRenderBatcher_kt_urwcod;
function _init_properties_LineRenderBatcher_kt__ezqewb() {
  if (!properties_initialized_LineRenderBatcher_kt_urwcod) {
    properties_initialized_LineRenderBatcher_kt_urwcod = true;
    debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
  }
}
var FlushKind_STATE_instance;
var FlushKind_FULL_instance;
var FlushKind_entriesInitialized;
function FlushKind_initEntries() {
  if (FlushKind_entriesInitialized)
    return Unit_instance;
  FlushKind_entriesInitialized = true;
  FlushKind_STATE_instance = new FlushKind('STATE', 0);
  FlushKind_FULL_instance = new FlushKind('FULL', 1);
}
function RenderContext$tempTexturePool$lambda(it) {
  return new AGTexture();
}
function RenderContext$projViewMatUB$delegate$lambda(this$0) {
  return function () {
    return this$0.y8r(ProjViewUB_getInstance());
  };
}
function RenderContext$dynamicVertexBufferPool$lambda(it) {
  return new AGBuffer();
}
function RenderContext$frameBuffers$lambda(it) {
  return AGFrameBuffer.g8k(VOID, it);
}
function FlushKind_STATE_getInstance() {
  FlushKind_initEntries();
  return FlushKind_STATE_instance;
}
function FlushKind_FULL_getInstance() {
  FlushKind_initEntries();
  return FlushKind_FULL_instance;
}
function projViewMatUB$factory() {
  return getPropertyCallableRef('projViewMatUB', 1, KProperty1, function (receiver) {
    return receiver.wah();
  }, null);
}
function get_logger_0() {
  _init_properties_RenderContext2D_kt__7o43tz();
  return logger_1;
}
var logger_1;
function RenderContext2D$mpool$lambda(it) {
  return new MMatrix();
}
var properties_initialized_RenderContext2D_kt_ica10b;
function _init_properties_RenderContext2D_kt__7o43tz() {
  if (!properties_initialized_RenderContext2D_kt_ica10b) {
    properties_initialized_RenderContext2D_kt_ica10b = true;
    logger_1 = Companion_getInstance_2().ez('RenderContext2D');
  }
}
function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
  $this$FUNC.s93($this$FUNC.n94(a, b, c));
  return Unit_instance;
}
function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.s93($this$FUNC.v9p(a, b));
  return Unit_instance;
}
function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.s93($this$FUNC.m94(a, b));
  return Unit_instance;
}
function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.s93($this$FUNC.m94(a, $this$FUNC.f95(b)));
  return Unit_instance;
}
function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.s93($this$FUNC.g95(d, r));
  return Unit_instance;
}
function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.s93($this$FUNC.g95($this$FUNC.h94(d), r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
  // Inline function 'korlibs.graphics.shader.Builder.IF' call
  var cond = $this$FUNC.r95(d, 0.0);
  var body = $this$FUNC.w92();
  // Inline function 'korlibs.korge.render.SDFShaders.opBorderInner$delegate.<anonymous>.<anonymous>' call
  body.s93(d);
  var stmIf = new If(cond, body.y92());
  // Inline function 'kotlin.collections.plusAssign' call
  $this$FUNC.e92_1.f(stmIf);
  var tmp = stmIf;
  $this$FUNC.l93(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
  return function ($this$ELSE) {
    $this$ELSE.s93($this$ELSE.g95($this$ELSE.h94($d), $r));
    return Unit_instance;
  };
}
function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
  $this$FUNC.s93($this$FUNC.h95(1.0, $this$FUNC.l94($this$FUNC.y9p($this$FUNC.u92(d, $this$FUNC.w9p(d)), 0.5), $this$FUNC.l92(0.0), $this$FUNC.l92(1.0))));
  return Unit_instance;
}
function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
  $this$FUNC.s93($this$FUNC.l94($this$FUNC.y9p($this$FUNC.u92(d, $this$FUNC.w9p(d)), 0.5), $this$FUNC.l92(0.0), $this$FUNC.l92(1.0)));
  return Unit_instance;
}
function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.h93($this$FUNC.w93());
  $this$FUNC.f92(h, $this$FUNC.l94($this$FUNC.x9p(0.5, $this$FUNC.u92($this$FUNC.z9p(0.5, $this$FUNC.g95(d2, d1)), k)), $this$FUNC.l92(0.0), $this$FUNC.l92(1.0)));
  $this$FUNC.s93($this$FUNC.g95($this$FUNC.n94(d2, d1, h), $this$FUNC.j92($this$FUNC.j92(k, h), $this$FUNC.h95(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.h93($this$FUNC.w93());
  $this$FUNC.f92(h, $this$FUNC.l94($this$FUNC.h95(0.5, $this$FUNC.u92($this$FUNC.z9p(0.5, $this$FUNC.i95(d2, d1)), k)), $this$FUNC.l92(0.0), $this$FUNC.l92(1.0)));
  $this$FUNC.s93($this$FUNC.i95($this$FUNC.n94(d2, $this$FUNC.f95(d1), h), $this$FUNC.j92($this$FUNC.j92(k, h), $this$FUNC.h95(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.h93($this$FUNC.w93());
  $this$FUNC.f92(h, $this$FUNC.l94($this$FUNC.h95(0.5, $this$FUNC.u92($this$FUNC.z9p(0.5, $this$FUNC.g95(d2, d1)), k)), $this$FUNC.l92(0.0), $this$FUNC.l92(1.0)));
  $this$FUNC.s93($this$FUNC.i95($this$FUNC.n94(d2, d1, h), $this$FUNC.j92($this$FUNC.j92(k, h), $this$FUNC.h95(1.0, h))));
  return Unit_instance;
}
function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
  $this$FUNC.s93($this$FUNC.g95($this$FUNC.p94(p), r));
  return Unit_instance;
}
function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
  var q = $this$FUNC.h93($this$FUNC.x93());
  $this$FUNC.f92($this$FUNC.o92(r, 'xy'), $this$FUNC.b94($this$FUNC.r95($this$FUNC.a95(p), 0.0), $this$FUNC.o92(r, 'xy'), $this$FUNC.o92(r, 'zw')));
  $this$FUNC.f92($this$FUNC.a95(r), $this$FUNC.b94($this$FUNC.r95($this$FUNC.b95(p), 0.0), $this$FUNC.a95(r), $this$FUNC.b95(r)));
  $this$FUNC.f92(q, $this$FUNC.i95($this$FUNC.g95($this$FUNC.h94(p), b), $this$FUNC.a95(r)));
  $this$FUNC.s93($this$FUNC.g95($this$FUNC.i95($this$FUNC.v9p($this$FUNC.m94($this$FUNC.a95(q), $this$FUNC.b95(q)), $this$FUNC.l92(0.0)), $this$FUNC.p94($this$FUNC.m94(q, $this$FUNC.l92(0.0)))), $this$FUNC.a95(r)));
  return Unit_instance;
}
function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
  var d = $this$FUNC.h93($this$FUNC.x93());
  $this$FUNC.f92(d, $this$FUNC.g95($this$FUNC.h94(p), b));
  $this$FUNC.s93($this$FUNC.i95($this$FUNC.p94($this$FUNC.m94(d, $this$FUNC.l92(0.0))), $this$FUNC.v9p($this$FUNC.m94($this$FUNC.a95(d), $this$FUNC.b95(d)), $this$FUNC.l92(0.0))));
  return Unit_instance;
}
function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
  $this$FUNC.s93($this$FUNC.i95(src, $this$FUNC.j92(dst, $this$FUNC.h95(1.0, $this$FUNC.s92(src)))));
  return Unit_instance;
}
var SDFShaders_instance;
function SDFShaders_getInstance() {
  if (SDFShaders_instance === VOID)
    SDFShaders.waj();
  return SDFShaders_instance;
}
function opInterpolate$factory() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.xaj();
  }, null);
}
function opUnion$factory() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.yaj();
  }, null);
}
function opIntersect$factory() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.zaj();
  }, null);
}
function opSubtract$factory() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.aak();
  }, null);
}
function opRound$factory() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.bak();
  }, null);
}
function opBorder$factory() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.cak();
  }, null);
}
function opBorderInner$factory() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.dak();
  }, null);
}
function opAA$factory() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.eak();
  }, null);
}
function opAARev$factory() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.fak();
  }, null);
}
function opSmoothUnion$factory() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.gak();
  }, null);
}
function opSmoothSubtraction$factory() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.hak();
  }, null);
}
function opSmoothIntersection$factory() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.iak();
  }, null);
}
function circle$factory() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.jak();
  }, null);
}
function roundedBox$factory() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.kak();
  }, null);
}
function box$factory() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.lak();
  }, null);
}
function opCombinePremultipliedColors$factory() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.mak();
  }, null);
}
function opInterpolate$factory_0() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.xaj();
  }, null);
}
function opUnion$factory_0() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.yaj();
  }, null);
}
function opIntersect$factory_0() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.zaj();
  }, null);
}
function opSubtract$factory_0() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.aak();
  }, null);
}
function opRound$factory_0() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.bak();
  }, null);
}
function opBorder$factory_0() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.cak();
  }, null);
}
function opBorderInner$factory_0() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.dak();
  }, null);
}
function opAA$factory_0() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.eak();
  }, null);
}
function opAARev$factory_0() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.fak();
  }, null);
}
function opSmoothUnion$factory_0() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.gak();
  }, null);
}
function opSmoothSubtraction$factory_0() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.hak();
  }, null);
}
function opSmoothIntersection$factory_0() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.iak();
  }, null);
}
function circle$factory_0() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.jak();
  }, null);
}
function roundedBox$factory_0() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.kak();
  }, null);
}
function box$factory_0() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.lak();
  }, null);
}
function opCombinePremultipliedColors$factory_0() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.mak();
  }, null);
}
function Texture(frameBuffer) {
  return Texture_0(frameBuffer.n8p(), frameBuffer.a8k_1, frameBuffer.b8k_1);
}
function Texture_0(agBase, width, height) {
  return new RectSlice(TextureBase.nak(agBase, SizeInt.c2v(width, height)), RectangleInt.d2u(0, 0, width, height));
}
function Texture_1(base, left, top, right, bottom) {
  left = left === VOID ? 0 : left;
  top = top === VOID ? 0 : top;
  right = right === VOID ? base.j2y() : right;
  bottom = bottom === VOID ? base.k2y() : bottom;
  return new RectSlice(base, Companion_instance_2.h2t(left, top, right, bottom));
}
function get_TEXTURED_ARRAY_QUAD_INDICES() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_QUAD_INDICES;
}
var TEXTURED_ARRAY_QUAD_INDICES;
var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
function get_TEXTURED_ARRAY_EMPTY_SHORT_ARRAY() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
}
var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
var Companion_instance_67;
function Companion_getInstance_75() {
  if (Companion_instance_67 === VOID)
    new Companion_58();
  return Companion_instance_67;
}
function TEXTURED_ARRAY_quadIndices(quadCount) {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  if (quadCount === 0)
    return get_TEXTURED_ARRAY_EMPTY_SHORT_ARRAY();
  var out = new Int16Array(imul(quadCount, 6));
  var m = 0;
  var base = 0;
  var inductionVariable = 0;
  if (inductionVariable < quadCount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = m;
      m = _unary__edvuaz + 1 | 0;
      out[_unary__edvuaz] = toShort(base + 0 | 0);
      var _unary__edvuaz_0 = m;
      m = _unary__edvuaz_0 + 1 | 0;
      out[_unary__edvuaz_0] = toShort(base + 1 | 0);
      var _unary__edvuaz_1 = m;
      m = _unary__edvuaz_1 + 1 | 0;
      out[_unary__edvuaz_1] = toShort(base + 2 | 0);
      var _unary__edvuaz_2 = m;
      m = _unary__edvuaz_2 + 1 | 0;
      out[_unary__edvuaz_2] = toShort(base + 3 | 0);
      var _unary__edvuaz_3 = m;
      m = _unary__edvuaz_3 + 1 | 0;
      out[_unary__edvuaz_3] = toShort(base + 0 | 0);
      var _unary__edvuaz_4 = m;
      m = _unary__edvuaz_4 + 1 | 0;
      out[_unary__edvuaz_4] = toShort(base + 2 | 0);
      base = base + 4 | 0;
    }
     while (inductionVariable < quadCount);
  return out;
}
var properties_initialized_TexturedVertexArray_kt_ouua70;
function _init_properties_TexturedVertexArray_kt__kev7cq() {
  if (!properties_initialized_TexturedVertexArray_kt_ouua70) {
    properties_initialized_TexturedVertexArray_kt_ouua70 = true;
    // Inline function 'kotlin.shortArrayOf' call
    TEXTURED_ARRAY_QUAD_INDICES = new Int16Array([0, 1, 2, 3, 0, 2]);
    TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
    TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
  }
}
function _get_root__dd8asp($this) {
  var tmp = $this.aal_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('root');
  }
}
function _get_mountable__707cy($this) {
  var tmp = $this.bal_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mountable');
  }
}
function V2Callback(init, callback) {
  var tmp;
  if (init === VOID) {
    tmp = V2Callback$lambda;
  } else {
    tmp = init;
  }
  init = tmp;
  var tmp_0 = dummy$factory(V2CallbackSupport_getInstance());
  return new V2(tmp_0, Unit_instance, Unit_instance, V2Callback$lambda_0(callback), true, VOID, VOID, init);
}
function _interpolate(ratio, l, r) {
  return interpolate(ratio, l, r);
}
function _interpolateColor(ratio, l, r) {
  return Companion_getInstance_13().t5j(l, r, ratio);
}
var V2CallbackSupport_instance;
function V2CallbackSupport_getInstance() {
  if (V2CallbackSupport_instance === VOID)
    new V2CallbackSupport();
  return V2CallbackSupport_instance;
}
function _interpolateRatio(ratio, l, r) {
  return interpolate_0(ratio, l, r);
}
function _interpolateDuration(ratio, l, r) {
  // Inline function 'korlibs.time.milliseconds' call
  var this_0 = _interpolate(ratio, get_milliseconds(l), get_milliseconds(r));
  return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
}
function _interpolateAngle(ratio, l, r) {
  return interpolateAngleNormalized(ratio, l, r);
}
function easing(_this__u8e3s4, easing) {
  return _this__u8e3s4.eam(VOID, VOID, VOID, easing$lambda(_this__u8e3s4, easing));
}
function incr(_this__u8e3s4, incr) {
  return new V2(_this__u8e3s4, 0.0, 0.0, incr$lambda(incr), false);
}
function _interpolateFloat(ratio, l, r) {
  return interpolate_1(ratio, l, r);
}
function V2Callback$lambda() {
  return Unit_instance;
}
function V2Callback$lambda_0($callback) {
  return function (ratio, _unused_var__etf5q3, _unused_var__etf5q3_0) {
    $callback(ratio);
    return Unit_instance;
  };
}
function easing$lambda($this_easing, $easing) {
  return function (ratio, a, b) {
    return $this_easing.ual_1(new Ratio(toRatio($easing.yz(Ratio__toDouble_impl_o7epze(ratio.e10_1)))), a, b);
  };
}
function incr$lambda($incr) {
  return function (it, start, _unused_var__etf5q3) {
    return interpolate(it.e10_1, start, start + $incr);
  };
}
function dummy$factory($b0) {
  return getPropertyCallableRef('dummy', 0, KMutableProperty0, function () {
    return Unit_instance;
  }, function (value) {
    $b0.fam_1 = value;
    return Unit_instance;
  });
}
var DEFAULT_instance;
function DEFAULT_getInstance() {
  return DEFAULT_instance;
}
var Unsupported_instance;
function Unsupported_getInstance() {
  return Unsupported_instance;
}
function alert_0(_this__u8e3s4, message, $completion) {
  return _this__u8e3s4.gam().ham(message, $completion);
}
function openFileDialog_0(_this__u8e3s4, filter, write, multi, currentDir, $completion) {
  filter = filter === VOID ? null : filter;
  write = write === VOID ? false : write;
  multi = multi === VOID ? false : multi;
  currentDir = currentDir === VOID ? null : currentDir;
  return _this__u8e3s4.gam().iam(filter, write, multi, currentDir, $completion);
}
var GLOBAL_CHECK_GL;
var Cursor_DEFAULT_instance;
var Cursor_CROSSHAIR_instance;
var Cursor_TEXT_instance;
var Cursor_HAND_instance;
var Cursor_MOVE_instance;
var Cursor_WAIT_instance;
var Cursor_RESIZE_EAST_instance;
var Cursor_RESIZE_WEST_instance;
var Cursor_RESIZE_SOUTH_instance;
var Cursor_RESIZE_NORTH_instance;
var Cursor_RESIZE_NORTH_EAST_instance;
var Cursor_RESIZE_NORTH_WEST_instance;
var Cursor_RESIZE_SOUTH_EAST_instance;
var Cursor_RESIZE_SOUTH_WEST_instance;
var Companion_instance_68;
function Companion_getInstance_76() {
  Cursor_initEntries();
  if (Companion_instance_68 === VOID)
    new Companion_59();
  return Companion_instance_68;
}
var Cursor_entriesInitialized;
function Cursor_initEntries() {
  if (Cursor_entriesInitialized)
    return Unit_instance;
  Cursor_entriesInitialized = true;
  Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
  Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
  Cursor_TEXT_instance = new Cursor('TEXT', 2);
  Cursor_HAND_instance = new Cursor('HAND', 3);
  Cursor_MOVE_instance = new Cursor('MOVE', 4);
  Cursor_WAIT_instance = new Cursor('WAIT', 5);
  Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
  Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
  Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
  Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
  Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
  Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
  Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
  Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
  Companion_getInstance_76();
}
function GameWindow$MenuItem$_init_$lambda_465oqx() {
  return Unit_instance;
}
var Quality_PERFORMANCE_instance;
var Quality_QUALITY_instance;
var Quality_AUTOMATIC_instance;
var Quality_entriesInitialized;
function Quality_initEntries() {
  if (Quality_entriesInitialized)
    return Unit_instance;
  Quality_entriesInitialized = true;
  Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0, 0.0);
  Quality_QUALITY_instance = new Quality('QUALITY', 1, 1.0);
  Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2, 0.5);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.qam_1($this.ram_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var CoroutineKey_instance;
function CoroutineKey_getInstance() {
  if (CoroutineKey_instance === VOID)
    new CoroutineKey();
  return CoroutineKey_instance;
}
function _get_fpsCached__581dty($this) {
  return $this.xan_1.ko($this, fpsCached$factory());
}
function *_generator_waitClose__fhnm35($this, $completion) {
  while ($this.mao_1) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    var tmp = delay_0(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_loop__qll5p8($this, entry, $completion) {
  var tmp = $this.qap($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  launchImmediately(tmp, GameWindow$loop$slambda_0(entry, $this));
  while ($this.mao_1) {
    var elapsed = $this.rap();
    var available = minus($this.sap(), elapsed);
    if (FastDuration__compareTo_impl_4fhnj7_0(available, Companion_getInstance().ik_1) > 0) {
      var tmp_0 = delay(available, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
    }
  }
  return Unit_instance;
}
function GameWindow$fpsCached$delegate$lambda(this$0) {
  return function () {
    return this$0.tap();
  };
}
function GameWindow$loop$slambda_0($entry, this$0) {
  var i = new GameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.pe($completion);
  };
  l.$arity = 0;
  return l;
}
function Cursor_DEFAULT_getInstance() {
  Cursor_initEntries();
  return Cursor_DEFAULT_instance;
}
function Cursor_TEXT_getInstance() {
  Cursor_initEntries();
  return Cursor_TEXT_instance;
}
function Cursor_HAND_getInstance() {
  Cursor_initEntries();
  return Cursor_HAND_instance;
}
function Cursor_RESIZE_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_EAST_instance;
}
function Cursor_RESIZE_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_WEST_instance;
}
function Cursor_RESIZE_SOUTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_instance;
}
function Cursor_RESIZE_NORTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_instance;
}
function Cursor_RESIZE_NORTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_EAST_instance;
}
function Cursor_RESIZE_NORTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_WEST_instance;
}
function Cursor_RESIZE_SOUTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_EAST_instance;
}
function Cursor_RESIZE_SOUTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_WEST_instance;
}
function Quality_PERFORMANCE_getInstance() {
  Quality_initEntries();
  return Quality_PERFORMANCE_instance;
}
function Quality_AUTOMATIC_getInstance() {
  Quality_initEntries();
  return Quality_AUTOMATIC_instance;
}
var Companion_instance_69;
function Companion_getInstance_77() {
  if (Companion_instance_69 === VOID)
    new Companion_60();
  return Companion_instance_69;
}
function configure(_this__u8e3s4, size, title, icon, fullscreen, bgcolor) {
  title = title === VOID ? 'GameWindow' : title;
  icon = icon === VOID ? null : icon;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  bgcolor = bgcolor === VOID ? Colors_getInstance().h4r_1 : bgcolor;
  _this__u8e3s4.iar(numberToInt(size.d2j_1), numberToInt(size.e2j_1));
  if (!(title == null)) {
    _this__u8e3s4.yaq(title);
  }
  _this__u8e3s4.zaq(icon);
  if (!(fullscreen == null)) {
    _this__u8e3s4.aar(fullscreen);
  }
  _this__u8e3s4.dar(bgcolor);
  _this__u8e3s4.car(true);
}
function toggleFullScreen(_this__u8e3s4) {
  _this__u8e3s4.aar(!_this__u8e3s4.bar());
}
function fpsCached$factory() {
  return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
    return _get_fpsCached__581dty(receiver);
  }, null);
}
function continuousRenderMode$factory() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.par();
  }, function (receiver, value) {
    return receiver.oar(value);
  });
}
function continuousRenderMode$factory_0() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.par();
  }, function (receiver, value) {
    return receiver.oar(value);
  });
}
var Companion_instance_70;
function Companion_getInstance_78() {
  if (Companion_instance_70 === VOID)
    new Companion_61();
  return Companion_instance_70;
}
function GameWindowCoroutineDispatcher$_init_$lambda_ooms1e() {
  return new FastDuration(PerformanceCounter_getInstance().k88());
}
function GameWindowCoroutineDispatcher$timedTasks$lambda(a, b) {
  return FastDuration__compareTo_impl_4fhnj7(a.qas_1, b.qas_1);
}
function GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda($task) {
  return function (it) {
    $task.tas_1 = it;
    return Unit_instance;
  };
}
function GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this$0, $task) {
  return function () {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this$0.gaq_1;
      this_0.w1w();
      try {
        this$0.faq_1.z34($task);
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$dispatch$lambda($block) {
  return function () {
    $block.p1a();
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda($cancelled) {
  return function (it) {
    $cancelled._v = it;
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($cancelled, $continuation) {
  return function () {
    var tmp;
    if (!($cancelled._v == null)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull($cancelled._v);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.id(tmp$ret$0);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      var this_1 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      this_1.id(tmp$ret$2);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.p1a();
    return Unit_instance;
  };
}
var Companion_instance_71;
function Companion_getInstance_79() {
  return Companion_instance_71;
}
var korgwJvmEngine;
var AGOpenglFactory_instance;
function AGOpenglFactory_getInstance() {
  return AGOpenglFactory_instance;
}
function get_korgwCanvasQuery() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.getValue' call
  var this_0 = korgwCanvasQuery$delegate;
  korgwCanvasQuery$factory();
  return this_0.b2();
}
var korgwCanvasQuery$delegate;
function jsObject(pairs) {
  _init_properties_GlExt_kt__oxmdm();
  var out = jsEmptyObject();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var k = _destruct__k2r9zo.km();
    var v = _destruct__k2r9zo.lm();
    if (!(v == null)) {
      out[k] = v;
    }
  }
  return out;
}
function jsEmptyObject() {
  _init_properties_GlExt_kt__oxmdm();
  return {};
}
function AGDefaultCanvas() {
  _init_properties_GlExt_kt__oxmdm();
  var tmp1_safe_receiver = get_korgwCanvasQuery();
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGDefaultCanvas.<anonymous>' call
    var tmp_0 = document.querySelector(tmp1_safe_receiver);
    tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    var tmp_2 = document.createElement('canvas');
    tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  return tmp_1;
}
function AGWebgl(config, canvas) {
  canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.also' call
  var this_0 = new AGOpengl(new KmlGlJsCanvas(canvas, jsObject([to('premultipliedAlpha', false), to('alpha', false), to('stencil', true), to('antialias', config.p8y_1)])));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.gl.AGWebgl.<anonymous>' call
  // Inline function 'kotlin.js.asDynamic' call
  window.ag = this_0;
  canvas.addEventListener('webglcontextlost', AGWebgl$lambda, false);
  canvas.addEventListener('webglcontextrestored', AGWebgl$lambda_0(this_0), false);
  return this_0;
}
function get_isCanvasCreatedAndHandled() {
  _init_properties_GlExt_kt__oxmdm();
  return get_korgwCanvasQuery() == null;
}
function korgwCanvasQuery$delegate$lambda() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return window.korgwCanvasQuery;
}
function AGWebgl$lambda(e) {
  _init_properties_GlExt_kt__oxmdm();
  e.preventDefault();
  return Unit_instance;
}
function AGWebgl$lambda_0($ag) {
  return function (e) {
    $ag.i8k();
    return Unit_instance;
  };
}
function korgwCanvasQuery$factory() {
  return getPropertyCallableRef('korgwCanvasQuery', 0, KProperty0, function () {
    return get_korgwCanvasQuery();
  }, null);
}
var properties_initialized_GlExt_kt_6pmiss;
function _init_properties_GlExt_kt__oxmdm() {
  if (!properties_initialized_GlExt_kt_6pmiss) {
    properties_initialized_GlExt_kt_6pmiss = true;
    korgwCanvasQuery$delegate = lazy(korgwCanvasQuery$delegate$lambda);
  }
}
function alloc(_this__u8e3s4, $this) {
  if (_this__u8e3s4 === null)
    return 0;
  // Inline function 'kotlin.js.asDynamic' call
  if (_this__u8e3s4.id === undefined) {
    if ($this.pat_1.a1()) {
      // Inline function 'kotlin.error' call
      var message = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
      throw IllegalStateException.m5(toString(message));
    }
    var index = $this.pat_1.q3($this.pat_1.j1() - 1 | 0);
    $this.oat_1[index] = _this__u8e3s4;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.id = index;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.id;
}
function get_3(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = $this.oat_1[_this__u8e3s4];
  } else {
    tmp = null;
  }
  return tmp;
}
function free(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = $this.oat_1[_this__u8e3s4];
    // Inline function 'kotlin.collections.plusAssign' call
    $this.pat_1.f(_this__u8e3s4);
    $this.oat_1[_this__u8e3s4] = null;
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function KmlGlJsCanvas$extensions$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.nat_1.getSupportedExtensions();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toSet_0(tmp);
  };
}
function KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.nat_1.getExtension('OES_texture_float_linear') != null || this$0.nat_1.getExtension('OES_texture_float') != null || this$0.mat_1 >= 2;
  };
}
function extensions$factory() {
  return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
    return receiver.h7j();
  }, null);
}
function isFloatTextureSupported$factory_0() {
  return getPropertyCallableRef('isFloatTextureSupported', 1, KProperty1, function (receiver) {
    return receiver.t8k();
  }, null);
}
function get_KorgeReloadInternal() {
  _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
  return KorgeReloadInternal;
}
var KorgeReloadInternal;
var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
  if (!properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
    properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
    KorgeReloadInternal = new KorgeReloadInternal$1();
  }
}
function CreateDefaultGameWindow(config) {
  return Companion_getInstance_3().zw() ? NodeJsGameWindow.oaz() : BrowserCanvasJsGameWindow.cax();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp23_safe_receiver = $this.bb2_1.zaw_1;
  if (tmp23_safe_receiver == null)
    null;
  else {
    var tmp = cancelAndJoin(tmp23_safe_receiver, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  window.close();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.cb2_1($this.db2_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onResized($this) {
  $this.qaw_1 = null;
  if (get_isCanvasCreatedAndHandled()) {
    var scale = $this.vah().pap(window.innerWidth, window.innerHeight, $this.rah());
    var canvasWidth = numberToInt(window.innerWidth * scale);
    var canvasHeight = numberToInt(window.innerHeight * scale);
    $this.naw_1.width = canvasWidth;
    $this.naw_1.height = canvasHeight;
    $this.naw_1.style.position = 'absolute';
    $this.naw_1.style.left = '0';
    $this.naw_1.style.right = '0';
    $this.naw_1.style.width = '' + window.innerWidth + 'px';
    $this.naw_1.style.height = '' + window.innerHeight + 'px';
    $this.vaw_1 = scale;
  } else {
    $this.vaw_1 = $this.naw_1.width / $this.naw_1.clientWidth;
  }
  $this.tar(0, 0, $this.naw_1.width, $this.naw_1.height);
}
function keyEvent($this, me) {
  var tmp;
  switch (me.key) {
    case '0':
      tmp = Key_N0_getInstance();
      break;
    case '1':
      tmp = Key_N1_getInstance();
      break;
    case '2':
      tmp = Key_N2_getInstance();
      break;
    case '3':
      tmp = Key_N3_getInstance();
      break;
    case '4':
      tmp = Key_N4_getInstance();
      break;
    case '5':
      tmp = Key_N5_getInstance();
      break;
    case '6':
      tmp = Key_N6_getInstance();
      break;
    case '7':
      tmp = Key_N7_getInstance();
      break;
    case '8':
      tmp = Key_N8_getInstance();
      break;
    case '9':
      tmp = Key_N9_getInstance();
      break;
    case 'a':
      tmp = Key_A_getInstance();
      break;
    case 'b':
      tmp = Key_B_getInstance();
      break;
    case 'c':
      tmp = Key_C_getInstance();
      break;
    case 'd':
      tmp = Key_D_getInstance();
      break;
    case 'e':
      tmp = Key_E_getInstance();
      break;
    case 'f':
      tmp = Key_F_getInstance();
      break;
    case 'g':
      tmp = Key_G_getInstance();
      break;
    case 'h':
      tmp = Key_H_getInstance();
      break;
    case 'i':
      tmp = Key_I_getInstance();
      break;
    case 'j':
      tmp = Key_J_getInstance();
      break;
    case 'k':
      tmp = Key_K_getInstance();
      break;
    case 'l':
      tmp = Key_L_getInstance();
      break;
    case 'm':
      tmp = Key_M_getInstance();
      break;
    case 'n':
      tmp = Key_N_getInstance();
      break;
    case 'o':
      tmp = Key_O_getInstance();
      break;
    case 'p':
      tmp = Key_P_getInstance();
      break;
    case 'q':
      tmp = Key_Q_getInstance();
      break;
    case 'r':
      tmp = Key_R_getInstance();
      break;
    case 's':
      tmp = Key_S_getInstance();
      break;
    case 't':
      tmp = Key_T_getInstance();
      break;
    case 'u':
      tmp = Key_U_getInstance();
      break;
    case 'v':
      tmp = Key_V_getInstance();
      break;
    case 'w':
      tmp = Key_W_getInstance();
      break;
    case 'x':
      tmp = Key_X_getInstance();
      break;
    case 'y':
      tmp = Key_Y_getInstance();
      break;
    case 'z':
      tmp = Key_Z_getInstance();
      break;
    case 'F1':
      tmp = Key_F1_getInstance();
      break;
    case 'F2':
      tmp = Key_F2_getInstance();
      break;
    case 'F3':
      tmp = Key_F3_getInstance();
      break;
    case 'F4':
      tmp = Key_F4_getInstance();
      break;
    case 'F5':
      tmp = Key_F5_getInstance();
      break;
    case 'F6':
      tmp = Key_F6_getInstance();
      break;
    case 'F7':
      tmp = Key_F7_getInstance();
      break;
    case 'F8':
      tmp = Key_F8_getInstance();
      break;
    case 'F9':
      tmp = Key_F9_getInstance();
      break;
    case 'F10':
      tmp = Key_F10_getInstance();
      break;
    case 'F11':
      tmp = Key_F11_getInstance();
      break;
    case 'F12':
      tmp = Key_F12_getInstance();
      break;
    case 'F13':
      tmp = Key_F13_getInstance();
      break;
    case 'F14':
      tmp = Key_F14_getInstance();
      break;
    case 'F15':
      tmp = Key_F15_getInstance();
      break;
    case 'F16':
      tmp = Key_F16_getInstance();
      break;
    case 'F17':
      tmp = Key_F17_getInstance();
      break;
    case 'F18':
      tmp = Key_F18_getInstance();
      break;
    case 'F19':
      tmp = Key_F19_getInstance();
      break;
    case 'F20':
      tmp = Key_F20_getInstance();
      break;
    case 'F21':
      tmp = Key_F21_getInstance();
      break;
    case 'F22':
      tmp = Key_F22_getInstance();
      break;
    case 'F23':
      tmp = Key_F23_getInstance();
      break;
    case 'F24':
      tmp = Key_F24_getInstance();
      break;
    case 'F25':
      tmp = Key_F25_getInstance();
      break;
    case '+':
      tmp = Key_PLUS_getInstance();
      break;
    case '-':
      tmp = Key_MINUS_getInstance();
      break;
    case "'":
      tmp = Key_APOSTROPHE_getInstance();
      break;
    case '"':
      tmp = Key_QUOTE_getInstance();
      break;
    default:
      var tmp_0;
      switch (me.code) {
        case 'MetaLeft':
          tmp_0 = Companion_getInstance_37().r8i();
          break;
        case 'MetaRight':
          tmp_0 = Companion_getInstance_37().s8i();
          break;
        case 'ShiftLeft':
          tmp_0 = Companion_getInstance_37().n8i();
          break;
        case 'ShiftRight':
          tmp_0 = Companion_getInstance_37().o8i();
          break;
        case 'ControlLeft':
          tmp_0 = Companion_getInstance_37().l8i();
          break;
        case 'ControlRight':
          tmp_0 = Companion_getInstance_37().m8i();
          break;
        case 'AltLeft':
          tmp_0 = Companion_getInstance_37().p8i();
          break;
        case 'AltRight':
          tmp_0 = Companion_getInstance_37().q8i();
          break;
        case 'Space':
          tmp_0 = Key_SPACE_getInstance();
          break;
        case 'ArrowUp':
          tmp_0 = Key_UP_getInstance();
          break;
        case 'ArrowDown':
          tmp_0 = Key_DOWN_getInstance();
          break;
        case 'ArrowLeft':
          tmp_0 = Key_LEFT_getInstance();
          break;
        case 'ArrowRight':
          tmp_0 = Key_RIGHT_getInstance();
          break;
        case 'PageUp':
          tmp_0 = Key_PAGE_UP_getInstance();
          break;
        case 'PageDown':
          tmp_0 = Key_PAGE_DOWN_getInstance();
          break;
        case 'Home':
          tmp_0 = Key_HOME_getInstance();
          break;
        case 'End':
          tmp_0 = Key_END_getInstance();
          break;
        case 'Enter':
          tmp_0 = Key_ENTER_getInstance();
          break;
        case 'Escape':
          tmp_0 = Key_ESCAPE_getInstance();
          break;
        case 'Backspace':
          tmp_0 = Key_BACKSPACE_getInstance();
          break;
        case 'Delete':
          tmp_0 = Key_DELETE_getInstance();
          break;
        case 'Insert':
          tmp_0 = Key_INSERT_getInstance();
          break;
        case 'Period':
          tmp_0 = Key_PERIOD_getInstance();
          break;
        case 'Comma':
          tmp_0 = Key_COMMA_getInstance();
          break;
        case 'Semicolon':
          tmp_0 = Key_SEMICOLON_getInstance();
          break;
        case 'Slash':
          tmp_0 = Key_SLASH_getInstance();
          break;
        case 'Tab':
          tmp_0 = Key_TAB_getInstance();
          break;
        default:
          // Inline function 'kotlin.js.asDynamic' call

          if (window.korgwShowUnsupportedKeys) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = CoroutineKey_getInstance().xam_1;
            var level = Level_INFO_getInstance();
            var tmp_1;
            if (this_0.u3g(level)) {
              // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.keyEvent.<anonymous>' call
              var tmp$ret$1 = 'Unsupported key key=' + me.key + ', code=' + me.code;
              this_0.v3g(level, tmp$ret$1);
              tmp_1 = Unit_instance;
            }
          }

          tmp_0 = Key_UNKNOWN_getInstance();
          break;
      }

      tmp = tmp_0;
      break;
  }
  var key = tmp;
  $this.v8a(invoke_0($this.tan_1, BrowserCanvasJsGameWindow$keyEvent$lambda(me, key)));
  if (key.equals(Key_TAB_getInstance()) || key.v8i()) {
    me.preventDefault();
  }
}
function touchEvent($this, e, type) {
  var canvasBounds = $this.naw_1.getBoundingClientRect();
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.event.TouchBuilder.frame' call
  var this_0 = $this.waw_1;
  this_0.y8f_1 = Mode_JS_getInstance();
  this_0.z8f(type, false);
  try {
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
    var inductionVariable = 0;
    var last = e.touches.length;
    if (inductionVariable < last)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = e.touches.item(n);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var touch = tmp;
        var touchId = touch.identifier;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
        var tmp_0 = (touch.clientX - canvasBounds.left) * $this.vaw_1;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
        var tmp$ret$1 = (touch.clientY - canvasBounds.top) * $this.vaw_1;
        var tmp_1 = Vector2D.u2n(tmp_0, tmp$ret$1);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_elvis_lhs = touch.force;
        this_0.c8g(touchId, tmp_1, tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs, Kind_FINGER_getInstance());
      }
       while (inductionVariable < last);
  }finally {
    this_0.a8g();
  }
  var this_1 = this_0.x8f_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
  $this.v8a(this_1);
}
function mouseEvent($this, e, type, pressingType) {
  var canvasBounds = $this.naw_1.getBoundingClientRect();
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
  var tmp$ret$0 = (e.clientX - canvasBounds.left) * $this.vaw_1;
  var tx = numberToInt(tmp$ret$0);
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
  var tmp$ret$1 = (e.clientY - canvasBounds.top) * $this.vaw_1;
  var ty = numberToInt(tmp$ret$1);
  invoke_0($this.uan_1, BrowserCanvasJsGameWindow$mouseEvent$lambda(e, pressingType, type, tx, ty));
  if (!$this.eb2() || type.equals(Type_SCROLL_getInstance())) {
    $this.v8a($this.uan_1);
  }
}
function mouseEvent$default($this, e, type, pressingType, $super) {
  pressingType = pressingType === VOID ? type : pressingType;
  return mouseEvent($this, e, type, pressingType);
}
function *_generator_loop__qll5p8_0($this, entry, $completion) {
  var tmp = $this;
  var tmp_0 = $this.qap($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.zaw_1 = launchImmediately(tmp_0, BrowserCanvasJsGameWindow$loop$slambda_0(entry, $this));
  _get_jsFrame__gugpar($this)(0.0);
  return Unit_instance;
}
function _get_jsFrame__gugpar($this) {
  var tmp = $this.aax_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('jsFrame');
  }
}
function ensureSoftKeyboardInput($this) {
  if ($this.bax_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.bax_1 = document.createElement('input');
    var tmp35_safe_receiver = $this.bax_1;
    if (tmp35_safe_receiver == null)
      null;
    else {
      tmp35_safe_receiver.id = 'softKeyboardInput';
    }
    var tmp36_safe_receiver = $this.bax_1;
    if (tmp36_safe_receiver == null)
      null;
    else {
      tmp36_safe_receiver.type = 'input';
    }
    var tmp37_safe_receiver = $this.bax_1;
    var tmp38_safe_receiver = tmp37_safe_receiver == null ? null : tmp37_safe_receiver.style;
    if (tmp38_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp38_safe_receiver.zIndex = '10000000';
      tmp38_safe_receiver.position = 'absolute';
      tmp38_safe_receiver.top = '0';
      tmp38_safe_receiver.left = '0';
      tmp38_safe_receiver.width = '200px';
      tmp38_safe_receiver.height = '24px';
      tmp38_safe_receiver.background = 'transparent';
    }
  }
}
function BrowserCanvasJsGameWindow$keyEvent$lambda($me, $key) {
  return function ($this$keyEvent) {
    var tmp = $this$keyEvent;
    var tmp_0;
    switch ($me.type) {
      case 'keydown':
        tmp_0 = Type_DOWN_getInstance();
        break;
      case 'keyup':
        tmp_0 = Type_UP_getInstance();
        break;
      case 'keypress':
        tmp_0 = Type_TYPE_getInstance();
        break;
      default:
        var message = 'Unsupported event type ' + $me.type;
        throw IllegalStateException.m5(toString(message));
    }
    tmp.d8c_1 = tmp_0;
    $this$keyEvent.e8c_1 = 0;
    $this$keyEvent.g8c_1 = $me.keyCode;
    $this$keyEvent.f8c_1 = $key;
    $this$keyEvent.i8c_1 = $me.shiftKey;
    $this$keyEvent.j8c_1 = $me.ctrlKey;
    $this$keyEvent.k8c_1 = $me.altKey;
    $this$keyEvent.l8c_1 = $me.metaKey;
    $this$keyEvent.h8c_1 = numberToChar($me.charCode);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$mouseEvent$lambda($e, $pressingType, $type, $tx, $ty) {
  return function ($this$mouseEvent) {
    $this$mouseEvent.x8c_1 = !($e.buttons === 0) ? $pressingType : $type;
    $this$mouseEvent.k8d_1 = false;
    $this$mouseEvent.y8c_1 = 0;
    $this$mouseEvent.z8c_1 = $tx;
    $this$mouseEvent.a8d_1 = $ty;
    $this$mouseEvent.b8d_1 = Companion_getInstance_38().i1($e.button);
    $this$mouseEvent.c8d_1 = $e.buttons;
    $this$mouseEvent.g8d_1 = $e.shiftKey;
    $this$mouseEvent.h8d_1 = $e.ctrlKey;
    $this$mouseEvent.i8d_1 = $e.altKey;
    $this$mouseEvent.j8d_1 = $e.metaKey;
    var tmp;
    if ($type.equals(Type_SCROLL_getInstance())) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var we = $e;
      var tmp18_subject = we.deltaMode;
      var mode = tmp18_subject === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp18_subject === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp18_subject === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
      var sensitivity = 0.05;
      $this$mouseEvent.s8d(mode, we.deltaX * sensitivity, we.deltaY * sensitivity, we.deltaZ * sensitivity);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$close$slambda_0(this$0) {
  var i = new BrowserCanvasJsGameWindow$close$slambda(this$0);
  var l = function ($completion) {
    return i.pe($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new BrowserCanvasJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.pe($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$lambda(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_SCROLL_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_0(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_ENTER_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_1(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_2(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_3(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_4(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_5(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_UP_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_6(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_DOWN_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_7(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_CLICK_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_8(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_START_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_9(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_MOVE_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_10(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_END_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_11(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_12(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_13(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_14(this$0) {
  return function (it) {
    onResized(this$0);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_15(this$0) {
  return function (it) {
    return this$0.yar(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_16(this$0) {
  return function (it) {
    return this$0.yar(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_17(this$0) {
  return function (it) {
    return this$0.yar(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_18(it) {
  it.preventDefault();
  return Unit_instance;
}
function BrowserCanvasJsGameWindow$lambda_19(this$0) {
  return function (it) {
    return this$0.yar(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_20(this$0) {
  return function (it) {
    return this$0.yar(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_21(this$0) {
  return function (it) {
    it.preventDefault();
    this$0.yar(Type_END_getInstance(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = until(0, items.length);
    var destination = ArrayList.m1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<anonymous>.<anonymous>' call
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp33_safe_receiver = items[element];
      var tmp34_safe_receiver = tmp33_safe_receiver == null ? null : tmp33_safe_receiver.getAsFile();
      var tmp0_safe_receiver = tmp34_safe_receiver == null ? null : toVfs(tmp34_safe_receiver);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.f(tmp0_safe_receiver);
      }
    }
    var files = destination;
    return this$0.yar(Type_DROP_getInstance(), files);
  };
}
function BrowserCanvasJsGameWindow$lambda_22(this$0) {
  return function (step) {
    window.requestAnimationFrame(_get_jsFrame__gugpar(this$0));
    this$0.rap();
    return Unit_instance;
  };
}
function DialogInterfaceJs$openFileDialog$lambda($input, $deferred) {
  return function (it) {
    var files = $input.files;
    var tmp;
    if (!(files == null)) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, files.length);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.render.DialogInterfaceJs.openFileDialog.<anonymous>.<anonymous>' call
        // Inline function 'org.w3c.files.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp45_safe_receiver = files[item];
        var tmp$ret$2 = tmp45_safe_receiver == null ? null : toVfs(tmp45_safe_receiver);
        destination.f(tmp$ret$2);
      }
      tmp = $deferred.m1b(filterNotNull(destination));
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$5 = emptyList();
      tmp = $deferred.m1b(tmp$ret$5);
    }
    return tmp;
  };
}
function DialogInterfaceJs$openFileDialog$lambda_0(it) {
  return Unit_instance;
}
function DialogInterfaceJs$openFileDialog$lambda_1($input) {
  return function () {
    var tmp47_safe_receiver = document.body;
    return tmp47_safe_receiver == null ? null : tmp47_safe_receiver.removeChild($input);
  };
}
//region block: post-declaration
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, AutoCloseable]);
initMetadataForClass(BaseEventLoop, 'BaseEventLoop', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncEventLoop, 'SyncEventLoop', SyncEventLoop);
protoOf(Listener).iu = cancel;
initMetadataForClass(Listener, 'Listener', VOID, VOID, [CloseableCancellable]);
initMetadataForClass(ListenerNode, 'ListenerNode');
initMetadataForInterface(EventListener, 'EventListener');
protoOf(BaseEventListener).u8a = dispatch$default;
protoOf(BaseEventListener).w8a = onEvents;
protoOf(BaseEventListener).x8a = dispatchDown;
protoOf(BaseEventListener).y8a = dispatchUp;
initMetadataForClass(BaseEventListener, 'BaseEventListener', BaseEventListener.i8a, VOID, [EventListener]);
initMetadataForClass(EventResult, 'EventResult', EventResult);
initMetadataForCompanion(Companion);
initMetadataForClass(Event, 'Event');
initMetadataForClass(TypedEvent, 'TypedEvent');
initMetadataForClass(PauseEvent, 'PauseEvent', PauseEvent);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ResumeEvent, 'ResumeEvent', ResumeEvent);
initMetadataForCompanion(Companion_1);
initMetadataForClass(StopEvent, 'StopEvent', StopEvent);
initMetadataForCompanion(Companion_2);
initMetadataForClass(DestroyEvent, 'DestroyEvent', DestroyEvent);
initMetadataForClass(RenderEvent, 'RenderEvent', RenderEvent);
initMetadataForCompanion(Companion_3);
initMetadataForClass(InitEvent, 'InitEvent', InitEvent);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(DisposeEvent, 'DisposeEvent', DisposeEvent);
initMetadataForCompanion(Companion_6);
initMetadataForClass(FullScreenEvent, 'FullScreenEvent', FullScreenEvent);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ReshapeEvent, 'ReshapeEvent', ReshapeEvent);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Type, 'Type');
initMetadataForClass(KeyEvent, 'KeyEvent', KeyEvent);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Type_0, 'Type');
initMetadataForClass(ScrollDeltaMode, 'ScrollDeltaMode');
initMetadataForClass(MouseEvent, 'MouseEvent', MouseEvent);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Type_1, 'Type');
initMetadataForClass(GestureEvent, 'GestureEvent', GestureEvent);
initMetadataForCompanion(Companion_11);
initMetadataForClass(Type_2, 'Type');
initMetadataForClass(DropFileEvent, 'DropFileEvent', DropFileEvent);
initMetadataForClass(StopPropagatingException, 'StopPropagatingException', StopPropagatingException.k8e);
initMetadataForClass(Status, 'Status');
initMetadataForClass(Kind, 'Kind');
initMetadataForCompanion(Companion_12);
initMetadataForClass(Touch, 'Touch', Touch);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Type_3, 'Type');
initMetadataForCompanion(Companion_14);
initMetadataForClass(TouchEvent, 'TouchEvent', TouchEvent);
initMetadataForClass(Mode, 'Mode');
initMetadataForClass(TouchBuilder, 'TouchBuilder', TouchBuilder);
initMetadataForClass(GamepadInfoEmitter, 'GamepadInfoEmitter');
initMetadataForClass(BatteryStatus, 'BatteryStatus');
initMetadataForCompanion(Companion_15);
initMetadataForClass(GamepadInfo, 'GamepadInfo', GamepadInfo);
initMetadataForCompanion(Companion_16);
initMetadataForClass(GamePadUpdateEvent, 'GamePadUpdateEvent', GamePadUpdateEvent);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Type_4, 'Type');
initMetadataForClass(GamePadConnectionEvent, 'GamePadConnectionEvent', GamePadConnectionEvent);
initMetadataForCompanion(Companion_18);
initMetadataForClass(GameButton, 'GameButton');
initMetadataForCompanion(Companion_19);
initMetadataForClass(GameStick, 'GameStick');
initMetadataForCompanion(Companion_20);
initMetadataForClass(Key, 'Key');
initMetadataForCompanion(Companion_21);
initMetadataForClass(MouseButton, 'MouseButton');
initMetadataForInterface(ISoftKeyboardConfig, 'ISoftKeyboardConfig');
initMetadataForClass(SoftKeyboardType, 'SoftKeyboardType');
initMetadataForClass(SoftKeyboardReturnKeyType, 'SoftKeyboardReturnKeyType');
initMetadataForClass(SoftKeyboardConfig, 'SoftKeyboardConfig', SoftKeyboardConfig, VOID, [ISoftKeyboardConfig]);
initMetadataForCompanion(Companion_22);
initMetadataForInterface(AGFeatures, 'AGFeatures');
protoOf(AG).o8k = get_parentFeatures;
protoOf(AG).p8k = get_graphicExtensions;
protoOf(AG).q8k = get_isInstancedSupported;
protoOf(AG).r8k = get_isUniformBuffersSupported;
protoOf(AG).s8k = get_isVertexArraysSupported;
protoOf(AG).t8k = get_isFloatTextureSupported;
initMetadataForClass(AG, 'AG', VOID, VOID, [AGFeatures]);
initMetadataForClass(Immutable, 'Immutable', Immutable, VOID, [AGFeatures]);
initMetadataForClass(Mutable, 'Mutable', Mutable, VOID, [AGFeatures]);
initMetadataForClass(AGObject, 'AGObject', AGObject, VOID, [AutoCloseable]);
initMetadataForClass(AGBuffer, 'AGBuffer', AGBuffer);
initMetadataForCompanion(Companion_23);
initMetadataForClass(AGTextureUnits, 'AGTextureUnits', AGTextureUnits.e8o);
initMetadataForCompanion(Companion_24);
initMetadataForClass(AGFrameBuffer, 'AGFrameBuffer', AGFrameBuffer.g8k, VOID, [AutoCloseable]);
initMetadataForClass(AGTexture, 'AGTexture', AGTexture, VOID, [AGObject, AutoCloseable]);
initMetadataForClass(AGFrameBufferBase, 'AGFrameBufferBase');
initMetadataForCompanion(Companion_25);
initMetadataForClass(AGTextureUnitInfo, 'AGTextureUnitInfo');
initMetadataForInterface(AGNativeObject, 'AGNativeObject');
initMetadataForClass(BufferCache, 'BufferCache', BufferCache);
initMetadataForClass(AGProgramWithUniforms, 'AGProgramWithUniforms');
initMetadataForClass(AGVertexArrayObject, 'AGVertexArrayObject');
initMetadataForClass(AGVertexData, 'AGVertexData', AGVertexData.w8t);
initMetadataForCompanion(Companion_26);
initMetadataForClass(AGDrawType, 'AGDrawType');
initMetadataForCompanion(Companion_27);
initMetadataForClass(AGIndexType, 'AGIndexType');
initMetadataForCompanion(Companion_28);
initMetadataForClass(AGBlending, 'AGBlending');
initMetadataForCompanion(Companion_29);
initMetadataForClass(AGScissor, 'AGScissor');
initMetadataForCompanion(Companion_30);
initMetadataForObject(AGFinish, 'AGFinish');
initMetadataForClass(AGClear, 'AGClear');
initMetadataForCompanion(Companion_31);
initMetadataForClass(AGStencilReference, 'AGStencilReference');
initMetadataForCompanion(Companion_32);
initMetadataForClass(AGStencilOpFunc, 'AGStencilOpFunc');
initMetadataForCompanion(Companion_33);
initMetadataForClass(AGColorMask, 'AGColorMask');
initMetadataForCompanion(Companion_34);
initMetadataForCompanion(Companion_35);
initMetadataForClass(AGCullFace, 'AGCullFace');
initMetadataForClass(AGBatch, 'AGBatch');
initMetadataForCompanion(Companion_36);
initMetadataForClass(AGTextureTargetKind, 'AGTextureTargetKind');
initMetadataForCompanion(Companion_37);
initMetadataForClass(AGWrapMode, 'AGWrapMode');
initMetadataForCompanion(Companion_38);
initMetadataForClass(AGBlendFactor, 'AGBlendFactor');
initMetadataForCompanion(Companion_39);
initMetadataForClass(AGBlendEquation, 'AGBlendEquation');
initMetadataForCompanion(Companion_40);
initMetadataForCompanion(Companion_41);
initMetadataForClass(AGStencilOp, 'AGStencilOp');
initMetadataForCompanion(Companion_42);
initMetadataForClass(AGCompareMode, 'AGCompareMode');
initMetadataForCompanion(Companion_43);
initMetadataForClass(AGMultiBatch, 'AGMultiBatch');
initMetadataForClass(AGConfig, 'AGConfig', AGConfig);
initMetadataForClass(AGBufferKind, 'AGBufferKind');
initMetadataForClass(AGStats, 'AGStats', AGStats);
initMetadataForClass(UniformBlock, 'UniformBlock');
initMetadataForObject(ProjViewUB, 'ProjViewUB');
initMetadataForObject(DefaultShaders, 'DefaultShaders');
initMetadataForInterface(VarTypeAccessor, 'VarTypeAccessor');
initMetadataForInterface(ExpressionBuilder, 'ExpressionBuilder');
protoOf(Builder).v93 = get_Int1;
protoOf(Builder).w93 = get_Float1;
protoOf(Builder).x93 = get_Float2;
protoOf(Builder).a9r = get_Float4;
protoOf(Builder).i92 = get_out;
protoOf(Builder).y93 = sin;
protoOf(Builder).z93 = cos;
protoOf(Builder).a94 = atan;
protoOf(Builder).q92 = texture2D;
protoOf(Builder).b94 = TERNARY;
protoOf(Builder).c94 = int;
protoOf(Builder).d94 = float;
protoOf(Builder).e94 = pow;
protoOf(Builder).f94 = exp;
protoOf(Builder).g94 = sqrt;
protoOf(Builder).h94 = abs;
protoOf(Builder).i94 = ceil;
protoOf(Builder).j94 = fract;
protoOf(Builder).k94 = clamp01;
protoOf(Builder).l94 = clamp;
protoOf(Builder).v9p = min_0;
protoOf(Builder).m94 = max_1;
protoOf(Builder).w9p = fwidth;
protoOf(Builder).n94 = mix;
protoOf(Builder).o94 = smoothstep;
protoOf(Builder).p94 = length;
protoOf(Builder).q94 = dot;
protoOf(Builder).r94 = normalize;
protoOf(Builder).s94 = reflect;
protoOf(Builder).t94 = get_lit;
protoOf(Builder).l92 = get_lit_0;
protoOf(Builder).u94 = vec2;
protoOf(Builder).v94 = vec2_0;
protoOf(Builder).w94 = vec3;
protoOf(Builder).m92 = vec4;
protoOf(Builder).x94 = vec4_0;
protoOf(Builder).y94 = mat2;
protoOf(Builder).z94 = get_1;
protoOf(Builder).o92 = get_2;
protoOf(Builder).a95 = get_x;
protoOf(Builder).b95 = get_y;
protoOf(Builder).c95 = get_z;
protoOf(Builder).d95 = get_w;
protoOf(Builder).e95 = get_r;
protoOf(Builder).s92 = get_a;
protoOf(Builder).f95 = unaryMinus;
protoOf(Builder).g95 = minus_0;
protoOf(Builder).h95 = minus_1;
protoOf(Builder).i95 = plus_2;
protoOf(Builder).x9p = plus_3;
protoOf(Builder).y9p = plus_4;
protoOf(Builder).j92 = times;
protoOf(Builder).z9p = times_0;
protoOf(Builder).j95 = times_1;
protoOf(Builder).u92 = div;
protoOf(Builder).k95 = div_0;
protoOf(Builder).l95 = eq;
protoOf(Builder).m95 = ne;
protoOf(Builder).n95 = lt;
protoOf(Builder).o95 = lt_0;
protoOf(Builder).p95 = le;
protoOf(Builder).q95 = gt;
protoOf(Builder).r95 = gt_0;
protoOf(Builder).s95 = ge;
protoOf(Builder).t95 = and;
protoOf(Builder).u95 = inRange;
initMetadataForClass(Builder, 'Builder', Builder.v92, VOID, [VarTypeAccessor, ExpressionBuilder]);
initMetadataForInterface(IDefaultShaders, 'IDefaultShaders');
protoOf(ProgramBuilderDefault).p92 = get_u_Tex;
protoOf(ProgramBuilderDefault).q8z = get_u_ProjMat;
protoOf(ProgramBuilderDefault).r8z = get_u_ViewMat;
protoOf(ProgramBuilderDefault).k92 = get_a_Pos;
protoOf(ProgramBuilderDefault).c92 = get_a_Tex;
protoOf(ProgramBuilderDefault).h92 = get_a_Col;
protoOf(ProgramBuilderDefault).b92 = get_v_Tex;
protoOf(ProgramBuilderDefault).g92 = get_v_Col;
protoOf(ProgramBuilderDefault).t92 = get_t_Temp0;
protoOf(ProgramBuilderDefault).v95 = get_t_Temp1;
protoOf(ProgramBuilderDefault).w95 = get_t_TempMat2;
initMetadataForClass(ProgramBuilderDefault, 'ProgramBuilderDefault', ProgramBuilderDefault.a92, VOID, [Builder, IDefaultShaders]);
initMetadataForClass(GLVAO, 'GLVAO');
initMetadataForClass(ShaderException, 'ShaderException');
initMetadataForClass(TextureUnitParams, 'TextureUnitParams');
initMetadataForClass(AGOpengl, 'AGOpengl');
initMetadataForClass(GLGlobalState, 'GLGlobalState');
initMetadataForClass(GLBaseObject, 'GLBaseObject', VOID, VOID, [AGNativeObject]);
initMetadataForClass(GLBaseProgram, 'GLBaseProgram');
initMetadataForClass(GLBuffer, 'GLBuffer');
initMetadataForClass(GLTexture, 'GLTexture');
initMetadataForClass(GLFrameBuffer, 'GLFrameBuffer');
initMetadataForClass(GLProgramInfo, 'GLProgramInfo');
initMetadataForObject(GLShaderCompiler, 'GLShaderCompiler');
initMetadataForClass(AGDummy, 'AGDummy', AGDummy);
initMetadataForClass(AGBaseLog, 'AGBaseLog', AGBaseLog);
initMetadataForClass(AGPrint, 'AGPrint', AGPrint);
initMetadataForClass(Kind_0, 'Kind');
initMetadataForCompanion(Companion_44);
initMetadataForClass(UniformBlocksBuffersRef, 'UniformBlocksBuffersRef');
initMetadataForClass(Gen, 'Gen');
initMetadataForClass(Operand, 'Operand');
initMetadataForClass(OperandWithArray, 'OperandWithArray');
initMetadataForClass(Variable, 'Variable');
initMetadataForClass(VariableWithOffset, 'VariableWithOffset');
initMetadataForClass(TypedUniform, 'TypedUniform');
initMetadataForCompanion(Companion_45);
initMetadataForClass(UniformBlockBuffer, 'UniformBlockBuffer');
initMetadataForClass(UBLayoutBuilder, 'UBLayoutBuilder', UBLayoutBuilder);
initMetadataForClass(UniformsRef, 'UniformsRef');
initMetadataForCompanion(Companion_46);
initMetadataForClass(GLVariant, 'GLVariant');
initMetadataForClass(Visitor, 'Visitor');
initMetadataForClass(GlobalsProgramVisitor, 'GlobalsProgramVisitor', GlobalsProgramVisitor);
initMetadataForCompanion(Companion_47);
initMetadataForClass(Result, 'Result');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForInterface(BaseGlslGenerator, 'BaseGlslGenerator');
protoOf(GlslGenerator).b9m = precToString;
protoOf(GlslGenerator).c9m = typeToString;
protoOf(GlslGenerator).d9m = get_arrayDecl;
protoOf(GlslGenerator).a9m = get_IN;
protoOf(GlslGenerator).f9m = get_OUT;
protoOf(GlslGenerator).e9m = get_UNIFORM;
initMetadataForClass(GlslGenerator, 'GlslGenerator', VOID, VOID, [BaseGlslGenerator]);
initMetadataForCompanion(Companion_48);
initMetadataForClass(GlslConfig, 'GlslConfig');
protoOf(GlslBodyGenerator).c9m = typeToString;
initMetadataForClass(GlslBodyGenerator, 'GlslBodyGenerator', VOID, VOID, [Visitor, BaseGlslGenerator]);
initMetadataForClass(ProgramLayout, 'ProgramLayout', VOID, VOID, [Iterable]);
initMetadataForClass(Attribute, 'Attribute');
initMetadataForClass(Stm, 'Stm');
initMetadataForClass(Stms, 'Stms');
initMetadataForClass(Set, 'Set');
initMetadataForClass(Return, 'Return');
initMetadataForObject(Break, 'Break');
initMetadataForObject(Continue, 'Continue');
initMetadataForObject(Discard, 'Discard');
initMetadataForClass(If, 'If');
initMetadataForClass(ForSimple, 'ForSimple');
initMetadataForClass(Raw, 'Raw');
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).q92 = texture2D;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).b94 = TERNARY;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).e94 = pow;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).l94 = clamp;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).t94 = get_lit;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).l92 = get_lit_0;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).m92 = vec4;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).o92 = get_2;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).a95 = get_x;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).b95 = get_y;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).c95 = get_z;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).d95 = get_w;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).g95 = minus_0;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).i95 = plus_2;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).j92 = times;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).u92 = div;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).n95 = lt;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).q95 = gt;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).s95 = ge;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).t95 = and;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).u95 = inRange;
initMetadataForClass(Program$ExpressionBuilder$Companion$INSTANCE$1, VOID, VOID, VOID, [ExpressionBuilder]);
initMetadataForCompanion(Companion_49);
initMetadataForClass(FuncBuilder, 'FuncBuilder');
initMetadataForClass(FuncDeclGetter, 'FuncDeclGetter');
initMetadataForClass(FuncProvider, 'FuncProvider');
initMetadataForClass(Program$Builder$_funcs$1);
initMetadataForClass(Ternary, 'Ternary');
initMetadataForClass(Unop, 'Unop');
initMetadataForClass(Binop, 'Binop');
initMetadataForClass(IntLiteral, 'IntLiteral');
initMetadataForClass(FloatLiteral, 'FloatLiteral');
initMetadataForClass(BoolLiteral, 'BoolLiteral');
initMetadataForClass(Vector, 'Vector');
initMetadataForClass(Swizzle, 'Swizzle');
initMetadataForClass(ArrayAccess, 'ArrayAccess');
initMetadataForClass(BaseFunc, 'BaseFunc');
initMetadataForClass(Func, 'Func');
initMetadataForClass(CustomFunc, 'CustomFunc');
initMetadataForInterface(FuncRef, 'FuncRef');
initMetadataForClass(BuilderContext, 'BuilderContext', BuilderContext);
initMetadataForClass(Program, 'Program', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Shader, 'Shader');
initMetadataForClass(Varying, 'Varying');
initMetadataForObject(Output, 'Output');
initMetadataForClass(Provider, 'Provider');
initMetadataForClass(Sampler, 'Sampler');
initMetadataForClass(SamplerVarType, 'SamplerVarType');
initMetadataForClass(Uniform, 'Uniform');
initMetadataForCompanion(Companion_50);
initMetadataForClass(VarType, 'VarType');
initMetadataForClass(Precision, 'Precision');
initMetadataForClass(Temp, 'Temp');
initMetadataForClass(FuncDecl, 'FuncDecl', VOID, VOID, [FuncRef]);
initMetadataForClass(VarKind, 'VarKind');
initMetadataForClass(UniformInProgram, 'UniformInProgram');
initMetadataForClass(Arg, 'Arg');
initMetadataForClass(ShaderType, 'ShaderType');
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0');
initMetadataForClass(ContextInfo, 'ContextInfo', ContextInfo);
initMetadataForCompanion(Companion_51);
protoOf(KmlGl).o8k = get_parentFeatures;
protoOf(KmlGl).q8k = get_isInstancedSupported;
protoOf(KmlGl).r8k = get_isUniformBuffersSupported;
protoOf(KmlGl).s8k = get_isVertexArraysSupported;
initMetadataForClass(KmlGl, 'KmlGl', KmlGl, VOID, [AGFeatures]);
initMetadataForClass(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', KorgeReloadInternalImpl);
initMetadataForClass(ReloadClassContext, 'ReloadClassContext');
initMetadataForObject(KorgeReload, 'KorgeReload');
initMetadataForCompanion(Companion_52);
initMetadataForCompanion(Companion_53);
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(InputKeys, 'InputKeys', InputKeys);
initMetadataForCompanion(Companion_54);
initMetadataForClass(Input, 'Input', Input);
initMetadataForObject(DefaultViewport, 'DefaultViewport');
initMetadataForCompanion(Companion_55);
initMetadataForClass(Props, 'Props', Props, VOID, [KtMutableMap]);
initMetadataForClass(Entry, 'Entry', Entry);
initMetadataForClass(AgAutoFreeManager, 'AgAutoFreeManager', AgAutoFreeManager, VOID, [AutoCloseable]);
initMetadataForClass(BitmapTextureInfo, 'BitmapTextureInfo', BitmapTextureInfo);
initMetadataForClass(AgBitmapTextureManager, 'AgBitmapTextureManager', VOID, VOID, [AutoCloseable]);
initMetadataForClass(AgBufferManager, 'AgBufferManager');
initMetadataForClass(AgCachedBuffer, 'AgCachedBuffer');
initMetadataForClass(BatchBuffers, 'BatchBuffers', BatchBuffers);
initMetadataForCompanion(Companion_56);
initMetadataForClass(BatchBuilder2D, 'BatchBuilder2D');
initMetadataForInterface(BoundsProvider, 'BoundsProvider');
protoOf(Base).kag = get_actualVirtualWidth;
protoOf(Base).lag = get_actualVirtualHeight;
protoOf(Base).mag = get_virtualLeft;
protoOf(Base).nag = get_virtualTop;
protoOf(Base).oag = get_virtualRight;
protoOf(Base).pag = get_virtualBottom;
protoOf(Base).qag = get_windowToGlobalScaleAvg;
protoOf(Base).rag = get_globalToWindowScaleAvg;
protoOf(Base).sag = windowToGlobalCoords;
initMetadataForClass(Base, 'Base', Base, VOID, [BoundsProvider]);
initMetadataForCompanion(Companion_57);
initMetadataForClass(LineRenderBatcher, 'LineRenderBatcher');
initMetadataForClass(FlushKind, 'FlushKind');
initMetadataForInterface(DeviceDimensionsProvider, 'DeviceDimensionsProvider');
initMetadataForClass(RenderContext, 'RenderContext', VOID, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, AutoCloseable]);
initMetadataForClass(RenderContext2D, 'RenderContext2D');
initMetadataForObject(SDFShaders, 'SDFShaders');
initMetadataForClass(TextureBase, 'TextureBase', VOID, VOID, [AutoCloseable]);
initMetadataForClass(TextureWithBitmapSlice, 'TextureWithBitmapSlice');
initMetadataForCompanion(Companion_58);
initMetadataForClass(TexturedVertexArray, 'TexturedVertexArray');
initMetadataForClass(ShrinkableTexturedVertexArray, 'ShrinkableTexturedVertexArray');
initMetadataForClass(ResourcesRoot, 'ResourcesRoot', ResourcesRoot, VOID, [InjectorDependency], [1]);
initMetadataForClass(Counter, 'Counter');
initMetadataForClass(RCollection, 'RCollection', RCollection);
initMetadataForClass(Stats, 'Stats', Stats);
initMetadataForClass(V2, 'V2');
initMetadataForObject(V2CallbackSupport, 'V2CallbackSupport');
protoOf(DEFAULT).rah = get_devicePixelRatio;
protoOf(DEFAULT).sah = get_pixelsPerInch;
protoOf(DEFAULT).tah = get_pixelsPerLogicalInchRatio;
protoOf(DEFAULT).uah = get_computedPixelRatio;
initMetadataForObject(DEFAULT, 'DEFAULT', VOID, VOID, [DeviceDimensionsProvider]);
initMetadataForInterface(DialogInterface, 'DialogInterface', VOID, VOID, VOID, [1, 2, 4]);
protoOf(Unsupported).gam = get_dialogInterface;
protoOf(Unsupported).ham = alert;
protoOf(Unsupported).iam = openFileDialog;
initMetadataForObject(Unsupported, 'Unsupported', VOID, VOID, [DialogInterface], [1, 2, 4]);
initMetadataForClass(FileFilter, 'FileFilter');
initMetadataForClass(Impl, 'Impl', Impl);
initMetadataForCompanion(Companion_59);
initMetadataForClass(Cursor, 'Cursor');
initMetadataForClass(MenuItem, 'MenuItem');
initMetadataForObject(CoroutineKey, 'CoroutineKey');
initMetadataForClass(Quality, 'Quality');
initMetadataForLambda(GameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(_no_name_provided__qut3iv);
protoOf(GameWindow).rah = get_devicePixelRatio;
protoOf(GameWindow).sah = get_pixelsPerInch;
protoOf(GameWindow).tah = get_pixelsPerLogicalInchRatio;
protoOf(GameWindow).uah = get_computedPixelRatio;
protoOf(GameWindow).td = get;
protoOf(GameWindow).wn = fold;
protoOf(GameWindow).vn = minusKey;
protoOf(GameWindow).xn = plus_1;
initMetadataForClass(GameWindow, 'GameWindow', GameWindow.xap, VOID, [BaseEventListener, DeviceDimensionsProvider, Element], [0, 1]);
initMetadataForCompanion(Companion_60);
initMetadataForClass(GameWindowCreationConfig, 'GameWindowCreationConfig', GameWindowCreationConfig);
initMetadataForClass(TextClipboardData, 'TextClipboardData');
initMetadataForClass(TimedTask_0, 'TimedTask');
initMetadataForCompanion(Companion_61);
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0_0, 'sam$kotlinx_coroutines_DisposableHandle$0');
initMetadataForClass(GameWindowCoroutineDispatcher, 'GameWindowCoroutineDispatcher', GameWindowCoroutineDispatcher.laq, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForClass(SyncEventLoopCoroutineDispatcher, 'SyncEventLoopCoroutineDispatcher', SyncEventLoopCoroutineDispatcher.aaq, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForCompanion(Companion_62);
initMetadataForClass(UpdateEvent, 'UpdateEvent', UpdateEvent);
initMetadataForObject(AGOpenglFactory, 'AGOpenglFactory');
initMetadataForClass(KmlGlJsCanvas, 'KmlGlJsCanvas');
initMetadataForClass(WebGLExtension, 'WebGLExtension');
initMetadataForClass(KorgeReloadInternal$1);
initMetadataForClass(JsGameWindow, 'JsGameWindow', JsGameWindow.ab2, VOID, VOID, [0, 1]);
initMetadataForClass(NodeJsGameWindow, 'NodeJsGameWindow', NodeJsGameWindow.oaz, VOID, VOID, [0, 1]);
initMetadataForLambda(BrowserCanvasJsGameWindow$close$slambda, VOID, VOID, [0]);
initMetadataForLambda(BrowserCanvasJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(BrowserCanvasJsGameWindow, 'BrowserCanvasJsGameWindow', BrowserCanvasJsGameWindow.cax, VOID, VOID, [1, 0]);
protoOf(DialogInterfaceJs).gam = get_dialogInterface;
initMetadataForClass(DialogInterfaceJs, 'DialogInterfaceJs', DialogInterfaceJs, VOID, [DialogInterface], [1, 2, 4]);
//endregion
//region block: init
Companion_instance_8 = new Companion();
Companion_instance_9 = new Companion_0();
Companion_instance_10 = new Companion_1();
Companion_instance_11 = new Companion_2();
Companion_instance_14 = new Companion_5();
Companion_instance_15 = new Companion_6();
Companion_instance_16 = new Companion_7();
Companion_instance_23 = new Companion_14();
Companion_instance_24 = new Companion_15();
Companion_instance_25 = new Companion_16();
Companion_instance_32 = new Companion_23();
Companion_instance_33 = new Companion_24();
AGFinish_instance = new AGFinish();
Companion_instance_49 = new Companion_40();
Companion_instance_54 = new Companion_45();
Companion_instance_55 = new Companion_46();
Companion_instance_59 = new Companion_50();
Companion_instance_60 = new Companion_51();
Companion_instance_61 = new Companion_52();
debugBmpFontOrNull = null;
Companion_instance_63 = new Companion_54();
Companion_instance_64 = new Companion_55();
DEFAULT_instance = new DEFAULT();
Unsupported_instance = new Unsupported();
GLOBAL_CHECK_GL = false;
Companion_instance_71 = new Companion_62();
korgwJvmEngine = null;
AGOpenglFactory_instance = new AGOpenglFactory();
//endregion
//region block: exports
export {
  Type_DROP_getInstance as Type_DROP_getInstance37jdln1dn5lup,
  GameButton_BUTTON_NORTH_getInstance as GameButton_BUTTON_NORTH_getInstance6rl4ta8izocg,
  GameButton_BUTTON_SOUTH_getInstance as GameButton_BUTTON_SOUTH_getInstancefuuqbnftxu5s,
  GameButton_BUTTON_WEST_getInstance as GameButton_BUTTON_WEST_getInstance9mbjk7favy3t,
  GameButton_LX_getInstance as GameButton_LX_getInstance3lu9212pwqcbw,
  GameButton_LY_getInstance as GameButton_LY_getInstance2eqq84hvfc09s,
  GameStick_LEFT_getInstance as GameStick_LEFT_getInstanceqs0nc2u1h6p8,
  Key_BACKSPACE_getInstance as Key_BACKSPACE_getInstance3rjprs9bquj2s,
  Key_DOWN_getInstance as Key_DOWN_getInstance3uv13du3770bq,
  Key_ESCAPE_getInstance as Key_ESCAPE_getInstance3cajn3snqk2cl,
  Key_F12_getInstance as Key_F12_getInstance3iwen1o4s4mlo,
  Key_F7_getInstance as Key_F7_getInstance1rgyn6mno38yl,
  Key_LEFT_getInstance as Key_LEFT_getInstance4xv6s4l9ffcr,
  Key_RIGHT_getInstance as Key_RIGHT_getInstancevkjx63tsbibt,
  Key_SPACE_getInstance as Key_SPACE_getInstance13zcep8fbcon1,
  Key_TAB_getInstance as Key_TAB_getInstance1i9er9c2pz5on,
  Key_UP_getInstance as Key_UP_getInstanceb8rctup40hnz,
  Key_X_getInstance as Key_X_getInstancecx3jjvu3v5gk,
  Key_Z_getInstance as Key_Z_getInstance3takq9lezu1le,
  Type_DOWN_getInstance as Type_DOWN_getInstance313b56cnb7a70,
  Type_TYPE_getInstance as Type_TYPE_getInstanceae1nnzr8xwbc,
  Type_UP_getInstance as Type_UP_getInstance14prrhxnriw3z,
  MouseButton_LEFT_getInstance as MouseButton_LEFT_getInstance2dunhocwmk9pi,
  ScrollDeltaMode_PIXEL_getInstance as ScrollDeltaMode_PIXEL_getInstance1t158ggrr658n,
  Type_DOWN_getInstance_0 as Type_DOWN_getInstance20slx18g3n9iw,
  Type_DRAG_getInstance as Type_DRAG_getInstance3nknmoqnyfvel,
  Type_UP_getInstance_0 as Type_UP_getInstance3cbsyzwl1abw4,
  Kind_MOUSE_getInstance as Kind_MOUSE_getInstance1x6f2nb0du729,
  Status_ADD_getInstance as Status_ADD_getInstance2ikhpw2btzfzo,
  Status_KEEP_getInstance as Status_KEEP_getInstance3p1s7ste35m5y,
  Status_REMOVE_getInstance as Status_REMOVE_getInstance21rl9vf9qjrb0,
  Type_END_getInstance_0 as Type_END_getInstance331lr99r7xh7i,
  Type_MOVE_getInstance_0 as Type_MOVE_getInstance2g4jkr289s1a8,
  Type_START_getInstance_0 as Type_START_getInstancegn6n8lkvuoxm,
  Precision_HIGH_getInstance as Precision_HIGH_getInstance6iuog1cw3jr0,
  Precision_LOW_getInstance as Precision_LOW_getInstance3sce4muk7g3c6,
  Precision_MEDIUM_getInstance as Precision_MEDIUM_getInstance45g8detuxjnt,
  SamplerVarType_Sampler2D_getInstance as SamplerVarType_Sampler2D_getInstancepf6ffmb89evn,
  ShaderType_FRAGMENT_getInstance as ShaderType_FRAGMENT_getInstance2q2lcwtkv0h13,
  ShaderType_VERTEX_getInstance as ShaderType_VERTEX_getInstance1cr8wwngbi4ix,
  VarKind_TBYTE_getInstance as VarKind_TBYTE_getInstance2f4bqopvsa557,
  VarKind_TFLOAT_getInstance as VarKind_TFLOAT_getInstance3qr8a0l2vrn4p,
  VarKind_TINT_getInstance as VarKind_TINT_getInstance3fbaa1lxq42j,
  VarKind_TSHORT_getInstance as VarKind_TSHORT_getInstance3bz2uawb9nt6z,
  VarKind_TUNSIGNED_BYTE_getInstance as VarKind_TUNSIGNED_BYTE_getInstancelmv3e9ctu0su,
  VarKind_TUNSIGNED_SHORT_getInstance as VarKind_TUNSIGNED_SHORT_getInstance1vvmqqcsbjp9,
  VarType_Byte4_getInstance as VarType_Byte4_getInstance141vunatqfafm,
  VarType_Float1_getInstance as VarType_Float1_getInstance2yyqoe6yly9a9,
  VarType_Float2_getInstance as VarType_Float2_getInstance26tgtz9tkdb0r,
  VarType_Float3_getInstance as VarType_Float3_getInstance2ijj9ybtzxz8w,
  VarType_Float4_getInstance as VarType_Float4_getInstanceomsfyancnlr,
  VarType_Int1_getInstance as VarType_Int1_getInstance1li648f16m3co,
  VarType_Mat4_getInstance as VarType_Mat4_getInstance2srh53egil2ho,
  VarType_UByte1_getInstance as VarType_UByte1_getInstanceedmnuc4ekhqj,
  VarType_UShort2_getInstance as VarType_UShort2_getInstance1kb0okwtn0sad,
  Cursor_DEFAULT_getInstance as Cursor_DEFAULT_getInstance11huz1cp1hftw,
  Cursor_HAND_getInstance as Cursor_HAND_getInstance1a8elkut4sr6s,
  Cursor_RESIZE_EAST_getInstance as Cursor_RESIZE_EAST_getInstance2w703jzx4ubcd,
  Cursor_TEXT_getInstance as Cursor_TEXT_getInstance38yy9u9rxp5sl,
  Quality_PERFORMANCE_getInstance as Quality_PERFORMANCE_getInstance2im0li1v0jac6,
  debugBmpFont as debugBmpFont119k9qsj5fsyz,
  configureLoggerFromProperties as configureLoggerFromProperties1t3glidkjwd17,
  alert_0 as alert2d79t85yuh93y,
  openFileDialog_0 as openFileDialog3eegkhbnqs6u1,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo33l2pvqtfq9yj,
  AGStencilOpFunc__withActionOnDepthFail$default_impl_n96pyd as AGStencilOpFunc__withActionOnDepthFail$default_impl_n96pyd2tf3sk32uhtv1,
  AGStencilOpFunc__withActionOnDepthPassStencilFail$default_impl_4acstw as AGStencilOpFunc__withActionOnDepthPassStencilFail$default_impl_4acstw2amtefs1nlpor,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv as AGStencilOpFunc__withCompareMode$default_impl_rzbauv5p5tszphd23r,
  AGStencilReference__withReadMask$default_impl_7mdffx as AGStencilReference__withReadMask$default_impl_7mdffx1g2sfp701cvyr,
  AGStencilReference__withReferenceValue$default_impl_2trj0v as AGStencilReference__withReferenceValue$default_impl_2trj0v232x7ttx8ekye,
  AGStencilReference__withWriteMask$default_impl_b7j7b4 as AGStencilReference__withWriteMask$default_impl_b7j7b43mm4w8krkt3ep,
  _AGColorMask___init__impl__j38ai8_0 as _AGColorMask___init__impl__j38ai814mo4mz42teo7,
  _AGColorMask___init__impl__j38ai8_1 as _AGColorMask___init__impl__j38ai83dsldtujda2h7,
  AGColorMask__hashCode_impl_g9082f as AGColorMask__hashCode_impl_g9082fi7509ibyna3k,
  AGColorMask__toString_impl_5i5oqg as AGColorMask__toString_impl_5i5oqg2gcs1m2a75488,
  AGCompareMode__inverted_impl_7xxk8m as AGCompareMode__inverted_impl_7xxk8m26xkfw1943nj2,
  AGCullFace__hashCode_impl_t4e5ur as AGCullFace__hashCode_impl_t4e5ur1en9y9rx0mxgq,
  AGCullFace__toString_impl_7d891w as AGCullFace__toString_impl_7d891wpots1bgmosc2,
  AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs as AGDepthAndFrontFace__withDepthFunc_impl_7t7yrshaluzbo1kv57,
  AGDepthAndFrontFace__withDepth_impl_wsx82k as AGDepthAndFrontFace__withDepth_impl_wsx82k3od8qukq65bpe,
  AGDrawType__hashCode_impl_ylaury as AGDrawType__hashCode_impl_ylauryzr6i7tjdryw8,
  AGDrawType__toString_impl_eonaeb as AGDrawType__toString_impl_eonaeb25w5br3wcp5j8,
  _AGIndexType___get_bytesSize__impl__lsf184 as _AGIndexType___get_bytesSize__impl__lsf1842zwb6tiav2tom,
  AGIndexType__hashCode_impl_47f06s as AGIndexType__hashCode_impl_47f06sm5x1b5uy8g0k,
  AGIndexType__toString_impl_hjqwm3 as AGIndexType__toString_impl_hjqwm32mdzx8y07ki6u,
  AGStencilOpFunc__hashCode_impl_nopebb as AGStencilOpFunc__hashCode_impl_nopebb7w0dexbvx0dj,
  AGStencilOpFunc__toString_impl_pl8quy as AGStencilOpFunc__toString_impl_pl8quy5ckch3y49o93,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at30n6rjhwnoxep,
  AGStencilOpFunc__withEnabled_impl_mpcwmr as AGStencilOpFunc__withEnabled_impl_mpcwmrtmo0h8rbfy7w,
  AGStencilReference__hashCode_impl_52zufx as AGStencilReference__hashCode_impl_52zufx2wwwwyq5gfu31,
  AGStencilReference__toString_impl_qu5r8s as AGStencilReference__toString_impl_qu5r8sbb7dfey0kemg,
  AGTextureUnitInfo__withLinear_impl_jl8yud as AGTextureUnitInfo__withLinear_impl_jl8yudmrq2e4l66lkn,
  AGTextureUnitInfo__withWrap_impl_akwb6y as AGTextureUnitInfo__withWrap_impl_akwb6y3ls6427f6ddao,
  AGTextureUnitInfoArray__get_impl_xhvpef as AGTextureUnitInfoArray__get_impl_xhvpef3h2w6c3rmad6f,
  Companion_instance_11 as Companion_instance3nf2h14fw03zr,
  Companion_getInstance_28 as Companion_getInstance35vn8xpzue606,
  Companion_getInstance_35 as Companion_getInstance31f0y2ylke4bl,
  Companion_getInstance_34 as Companion_getInstancenz8ykkb6phk0,
  Companion_instance_25 as Companion_instanceozmuwjcmdf52,
  Companion_getInstance_36 as Companion_getInstance1yaadt0u5el0f,
  Companion_getInstance_27 as Companion_getInstancex1pk9m73g9c6,
  Companion_getInstance_37 as Companion_getInstance77k1lbkmp5wu,
  Companion_getInstance_25 as Companion_getInstancezx9mtebwpbyq,
  Companion_getInstance_26 as Companion_getInstance2sn5bsju340al,
  Companion_instance_8 as Companion_instancelgkpg07onuw2,
  Companion_instance_16 as Companion_instancez9q7819xwnc1,
  Companion_instance_9 as Companion_instance2kf6v2is0lhhr,
  Companion_instance_10 as Companion_instance2ffiktwt5nfeb,
  Companion_getInstance_30 as Companion_getInstance18fciagsd02o3,
  Companion_instance_55 as Companion_instance21gpry3t4pmsj,
  Companion_getInstance_66 as Companion_getInstance2milgz47dwnlh,
  Companion_instance_54 as Companion_instance3jw50k8jil3sx,
  Companion_instance_59 as Companion_instance3fmek7gj0zzwa,
  Companion_getInstance_50 as Companion_getInstance18pjxyoy9tzln,
  Companion_getInstance_59 as Companion_getInstance2v5l7b83xykmk,
  Companion_getInstance_52 as Companion_getInstance2sk7vs29gnik3,
  Companion_getInstance_51 as Companion_getInstance1c5y8vpd826by,
  Companion_getInstance_43 as Companion_getInstance1r9b3td34f16o,
  Companion_getInstance_44 as Companion_getInstance2nqpuzpsa8xr1,
  Companion_getInstance_46 as Companion_getInstance2hvv939x49crx,
  Companion_getInstance_58 as Companion_getInstance19lgm19ipf6do,
  Companion_getInstance_49 as Companion_getInstancer6z1nlxalqx7,
  Companion_getInstance_48 as Companion_getInstancey5u5n7g62xvk,
  Companion_getInstance_42 as Companion_getInstance21hbm5vhzozgd,
  Companion_getInstance_54 as Companion_getInstance2gaa7ku0bx2qt,
  ProjViewUB_getInstance as ProjViewUB_getInstance24kbqbtea649t,
  DefaultShaders_getInstance as DefaultShaders_getInstance11xvl6rr8iso,
  Companion_getInstance_70 as Companion_getInstance3jgth1v8sehkm,
  DefaultViewport_getInstance as DefaultViewport_getInstance3j3s2jy6zu9ca,
  Companion_getInstance_73 as Companion_getInstance12gtxroo40wno,
  SDFShaders_getInstance as SDFShaders_getInstance27u34u1y8yo31,
  Companion_getInstance_75 as Companion_getInstance29r688krv3c4g,
  KorgeReload_getInstance as KorgeReload_getInstance1i7uio6gustu7,
  Companion_instance_61 as Companion_instancekrhj1pqvxv6j,
  Companion_instance_71 as Companion_instance18k7zco3357fp,
  CoroutineKey_getInstance as CoroutineKey_getInstance3nlh6pc2noqhi,
  Companion_getInstance_76 as Companion_getInstance37zfsbm2flr4o,
  BaseEventListener as BaseEventListener6clplq3qhf9k,
  EventResult as EventResult1qajuo9ssrvv5,
  Event as Eventnral6s6c3h27,
  GamePadUpdateEvent as GamePadUpdateEvent1d3tqgcuuj4dw,
  GamepadInfo as GamepadInfoyijqqtg064su,
  GestureEvent as GestureEvent15rebw4wmjtpj,
  ISoftKeyboardConfig as ISoftKeyboardConfige7b4czi6ukd7,
  KeyEvent as KeyEvent3kdv2rq8w0dew,
  MouseEvent as MouseEventmt8xebywpdp9,
  ReshapeEvent as ReshapeEvent3137ki3m95agm,
  SoftKeyboardConfig as SoftKeyboardConfig3ue4h4egpkqhq,
  StopPropagatingException as StopPropagatingException3fryyzw9pc422,
  TouchEvent as TouchEvent37l81isz00qgj,
  TypedEvent as TypedEvent2sht3ekuftqke,
  jsObject as jsObject3lpbwuxli49jf,
  AGPrint as AGPrint2do8iynklt71b,
  GlslConfig as GlslConfig298xixs7efncl,
  GlslGenerator as GlslGenerator2uoj59ir73hv0,
  Attribute as Attribute3obvnbxr5w4xd,
  FragmentShader as FragmentShader2u3ycaqbgbmdi,
  ArrayAccess as ArrayAccessethjey8s09dj,
  ForSimple as ForSimple22pqvfecoo85d,
  If as If1av5krmfyt44s,
  ProgramLayout as ProgramLayout373hh4xkth3qt,
  Program as Program1hnygp9hph4ry,
  Sampler as Sampler1pcjbdzdxbif3,
  Shader as Shader39o79ur9unxav,
  Temp as Temp2o9ep2ww9mag1,
  UniformBlockBuffer as UniformBlockBuffer2p2oao2ic417b,
  UniformBlock as UniformBlock2qoqszhm3r9i2,
  values_8 as values27fkm2c0pan63,
  Varying as Varying105nnu9x9j75f,
  VertexShader as VertexShader26kcg39ndf3s1,
  AGBatch as AGBatch2bse24318tbhc,
  AGBuffer as AGBuffer24eh7xseqt7zt,
  AGColorMask as AGColorMaskwqd86t1dhpnk,
  AGCullFace as AGCullFaceff7di2v9k2ne,
  AGDrawType as AGDrawType11vxw4gf0yugk,
  Mutable as Mutable1g6izonky2e38,
  AGIndexType as AGIndexTypenyfo4cxtrg69,
  AGScissor as AGScissor1lpa42gfyr1p2,
  AGStencilOpFunc as AGStencilOpFunc1juigl5mvjr07,
  AGStencilReference as AGStencilReference8at184sv64zi,
  AGTextureUnits as AGTextureUnits3k80ikbk5qbv9,
  AGVertexArrayObject as AGVertexArrayObjectp6l6cor3jhq8,
  AGVertexData as AGVertexDatawn78bdwnwjab,
  AG as AG35f0xk1ko87rh,
  ProgramBuilderDefault as ProgramBuilderDefault3573mhybddt0b,
  applyMatrixBounds as applyMatrixBounds3j13fpymjibm6,
  draw as drawfyi5eaogony1,
  draw_1 as draw3n7i8s75fp58g,
  plus_5 as plus3tmekjwnqrsa6,
  toAGScissor as toAGScissor50oxbqy8vpfx,
  drawText as drawText2ld6eqw3mc9xd,
  drawText_0 as drawText1tnl009j4blt0,
  Input as Input3ljaq07eyi73v,
  AgBitmapTextureManager as AgBitmapTextureManager2xbtbx0jd1or0,
  AgBufferManager as AgBufferManager1sha16u5by4lx,
  AgCachedBuffer as AgCachedBuffer8k1i505isl6b,
  get_BB_MAX_TEXTURES as get_BB_MAX_TEXTURES19x2awozztfc7,
  Base as Basef4lqzcfsxjhi,
  BoundsProvider as BoundsProvideri69utw6h2duh,
  RenderContext as RenderContext3l27as458i66g,
  ShrinkableTexturedVertexArray as ShrinkableTexturedVertexArray2dp7296cmttgp,
  get_TEXTURED_ARRAY_QUAD_INDICES as get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz,
  TEXTURED_ARRAY_quadIndices as TEXTURED_ARRAY_quadIndices1vrv67jygypre,
  TextureBase as TextureBase31xvoisoo1pp7,
  TextureWithBitmapSlice as TextureWithBitmapSlice1c4x879lwy0ns,
  TexturedVertexArray as TexturedVertexArrayt1cf0uhgxqi1,
  Texture as Texture2obedkmljq67n,
  Texture_1 as Texture39uvj3jju6ujd,
  get_debugLineRenderContext as get_debugLineRenderContext3s3h9yq8a0rtj,
  ResourcesRoot as ResourcesRoot36ooexy6oq69y,
  Stats as Statslnkcsgem8jjl,
  V2Callback as V2Callback2d6dtckx13wqz,
  V2 as V22su20mpwty0v0,
  _interpolateAngle as _interpolateAngle308nqn33qn9pa,
  _interpolateColor as _interpolateColor3ps0kri0tazz4,
  _interpolateDuration as _interpolateDuration2bmwsmq7hgv6e,
  _interpolateFloat as _interpolateFloat22vwsp58cwzfw,
  _interpolateRatio as _interpolateRatio2cj6ldbl0g6ae,
  _interpolate as _interpolated0idy8l9id9j,
  easing as easing3hki2a7unu7kd,
  incr as incrvqd3aj0o2965,
  UpdateEvent as UpdateEvent2wwv3f0im2cby,
  CreateDefaultGameWindow as CreateDefaultGameWindow1l94icsbq4y8h,
  DeviceDimensionsProvider as DeviceDimensionsProvider22igvmdnpe2w1,
  FileFilter as FileFilter2m8aa16dn76e3,
  GameWindowCreationConfig as GameWindowCreationConfigbzmga8g39et1,
  GameWindow as GameWindow35197f3hcbh1b,
  TextClipboardData as TextClipboardDatafimoftc14pmm,
  configure as configure1a7py4k2lj4vi,
  toggleFullScreen as toggleFullScreent48jynguinig,
};
//endregion
